var version = "2.3.2";

function c$6() {
    return "labels" in HTMLInputElement.prototype
}

function i$4(Et) {
    if (!Et.isContentEditable) {
        if ("innerText" in Et) {
            let is = Et.innerText;
            if (!A$7()) {
                var es = "script, style",
                    ts = Et.querySelectorAll(es);
                for (let ns = 0; ns < ts.length; ns += 1) {
                    const rs = ts[ns];
                    if ("innerText" in rs) {
                        const ss = rs.innerText;
                        ss && 0 < ss.trim().length && (is = is.replace(ss, ""))
                    }
                }
            }
            return is
        }
        return Et.textContent
    }
}

function f$3(Et, es) {
    var ts = 0;
    if (ts < Et.length) return es(ts)
}

function p$a(Et, es, ts = "") {
    var is = Et.charCodeAt(es - 1),
        is = 55296 <= is && is <= 56319 ? es + 1 : es;
    return Et.length <= is ? Et : "" + Et.slice(0, is) + ts
}

function b$6(Et) {
    return 100 < Et.length ? p$a(Et, 100) + " [...]" : Et
}

function g$8(Et) {
    return Et.replace(/\s+/g, " ")
}

function d$c(Et, es) {
    return Et.ownerDocument ? Et.ownerDocument.getElementById(es) : null
}
const m$7 = [Et => {
    var es;
    if (c$6()) {
        if ("labels" in Et && Et.labels && 0 < Et.labels.length) return i$4(Et.labels[0])
    } else if (Et.id) return (es = Et.ownerDocument && f$3(Et.ownerDocument.querySelectorAll("label"), ts => ts.htmlFor === Et.id)) && i$4(es)
}, Et => {
    if (Et.nodeName === "INPUT") {
        var es = Et.getAttribute("type");
        if (es === "button" || es === "submit" || es === "reset") return Et.value
    }
}, Et => {
    if (Et.nodeName === "BUTTON" || Et.nodeName === "LABEL" || Et.getAttribute("role") === "button") return i$4(Et)
}, Et => Et.getAttribute("aria-label"), Et => {
    var es = Et.getAttribute("aria-labelledby");
    if (es) return es.split(/\s+/).map(ts => d$c(Et, ts)).filter(ts => !!ts).map(ts => i$4(ts)).join(" ")
}, Et => Et.getAttribute("alt"), Et => Et.getAttribute("name"), Et => Et.getAttribute("title"), Et => Et.getAttribute("placeholder"), Et => {
    if ("options" in Et && 0 < Et.options.length) return i$4(Et.options[0])
}];

function A$7() {
    return !T$6()
}

function T$6() {
    return !!document.documentMode
}
const y$6 = [Et => i$4(Et)],
    x$5 = 10;

function s$5(Et, es) {
    let ts = Et,
        is = 0;
    for (; is <= x$5 && ts && ts.nodeName !== "BODY" && ts.nodeName !== "HTML" && ts.nodeName !== "HEAD";) {
        for (const ns of es) {
            const rs = ns(ts);
            if (typeof rs == "string") {
                const ss = rs.trim();
                if (ss) return b$6(g$8(ss))
            }
        }
        if (ts.nodeName === "FORM") break;
        ts = ts.parentElement, is += 1
    }
}

function getActionText(Et) {
    return s$5(Et, m$7) || s$5(Et, y$6) || ""
}

function t(Et) {
    var es = Math.floor(100 * Math.random());
    return !(0 <= Et && Et <= 100) || es < Et
}
var d$b = 8;

function hex_md5(Et) {
    return p$9(w$9(k$4(Et), Et.length * d$b))
}

function w$9(Et, es) {
    Et[es >> 5] |= 128 << es % 32, Et[14 + (es + 64 >>> 9 << 4)] = es;
    for (var ts = 1732584193, is = -271733879, ns = -1732584194, rs = 271733878, ss = 0; ss < Et.length; ss += 16) {
        var os = ts,
            as = is,
            cs = ns,
            ds = rs,
            ts = v$a(ts, is, ns, rs, Et[ss + 0], 7, -680876936),
            rs = v$a(rs, ts, is, ns, Et[ss + 1], 12, -389564586),
            ns = v$a(ns, rs, ts, is, Et[ss + 2], 17, 606105819),
            is = v$a(is, ns, rs, ts, Et[ss + 3], 22, -1044525330);
        ts = v$a(ts, is, ns, rs, Et[ss + 4], 7, -176418897), rs = v$a(rs, ts, is, ns, Et[ss + 5], 12, 1200080426), ns = v$a(ns, rs, ts, is, Et[ss + 6], 17, -1473231341), is = v$a(is, ns, rs, ts, Et[ss + 7], 22, -45705983), ts = v$a(ts, is, ns, rs, Et[ss + 8], 7, 1770035416), rs = v$a(rs, ts, is, ns, Et[ss + 9], 12, -1958414417), ns = v$a(ns, rs, ts, is, Et[ss + 10], 17, -42063), is = v$a(is, ns, rs, ts, Et[ss + 11], 22, -1990404162), ts = v$a(ts, is, ns, rs, Et[ss + 12], 7, 1804603682), rs = v$a(rs, ts, is, ns, Et[ss + 13], 12, -40341101), ns = v$a(ns, rs, ts, is, Et[ss + 14], 17, -1502002290), ts = f$2(ts, is = v$a(is, ns, rs, ts, Et[ss + 15], 22, 1236535329), ns, rs, Et[ss + 1], 5, -165796510), rs = f$2(rs, ts, is, ns, Et[ss + 6], 9, -1069501632), ns = f$2(ns, rs, ts, is, Et[ss + 11], 14, 643717713), is = f$2(is, ns, rs, ts, Et[ss + 0], 20, -373897302), ts = f$2(ts, is, ns, rs, Et[ss + 5], 5, -701558691), rs = f$2(rs, ts, is, ns, Et[ss + 10], 9, 38016083), ns = f$2(ns, rs, ts, is, Et[ss + 15], 14, -660478335), is = f$2(is, ns, rs, ts, Et[ss + 4], 20, -405537848), ts = f$2(ts, is, ns, rs, Et[ss + 9], 5, 568446438), rs = f$2(rs, ts, is, ns, Et[ss + 14], 9, -1019803690), ns = f$2(ns, rs, ts, is, Et[ss + 3], 14, -187363961), is = f$2(is, ns, rs, ts, Et[ss + 8], 20, 1163531501), ts = f$2(ts, is, ns, rs, Et[ss + 13], 5, -1444681467), rs = f$2(rs, ts, is, ns, Et[ss + 2], 9, -51403784), ns = f$2(ns, rs, ts, is, Et[ss + 7], 14, 1735328473), ts = o$2(ts, is = f$2(is, ns, rs, ts, Et[ss + 12], 20, -1926607734), ns, rs, Et[ss + 5], 4, -378558), rs = o$2(rs, ts, is, ns, Et[ss + 8], 11, -2022574463), ns = o$2(ns, rs, ts, is, Et[ss + 11], 16, 1839030562), is = o$2(is, ns, rs, ts, Et[ss + 14], 23, -35309556), ts = o$2(ts, is, ns, rs, Et[ss + 1], 4, -1530992060), rs = o$2(rs, ts, is, ns, Et[ss + 4], 11, 1272893353), ns = o$2(ns, rs, ts, is, Et[ss + 7], 16, -155497632), is = o$2(is, ns, rs, ts, Et[ss + 10], 23, -1094730640), ts = o$2(ts, is, ns, rs, Et[ss + 13], 4, 681279174), rs = o$2(rs, ts, is, ns, Et[ss + 0], 11, -358537222), ns = o$2(ns, rs, ts, is, Et[ss + 3], 16, -722521979), is = o$2(is, ns, rs, ts, Et[ss + 6], 23, 76029189), ts = o$2(ts, is, ns, rs, Et[ss + 9], 4, -640364487), rs = o$2(rs, ts, is, ns, Et[ss + 12], 11, -421815835), ns = o$2(ns, rs, ts, is, Et[ss + 15], 16, 530742520), ts = F$4(ts, is = o$2(is, ns, rs, ts, Et[ss + 2], 23, -995338651), ns, rs, Et[ss + 0], 6, -198630844), rs = F$4(rs, ts, is, ns, Et[ss + 7], 10, 1126891415), ns = F$4(ns, rs, ts, is, Et[ss + 14], 15, -1416354905), is = F$4(is, ns, rs, ts, Et[ss + 5], 21, -57434055), ts = F$4(ts, is, ns, rs, Et[ss + 12], 6, 1700485571), rs = F$4(rs, ts, is, ns, Et[ss + 3], 10, -1894986606), ns = F$4(ns, rs, ts, is, Et[ss + 10], 15, -1051523), is = F$4(is, ns, rs, ts, Et[ss + 1], 21, -2054922799), ts = F$4(ts, is, ns, rs, Et[ss + 8], 6, 1873313359), rs = F$4(rs, ts, is, ns, Et[ss + 15], 10, -30611744), ns = F$4(ns, rs, ts, is, Et[ss + 6], 15, -1560198380), is = F$4(is, ns, rs, ts, Et[ss + 13], 21, 1309151649), ts = F$4(ts, is, ns, rs, Et[ss + 4], 6, -145523070), rs = F$4(rs, ts, is, ns, Et[ss + 11], 10, -1120210379), ns = F$4(ns, rs, ts, is, Et[ss + 2], 15, 718787259), is = F$4(is, ns, rs, ts, Et[ss + 9], 21, -343485551), ts = h$b(ts, os), is = h$b(is, as), ns = h$b(ns, cs), rs = h$b(rs, ds)
    }
    return Array(ts, is, ns, rs)
}

function _$2(Et, es, ts, is, ns, rs) {
    return h$b(C$8(h$b(h$b(es, Et), h$b(is, rs)), ns), ts)
}

function v$a(Et, es, ts, is, ns, rs, ss) {
    return _$2(es & ts | ~es & is, Et, es, ns, rs, ss)
}

function f$2(Et, es, ts, is, ns, rs, ss) {
    return _$2(es & is | ts & ~is, Et, es, ns, rs, ss)
}

function o$2(Et, es, ts, is, ns, rs, ss) {
    return _$2(es ^ ts ^ is, Et, es, ns, rs, ss)
}

function F$4(Et, es, ts, is, ns, rs, ss) {
    return _$2(ts ^ (es | ~is), Et, es, ns, rs, ss)
}

function h$b(Et, es) {
    var ts = (65535 & Et) + (65535 & es);
    return (Et >> 16) + (es >> 16) + (ts >> 16) << 16 | 65535 & ts
}

function C$8(Et, es) {
    return Et << es | Et >>> 32 - es
}

function k$4(Et) {
    for (var es = Array(), ts = (1 << d$b) - 1, is = 0; is < Et.length * d$b; is += d$b) es[is >> 5] |= (Et.charCodeAt(is / d$b) & ts) << is % 32;
    return es
}

function p$9(Et) {
    for (var es = "0123456789abcdef", ts = "", is = 0; is < 4 * Et.length; is++) ts += es.charAt(Et[is >> 2] >> is % 4 * 8 + 4 & 15) + es.charAt(Et[is >> 2] >> is % 4 * 8 & 15);
    return ts
}
let e$5 = {
    "3dm": "x-world/x-3dmf",
    "3dmf": "x-world/x-3dmf",
    a: "application/octet-stream",
    aab: "application/x-authorware-bin",
    aam: "application/x-authorware-map",
    aas: "application/x-authorware-seg",
    abc: "text/vndabc",
    acgi: "text/html",
    afl: "video/animaflex",
    ai: "application/postscript",
    aif: "audio/x-aiff",
    aifc: "audio/x-aiff",
    aiff: "audio/x-aiff",
    aim: "application/x-aim",
    aip: "text/x-audiosoft-intra",
    ani: "application/x-navi-animation",
    aos: "application/x-nokia-9000-communicator-add-on-software",
    aps: "application/mime",
    arc: "application/octet-stream",
    arj: "application/octet-stream",
    art: "image/x-jg",
    asf: "video/x-ms-asf",
    asm: "text/x-asm",
    asp: "text/asp",
    asx: "application/x-mplayer2",
    au: "audio/x-au",
    avi: "video/avi",
    bcpio: "application/x-bcpio",
    bin: "application/x-macbinary",
    bm: "image/bmp",
    bmp: "image/x-windows-bmp",
    boo: "application/book",
    book: "application/book",
    boz: "application/x-bzip2",
    bsh: "application/x-bsh",
    bz: "application/x-bzip",
    bz2: "application/x-bzip2",
    c: "text/plain",
    "c++": "text/plain",
    cat: "application/vndms-pki.seccat",
    cc: "text/plain",
    ccad: "application/clariscad",
    cco: "application/x-cocoa",
    cdf: "application/x-cdf",
    cer: "application/pkix-cert",
    cha: "application/x-chat",
    chat: "application/x-chat",
    class: "application/x-java-class",
    com: "application/octet-stream",
    conf: "text/plain",
    cpio: "application/x-cpio",
    cpp: "text/x-c",
    cpt: "application/x-cpt",
    crl: "application/pkcs-crl",
    crt: "application/x-x509-ca-cert",
    csh: "application/x-csh",
    css: "application/x-pointplus",
    cxx: "text/plain",
    dcr: "application/x-director",
    deepv: "application/x-deepv",
    der: "application/x-x509-ca-cert",
    dif: "video/x-dv",
    dir: "application/x-director",
    dl: "video/dl",
    doc: "application/msword",
    dot: "application/msword",
    dp: "application/commonground",
    drw: "application/drafting",
    dump: "application/octet-stream",
    dv: "video/x-dv",
    dvi: "application/x-dvi",
    dwf: "model/vnd.dwf",
    dwg: "application/acad",
    dxf: "application/dxf",
    dxr: "application/x-director",
    el: "text/x-script.elisp",
    elc: "application/x-bytecode.elisp compiled elisp)",
    env: "application/x-envoy",
    eps: "application/postscript",
    es: "application/x-esrehber",
    etx: "text/x-setext",
    evy: "application/x-envoy",
    exe: "application/octet-stream",
    f: "text/x-fortran",
    f77: "text/x-fortran",
    f90: "text/x-fortran",
    fdf: "application/vnd.fdf",
    fif: "application/fractals",
    fli: "video/x-fli",
    flo: "image/florian",
    flx: "text/vnd.fmi.flexstor",
    fmf: "video/x-atomic3d-feature",
    for: "text/x-fortran",
    fpx: "image/vnd.net-fpx",
    frl: "application/freeloader",
    funk: "audio/make",
    g: "text/plain",
    g3: "image/g3fax",
    gif: "image/gif",
    gl: "video/x-gl",
    gsd: "audio/x-gsm",
    gsm: "audio/x-gsm",
    gsp: "application/x-gsp",
    gss: "application/x-gss",
    gtar: "application/x-gtar",
    gz: "application/x-compressed",
    gzip: "application/x-gzip",
    h: "text/x-h",
    hdf: "application/x-hdf",
    help: "application/x-helpfile",
    hgl: "application/vnd.hp-hpgl",
    hh: "text/x-h",
    hlb: "text/x-script",
    hlp: "application/x-winhelp",
    hpg: "application/vnd.hp-hpgl",
    hpgl: "application/vnd.hp-hpgl",
    hqx: "application/binhex",
    hta: "application/hta",
    htc: "text/x-component",
    htm: "text/html",
    html: "text/html",
    htmls: "text/html",
    htt: "text/webviewhtml",
    htx: "text/html",
    ice: "x-conference/x-cooltalk",
    ico: "image/x-icon",
    idc: "text/plain",
    ief: "image/ief",
    iefs: "image/ief",
    iges: "application/iges",
    igs: "model/iges",
    ima: "application/x-ima",
    imap: "application/x-httpd-imap",
    inf: "application/inf",
    ins: "application/x-internett-signup",
    ip: "application/x-ip2",
    isu: "video/x-isvideo",
    it: "audio/it",
    iv: "application/x-inventor",
    ivr: "i-world/i-vrml",
    ivy: "application/x-livescreen",
    jam: "audio/x-jam",
    jav: "text/x-java-source",
    java: "text/x-java-source",
    jcm: "application/x-java-commerce",
    jfif: "image/pjpeg",
    "jfif-tbnl": "image/jpeg",
    jpe: "image/pjpeg",
    jpeg: "image/pjpeg",
    jpg: "image/pjpeg",
    jps: "image/x-jps",
    js: "application/x-javascript",
    jut: "image/jutvision",
    kar: "audio/midi",
    ksh: "application/x-ksh",
    la: "audio/x-nspaudio",
    lam: "audio/x-liveaudio",
    latex: "application/x-latex",
    lha: "application/octet-stream",
    lhx: "application/octet-stream",
    list: "text/plain",
    lma: "audio/x-nspaudio",
    log: "text/plain",
    lsp: "application/x-lisp",
    lst: "text/plain",
    lsx: "text/x-la-asf",
    ltx: "application/x-latex",
    lzh: "application/octet-stream",
    lzx: "application/octet-stream",
    m: "text/x-m",
    m1v: "video/mpeg",
    m2a: "audio/mpeg",
    m2v: "video/mpeg",
    m3u: "audio/x-mpequrl",
    man: "application/x-troff-man",
    map: "application/x-navimap",
    mar: "text/plain",
    mbd: "application/mbedlet",
    mc$: "application/x-magic-cap-package-1.0",
    mcd: "application/x-mathcad",
    mcf: "text/mcf",
    mcp: "application/netmc",
    me: "application/x-troff-me",
    mht: "message/rfc822",
    mhtml: "message/rfc822",
    mid: "application/x-midi",
    midi: "application/x-midi",
    mif: "application/x-mif",
    mime: "www/mime",
    mjf: "audio/x-vnd.audioexplosion.mjuicemediafile",
    mjpg: "video/x-motion-jpeg",
    mm: "application/x-meme",
    mod: "audio/x-mod",
    moov: "video/quicktime",
    mov: "video/quicktime",
    movie: "video/x-sgi-movie",
    mp2: "audio/x-mpeg",
    mp3: "audio/x-mpeg-3",
    mpa: "audio/mpeg",
    mpc: "application/x-project",
    mpe: "video/mpeg",
    mpeg: "video/mpeg",
    mpg: "video/mpeg",
    mpga: "audio/mpeg",
    mpp: "application/vnd.ms-project",
    mpt: "application/x-project",
    mpv: "application/x-project",
    mpx: "application/x-project",
    mrc: "application/marc",
    ms: "application/x-troff-ms",
    mv: "video/x-sgi-movie",
    my: "audio/make",
    mzz: "application/x-vnd.audioexplosion.mzz",
    nap: "image/naplps",
    naplps: "image/naplps",
    nc: "application/x-netcdf",
    ncm: "application/vnd.nokia.configuration-message",
    nif: "image/x-niff",
    niff: "image/x-niff",
    nix: "application/x-mix-transfer",
    nsc: "application/x-conference",
    nvd: "application/x-navidoc",
    o: "application/octet-stream",
    oda: "application/oda",
    omc: "application/x-omc",
    omcd: "application/x-omcdatamaker",
    omcr: "application/x-omcregerator",
    p: "text/x-pascal",
    p10: "application/x-pkcs10",
    p12: "application/x-pkcs12",
    p7a: "application/x-pkcs7-signature",
    p7c: "application/x-pkcs7-mime",
    p7m: "application/x-pkcs7-mime",
    p7r: "application/x-pkcs7-certreqresp",
    p7s: "application/pkcs7-signature",
    part: "application/pro_eng",
    pas: "text/pascal",
    pbm: "image/x-portable-bitmap",
    pcl: "application/x-pcl",
    pcx: "image/x-pcx",
    pdb: "chemical/x-pdb",
    pdf: "application/pdf",
    pfunk: "audio/make.my.funk",
    pgm: "image/x-portable-greymap",
    pic: "image/pict",
    pict: "image/pict",
    pkg: "application/x-newton-compatible-pkg",
    pko: "application/vnd.ms-pki.pko",
    pl: "text/x-script.perl",
    plx: "application/x-pixclscript",
    pm: "text/x-script.perl-module",
    pm4: "application/x-pagemaker",
    pm5: "application/x-pagemaker",
    png: "image/png",
    pnm: "application/x-portable-anymap",
    pot: "application/mspowerpoint",
    pov: "model/x-pov",
    ppa: "application/vnd.ms-powerpoint",
    ppm: "image/x-portable-pixmap",
    pps: "application/vnd.ms-powerpoint",
    ppt: "application/powerpoint",
    ppz: "application/mspowerpoint",
    pre: "application/x-freelance",
    prt: "application/pro_eng",
    ps: "application/postscript",
    psd: "application/octet-stream",
    pvu: "paleovu/x-pv",
    pwz: "application/vnd.ms-powerpoint",
    py: "text/x-script.phyton",
    pyc: "application/x-bytecode.python",
    qcp: "audio/vnd.qcelp",
    qd3: "x-world/x-3dmf",
    qd3d: "x-world/x-3dmf",
    qif: "image/x-quicktime",
    qt: "video/quicktime",
    qtc: "video/x-qtc",
    qti: "image/x-quicktime",
    qtif: "image/x-quicktime",
    ra: "audio/x-realaudio",
    ram: "audio/x-pn-realaudio",
    ras: "application/x-cmu-raster",
    rast: "image/cmu-raster",
    rexx: "text/x-script.rexx",
    rf: "image/vnd.rn-realflash",
    rgb: "image/x-rgb",
    rm: "application/vnd.rn-realmedia",
    rmm: "audio/x-pn-realaudio",
    rmp: "audio/x-pn-realaudio-plugin",
    rng: "application/vnd.nokia.ringing-tone",
    rnx: "application/vnd.rn-realplayer",
    roff: "application/x-troff",
    rp: "image/vnd.rn-realpix",
    rpm: "audio/x-pn-realaudio-plugin",
    rt: "text/vnd.rn-realtext",
    rtf: "application/x-rtf",
    rtx: "application/rtf",
    rv: "video/vnd.rn-realvideo",
    s: "text/x-asm",
    s3m: "audio/s3m",
    saveme: "application/octet-stream",
    sbk: "application/x-tbook",
    scm: "application/x-lotusscreencam",
    sdml: "text/plain",
    sdp: "application/x-sdp",
    sdr: "application/sounder",
    sea: "application/x-sea",
    set: "application/set",
    sgm: "text/x-sgml",
    sgml: "text/x-sgml",
    sh: "application/x-sh",
    shar: "application/x-shar",
    shtml: "text/x-server-parsed-html",
    sid: "audio/x-psid",
    sit: "application/x-sit",
    skd: "application/x-koan",
    skm: "application/x-koan",
    skp: "application/x-koan",
    skt: "application/x-koan",
    sl: "application/x-seelogo",
    smi: "application/smil",
    smil: "application/smil",
    snd: "audio/x-adpcm",
    sol: "application/solids",
    spc: "application/x-pkcs7-certificates",
    spl: "application/futuresplash",
    spr: "application/x-sprite",
    sprite: "application/x-sprite",
    src: "application/x-wais-source",
    ssi: "text/x-server-parsed-html",
    ssm: "application/streamingmedia",
    sst: "application/vnd.ms-pki.certstore",
    step: "application/step",
    stl: "application/vnd.ms-pki.stl",
    stp: "application/step",
    sv4cpio: "application/x-sv4cpio",
    sv4crc: "application/x-sv4crc",
    svf: "image/x-dwg",
    svr: "application/x-world",
    swf: "application/x-shockwave-flash",
    t: "application/x-troff",
    talk: "text/x-speech",
    tar: "application/x-tar",
    tbk: "application/toolbook",
    tcl: "application/x-tcl",
    tcsh: "text/x-script.tcsh",
    tex: "application/x-tex",
    texi: "application/x-texinfo",
    texinfo: "application/x-texinfo",
    text: "application/plain",
    tgz: "application/gnutar",
    tif: "image/x-tiff",
    tiff: "image/x-tiff",
    tr: "application/x-troff",
    tsi: "audio/tsp-audio",
    tsp: "application/dsptype",
    tsv: "text/tab-separated-values",
    turbot: "image/florian",
    txt: "text/plain",
    uil: "text/x-uil",
    uni: "text/uri-list",
    unis: "text/uri-list",
    unv: "application/i-deas",
    uri: "text/uri-list",
    uris: "text/uri-list",
    ustar: "application/x-ustar",
    uu: "application/octet-stream",
    uue: "text/x-uuencode",
    vcd: "application/x-cdlink",
    vcs: "text/x-vcalendar",
    vda: "application/vda",
    vdo: "video/vdo",
    vew: "application/groupwise",
    viv: "video/vivo",
    vivo: "video/vivo",
    vmd: "application/vocaltec-media-desc",
    vmf: "application/vocaltec-media-file",
    voc: "audio/x-voc",
    vos: "video/vosaic",
    vox: "audio/voxware",
    vqe: "audio/x-twinvq-plugin",
    vqf: "audio/x-twinvq",
    vql: "audio/x-twinvq-plugin",
    vrml: "application/x-vrml",
    vrt: "x-world/x-vrt",
    vsd: "application/x-visio",
    vst: "application/x-visio",
    vsw: "application/x-visio",
    w60: "application/wordperfect6.0",
    w61: "application/wordperfect6.1",
    w6w: "application/msword",
    wav: "audio/x-wav",
    wb1: "application/x-qpro",
    wbmp: "image/vnd.wap.wbmp",
    web: "application/vnd.xara",
    wiz: "application/msword",
    wk1: "application/x-123",
    wmf: "windows/metafile",
    wml: "text/vnd.wap.wml",
    wmlc: "application/vnd.wap.wmlc",
    wmls: "text/vnd.wap.wmlscript",
    wmlsc: "application/vnd.wap.wmlscriptc",
    word: "application/msword",
    wp: "application/wordperfect",
    wp5: "application/wordperfect",
    wp6: "application/wordperfect",
    wpd: "application/wordperfect",
    wq1: "application/x-lotus",
    wri: "application/x-wri",
    wrl: "application/x-world",
    wrz: "model/vrml",
    wsc: "text/scriplet",
    wsrc: "application/x-wais-source",
    wtk: "application/x-wintalk",
    xbm: "image/x-xbitmap",
    xdr: "video/x-amt-demorun",
    xgz: "xgl/drawing",
    xif: "image/vnd.xiff",
    xl: "application/excel",
    xla: "application/x-msexcel",
    xlb: "application/x-excel",
    xlc: "application/x-excel",
    xld: "application/x-excel",
    xlk: "application/x-excel",
    xll: "application/x-excel",
    xlm: "application/x-excel",
    xls: "application/excel",
    xlt: "application/excel",
    xlv: "application/x-excel",
    xlw: "application/vnd.ms-excel",
    xm: "audio/xm",
    xml: "application/xml",
    xmz: "xgl/movie",
    xpix: "application/x-vnd.ls-xpix",
    xpm: "image/x-xpixmap",
    "x-png": "image/png",
    xsr: "video/x-amt-showrun",
    xwd: "image/x-xwindowdump",
    xyz: "chemical/x-pdb",
    z: "application/x-compressed",
    zip: "multipart/x-zip",
    zoo: "application/octet-stream",
    zsh: "text/x-script.zsh"
};

function getMineTypeByHeader(Et, es = "text/html") {
    return isEmpty(Et) ? es : (Et["Content-Type"] || Et["content-type"] || es).split(";")[0].trim()
}

function getMineTypeByUrl(Et) {
    var es = "text/html";
    return isEmpty(Et) ? es : l$3(c$5(Et), es)
}

function c$5(Et) {
    if (isEmpty(Et)) return "";
    let es = "",
        ts = Et.lastIndexOf(".");
    if (ts != -1) {
        let is = Et.indexOf("?", ts);
        is == -1 && (is = Et.length), es = Et.substring(ts + 1, is)
    }
    return es
}

function l$3(Et, es) {
    return isEmpty(Et) || isEmpty(Et = e$5[Et]) ? es : Et
}

function getRandom(Et) {
    return Et < 0 ? NaN : Et <= 30 ? 0 | Math.random() * (1 << Et) : Et <= 53 ? (0 | Math.random() * (1 << 30)) + (0 | Math.random() * (1 << Et - 30)) * (1 << 30) : NaN
}

function r$4(Et, es) {
    for (var ts = Et.toString(16), is = es - ts.length, ns = "0"; 0 < is; is >>>= 1, ns += ns) 1 & is && (ts = ns + ts);
    return ts
}

function uuid() {
    return r$4(getRandom(32), 8) + "-" + r$4(getRandom(16), 4) + "-" + r$4(16384 | getRandom(12), 4) + "-" + r$4(32768 | getRandom(14), 4) + "-" + r$4(getRandom(48), 12)
}

function uuidWithLength(Et) {
    return Et == 16 ? r$4(getRandom(32), 8) + r$4(getRandom(32), 8) : Et == 32 ? r$4(getRandom(32), 8) + r$4(getRandom(32), 8) + r$4(getRandom(32), 8) + r$4(getRandom(32), 8) : void 0
}

function skyUuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, Et => {
        var es = 16 * Math.random() | 0;
        return (Et === "x" ? es : 3 & es | 8).toString(16)
    })
}

function buildViewID() {
    return Date.now().toString(36) + Math.ceil(1e3 * Math.random()).toString(16)
}

function enBase64(Et) {
    for (var es = [], ts = 0, is = (Et = new TextEncoder().encode(Et)).length; ts < is; ts += 4096) es.push(String.fromCharCode.bind(String).apply(null, Et.subarray(ts, ts + 4096)));
    return btoa(es.join(""))
}

function traceId(Et) {
    return 0 <= Et && Et <= 100 && t(Et) ? "00-" + r$4(getRandom(32), 8) + r$4(getRandom(32), 8) + r$4(getRandom(32), 8) + r$4(getRandom(32), 8) + "-" + r$4(getRandom(32), 8) + r$4(getRandom(32), 8) + "-01" : "00-" + r$4(getRandom(32), 8) + r$4(getRandom(32), 8) + r$4(getRandom(32), 8) + r$4(getRandom(32), 8) + "-" + r$4(getRandom(32), 8) + r$4(getRandom(32), 8) + "-00"
}
var $global = window || {};

function isDefined(Et) {
    return Et != null
}

function log(Et, es) {
    (es || isDefined(window.BonreeAgent) && isDefined(window.BonreeAgent.isDebuge) || isDefined(window.BonreeClient) && isDefined(window.BonreeClient.isDebuge)) && isDefined(window.console) && (window.console.$bonree = !0, console.log(Et), window.console.$bonree = !1)
}

function extend(Et, es) {
    return Et && es && forEachOwn(es, function (ts, is) {
        Et[is] = ts
    }), Et
}

function isString(Et) {
    return typeof Et == "string"
}

function isJSON(Et) {
    if (isString(Et)) try {
        var es = JSON.parse(Et);
        return !(typeof es != "object" || !es)
    } catch (ts) {
        return !1
    }
}

function NIL_FN() {}

function hasOwnProperty(Et, es) {
    return Et && Object.prototype.hasOwnProperty.call(Et, es)
}

function isObject(Et) {
    return typeof Et == "object"
}

function overwrite(Et, es) {
    return Et && es && forEachOwn(es, function (ts, is) {
        hasOwnProperty(Et, is) && (Et[is] = ts)
    }), Et
}

function forEachOwn(Et, es, ts) {
    if (isDefined(Et)) {
        for (var is in Et)
            if (hasOwnProperty(Et, is)) {
                var ns = Et[is];
                try {
                    if (es(ns, is) === !1) break
                } catch (rs) {
                    log("3333", rs)
                }
            } ts && ts()
    }
}

function isFunction(Et) {
    return typeof Et == "function"
}

function isArray(Et) {
    return isDefined(Et) && Et instanceof Array
}

function forEach(Et, es, ts) {
    return (isArray(Et) ? forEachArray : forEachOwn)(Et, es, ts)
}

function forEachArray(Et, es, ts) {
    if (isArray(Et)) {
        for (var is = 0, ns = Et.length; is < ns && es(Et[is], is) !== !1; is++);
        ts && ts()
    }
}

function bind(Et, es) {
    return function () {
        return Et.apply(es, arguments)
    }
}

function isEmpty(Et) {
    if (isDefined(Et)) {
        if (hasOwnProperty(Et, "length")) return !Et.length;
        if (hasOwnProperty(Et, "size")) return !Et.size;
        for (var es in Et)
            if (hasOwnProperty(Et, es)) return !1
    }
    return !0
}

function setCookie(Et, es, ts) {
    try {
        var is = Et + "=" + es;
        isDefined((ts = ts || {}).domain) && (is += ";domain=" + ts.domain), isDefined(ts.path) && (is += ";path=" + ts.path), isDefined(ts.expires) && (typeof ts.expires == "string" ? is += ";expires=" + ts.expires : is += ";expires=" + ts.expires.toUTCString()), document.cookie = is, window.sessionStorage && window.sessionStorage.setItem(Et, es), window.localStorage && window.localStorage.setItem(Et, es)
    } catch (ns) {
        log("C107")
    }
}

function getLocaStore(Et) {
    let es = "";
    return es = window.localStorage ? window.localStorage.getItem(Et) || "" : es
}

function getCookie(Et) {
    try {
        var es = document.cookie.split(/;\s?/);
        if (document.cookie)
            for (var ts = 0, is = es.length; ts < is; ts++) {
                var ns = es[ts].split("="),
                    rs = ns[0],
                    ss = ns[1];
                if (rs === Et && isDefined(ss)) return ss
            }
        return getSession(Et) || ""
    } catch (os) {
        return log("C108"), ""
    }
}

function getSession(Et) {
    let es = "";
    return es = window.sessionStorage && isDefined(es = window.sessionStorage.getItem(Et) || "") && es != "" ? es : getLocaStore(Et) || ""
}

function setLocalStore(Et, es) {
    window.localStorage && window.localStorage.setItem(Et, es)
}

function isReadable(Et) {
    return isDefined(Et) && !isEmpty(Et)
}

function dateNow() {
    return Date.now ? Date.now() : new Date().getTime()
}
var nowtime = function () {
    var Et = dateNow();
    return function (es) {
        var ts;
        return isDefined($global.performance) && isDefined($global.performance.now) && isDefined($global.performance.timing) ? [1e3 * (ts = es === 0 ? 0 : Math.round($global.performance.now())), 1e3 * (ts + $global.performance.timing.navigationStart)] : [1e3 * ((ts = es === 0 ? Et : dateNow()) - Et), 1e3 * ts]
    }
}();

function now(Et) {
    return nowtime(Et)[1]
}

function tillNow(Et) {
    return nowtime(Et)[0]
}

function getTime() {
    var Et = nowtime();
    return {
        startTime: Et[0],
        timestamp: Et[1]
    }
}

function args(Et) {
    return isDefined(Et.length) ? Array.prototype.slice.call(Et) : Et
}

function map(Et, es) {
    var ts = [];
    return forEach(Et, function (is, ns) {
        is = es && es(is, ns), isDefined(is) && ts.push(is)
    }), ts
}
var getFixedMetric = function (Et, es) {
        return Et = Et[es], isDefined(Et) && 0 < Et ? Math.round(Et) : 0
    },
    getContentSize = function (Et) {
        return isDefined(Et) ? window.ArrayBuffer && Et instanceof ArrayBuffer ? Et.byteLength : window.Blob && Et instanceof Blob ? Et.size : Et.toJSON ? stringify(Et.toJSON()).length : Et.length || 0 : 0
    },
    getRequestParam = function (Et) {
        if (!isDefined(Et)) return "";
        var es = "";
        if (typeof Et == "string") es = Et;
        else if (window.FormData && Et instanceof FormData) {
            var ts = {};
            try {
                forEach(iterate(Et.entries()), function (ss) {
                    var ns, rs = ss[0],
                        ss = ss[1];
                    window.File && ss instanceof File ? 0 < ss.size && (ns = ss.name ? " " + ss.name : "", ts[rs] = "[File]" + ns) : ts[rs] = ss
                })
            } catch (is) {
                ts = {}, log("C145")
            }
            es = "[FormData] " + stringify(ts)
        } else {
            if (window.Blob && Et instanceof Blob) return "[Blob]";
            if (window.ArrayBuffer && Et instanceof ArrayBuffer) return "[ArrayBuffer]";
            if (Et.toJSON) es = stringify(Et.toJSON());
            else {
                if (!Et.toString) return "[unknown]";
                es = Et.toString()
            }
        }
        return withLength(es, 2e3)
    };

function getIP(Et) {
    return Et ? (Et = Et.split("?")[0], /(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\:([0-9]{1,5})/.test(Et) ? [`${RegExp.$1}.${RegExp.$2}.${RegExp.$3}.` + RegExp.$4, Number(RegExp.$5)] : /\:([0-9]{1,5})/.test(Et) ? ["", Number(RegExp.$1)] : -1 < Et.indexOf("https") ? ["", 443] : ["", 80]) : ["", ""]
}

function getUrl(Et = "") {
    return window.location.protocol !== "file:" || startWith(Et, "http") ? isDefined(Et) && Et.indexOf("http") === 0 ? Et : /^\/{2}/.test(Et) ? window && window.location.protocol + Et || "http:" + Et : /^\?/.test(Et) ? window && window.location.origin + window.location.pathname + Et || Et : /^\/{1}/.test(Et) ? window && window.location.origin + Et || Et : /^\.{1,}/.test(Et) ? window && window.location.origin + Et.replace(/^(\.{1,}\/){1,}/, "/") || Et : isDefined(Et) && window && window.location.origin + "/" + Et || Et : Et || window && window.location.href + Et
}
var stringify = isDefined($global.JSON) ? $global.JSON.stringify : function (Et) {
    var es, ts, is = typeof Et;
    return is == "undefined" ? '"undefined"' : is == "boolean" ? Et ? "true" : "false" : is == "number" ? Et.toString() : is == "string" ? '"' + (es = Et.replace(/(["\\])/g, "\\$1").replace(/\r/g, "\\r").replace(/\n/g, "\\n")) + '"' : is == "object" ? Et ? Et instanceof Array ? (es = "[", forEach(Et, function (ns, rs) {
        0 < rs && (es += ","), es += stringify(ns)
    }), es += "]") : (es = "{", ts = 0, forEachOwn(Et, function (ns, rs) {
        0 < ts && (es += ","), es += stringify(rs) + ":" + stringify(ns), ts++
    }), es += "}") : "null" : "[none]"
};

function addListener(Et, es, ts, is) {
    Et && Et.addEventListener && Et.addEventListener(es, ts, is)
}

function on$1(Et, es, ts, is) {
    if (Et && Et.addEventListener) return Et.addEventListener(es, ts, is);
    Et && Et.attachEvent && Et.attachEvent("on" + es, ts)
}

function delay(Et, es) {
    return Et.$$original = !0, setTimeout(Et, isDefined(es) ? es : 0)
}

function last(Et) {
    if (isArray(Et) && !isEmpty(Et)) return Et[Et.length - 1]
}
var unicode = function (Et) {
        for (var es = "", ts = 0; ts < Et.length; ts++) es += "\\u" + ("0000" + Et.charCodeAt(ts).toString(16)).slice(-4);
        return es
    },
    hack = function (Et, es, ts, is) {
        var ns;
        return (Et = isDefined(Et) ? Et : function () {}).$$original ? Et : ((ns = function () {
            var rs, ss = args(arguments);
            try {
                return isDefined(es) && es.apply(this, ss), Et.apply(this, ss)
            } catch (os) {
                isDefined(is) ? is.apply(this, ss.concat(os)) : (rs = os, isDefined(window.console) && (window.console.$bonree = !0, (isDefined(window.console.error) ? window.console.error(rs) : NIL_FN)(rs), window.console.$bonree = !1))
            } finally {
                if (isDefined(ts) && ts.apply(this, ss), ss && ss[0] && ss[0] instanceof Error && Et && Et.name !== "error") throw ss[0]
            }
        }).$$original = Et, ns)
    },
    xpath = function (Et) {
        if (!Et) return "";
        var es = Et.id;
        if (es) return '//*[@id="' + es + '"]';
        for (var ts = [], is = Et; is;) {
            var ns = is.tagName && is.tagName.toLowerCase && is.tagName.toLowerCase() || null;
            if (!ns) break;
            var rs = is.parentElement && is.parentElement || null;
            if (!isDefined(rs)) {
                ts.unshift(ns);
                break
            }
            for (var ss = rs.children, os = ss.length, as = 0, cs = 0, ds = 0; ds < os; ds++) {
                var fs = ss[ds];
                if (fs.tagName.toLowerCase() === ns && (cs++, 0 < as)) break;
                fs === is && (as = cs)
            }
            ts.unshift(cs === 1 ? ns : ns + "[" + as + "]"), is = rs
        }
        return "/" + ts.join("/")
    },
    prop = function (Et, es) {
        return isDefined(Et) && hasOwnProperty(Et, es) ? Et[es] : null
    };

function includes(Et, es) {
    for (let ts = 0, is = Et.length; ts < is; ++ts)
        if (Et[ts] === es) return !0;
    return !1
}

function isObj(Et) {
    return typeof Et == "object"
}

function getUserAgent() {
    try {
        var Et = {
                Chrome: /Chrome/,
                IE: /MSIE/,
                Firefox: /Firefox/,
                Opera: /Presto/,
                Safari: /Version\/([\d.]+).*Safari/,
                360: /360SE/,
                QQBrowswe: /QQ/
            },
            es = {
                iPhone: /iPhone/,
                iPad: /iPad/,
                Android: /Android/,
                Windows: /Windows/,
                Mac: /Macintosh/
            },
            ts = navigator && navigator.userAgent;
        if (!ts) return null;
        var is, ns, rs = {
            browserName: "",
            browserVersion: "",
            osName: "",
            osVersion: "",
            deviceName: ""
        };
        for (is in Et) Et[is].test(ts) && (rs.browserName = is, is === "Chrome" ? rs.browserVersion = ts.split("Chrome/")[1].split(" ")[0] : is === "IE" ? rs.browserVersion = ts.split("MSIE ")[1].split(" ")[1] : is === "Firefox" ? rs.browserVersion = ts.split("Firefox/")[1] : is === "Opera" ? rs.browserVersion = ts.split("Version/")[1] : is === "Safari" ? rs.browserVersion = ts.split("Version/")[1].split(" ")[0] : is === "360" ? rs.browserVersion = "" : is === "QQBrowswe" && (rs.browserVersion = ts.split("Version/")[1].split(" ")[0]));
        for (ns in es) es[ns].test(ts) && (rs.osName = ns, ns === "Windows" ? rs.osVersion = ts.split("Windows NT ")[1].split(";")[0] : ns === "Mac" ? rs.osVersion = ts.split("Mac OS X ")[1].split(")")[0] : ns === "iPhone" ? rs.osVersion = ts.split("iPhone OS ")[1].split(" ")[0] : ns === "iPad" ? rs.osVersion = ts.split("iPad; CPU OS ")[1].split(" ")[0] : ns === "Android" && (rs.osVersion = ts.split("Android ")[1].split(";")[0], rs.deviceName = ts.split("(Linux; Android ")[1].split("; ")[1].split(" Build")[0]));
        return rs
    } catch (ss) {
        log("C123")
    }
}

function getElementForNum(Et, es) {
    var ts;
    return isObj(Et) ? (ts = {}, Object.keys(Et).map((is, ns) => {
        ns <= es && (ts[is] = Et[is])
    }), ts) : {}
}

function iterate(Et) {
    var es = [];
    if (isDefined(Et) && isDefined(Et.next))
        for (var ts = Et.next(); !ts.done;) es.push(ts.value), ts = Et.next();
    return es
}

function readBytesFromStream(Et, es, ts) {
    if (!Et.getReader) return 0;
    const is = Et.getReader(),
        ns = [];
    let rs = 0;

    function ss() {
        var os;
        is.cancel().catch(noop); {
            let as;
            if (ns.length === 1) as = ns[0];
            else {
                as = new Uint8Array(rs);
                let cs = 0;
                ns.forEach(ds => {
                    as.set(ds, cs), cs += ds.length
                })
            }
            return os = as.slice(0, es.bytesLimit), as.length, es.bytesLimit, os.length
        }
    }(function os() {
        is.read().then(as => {
            var cs;
            as.done ? (cs = ss(), ts(cs)) : (ns.push(as.value), (rs += as.value.length) > es.bytesLimit ? (cs = ss(), ts(cs)) : os())
        })
    })()
}

function noop() {}

function tryToClone(Et) {
    try {
        return Et.clone()
    } catch (es) {}
}

function set_64_keys(data, emit) {
    var reData = {},
        keys;
    if (isDefined(data)) {
        if (typeof data == "string" && data !== "") {
            if (data = eval("(" + data + ")"), !isJSON(data)) return data;
            data = JSON.parse(data)
        }
        return typeof data != "object" ? data : (keys = Object.keys(data), keys.length > emit ? (keys = keys.slice(0, emit), keys.forEach(function (Et) {
            reData[Et] = data[Et]
        }), reData) : data)
    }
    return reData
}

function filter(Et, es) {
    var ts = [];
    return forEach(Et, function (is, ns) {
        es && es(is, ns) === !0 && ts.push(is)
    }), ts
}

function setDeviceForLog(Et) {
    window.bonreeRUM && Et && (window.bonreeRUM.fingerId = Et)
}

function size(Et) {
    if (Et) {
        if (typeof Et == "string") return strSize(Et);
        if (Et instanceof ArrayBuffer) return Et.byteLength;
        if (isObject(Et)) {
            let es = "";
            try {
                es = JSON.stringify(Et)
            } catch (ts) {}
            return strSize(es)
        }
    }
    return 0
}

function strSize(Et) {
    let es = 0;
    for (let is = 0, ns = Et.length; is < ns; is++) {
        var ts = Et.charCodeAt(is);
        es += ts <= 127 ? 1 : ts <= 2047 ? 2 : ts <= 65535 ? 3 : 4
    }
    return es
}

function trim(Et) {
    return Et ? String.prototype.trim ? String.prototype.trim.call(Et) : Et.toString().replace(/(^\s+)|(\s+$)/g, "") : ""
}

function startWith(Et, es) {
    return !(!Et || !Et.indexOf) && Et.indexOf(es) === 0
}

function endWith(Et, es) {
    return !!areUrlsEqual(Et, es) || !!(Et && es && Et.length >= es.length) && (Et.slice(-1) === "/" && (es += "/"), Et.substring(Et.length - es.length) === es)
}

function areUrlsEqual(Et, es) {
    try {
        var ts = new URL(Et),
            is = new URL(es);
        return ts.protocol === is.protocol && ts.host === is.host && ts.pathname === is.pathname && ts.search === is.search && ts.hash === is.hash
    } catch (ns) {
        return !1
    }
}

function withLength(Et, es) {
    try {
        return Et ? Et.length <= es ? Et : Et.substr(0, es - 3) + "..." : ""
    } catch (ts) {
        return "The data cannot be parsed normally, please handle it manually"
    }
}

function toUpper(Et, es) {
    return isDefined(es) || (es = ""), Et && Et.toUpperCase ? Et.toUpperCase() : es
}

function toLower(Et, es) {
    return isDefined(es) || (es = ""), Et && Et.toLowerCase ? Et.toLowerCase() : es
}
var stringify = isDefined(window.JSON) ? window.JSON.stringify : function (Et) {
    var es, ts, is = typeof Et;
    return is == "undefined" ? '"undefined"' : is == "boolean" ? Et ? "true" : "false" : is == "number" ? Et.toString() : is == "string" ? '"' + (es = Et.replace(/(["\\])/g, "\\$1").replace(/\r/g, "\\r").replace(/\n/g, "\\n")) + '"' : is == "object" ? Et ? Et instanceof Array ? (es = "[", forEach(Et, function (ns, rs) {
        0 < rs && (es += ","), es += stringify(ns)
    }), es += "]") : (es = "{", ts = 0, forEachOwn(Et, function (ns, rs) {
        0 < ts && (es += ","), es += stringify(rs) + ":" + stringify(ns), ts++
    }), es += "}") : "null" : "[none]"
};

function toString(Et) {
    return typeof Et == "string" ? Et : JSON.stringify(Et)
}

function set_length(Et, es) {
    return Et && (Et.length > es ? Et.slice(0, es) : Et)
}

function getDataSize(Et, es) {
    return typeof Et != "string" && (Et = JSON.stringify(Et)), Et = new Blob([Et]).size / 1048576, isDefined(es) ? Et < es : Et
}

function isNumber(Et) {
    return typeof Et == "number" && !isNaN(Et)
}

function isRightTimestamp(Et) {
    return isNumber(Et) && isFinite(Et) && 0 <= Et
}

function i$3(Et, es) {
    return Et = JSON.parse(Et), Et.k = es, Et
}

function checkMoudle(Et) {
    return !(!isDefined(f$1.secondSett) || !isDefined(f$1.secondSett.mn)) && f$1.secondSett.mn.indexOf(Et) !== -1
}
const v$9 = {
    addAtt: function (Et) {
        try {
            var es = f$1.secondSett;
            if (!getDataSize(Et, 5)) return !1;
            S$5(es.osType) ? window.webkit.messageHandlers.brsWKAddEventAttributes.postMessage(stringify(Et)) : w$6(es.osType) || window.bonreePrivateInterface.addEventAttribute(stringify(Et))
        } catch (ts) {}
    },
    delAtt: function (Et) {
        try {
            var es = f$1.secondSett;
            if (!getDataSize(Et, 5)) return !1;
            S$5(es.osType) ? window.webkit.messageHandlers.brsWKRemoveEventAttributes.postMessage(stringify(Et)) : w$6(es.osType) || window.bonreePrivateInterface.removeEventAttribute(stringify(Et))
        } catch (ts) {}
    },
    delAttAll: function () {
        try {
            var Et = f$1.secondSett;
            S$5(Et.osType) ? window.webkit.messageHandlers.brsWKRemoveAllEventAttributes.postMessage("") : w$6(Et.osType) || window.bonreePrivateInterface.removeAllEventAttributes()
        } catch (es) {}
    },
    setUserProperty: function (Et) {
        try {
            var es = f$1.secondSett;
            if (!getDataSize(Et, 5)) return !1;
            S$5(es.osType) ? window.webkit.messageHandlers.brsWKUserChangeEvent.postMessage(Et) : w$6(es.osType) || window.bonreePrivateInterface.webViewEventBus(stringify({
                userchange: [i$3(Et, "userchange")]
            }), es.webviewID)
        } catch (ts) {}
    },
    shadeArea: function (Et, es) {
        try {
            var ts = {
                sensitiveInfos: {
                    masks: Et
                }
            };
            if (!getDataSize(ts, 5)) return !1;
            S$5(es.osType) ? window.webkit.messageHandlers.brsWKSensitiveInfos.postMessage(stringify(ts)) : w$6(es.osType) || window.bonreePrivateInterface.webViewEventBus(stringify(ts), es.webviewID)
        } catch (is) {}
    },
    log: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        try {
            S$5(es.osType) ? window.webkit.messageHandlers.brsWKLog.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                log: Et
            })) : window.bonreePrivateInterface.log(Et)
        } catch (ts) {}
    },
    webviewPerformanceTimingEvent: function (Et, es, ts) {
        if (!getDataSize(Et, 5)) return !1;
        if (checkMoudle("h5")) {
            this.log("webviewPerformanceTimingEvent=>" + Et, es);
            try {
                S$5(es.osType) ? window.webkit.messageHandlers.brsWKWebviewPerformanceTimingEvent.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                    h5: [i$3(Et, "h5")],
                    imd: ts
                })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                    h5: [i$3(Et, "h5")],
                    imd: ts
                }), es.webviewID)
            } catch (is) {}
        }
    },
    webviewJSErrorEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        if (checkMoudle("jserror")) {
            this.log("webviewJSErrorEvent=>" + Et, es);
            try {
                S$5(es.osType) ? window.webkit.messageHandlers.brsWKWebviewJSErrorEvent.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                    jserror: [i$3(Et, "jserror")]
                })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                    jserror: [i$3(Et, "jserror")]
                }), es.webviewID)
            } catch (ts) {}
        }
    },
    NetworkEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        if (checkMoudle("network")) {
            this.log("NetworkEvent=>" + Et);
            try {
                S$5(es.osType) ? window.webkit.messageHandlers.brsWKAjaxPerformanceTimingEvent.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                    network: [i$3(Et, "network")]
                })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                    network: [i$3(Et, "network")],
                    imd: 2
                }), es.webviewID)
            } catch (ts) {}
        }
    },
    webviewActionEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        if (checkMoudle("action")) {
            this.log("webviewActionEvent=>" + Et, es);
            var ts = JSON.parse(Et);
            try {
                S$5(es.osType) ? (isDefined(ts.v.ice) ? ts.v.isa = !0 : ts.v.isa = !1, window.webkit.messageHandlers.brsWKWebviewActionEvent.postMessage(stringify(ts))) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                    action: [i$3(Et, "action")]
                })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                    action: [i$3(Et, "action")]
                }), es.webviewID)
            } catch (is) {}
        }
    },
    webviewPageEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        this.log("webviewPageEvent=>" + Et);
        try {
            S$5(es.osType) ? window.webkit.messageHandlers.brsWKWebviewPageEvent.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                view: [i$3(Et, "view")]
            })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                view: [i$3(Et, "view")]
            }), es.webviewID)
        } catch (ts) {}
    },
    routeChangeData: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        if (checkMoudle("routechange")) {
            this.log("routeChangeData=>" + Et, es);
            try {
                S$5(es.osType) ? window.webkit.messageHandlers.brsWKRouteChangeEvent.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                    routechange: [i$3(Et, "routechange")]
                })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                    routechange: [i$3(Et, "routechange")]
                }), es.webviewID)
            } catch (ts) {}
        }
    },
    consoleEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        if (checkMoudle("console")) {
            this.log("consoleData=>", Et, es);
            try {
                S$5(es.osType) ? window.webkit.messageHandlers.brsWKConsoleEvent.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                    console: [i$3(Et, "console")]
                })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                    console: [i$3(Et, "console")]
                }), es.webviewID)
            } catch (ts) {}
        }
    },
    spanEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        if (checkMoudle("span")) {
            this.log("spanData=>" + Et, es);
            try {
                S$5(es.osType) ? window.webkit.messageHandlers.brsWKSpanEvent.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                    span: [i$3(Et, "span")]
                })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                    span: [i$3(Et, "span")]
                }), es.webviewID)
            } catch (ts) {}
        }
    },
    customLogEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        this.log("setCustomLog=>" + Et);
        try {
            S$5(es.osType) ? window.webkit.messageHandlers.brsWKSetCustomLog.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                customlog: [i$3(Et, "customlog")]
            })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                customlog: [i$3(Et, "customlog")]
            }), es.webviewID)
        } catch (ts) {}
    },
    customMetricEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        this.log("setCustomMetric=>" + Et);
        try {
            S$5(es.osType) ? window.webkit.messageHandlers.brsWKSetCustomMetric.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                custommetric: [i$3(Et, "custommetric")]
            })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                custommetric: [i$3(Et, "custommetric")]
            }), es.webviewID)
        } catch (ts) {}
    },
    customExceptionEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        this.log("setCustomException=>" + Et);
        try {
            S$5(es.osType) ? window.webkit.messageHandlers.brsWKSetCustomException.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                crash: [i$3(Et, "crash")]
            })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                crash: [i$3(Et, "crash")]
            }), es.webviewID)
        } catch (ts) {}
    },
    customSpeedTestEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        this.log("speedTest=>" + Et);
        try {
            S$5(es.osType) ? window.webkit.messageHandlers.brsWKsetCustomSpeedTest.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                speedtest: [i$3(Et, "speedtest")]
            })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                speedtest: [i$3(Et, "speedtest")]
            }), es.webviewID)
        } catch (ts) {}
    },
    customEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        this.log("setCustomEvent=>" + Et);
        try {
            S$5(es.osType) ? window.webkit.messageHandlers.brsWKsetCustomEvent.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                customevent: [i$3(Et, "customevent")]
            })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                customevent: [i$3(Et, "customevent")]
            }), es.webviewID)
        } catch (ts) {}
    },
    MainDocumentNetworkEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        this.log("MainDocumentNetworkEvent=>" + Et);
        try {
            var ts;
            S$5(es.osType) ? ((ts = JSON.parse(Et)).imd = 1, window.webkit.messageHandlers.brsWKMainDocumentNetworkEvent.postMessage(stringify(ts))) : w$6(es.osType) ? window.bonreePrivateInterface.call(stringify({
                network: [i$3(Et, "network")],
                imd: 1
            })) : window.bonreePrivateInterface.webViewEventBus(stringify({
                network: [i$3(Et, "network")],
                imd: 1
            }), es.webviewID)
        } catch (is) {}
    },
    ResourceNetworkEvent: function (Et, es) {
        if (!getDataSize(Et, 5)) return !1;
        this.log("ResourceNetworkEvent=>" + Et);
        try {
            S$5(es.osType) ? window.webkit.messageHandlers.brsWKResourceNetworkEvent.postMessage(Et) : w$6(es.osType) ? window.bonreePrivateInterface.call(Et) : window.bonreePrivateInterface.webViewEventBus(Et, es.webviewID)
        } catch (ts) {}
    }
};

function a$5(Et, es) {
    let ts = null;
    return ts = (ts = Et.Zone && typeof Et.Zone.__symbol__ == "function" ? Et[Et.Zone.__symbol__(es)] : ts) || Et[es]
}

function getMutationObserver() {
    let Et = null;
    var es;
    return window.Zone && (Et = a$5(window, "MutationObserver")), window.MutationObserver && Et === window.MutationObserver && (es = a$5(new window.MutationObserver(function () {}), "originalInstance"), Et = es && es.constructor), Et = Et || window.MutationObserver
}
class PageActivityManager {
    constructor(es) {
        this.mutationRecord = [], this.performanceRecord = [], this.record = !1, this.unlocked = !0, window.PerformanceObserver && (this.PerformanceObserver = new PerformanceObserver(ns => {
            var ns = ns.getEntries(),
                rs = isDefined(window.$bonreeReplayUrl) ? window.$bonreeReplayUrl : null;
            ns.some(ss => ss.entryType === "resource") && this.record && (this.performanceRecord.push(now()), isDefined(es)) && es(ns.filter(function (ss) {
                return ss.entryType === "resource" && !d$a([f$1.sett.uploadAddrHttp, f$1.sett.uploadAddrHttps, rs], ss.name.split("?")[0])
            }))
        }));
        var ts = getMutationObserver();
        isDefined(ts) && (this.mutationObserver = new ts(is => {
            0 < this.mutationRecord.lengths && this.stopPageActivityObserver(1), this.record && this.mutationRecord.push(now())
        }))
    }
    startPageActivityObserver() {
        window.PerformanceObserver && this.PerformanceObserver.observe({
            entryTypes: ["resource"]
        }), this.mutationObserver.observe(window.document, {
            attributes: !0,
            attributeOldValue: !0,
            characterData: !0,
            characterDataOldValue: !0,
            childList: !0,
            subtree: !0
        })
    }
    turnOnRecord() {
        this.record = !0
    }
    turnOffRecord() {
        this.record = !1, this.mutationRecord = [], this.performanceRecord = []
    }
    stopPageActivityObserver(es) {
        (isDefined(es) || (window.PerformanceObserver && this.PerformanceObserver.disconnect(), isDefined(this.mutationObserver))) && this.mutationObserver.disconnect()
    }
}

function d$a(Et, es) {
    return -1 < Et.indexOf(es)
}

function checkRecord(Et, es) {
    if (!(Et.length === 0 || Et[Et.length - 1] < es)) {
        for (var ts = 0; ts <= Et.length; ts++)
            if (0 <= (Et[ts] - es) / 1e3) return !0
    }
    return !1
}
var u$4 = new PageActivityManager;
let A$6 = class {
        constructor() {
            this.isOpen = !1, this.isScroll = !1, this.elements = ["input", "textarea", "select"], this.stl = null, this.isFirst = !0, this.lastTime = 0, this.observer = null
        }
        isStart(Et) {
            this.isOpen = Et;
            let es = this,
                ts = ns => {
                    window.removeEventListener("scroll", this.checkElement.bind(es)), isDefined(ns) && (ns.disconnect(), this.observer = null)
                };
            var is = getMutationObserver();
            Et ? (ts.call(this, this.observer), setTimeout(() => {
                es.observer = new is(ns => {
                    es.checkElement.bind(es)
                }), es.observer.observe(window.document, {
                    attributes: !0,
                    attributeOldValue: !0,
                    characterData: !0,
                    characterDataOldValue: !0,
                    childList: !0,
                    subtree: !0
                })
            }, 200), setTimeout(() => {
                es.checkElement.call(es)
            }, 500), this.listenScroll()) : ts.call(this, this.observer)
        }
        listenScroll() {
            let Et = null,
                es = this,
                ts = () => {
                    this.isScroll = !1, this.checkElement.call(es)
                };
            document && document.body && document.body.addEventListener("scroll", function () {
                clearTimeout(Et), es.isScroll = !0, Et = setTimeout(ts.bind(es), 300)
            }), window && window.addEventListener && window.addEventListener("scroll", function () {
                clearTimeout(Et), es.isScroll = !0, Et = setTimeout(ts.bind(es), 300)
            })
        }
        checkElement() {
            let Et = [],
                es = () => {
                    if (!this.isScroll) {
                        var is = document.querySelectorAll("input"),
                            ns = document.querySelectorAll("textarea"),
                            rs = document.querySelectorAll("select"),
                            ss = Array.prototype.concat(Array.from(is), Array.from(ns), Array.from(rs)),
                            os = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                            as = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                        for (let ds = 0, fs = ss.length - 1; ds <= fs; ds++) {
                            var cs = this.calculatedCoordinates(ss[ds], os, as);
                            isDefined(cs) && Et.push(cs)
                        }
                        v$9.shadeArea(Et, f$1.secondSett)
                    }
                };
            this.isFirst && (es.call(this), this.isFirst = !1);
            var ts = Date.now();
            return 50 < ts - this.lastTime && es.call(this), this.lastTime = ts, {
                sensitiveInfos: {
                    masks: Et
                }
            }
        }
        calculatedCoordinates(Et, es, ts) {
            if (isDefined(Et) && isDefined(es) && isDefined(ts)) try {
                var is = Et.getClientRects()[0];
                if (isDefined(is) && isDefined(is.x) && isDefined(is.y) && isDefined(is.width) && isDefined(is.height)) {
                    let ns = is.x,
                        rs = is.y,
                        ss = is.width,
                        os = is.height,
                        as = is.bottom,
                        cs = is.right;
                    return ns > es || rs > ts || as < 0 || cs < 0 ? null : (ns <= 0 && rs <= 0 ? (ss += ns, ns = 0, os += rs, rs = 0, ss > es && (ss = es), os > ts && (os = ts)) : ns <= 0 && 0 < rs ? (ss += ns, ns = 0, ss > es && (ss = es), os + rs > ts && (os = ts - rs)) : 0 < ns && rs <= 0 && (os += rs, rs = 0, ss + ns > es && (ss = es - ns), os > ts) && (os = ts), {
                        x: ns,
                        y: rs,
                        w: ss,
                        h: os
                    })
                }
            } catch (ns) {
                log("calculatedCoordinates" + ns)
            }
            return null
        }
    },
    S$7 = new A$6;
const GC = {
    BROWSER: 0,
    ANDROID: 1,
    IOS: 2,
    WINDOWS: 3,
    HOS: 4,
    ZERO: 0,
    THOUSAND: 1e3,
    TYPEARR: ["", "android", "ios", "pc"],
    FLUSH_DATA: "data/flush",
    PAGE_READY: "page/ready",
    PAGE_LOAD: "page/load",
    PAGE_DATA: "data/page",
    RESOURCE_DATA: "data/resource",
    CONSOLE_DATA: "data/console",
    USERCHANGE: "userchange",
    TITLE: "title",
    DURATION: "duration",
    NAVIGATION_START: "navigationStart",
    FETCH_START: "fetchStart",
    START_TIME: "startTime",
    UNLOAD_EVENT_START: "unloadEventStart",
    UNLOAD_EVENT_END: "unloadEventEnd",
    REDIRECT_START: "redirectStart",
    REDIRECT_END: "redirectEnd",
    DOMAIN_LOOKUP_START: "domainLookupStart",
    DOMAIN_LOOKUP_END: "domainLookupEnd",
    CONNECT_START: "connectStart",
    CONNECT_END: "connectEnd",
    SECURE_CONNECTION_START: "secureConnectionStart",
    REQUEST_START: "requestStart",
    RESPONSE_START: "responseStart",
    RESPONSE_END: "responseEnd",
    RESPONSE_STATUS: "responseStatus",
    DOM_LOADING: "domLoading",
    DOM_INTERACTIVE: "domInteractive",
    DOM_CONTENT_LOADED_EVENT_START: "domContentLoadedEventStart",
    DOM_CONTENT_LOADED_EVENT_END: "domContentLoadedEventEnd",
    DOM_COMPLETE: "domComplete",
    LOAD_EVENT_START: "loadEventStart",
    LOAD_EVENT_END: "loadEventEnd",
    FIRST_PAINT: "fp",
    FIRST_DAY: "brs_ifd",
    FIRST_CONTENTFUL_PAINT: "fcp",
    LARGEST_CONTENTFUL_PAINT: "lcp",
    REDIRECT_COUNT: "redirectCount",
    WORKER_START: "workerStart",
    NEXT_HOP_PROTOCOL: "nextHopProtocol",
    TRANSFER_SIZE: "transferSize",
    ENCODED_BODY_SIZE: "encodedBodySize",
    DECODED_BODY_SIZE: "decodedBodySize",
    UPLOAD_BODY_SIZE: "uploadBodySize",
    REQUEST_HEADER: "requestHeader",
    RESPONSE_HEADER: "responseHeader",
    CALLBACK_START: "callbackStart",
    CALLBACK_END: "callbackEnd",
    CALLBACK_TIME: "callbackTime",
    USER_TIME: "userTime",
    TIMESTAMP: "timestamp",
    INITIATOR_TYPE: "initiatorType",
    XML_HTTP_REQUEST: "xmlhttprequest",
    FETCH: "fetch",
    TAG_NAME: "tagName",
    TYPE: "type",
    MODEL: "model",
    EMBED: "embed",
    IS_MAIN_DOCUMENT: "isMainDocument",
    PAGE_ID: "pageViewId",
    PAGE_URL: "pageUrl",
    PAGE_TITLE: "pageTitle",
    MESSAGE: "message",
    NAME: "name",
    ERROR_LINE: "line",
    ERROR_FILE: "file",
    ERROR_COLUMN: "column",
    ERROR_STACK: "stack",
    JS_ERROR: "jsError",
    IS_SLOW: "isSlow",
    IS_CUSTOM: "isCustome",
    URL: "url",
    NET_METHOD: "method",
    NET_PORT: "port",
    NET_IP: "ip",
    NET_DT: "domainLookupTime",
    NET_CT: "connectTime",
    NET_SSLT: "ssl",
    NET_DTI: "downloadTime",
    NET_CNA: "cname",
    NET_PT: "protocalType",
    NET_TID: "guid",
    NET_XBR: "xBrResponse",
    NET_TRACE: "traceResponse",
    NET_TPAR: "tpar",
    NET_EOP: "errorOccurrentProcess",
    NET_EC: "code",
    NET_TYPE: "requestType",
    NET_RET: "resourceType",
    CUSTOM_IC: "customIc",
    NET_CBBQ: "requestBodyByKey",
    REQUEST_BODY: "requestBody",
    NET_CBHQ: "requestHeaderByKey",
    NET_CBQ: "reqUrlDta",
    REQUEST_HEADER_ALL: "requestHeaderAll",
    E_TYPE: "eType",
    UA: "userAgent",
    SOURCE_OF_ACTION: "sourceOfAction",
    FRAME_TYPE: "frameType",
    STAY_TIME: "stayTime",
    CORRELATION_ID: "correlationId",
    IS_EXIT: "isExit",
    PAGE_CREATE_TIME: "pageCreateTime",
    REFERRER: "referrer",
    STATUS: "status",
    STATUS_TEXT: "statusText",
    ALIAS: "alias",
    PATH: "path",
    ROOT: "root",
    FULL_URL: "fullUrl",
    FRAME_WORK: "framework",
    CLIENT_TYPE: "clientType",
    VALUE: "value",
    FULL_RESOURCE_LOAD_TIME: "fullResourceLoadTime",
    PAGE_INVISIBLE: "page/invisible",
    PAGE_VISIBLE: "page/visible",
    RESOURCE_DUMP: "resource/dump",
    ERROR_DATA: "data/error",
    REQUEST_INIT: "request/init",
    REQUEST_DATA: "data/request",
    ROUTE_DATA: "data/route",
    ACTION_DATA: "data/event",
    TRACE_ACTION_DATA: "data/traceAction",
    SESSION_CHANGE: "session/change",
    USER_SET: "user/set",
    PARAM: "param",
    SPAN_DATA: "data/span",
    FULLY_COLLECT: 1e3,
    NET: "network",
    VIEW: "view",
    ERROR: "jserror",
    ACTION: "action",
    ROUTE: "routechange",
    WEBVIEWDATA: "h5",
    PAGE: "page",
    RESOURCE: "resource",
    CUSTOM_EVENT: "customevent",
    CUSTOM_METRIC: "custommetric",
    CUSTOM_LOG: "customlog",
    CRASH: "crash",
    SPEED_TEST: "speedtest",
    CONSOLE: "console",
    SPAN: "span",
    GUID_KEY: "br-resp-key",
    X_BR_RESPONSE: "x-br-response",
    TRACE_RESPONSE: "traceresponse",
    BREAK_LINE: `\r
`,
    LIFESTYLE_XHR_START: "XMLHttpRequest_Start",
    LIFESTYLE_REQUEST_END: "Request_Completed",
    LIFESTYLE_FETCH_START: "FETCH_Satrt",
    CUSTOM_ACTION_END: "customActionEnd",
    INIT_SESSION_START: "initSessionStart",
    LIFESTYLE_CALLBACK_REQUEST_START: "CallbackRequest_Start",
    ROUTE_CHANGE_START: "ROUTE_CHANGE_START",
    ROUTE_CHANGE_END: "ROUTE_CHANGE_END",
    SPAN_CALLBACK_DATA: "SPAN_CALLBACK_DATA",
    WEBSOCKET_CONNECTION_START: "WEBSOCKET_CONNECTION_START",
    WEBSOCKET_CONNECTION_END: "WEBSOCKET_CONNECTION_END",
    XHR_CALLBACK_IDENTIFY: "XHR_CALLBACK_IDENTIFY",
    LIMIT_64: 64,
    LIMIT_256: 256,
    LIMIT_512: 512,
    ATT_REG: /^[:0-9a-zA-Z /@._-]{1,}$/,
    BR_ATTRIBUTE: "br-att"
};

function u$3(Et) {
    return !(!isDefined(Et) || Et instanceof Object || (isString(Et) || (Et = "" + Et), !(/^[\u4E00-\u9FFFa-zA-Z0-9:_\-@.\s/*#!]+$/.test(Et) && Et.length <= 256)))
}
let p$8 = class {
        constructor() {
            this.useAPI = !1, this.configeManage = [], this.originManageData = null, this.cookieArr = [], this.requestArr = [], this.responseArr = [], this.isStopGetValue = 50
        }
        checkOriginManageData(Et) {
            this.useAPI || isDefined(Et = Et && isString(Et) && JSON.parse(Et) || Et) && Array.isArray(Et) && (50 < (this.originManageData = Et).length ? this.configeManage = Et.slice(0, 50) : this.configeManage = Et, this.startCatchDataFun())
        }
        startCatchDataFun() {
            for (let es = 0, ts = this.configeManage.length - 1; es <= ts; es++)
                if (this.configeManage[es] && this.configeManage[es].type) switch (this.configeManage[es].type) {
                    case 1:
                        var Et = this.getDataWithType_1(this.configeManage[es].rule);
                        isDefined(Et) && setCookie("login_username", Et), this.configeManage[es].value = Et;
                        break;
                    case 2:
                        this.configeManage[es].value = this.getDataWithType_2(this.configeManage[es].rule);
                        break;
                    case 3:
                        this.configeManage[es].value = this.getDataWithType_3(this.configeManage[es].rule);
                        break;
                    case 4:
                        this.getDataWithType_4(this.configeManage[es].rule, es);
                        break;
                    case 5:
                        this.configeManage[es].value = this.getDataWithType_5(this.configeManage[es].rule);
                        break;
                    case 6:
                        this.getDataWithType_6(this.configeManage[es].rule, es);
                        break;
                    case 7:
                        this.getDataWithType_7(this.configeManage[es].rule, es)
                }
            M$7(), this.checkValueRight()
        }
        checkValueRight() {
            for (let Et = 0, es = this.configeManage.length - 1; Et <= es; Et++)
                if (isDefined(this.configeManage[Et]) && isDefined(this.configeManage[Et].value)) return this.isStopGetValue = Et, void u$1.configUser(this.configeManage[Et].value, !0)
        }
        getDataWithType_1(Et) {
            if (!(Et && 256 < Et.length)) try {
                if (Et && 0 < Et.indexOf("@")) {
                    var es = Et.split("@"),
                        ts = document && document.querySelector(es[0]) || null;
                    if (ts && ts[es[1]] && u$3(ts[es[1]])) return ts[es[1]]
                } else {
                    var is = document && document.querySelector(Et) || null;
                    if (is && u$3(is.innerText)) return is.innerText
                }
            } catch (ns) {
                log("C138")
            }
        }
        getDataWithType_2(Et) {
            if (!(Et && 256 < Et.length) && isDefined(Et)) {
                if (Et.indexOf(".") != -1) {
                    let es;
                    if (Et.split(".").map(function (ts, is) {
                            es = es && es[ts] || is == 0 && window[ts] || void 0
                        }), es && u$3(es)) return isString(es) ? es : "" + es
                } else if (u$3(window[Et])) return "" + window[Et]
            }
        }
        getDataWithType_3(Et) {
            if (!(Et && 256 < Et.length)) try {
                var es = document.head.querySelector(`[name~=${Et}][content]`).content;
                if (isDefined(es) && u$3(es)) return es
            } catch (ts) {
                log("C139")
            }
        }
        getDataWithType_4(Et, es) {
            Et && 256 < Et.length || this.cookieArr.push({
                rule: Et,
                index: es
            })
        }
        getDataWithType_5(Et) {
            try {
                var es;
                if (!(Et && 256 < Et.length) && window && window.location && window.location.search) {
                    for (es of decodeURI(window.location.search).split("?")[1].split("&"))
                        if (es.split("=")[0] == Et && u$3(es.split("=")[1])) return es.split("=")[1]
                }
            } catch (ts) {
                log("C140")
            }
        }
        getDataWithType_6(Et, es) {
            if (!(Et && 256 < Et.length)) {
                let ts = !1;
                this.requestArr.map(function (is) {
                    is.rule == Et && (ts = !0)
                }), ts || this.requestArr.push({
                    rule: Et,
                    index: es
                })
            }
        }
        getDataWithType_7(Et, es) {
            if (!(Et && 256 < Et.length)) {
                let ts = !1;
                this.responseArr.map(function (is) {
                    is.rule == Et && (ts = !0)
                }), ts || this.responseArr.push({
                    rule: Et,
                    index: es
                })
            }
        }
        changeUseAPI(Et) {
            this.useAPI = Et
        }
    },
    g$7 = new p$8;

function M$7() {
    var Et = g$7.cookieArr,
        es = g$7.configeManage;
    if (0 < Et.length)
        for (let is = 0, ns = Et.length - 1; is <= ns; is++) {
            var ts = getCookie(Et[is].rule);
            if (isDefined(ts) && u$3(ts) && Et[is].index <= g$7.isStopGetValue) return es[Et[is].index].value = "" + ts, void g$7.checkValueRight()
        }
}

function a$4() {
    this.listeners = {}
}
extend(a$4.prototype, {
    on: function (Et, es) {
        var ts;
        isDefined(Et) && isFunction(es) && forEach(ts = isArray(ts = Et) ? ts : [Et], bind(function (is) {
            var ns = this.listeners[is];
            (ns = isDefined(ns) ? ns : this.listeners[is] = []).push(es)
        }, this))
    },
    emit: function (Et) {
        var es;
        isDefined(Et) && isDefined(Et.t) && (es = Et.t, forEach(this.listeners[es], function (ts) {
            ts(Et)
        }))
    },
    remove: function (Et) {
        var es;
        isDefined(Et) && forEach(es = isArray(es = Et) ? es : [Et], bind(function (ts) {
            delete this.listeners[ts]
        }, this))
    }
});
var e$4 = new a$4,
    v$8 = bind(e$4.on, e$4),
    c$4 = bind(e$4.emit, e$4),
    d$9 = bind(e$4.remove, e$4);
let c$3 = !1,
    u$2 = null,
    d$8 = !1,
    w$8 = null,
    p$7 = null;
const sunSendMsg = Et => {
        const es = document.querySelectorAll("iframe"),
            ts = Array.from(es).filter(is => is.src);
        if (ts.length && b$5.isPostMsg === !1) {
            const is = ts.length,
                ns = f$1.sett.appId;
            for (let rs = 0; rs < is; rs++) ts[rs].contentWindow.postMessage({
                sectionvalue: Et,
                appId: ns
            }, "*"), rs == is - 1 && b$5.changePostMsgStat(!0)
        }
    },
    S$6 = (Et, es) => {
        if (es) {
            var ts = document.querySelectorAll("iframe"),
                ts = Array.from(ts).filter(is => is.src === es);
            if (ts.length) {
                const is = f$1.sett.appId;
                ts[0].contentWindow.postMessage({
                    sectionvalue: Et,
                    appId: is
                }, "*")
            }
        }
    },
    sunReceiveMsg = Et => {
        let es, ts;
        var is = ns => {
            let rs = ns.data;
            if (isDefined(rs.sectionvalue)) {
                es = rs.sectionvalue, ts = rs.appId, c$3 = !0;
                const ss = document.querySelectorAll("iframe");
                D$5.changePostMsgStat(!0), clearInterval(p$7), ss.length === 0 ? (isDefined(f$1.sett.RecordConfiguration || f$1.sett.mc) && d$8 === !1 && (d$8 = !0, isDefined(window.BonreeRecord) && isDefined(window.BonreeRecord.BonreeRecord) ? window.BonreeRecord.BonreeRecord(f$1.sett) : isDefined(window.BonreeAgent) && isDefined(window.BonreeAgent.BonreeRecord) && window.BonreeAgent.BonreeRecord(f$1.sett)), ts && ts == f$1.sett.appId && resetSetCookie(es), Et && Et()) : (isDefined(f$1.sett.RecordConfiguration || f$1.sett.mc) && d$8 === !1 && typeof InstallTrigger != "undefined" && (d$8 = !0, isDefined(window.BonreeRecord) && isDefined(window.BonreeRecord.BonreeRecord) ? window.BonreeRecord.BonreeRecord(f$1.sett) : isDefined(window.BonreeAgent) && isDefined(window.BonreeAgent.BonreeRecord) && window.BonreeAgent.BonreeRecord(f$1.sett)), setTimeout(() => {
                    d$8 === !1 && (clearInterval(w$8), Et && Et(), sunSendMsg(), d$8 = !0)
                }, 1e4))
            }
            rs.type && rs.type === "bonree-msg" && (clearInterval(w$8), w$8 = setInterval(() => {
                es && (clearInterval(w$8), clearInterval(p$7), D$5.changePostMsgStat(!0), isDefined(f$1.sett.RecordConfiguration || f$1.sett.mc) && d$8 === !1 && (d$8 = !0, isDefined(window.BonreeRecord) && isDefined(window.BonreeRecord.BonreeRecord) ? window.BonreeRecord.BonreeRecord(f$1.sett) : isDefined(window.BonreeAgent) && isDefined(window.BonreeAgent.BonreeRecord) && window.BonreeAgent.BonreeRecord(f$1.sett)), ts && ts == f$1.sett.appId ? (resetSetCookie(es), Et && Et(), S$6(es, rs.src)) : (Et && Et(), S$6(w$7.getSession().sessionID, rs.src)))
            }, 50)), rs.type && rs.type === "to-sun-rest-take-full-snapshot" && (resetSetCookie(rs.sessionID), w$7.resetTakeFullSnapshotToSun(rs.sessionID)), rs.type && rs.type === "to-parent-rest-take-full-snapshot" && (resetSetCookie(rs.sessionID), w$7.resetTakeFullSnapshotToParent(rs.sessionID))
        };
        window.addEventListener ? window.addEventListener("message", is) : window.attachEvent("onmessage", is)
    },
    sunLoaded = Et => {
        if (window.self !== window.parent) {
            const es = {
                type: "bonree-msg",
                src: window.location.href,
                msg: "iframe loaded"
            };
            D$5.isPostMsg === !1 && (clearInterval(p$7), p$7 = setInterval(() => {
                window.parent.postMessage(es, "*")
            }, 50)), window.parent.postMessage(es, "*"), setTimeout(() => {
                c$3 === !1 && (Et && Et(), c$3 = !0, clearInterval(p$7), window.document.querySelectorAll("iframe").length) && sunSendMsg(w$7.getSession().sessionID)
            }, 1e4)
        }
    },
    v$7 = () => {
        const Et = document.querySelectorAll("iframe"),
            es = Array.from(Et).filter(ts => ts.src);
        if (es.length) {
            const ts = es.length,
                is = f$1.sett.appId;
            for (let ns = 0; ns < ts; ns++) {
                const rs = es[ns].contentWindow,
                    ss = {
                        sectionvalue: w$7.getSession().sessionID,
                        appId: is,
                        fromsrc: window.location.href
                    };
                rs.postMessage(ss, "*")
            }
        }
    },
    parentReceiveMsg = () => {
        var Et = es => {
            es = es.data, isDefined(es.type) && es.type === "bonree-msg" && c$3 === !1 && (c$3 = !0, v$7()), isDefined(es.type) && es.type && es.type === "to-parent-rest-take-full-snapshot" && (resetSetCookie(es.sessionID), w$7.resetTakeFullSnapshotToParent(es.sessionID))
        };
        window.addEventListener ? window.addEventListener("message", Et, !1) : window.attachEvent("onmessage", Et), document.querySelectorAll("iframe").length && (u$2 = setInterval(() => {
            c$3 === !1 ? (clearInterval(u$2), c$3 = !0, v$7()) : clearInterval(u$2)
        }, 100))
    };

function resetSetCookie(Et) {
    var es, ts = w$7.getCurrentSesssionKey(f$1.sett.appId || f$1.secondSett.appId),
        is = getCookie(ts),
        ns = JSON.parse(is) || [];
    for (es of ns) es.lastVisitedTime = new Date().getTime(), es.startTime = 0, es.sessionID = Et, setCookie(ts, JSON.stringify(ns), w$7.getSessionConfig())
}
const notifyToSunChangeSidAndRedraw = Et => {
        var es = document.querySelectorAll("iframe"),
            ts = Array.from(es).filter(ns => ns.src),
            is = {
                type: "to-sun-rest-take-full-snapshot",
                sessionID: Et
            };
        if (ts.length) {
            const ns = ts.length;
            for (let rs = 0; rs < ns; rs++) ts[rs].contentWindow.postMessage(is, "*")
        }
    },
    notifyToParentChangeSidAndRedraw = Et => {
        window !== window.parent && window.parent.postMessage({
            type: "to-parent-rest-take-full-snapshot",
            sessionID: Et
        }, "*")
    };
let T$5 = class {
        constructor() {
            this.sessionCache = "br-session-cache", this.current = "br-current-appid"
        }
        newAppid(Et) {
            var es, ts;
            !isDefined(Et) || getCookie(es = this.getCurrentSesssionKey(Et)) && this.queryAppid(Et) || (this.currentAppid = {
                appId: Et,
                sessionID: uuid(),
                lastVisitedTime: new Date().getTime(),
                startTime: 0
            }, getCookie(es) ? ((ts = JSON.parse(getCookie(es))).unshift(this.currentAppid), setCookie(es, JSON.stringify(ts), this.getSessionConfig())) : setCookie(es, JSON.stringify([this.currentAppid]), this.getSessionConfig()), setCookie(this.current, Et, this.getSessionConfig()))
        }
        setSessionCookie(Et, es) {
            setCookie(Et, es, this.getSessionConfig())
        }
        getSessionConfig() {
            var Et = {
                path: "/"
            };
            return f$1.sett.sessionDomain && (Et.domain = f$1.sett.sessionDomain), Et
        }
        resetTakeFullSnapshotToSun(Et) {
            try {
                isDefined(window.BonreeRecord) && isDefined(window.BonreeRecord.BonreeRecord) ? window.BonreeRecord.BonreeRecord.takeFullSnapshot() : isDefined(window.BonreeAgent) && isDefined(window.BonreeAgent.BonreeRecord) && window.BonreeAgent.BonreeRecord.takeFullSnapshot(), notifyToSunChangeSidAndRedraw(Et)
            } catch (es) {
                log("C155")
            }
        }
        resetTakeFullSnapshotToParent(Et) {
            try {
                isDefined(window.BonreeRecord) && isDefined(window.BonreeRecord.BonreeRecord) ? window.BonreeRecord.BonreeRecord.takeFullSnapshot() : isDefined(window.BonreeAgent) && isDefined(window.BonreeAgent.BonreeRecord) && window.BonreeAgent.BonreeRecord.takeFullSnapshot(), notifyToParentChangeSidAndRedraw(Et)
            } catch (es) {
                log("C155")
            }
        }
        queryAppid(Et) {
            var es, ts = this.getCurrentSesssionKey(Et),
                is = getCookie(ts),
                ns = isJSON(is) && JSON.parse(is) || [];
            for (es of ns)
                if (es.appId === Et) return new Date().getTime() - es.lastVisitedTime > f$1.sett.sessionTimeout / 1e3 ? (f$1.setData("isFirstUpload", 1), E$6.initUsdTime(), es.sessionID = uuid(), c$4({
                    t: GC.INIT_SESSION_START
                }), this.resetTakeFullSnapshotToSun(es.sessionID), window !== window.parent && this.resetTakeFullSnapshotToParent(es.sessionID), es.lastVisitedTime = new Date().getTime(), es.startTime = 0, es.isRestSID = !0) : (es.isRestSID = !1, es.lastVisitedTime = new Date().getTime()), setCookie(ts, JSON.stringify(ns), this.getSessionConfig()), es;
            return !1
        }
        setAppid(is) {
            f$1.setConfig(is, !1, 0);
            var es, ts, is = is.appId;
            isDefined(is) && (getCookie(es = this.getCurrentSesssionKey(is)) ? this.queryAppid(is) ? setCookie(this.current, is, this.getSessionConfig()) : (ts = JSON.parse(getCookie(es)), f$1.setData("isFirstUpload", 1), E$6.initUsdTime(), c$4({
                t: GC.INIT_SESSION_START
            }), this.currentAppid = {
                appId: is,
                sessionID: uuid(),
                lastVisitedTime: new Date().getTime(),
                startTime: 0
            }, this.resetTakeFullSnapshotToSun(this.currentAppid.sessionID), window !== window.parent && this.resetTakeFullSnapshotToParent(this.currentAppid.sessionID), ts.unshift(this.currentAppid), 20 <= ts.length && ts.pop(), setCookie(es, JSON.stringify(ts), this.getSessionConfig())) : (f$1.setData("isFirstUpload", 1), E$6.initUsdTime(), c$4({
                t: GC.INIT_SESSION_START
            }), this.currentAppid = {
                appId: is,
                sessionID: uuid(),
                lastVisitedTime: new Date().getTime(),
                startTime: 0
            }, this.resetTakeFullSnapshotToSun(this.currentAppid.sessionID), window !== window.parent && this.resetTakeFullSnapshotToParent(this.currentAppid.sessionID), setCookie(this.getCurrentSesssionKey(is), JSON.stringify([this.currentAppid]), this.getSessionConfig())), setCookie(this.current, is, this.getSessionConfig()))
        }
        getSession() {
            return this.queryAppid(f$1.sett.appId || f$1.secondSett.appId)
        }
        getCurrentSesssionKey(Et) {
            return this.sessionCache + "-" + Et
        }
    },
    w$7 = new T$5;

function n$2() {
    this.sett = {
        osType: GC.BROWSER,
        probability: GC.THOUSAND,
        sessionPeriod: 18e8,
        sessionTimeout: 3e8,
        sessionEvents: 2e3,
        debounce: 1e3,
        ignoreRequestParams: !1,
        ignoreRequestHeaders: !1,
        ignoreResources: !1,
        ignoreUserEvents: !1,
        isFirstUpload: 1,
        exBrowser: ["Firefox/47"],
        appVersion: "1.0.0",
        agentVersion: version,
        appName: "unKnown",
        appId: "",
        hcs: 1,
        channelId: null,
        deviceId: null,
        pageViewId: uuid(),
        pageUrl: document && document.URL,
        reqBodyKey: null,
        reqURLKey: null,
        reqHeaderKey: null,
        userKey: "br-user",
        isDebuge: !1,
        cycleTime: 10,
        useXHR: !1,
        maxSize: 20,
        enableWebsocket: !0,
        ac: {
            ac: !0,
            cp: 30,
            aot: 3e4
        },
        traceConfig: {
            urlTotalList: [],
            urlWhiteList: [],
            urlBlackList: []
        },
        typeArr: ["", "android", "ios", "pc"]
    }, this.oriArr = [], this.initArr = [], this.secondSett = {}
}
n$2.prototype.setConfig = function (Et, es = !0, ts = 0) {
    if (f$1.sett.appId === "" || !isDefined(Et.appId) || ts === 0)
        if (es && isDefined(Et.osType)) {
            if (this.secondSett = extend(this.secondSett, Et), isDefined(this.secondSett.mn) && isDefined(this.secondSett.sl)) {
                var is = this.secondSett.mn,
                    ns = this.secondSett.sl;
                if (is.indexOf("sessionreplay") !== -1 && ns !== 0) {
                    let rs = setInterval(() => {
                        1 < u$1.state && (S$7.isStart(!0), clearInterval(rs))
                    }, 50)
                } else S$7.isStart(!1)
            }
        } else {
            if (!es && ts === 1) return isDefined(Et.osType) ? void(this.secondSett = extend(this.secondSett, Et)) : void extend(this.sett, Et);
            isDefined(Et.probability) && (typeof Et.probability == "number" ? this.checkProbability(Et.probability) : log("C100")), this.sett.probability && (extend(this.sett, Et), this.sett.appId && es === !0 && w$7.newAppid(this.sett.appId), this.sett.userId && (isDefined(this.sett.extraInfo) ? (w$5(this.sett.userId), O$8(this.sett.extraInfo)) : w$5(this.sett.userId), g$7.changeUseAPI(!0)), isDefined(this.sett.userdefine) && g$7.checkOriginManageData(this.sett.userdefine), this.sett.isDebuge && isDefined(window.BonreeAgent) && (window.BonreeAgent.isDebuge = !0), this.sett.isDebuge) && isDefined(window.BonreeClient) && (window.BonreeClient.isDebuge = !0)
        }
}, n$2.prototype.checkProbability = function (Et) {
    Math.random() * GC.THOUSAND <= Et ? this.sett.probability = GC.THOUSAND : this.sett.probability = GC.ZERO
}, n$2.prototype.setData = function (Et, es) {
    if (!isDefined(Et) || !isDefined(es)) return !1;
    this.sett[Et] = es
};
var f$1 = new n$2;

function S$5(Et) {
    return Et === GC.IOS
}

function w$6(Et) {
    return Et === GC.HOS
}

function D$6(Et) {
    return Et === GC.BROWSER
}

function d$7(Et) {
    let es = Et.ui;
    document && forEach(document.querySelectorAll("iframe"), function (ts) {
        ts.setAttribute("bonreeID", es);
        let is = ts.contentWindow;
        setTimeout(() => {
            is.postMessage({
                bonreeID: es
            }, "*")
        }, 1e3)
    })
}
let K$3 = class {
        constructor() {
            this.state = 0, this.userInfoMap = {}, this.user = void 0, this.firstUserInfoSetMapKey = "", this.lastUserInfoSetMapKey = "", this.setUserInfoTimeStamp = 0, this.title = "", this.BonreeRecordState = !1, this.eventViewInfo = {
                n: document && document.URL
            }, this.eviKey = "", this.eviMap = {}, this.eei = {}, this.eeiKey = "", this.eeiMap = {}, this.eeiMapBackup = {}, this.timer = void 0
        }
        setEeiData(Et) {
            isEmpty(Et) ? (this.eeiKey = "", this.eei = {}, this.eeiMap = {}) : (this.eei = Object.assign({}, Et), Et = "", isEmpty(this.eei) ? this.eeiKey = "" : (this.eeiKey = Et = hex_md5(String(+new Date)), this.eeiMap[Et] = this.eei))
        }
        setEeiMapCopy() {
            var Et;
            this.eeiKey !== "" && isDefined(Et = this.eeiMap[this.eeiKey]) && (this.eeiMapBackup[this.eeiKey] = Et)
        }
        getEeiData(Et) {
            return Et == "key" ? (this.setEeiMapCopy(), this.eeiKey) : (Et = Object.assign({}, this.eeiMapBackup), this.eeiMapBackup = {}, Et)
        }
        setEviMap() {
            if (this.eviKey == "") this.eviKey = hex_md5(String(+new Date)), this.eviMap[this.eviKey] = Object.assign({}, this.eventViewInfo);
            else {
                let es = !1;
                for (const ts in this.eviMap) {
                    var Et;
                    Object.hasOwnProperty.call(this.eviMap, ts) && (Et = this.eviMap[ts], JSON.stringify(this.eventViewInfo) == JSON.stringify(Et)) && (es = !0, this.eviKey = ts)
                }
                es || (this.eviKey = hex_md5(String(+new Date)), this.eviMap[this.eviKey] = Object.assign({}, this.eventViewInfo))
            }
        }
        setEviData(Et, es) {
            Et == "n" ? this.eventViewInfo.n = es : this.eventViewInfo[Et] = es, isDefined(this.timer) && clearTimeout(this.timer), this.timer = setTimeout(() => {
                this.setEviMap.call(this)
            }, 50)
        }
        getEviData(Et) {
            return Et == "key" ? this.eviKey : Et == "value" ? this.eventViewInfo : this.eviMap
        }
        setData(Et, es) {
            if (!isDefined(Et) || !isDefined(es)) return !1;
            this[Et] = es, Et == "title" && es != "" && this.setEviData("vt", es)
        }
        changeState(Et) {
            this.state = Et
        }
        getUserInfo() {
            var Et;
            return isEmpty(this.userInfoMap) && (Et = this.getUser()) !== "" && this.configUser(Et), this.userInfoMap
        }
        getUser() {
            var Et;
            return isDefined(this.user) ? user : isReadable(Et = this.getLocalUser()) ? Et : ""
        }
        getLocalUser() {
            var Et, es;
            return isDefined(this.user) ? this.user : (es = f$1.sett.userKey, isDefined(window.sessionStorage) && isReadable(Et = sessionStorage.getItem(es)) || isDefined(window.localStorage) && isReadable(Et = localStorage.getItem(es)) ? Et : getCookie(es))
        }
        updateFirstUserInfoSetMapKey(Et) {
            this.firstUserInfoSetMapKey = Et
        }
        saveUser(Et) {
            setCookie(f$1.sett.userKey, Et)
        }
        configUser(Et, ns = !1) {
            if (!isDefined(Et)) return log("C141"), !1;
            if (Et instanceof Object) return log("C142"), !1;
            if (isString(Et) || (Et = "" + Et), !/^[\u4E00-\u9FFFa-zA-Z0-9:_\-@.\s/*#!]+$/.test(Et) || 256 < Et.length) return log("C143"), !1;
            ns || g$7.changeUseAPI(!0);
            let ts = !1;
            if (ns = hex_md5(Et), ts = isDefined(this.userInfoMap[ns]) ? !0 : ts) return !1;
            isEmpty(this.userInfoMap) && this.updateFirstUserInfoSetMapKey(ns), this.lastUserInfoSetMapKey = ns, this.setUserInfoTimeStamp = now();
            var is = {},
                ns = (is.ui = Et, this.userInfoMap[ns] = is, this.saveUser(Et), this.userInfoMap[this.lastUserInfoSetMapKey]);
            return isDefined(ns) && d$7(ns), !0
        }
        configUserExtraInfo(Et) {
            try {
                switch (typeof Et) {
                    case "string":
                        if (7e3 < Et.length) return;
                        var es;
                        Et = JSON.parse(Et), 64 < Object.getOwnPropertyNames(Et).length && (es = {}, Object.getOwnPropertyNames(Et).slice(0, 64).forEach(function (ts) {
                            es[ts] = Et[ts]
                        }), Et = es);
                        break;
                    case "object":
                        if (7e3 < JSON.stringify(Et).length || isEmpty(Et)) return;
                        64 < Object.getOwnPropertyNames(Et).length && (es = {}, Object.getOwnPropertyNames(Et).slice(0, 64).forEach(function (ts) {
                            es[ts] = Et[ts]
                        }), Et = es);
                        break;
                    default:
                        return
                }
            } catch (ts) {}
            isDefined(Et) && !isEmpty(this.userInfoMap) && (this.userInfoMap[this.lastUserInfoSetMapKey].ei = JSON.stringify(Et))
        }
    },
    S$4 = class {
        constructor() {
            this.usdTime = 0
        }
        initUsdTime() {
            this.usdTime = 0
        }
        changUsdTime(Et) {
            isDefined(Et) && (this.usdTime = Et)
        }
    },
    g$6 = class {
        constructor() {
            this.isPostMsg = !1
        }
        changePostMsgStat(Et) {
            this.isPostMsg = Et
        }
    };

function w$5(Et, es = !1) {
    u$1.configUser(Et, es)
}

function O$8(Et) {
    u$1.configUserExtraInfo(Et)
}
let u$1 = new K$3,
    E$6 = new S$4,
    b$5 = new g$6,
    D$5 = new g$6,
    s$4 = class {
        constructor() {
            this.items = {}
        }
        set(Et, es) {
            this.items[Et] = es
        }
        get(Et) {
            return this.items.hasOwnProperty(Et) ? this.items[Et] : void 0
        }
        has(Et) {
            return this.items.hasOwnProperty(Et)
        }
        delete(Et) {
            return !!this.has(Et) && (delete this.items[Et], !0)
        }
        clear() {
            this.items = {}
        }
        size() {
            return Object.keys(this.items).length
        }
        entries() {
            return Object.entries(this.items)
        }
        keys() {
            return Object.keys(this.items)
        }
        values() {
            return Object.values(this.items)
        }
    };
var R$3 = "0.7.28",
    z$1 = "",
    N$4 = "?",
    A$5 = "function",
    C$7 = "undefined",
    O$7 = "object",
    B$3 = "string",
    q$3 = "major",
    e$3 = "model",
    o$1 = "name",
    i$2 = "type",
    s$3 = "vendor",
    r$3 = "version",
    c$2 = "architecture",
    v$6 = "console",
    d$6 = "mobile",
    n$1 = "tablet",
    m$6 = "smarttv",
    E$5 = "wearable",
    M$6 = "embedded",
    L$8 = 255,
    p$6 = {
        extend: function (Et, es) {
            var ts, is = {};
            for (ts in Et) es[ts] && es[ts].length % 2 == 0 ? is[ts] = es[ts].concat(Et[ts]) : is[ts] = Et[ts];
            return is
        },
        has: function (Et, es) {
            return typeof Et === B$3 && es.toLowerCase().indexOf(Et.toLowerCase()) !== -1
        },
        lowerize: function (Et) {
            return Et.toLowerCase()
        },
        major: function (Et) {
            return typeof Et === B$3 ? Et.replace(/[^\d\.]/g, "").split(".")[0] : void 0
        },
        trim: function (Et, es) {
            return Et = Et.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), typeof es === C$7 ? Et : Et.substring(0, L$8)
        }
    },
    f = {
        rgx: function (Et, es) {
            for (var ts, is, ns, rs, ss, os = 0; os < es.length && !rs;) {
                for (var as = es[os], cs = es[os + 1], ds = ts = 0; ds < as.length && !rs;)
                    if (rs = as[ds++].exec(Et))
                        for (is = 0; is < cs.length; is++) ss = rs[++ts], typeof (ns = cs[is]) === O$7 && 0 < ns.length ? ns.length == 2 ? typeof ns[1] == A$5 ? this[ns[0]] = ns[1].call(this, ss) : this[ns[0]] = ns[1] : ns.length == 3 ? typeof ns[1] !== A$5 || ns[1].exec && ns[1].test ? this[ns[0]] = ss ? ss.replace(ns[1], ns[2]) : void 0 : this[ns[0]] = ss ? ns[1].call(this, ss, ns[2]) : void 0 : ns.length == 4 && (this[ns[0]] = ss ? ns[3].call(this, ss.replace(ns[1], ns[2])) : void 0) : this[ns] = ss || void 0;
                os += 2
            }
        },
        str: function (Et, es) {
            for (var ts in es)
                if (typeof es[ts] === O$7 && 0 < es[ts].length) {
                    for (var is = 0; is < es[ts].length; is++)
                        if (p$6.has(es[ts][is], Et)) return ts === N$4 ? void 0 : ts
                } else if (p$6.has(es[ts], Et)) return ts === N$4 ? void 0 : ts;
            return Et
        }
    },
    y$5 = {
        browser: {
            oldSafari: {
                version: {
                    "1.0": "/8",
                    1.2: "/1",
                    1.3: "/3",
                    "2.0": "/412",
                    "2.0.2": "/416",
                    "2.0.3": "/417",
                    "2.0.4": "/419",
                    "?": "/"
                }
            },
            oldEdge: {
                version: {
                    .1: "12.",
                    21: "13.",
                    31: "14.",
                    39: "15.",
                    41: "16.",
                    42: "17.",
                    44: "18."
                }
            }
        },
        os: {
            windows: {
                version: {
                    ME: "4.90",
                    "NT 3.11": "NT3.51",
                    "NT 4.0": "NT4.0",
                    2e3: "NT 5.0",
                    XP: ["NT 5.1", "NT 5.2"],
                    Vista: "NT 6.0",
                    7: "NT 6.1",
                    8: "NT 6.2",
                    8.1: "NT 6.3",
                    10: ["NT 6.4", "NT 10.0"],
                    RT: "ARM"
                }
            }
        }
    },
    x$4 = {
        browser: [
            [/\b(?:crmo|crios)\/([\w\.]+)/i],
            [r$3, [o$1, "Chrome"]],
            [/edg(?:e|ios|a)?\/([\w\.]+)/i],
            [r$3, [o$1, "Edge"]],
            [/(opera\smini)\/([\w\.-]+)/i, /(opera\s[mobiletab]{3,6})\b.+version\/([\w\.-]+)/i, /(opera)(?:.+version\/|[\/\s]+)([\w\.]+)/i],
            [o$1, r$3],
            [/opios[\/\s]+([\w\.]+)/i],
            [r$3, [o$1, "Opera Mini"]],
            [/\sopr\/([\w\.]+)/i],
            [r$3, [o$1, "Opera"]],
            [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i, /(ba?idubrowser)[\/\s]?([\w\.]+)/i, /(?:ms|\()(ie)\s([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i, /(rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([\w\.]+)/i, /(weibo)__([\d\.]+)/i],
            [o$1, r$3],
            [/(?:[\s\/]uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],
            [r$3, [o$1, "UCBrowser"]],
            [/(?:windowswechat)?\sqbcore\/([\w\.]+)\b.*(?:windowswechat)?/i],
            [r$3, [o$1, "WeChat(Win) Desktop"]],
            [/micromessenger\/([\w\.]+)/i],
            [r$3, [o$1, "WeChat"]],
            [/konqueror\/([\w\.]+)/i],
            [r$3, [o$1, "Konqueror"]],
            [/trident.+rv[:\s]([\w\.]{1,9})\b.+like\sgecko/i],
            [r$3, [o$1, "IE"]],
            [/yabrowser\/([\w\.]+)/i],
            [r$3, [o$1, "Yandex"]],
            [/(avast|avg)\/([\w\.]+)/i],
            [
                [o$1, /(.+)/, "$1 Secure Browser"], r$3
            ],
            [/focus\/([\w\.]+)/i],
            [r$3, [o$1, "Firefox Focus"]],
            [/opt\/([\w\.]+)/i],
            [r$3, [o$1, "Opera Touch"]],
            [/coc_coc_browser\/([\w\.]+)/i],
            [r$3, [o$1, "Coc Coc"]],
            [/dolfin\/([\w\.]+)/i],
            [r$3, [o$1, "Dolphin"]],
            [/coast\/([\w\.]+)/i],
            [r$3, [o$1, "Opera Coast"]],
            [/xiaomi\/miuibrowser\/([\w\.]+)/i],
            [r$3, [o$1, "MIUI Browser"]],
            [/fxios\/([\w\.-]+)/i],
            [r$3, [o$1, "Firefox"]],
            [/(qihu|qhbrowser|qihoobrowser|360browser)/i],
            [
                [o$1, "360 Browser"]
            ],
            [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i],
            [
                [o$1, /(.+)/, "$1 Browser"], r$3
            ],
            [/(comodo_dragon)\/([\w\.]+)/i],
            [
                [o$1, /_/g, " "], r$3
            ],
            [/\s(electron)\/([\w\.]+)\ssafari/i, /(tesla)(?:\sqtcarbrowser|\/(20[12]\d\.[\w\.-]+))/i, /m?(qqbrowser|baiduboxapp|2345Explorer)[\/\s]?([\w\.]+)/i],
            [o$1, r$3],
            [/(MetaSr)[\/\s]?([\w\.]+)/i, /(LBBROWSER)/i],
            [o$1],
            [/;fbav\/([\w\.]+);/i],
            [r$3, [o$1, "Facebook"]],
            [/FBAN\/FBIOS|FB_IAB\/FB4A/i],
            [
                [o$1, "Facebook"]
            ],
            [/safari\s(line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(chromium|instagram)[\/\s]([\w\.-]+)/i],
            [o$1, r$3],
            [/\bgsa\/([\w\.]+)\s.*safari\//i],
            [r$3, [o$1, "GSA"]],
            [/headlesschrome(?:\/([\w\.]+)|\s)/i],
            [r$3, [o$1, "Chrome Headless"]],
            [/\swv\).+(chrome)\/([\w\.]+)/i],
            [
                [o$1, "Chrome WebView"], r$3
            ],
            [/droid.+\sversion\/([\w\.]+)\b.+(?:mobile\ssafari|safari)/i],
            [r$3, [o$1, "Android Browser"]],
            [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],
            [o$1, r$3],
            [/version\/([\w\.]+)\s.*mobile\/\w+\s(safari)/i],
            [r$3, [o$1, "Mobile Safari"]],
            [/version\/([\w\.]+)\s.*(mobile\s?safari|safari)/i],
            [r$3, o$1],
            [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],
            [o$1, [r$3, f.str, y$5.browser.oldSafari.version]],
            [/(webkit|khtml)\/([\w\.]+)/i],
            [o$1, r$3],
            [/(navigator|netscape)\/([\w\.-]+)/i],
            [
                [o$1, "Netscape"], r$3
            ],
            [/ile\svr;\srv:([\w\.]+)\).+firefox/i],
            [r$3, [o$1, "Firefox Reality"]],
            [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, /(firefox)\/([\w\.]+)\s[\w\s\-]+\/[\w\.]+$/i, /(mozilla)\/([\w\.]+)\s.+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, /(links)\s\(([\w\.]+)/i, /(gobrowser)\/?([\w\.]*)/i, /(ice\s?browser)\/v?([\w\._]+)/i, /(mosaic)[\/\s]([\w\.]+)/i],
            [o$1, r$3]
        ],
        cpu: [
            [/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],
            [
                [c$2, "amd64"]
            ],
            [/(ia32(?=;))/i],
            [
                [c$2, p$6.lowerize]
            ],
            [/((?:i[346]|x)86)[;\)]/i],
            [
                [c$2, "ia32"]
            ],
            [/\b(aarch64|armv?8e?l?)\b/i],
            [
                [c$2, "arm64"]
            ],
            [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],
            [
                [c$2, "armhf"]
            ],
            [/windows\s(ce|mobile);\sppc;/i],
            [
                [c$2, "arm"]
            ],
            [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],
            [
                [c$2, /ower/, "", p$6.lowerize]
            ],
            [/(sun4\w)[;\)]/i],
            [
                [c$2, "sparc"]
            ],
            [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?:64|(?=v(?:[1-7]|[5-7]1)l?|;|eabi))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],
            [
                [c$2, p$6.lowerize]
            ]
        ],
        device: [
            [/\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus\s10)/i],
            [e$3, [s$3, "Samsung"],
                [i$2, n$1]
            ],
            [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy\snexus)/i, /\ssamsung[\s-]([\w-]+)/i, /sec-(sgh\w+)/i],
            [e$3, [s$3, "Samsung"],
                [i$2, d$6]
            ],
            [/\((ip(?:hone|od)[\s\w]*);/i],
            [e$3, [s$3, "Apple"],
                [i$2, d$6]
            ],
            [/\((ipad);[\w\s\),;-]+apple/i, /applecoremedia\/[\w\.]+\s\((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i],
            [e$3, [s$3, "Apple"],
                [i$2, n$1]
            ],
            [/\b((?:agr|ags[23]|bah2?|sht?)-a?[lw]\d{2})/i],
            [e$3, [s$3, "Huawei"],
                [i$2, n$1]
            ],
            [/d\/huawei([\w\s-]+)[;\)]/i, /\b(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?|ele-l\d\d)/i, /\b(\w{2,4}-[atu][ln][01259][019])[;\)\s]/i],
            [e$3, [s$3, "Huawei"],
                [i$2, d$6]
            ],
            [/\b(poco[\s\w]+)(?:\sbuild|\))/i, /\b;\s(\w+)\sbuild\/hm\1/i, /\b(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i, /\b(redmi[\s\-_]?(?:note|k)?[\w\s_]+)(?:\sbuild|\))/i, /\b(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i],
            [
                [e$3, /_/g, " "],
                [s$3, "Xiaomi"],
                [i$2, d$6]
            ],
            [/\b(mi[\s\-_]?(?:pad)(?:[\w\s_]+))(?:\sbuild|\))/i],
            [
                [e$3, /_/g, " "],
                [s$3, "Xiaomi"],
                [i$2, n$1]
            ],
            [/;\s(\w+)\sbuild.+\soppo/i, /\s(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i],
            [e$3, [s$3, "OPPO"],
                [i$2, d$6]
            ],
            [/\svivo\s(\w+)(?:\sbuild|\))/i, /\s(v[12]\d{3}\w?[at])(?:\sbuild|;)/i],
            [e$3, [s$3, "Vivo"],
                [i$2, d$6]
            ],
            [/\s(rmx[12]\d{3})(?:\sbuild|;)/i],
            [e$3, [s$3, "Realme"],
                [i$2, d$6]
            ],
            [/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)\b[\w\s]+build\//i, /\smot(?:orola)?[\s-](\w*)/i, /((?:moto[\s\w\(\)]+|xt\d{3,4}|nexus\s6)(?=\sbuild|\)))/i],
            [e$3, [s$3, "Motorola"],
                [i$2, d$6]
            ],
            [/\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],
            [e$3, [s$3, "Motorola"],
                [i$2, n$1]
            ],
            [/((?=lg)?[vl]k\-?\d{3})\sbuild|\s3\.[\s\w;-]{10}lg?-([06cv9]{3,4})/i],
            [e$3, [s$3, "LG"],
                [i$2, n$1]
            ],
            [/(lm-?f100[nv]?|nexus\s[45])/i, /lg[e;\s\/-]+((?!browser|netcast)\w+)/i, /\blg(\-?[\d\w]+)\sbuild/i],
            [e$3, [s$3, "LG"],
                [i$2, d$6]
            ],
            [/(ideatab[\w\-\s]+)/i, /lenovo\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+)|yt[\d\w-]{6}|tb[\d\w-]{6})/i],
            [e$3, [s$3, "Lenovo"],
                [i$2, n$1]
            ],
            [/(?:maemo|nokia).*(n900|lumia\s\d+)/i, /nokia[\s_-]?([\w\.-]*)/i],
            [
                [e$3, /_/g, " "],
                [s$3, "Nokia"],
                [i$2, d$6]
            ],
            [/droid.+;\s(pixel\sc)[\s)]/i],
            [e$3, [s$3, "Google"],
                [i$2, n$1]
            ],
            [/droid.+;\s(pixel[\s\daxl]{0,6})(?:\sbuild|\))/i],
            [e$3, [s$3, "Google"],
                [i$2, d$6]
            ],
            [/droid.+\s([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],
            [e$3, [s$3, "Sony"],
                [i$2, d$6]
            ],
            [/sony\stablet\s[ps]\sbuild\//i, /(?:sony)?sgp\w+(?:\sbuild\/|\))/i],
            [
                [e$3, "Xperia Tablet"],
                [s$3, "Sony"],
                [i$2, n$1]
            ],
            [/\s(kb2005|in20[12]5|be20[12][59])\b/i, /\ba000(1)\sbuild/i, /\boneplus\s(a\d{4})[\s)]/i],
            [e$3, [s$3, "OnePlus"],
                [i$2, d$6]
            ],
            [/(alexa)webm/i, /(kf[a-z]{2}wi)(\sbuild\/|\))/i, /(kf[a-z]+)(\sbuild\/|\)).+silk\//i],
            [e$3, [s$3, "Amazon"],
                [i$2, n$1]
            ],
            [/(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i],
            [
                [e$3, "Fire Phone"],
                [s$3, "Amazon"],
                [i$2, d$6]
            ],
            [/\((playbook);[\w\s\),;-]+(rim)/i],
            [e$3, s$3, [i$2, n$1]],
            [/((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10;\s(\w+)/i],
            [e$3, [s$3, "BlackBerry"],
                [i$2, d$6]
            ],
            [/(?:\b|asus_)(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus\s7|padfone|p00[cj])/i],
            [e$3, [s$3, "ASUS"],
                [i$2, n$1]
            ],
            [/\s(z[es]6[027][01][km][ls]|zenfone\s\d\w?)\b/i],
            [e$3, [s$3, "ASUS"],
                [i$2, d$6]
            ],
            [/(nexus\s9)/i],
            [e$3, [s$3, "HTC"],
                [i$2, n$1]
            ],
            [/(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i, /(zte)-(\w*)/i, /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],
            [s$3, [e$3, /_/g, " "],
                [i$2, d$6]
            ],
            [/droid[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],
            [e$3, [s$3, "Acer"],
                [i$2, n$1]
            ],
            [/droid.+;\s(m[1-5]\snote)\sbuild/i, /\bmz-([\w-]{2,})/i],
            [e$3, [s$3, "Meizu"],
                [i$2, d$6]
            ],
            [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, /(hp)\s([\w\s]+\w)/i, /(asus)-?(\w+)/i, /(microsoft);\s(lumia[\s\w]+)/i, /(lenovo)[_\s-]?([\w-]+)/i, /linux;.+(jolla);/i, /droid.+;\s(oppo)\s?([\w\s]+)\sbuild/i],
            [s$3, e$3, [i$2, d$6]],
            [/(archos)\s(gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /\s(nook)[\w\s]+build\/(\w+)/i, /(dell)\s(strea[kpr\s\d]*[\dko])/i, /[;\/]\s?(le[\s\-]+pan)[\s\-]+(\w{1,9})\sbuild/i, /[;\/]\s?(trinity)[\-\s]*(t\d{3})\sbuild/i, /\b(gigaset)[\s\-]+(q\w{1,9})\sbuild/i, /\b(vodafone)\s([\w\s]+)(?:\)|\sbuild)/i],
            [s$3, e$3, [i$2, n$1]],
            [/\s(surface\sduo)\s/i],
            [e$3, [s$3, "Microsoft"],
                [i$2, n$1]
            ],
            [/droid\s[\d\.]+;\s(fp\du?)\sbuild/i],
            [e$3, [s$3, "Fairphone"],
                [i$2, d$6]
            ],
            [/\s(u304aa)\sbuild/i],
            [e$3, [s$3, "AT&T"],
                [i$2, d$6]
            ],
            [/sie-(\w*)/i],
            [e$3, [s$3, "Siemens"],
                [i$2, d$6]
            ],
            [/[;\/]\s?(rct\w+)\sbuild/i],
            [e$3, [s$3, "RCA"],
                [i$2, n$1]
            ],
            [/[;\/\s](venue[\d\s]{2,7})\sbuild/i],
            [e$3, [s$3, "Dell"],
                [i$2, n$1]
            ],
            [/[;\/]\s?(q(?:mv|ta)\w+)\sbuild/i],
            [e$3, [s$3, "Verizon"],
                [i$2, n$1]
            ],
            [/[;\/]\s(?:barnes[&\s]+noble\s|bn[rt])([\w\s\+]*)\sbuild/i],
            [e$3, [s$3, "Barnes & Noble"],
                [i$2, n$1]
            ],
            [/[;\/]\s(tm\d{3}\w+)\sbuild/i],
            [e$3, [s$3, "NuVision"],
                [i$2, n$1]
            ],
            [/;\s(k88)\sbuild/i],
            [e$3, [s$3, "ZTE"],
                [i$2, n$1]
            ],
            [/;\s(nx\d{3}j)\sbuild/i],
            [e$3, [s$3, "ZTE"],
                [i$2, d$6]
            ],
            [/[;\/]\s?(gen\d{3})\sbuild.*49h/i],
            [e$3, [s$3, "Swiss"],
                [i$2, d$6]
            ],
            [/[;\/]\s?(zur\d{3})\sbuild/i],
            [e$3, [s$3, "Swiss"],
                [i$2, n$1]
            ],
            [/[;\/]\s?((zeki)?tb.*\b)\sbuild/i],
            [e$3, [s$3, "Zeki"],
                [i$2, n$1]
            ],
            [/[;\/]\s([yr]\d{2})\sbuild/i, /[;\/]\s(dragon[\-\s]+touch\s|dt)(\w{5})\sbuild/i],
            [
                [s$3, "Dragon Touch"], e$3, [i$2, n$1]
            ],
            [/[;\/]\s?(ns-?\w{0,9})\sbuild/i],
            [e$3, [s$3, "Insignia"],
                [i$2, n$1]
            ],
            [/[;\/]\s?((nxa|Next)-?\w{0,9})\sbuild/i],
            [e$3, [s$3, "NextBook"],
                [i$2, n$1]
            ],
            [/[;\/]\s?(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05]))\sbuild/i],
            [
                [s$3, "Voice"], e$3, [i$2, d$6]
            ],
            [/[;\/]\s?(lvtel\-)?(v1[12])\sbuild/i],
            [
                [s$3, "LvTel"], e$3, [i$2, d$6]
            ],
            [/;\s(ph-1)\s/i],
            [e$3, [s$3, "Essential"],
                [i$2, d$6]
            ],
            [/[;\/]\s?(v(100md|700na|7011|917g).*\b)\sbuild/i],
            [e$3, [s$3, "Envizen"],
                [i$2, n$1]
            ],
            [/[;\/]\s?(trio[\s\w\-\.]+)\sbuild/i],
            [e$3, [s$3, "MachSpeed"],
                [i$2, n$1]
            ],
            [/[;\/]\s?tu_(1491)\sbuild/i],
            [e$3, [s$3, "Rotor"],
                [i$2, n$1]
            ],
            [/(shield[\w\s]+)\sbuild/i],
            [e$3, [s$3, "Nvidia"],
                [i$2, n$1]
            ],
            [/(sprint)\s(\w+)/i],
            [s$3, e$3, [i$2, d$6]],
            [/(kin\.[onetw]{3})/i],
            [
                [e$3, /\./g, " "],
                [s$3, "Microsoft"],
                [i$2, d$6]
            ],
            [/droid\s[\d\.]+;\s(cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],
            [e$3, [s$3, "Zebra"],
                [i$2, n$1]
            ],
            [/droid\s[\d\.]+;\s(ec30|ps20|tc[2-8]\d[kx])\)/i],
            [e$3, [s$3, "Zebra"],
                [i$2, d$6]
            ],
            [/\s(ouya)\s/i, /(nintendo)\s([wids3utch]+)/i],
            [s$3, e$3, [i$2, v$6]],
            [/droid.+;\s(shield)\sbuild/i],
            [e$3, [s$3, "Nvidia"],
                [i$2, v$6]
            ],
            [/(playstation\s[345portablevi]+)/i],
            [e$3, [s$3, "Sony"],
                [i$2, v$6]
            ],
            [/[\s\(;](xbox(?:\sone)?(?!;\sxbox))[\s\);]/i],
            [e$3, [s$3, "Microsoft"],
                [i$2, v$6]
            ],
            [/smart-tv.+(samsung)/i],
            [s$3, [i$2, m$6]],
            [/hbbtv.+maple;(\d+)/i],
            [
                [e$3, /^/, "SmartTV"],
                [s$3, "Samsung"],
                [i$2, m$6]
            ],
            [/(?:linux;\snetcast.+smarttv|lg\snetcast\.tv-201\d)/i],
            [
                [s$3, "LG"],
                [i$2, m$6]
            ],
            [/(apple)\s?tv/i],
            [s$3, [e$3, "Apple TV"],
                [i$2, m$6]
            ],
            [/crkey/i],
            [
                [e$3, "Chromecast"],
                [s$3, "Google"],
                [i$2, m$6]
            ],
            [/droid.+aft([\w])(\sbuild\/|\))/i],
            [e$3, [s$3, "Amazon"],
                [i$2, m$6]
            ],
            [/\(dtv[\);].+(aquos)/i],
            [e$3, [s$3, "Sharp"],
                [i$2, m$6]
            ],
            [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],
            [
                [s$3, p$6.trim],
                [e$3, p$6.trim],
                [i$2, m$6]
            ],
            [/[\s\/\(](android\s|smart[-\s]?|opera\s)tv[;\)\s]/i],
            [
                [i$2, m$6]
            ],
            [/((pebble))app\/[\d\.]+\s/i],
            [s$3, e$3, [i$2, E$5]],
            [/droid.+;\s(glass)\s\d/i],
            [e$3, [s$3, "Google"],
                [i$2, E$5]
            ],
            [/droid\s[\d\.]+;\s(wt63?0{2,3})\)/i],
            [e$3, [s$3, "Zebra"],
                [i$2, E$5]
            ],
            [/(tesla)(?:\sqtcarbrowser|\/20[12]\d\.[\w\.-]+)/i],
            [s$3, [i$2, M$6]],
            [/droid .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i],
            [e$3, [i$2, d$6]],
            [/droid .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i],
            [e$3, [i$2, n$1]],
            [/\s(tablet|tab)[;\/]/i, /\s(mobile)(?:[;\/]|\ssafari)/i],
            [
                [i$2, p$6.lowerize]
            ],
            [/(android[\w\.\s\-]{0,9});.+build/i],
            [e$3, [s$3, "Generic"]],
            [/(phone)/i],
            [
                [i$2, d$6]
            ]
        ],
        engine: [
            [/windows.+\sedge\/([\w\.]+)/i],
            [r$3, [o$1, "EdgeHTML"]],
            [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],
            [r$3, [o$1, "Blink"]],
            [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, /(icab)[\/\s]([23]\.[\d\.]+)/i],
            [o$1, r$3],
            [/rv\:([\w\.]{1,9})\b.+(gecko)/i],
            [r$3, o$1]
        ],
        os: [
            [/microsoft\s(windows)\s(vista|xp)/i],
            [o$1, r$3],
            [/(windows)\snt\s6\.2;\s(arm)/i, /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)(?!.+xbox)/i],
            [o$1, [r$3, f.str, y$5.os.windows.version]],
            [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],
            [
                [o$1, "Windows"],
                [r$3, f.str, y$5.os.windows.version]
            ],
            [/ip[honead]{2,4}\b(?:.*os\s([\w]+)\slike\smac|;\sopera)/i, /cfnetwork\/.+darwin/i],
            [
                [r$3, /_/g, "."],
                [o$1, "iOS"]
            ],
            [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)(?!.+haiku)/i],
            [
                [o$1, "Mac OS"],
                [r$3, /_/g, "."]
            ],
            [/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/\s]([\w\.]+)/i, /\((series40);/i],
            [o$1, r$3],
            [/\(bb(10);/i],
            [r$3, [o$1, "BlackBerry"]],
            [/(?:symbian\s?os|symbos|s60(?=;)|series60)[\/\s-]?([\w\.]*)/i],
            [r$3, [o$1, "Symbian"]],
            [/mozilla.+\(mobile;.+gecko.+firefox/i],
            [
                [o$1, "Firefox OS"]
            ],
            [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],
            [r$3, [o$1, "webOS"]],
            [/crkey\/([\d\.]+)/i],
            [r$3, [o$1, "Chromecast"]],
            [/(cros)\s[\w]+\s([\w\.]+\w)/i],
            [
                [o$1, "Chromium OS"], r$3
            ],
            [/(nintendo|playstation)\s([wids345portablevuch]+)/i, /(xbox);\s+xbox\s([^\);]+)/i, /(mint)[\/\s\(\)]?(\w*)/i, /(mageia|vectorlinux)[;\s]/i, /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?=\slinux)|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus|raspbian)(?:\sgnu\/linux)?(?:\slinux)?[\/\s-]?(?!chrom|package)([\w\.-]*)/i, /(hurd|linux)\s?([\w\.]*)/i, /(gnu)\s?([\w\.]*)/i, /\s([frentopc-]{0,4}bsd|dragonfly)\s?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku)\s(\w+)/i],
            [o$1, r$3],
            [/(sunos)\s?([\w\.\d]*)/i],
            [
                [o$1, "Solaris"], r$3
            ],
            [/((?:open)?solaris)[\/\s-]?([\w\.]*)/i, /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i, /(unix)\s?([\w\.]*)/i],
            [o$1, r$3]
        ]
    },
    h$a = typeof window != "undefined" && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : z$1;
class UAParser {
    constructor() {
        this.VERSION = R$3, this.BROWSER = {
            NAME: o$1,
            MAJOR: q$3,
            VERSION: r$3
        }, this.CPU = {
            ARCHITECTURE: c$2
        }, this.DEVICE = {
            MODEL: e$3,
            VENDOR: s$3,
            TYPE: i$2,
            CONSOLE: v$6,
            MOBILE: d$6,
            SMARTTV: m$6,
            TABLET: n$1,
            WEARABLE: E$5,
            EMBEDDED: M$6
        }, this.ENGINE = {
            NAME: o$1,
            VERSION: r$3
        }, this.OS = {
            NAME: o$1,
            VERSION: r$3
        }
    }
}
UAParser.prototype.getBrowser = function () {
    var Et = {
        name: void 0,
        version: void 0
    };
    return f.rgx.call(Et, h$a, x$4.browser), Et.major = p$6.major(Et.version), Et
}, UAParser.prototype.getCPU = function () {
    var Et = {
        architecture: void 0
    };
    return f.rgx.call(Et, h$a, x$4.cpu), Et
}, UAParser.prototype.getDevice = function () {
    var Et = {
        vendor: void 0,
        model: void 0,
        type: void 0
    };
    return f.rgx.call(Et, h$a, x$4.device), Et
}, UAParser.prototype.getEngine = function () {
    var Et = {
        name: void 0,
        version: void 0
    };
    return f.rgx.call(Et, h$a, x$4.engine), Et
}, UAParser.prototype.getOS = function () {
    var Et = {
        name: void 0,
        version: void 0
    };
    return f.rgx.call(Et, h$a, x$4.os), Et
}, UAParser.prototype.getUA = function () {
    return h$a
}, UAParser.prototype.getResult = function () {
    return {
        ua: this.getUA(),
        browser: this.getBrowser(),
        engine: this.getEngine(),
        os: this.getOS(),
        device: this.getDevice(),
        cpu: this.getCPU()
    }
};
var p$5 = (Et, es, ts) => new Promise((is, ns) => {
        var rs = as => {
                try {
                    os(ts.next(as))
                } catch (cs) {
                    ns(cs)
                }
            },
            ss = as => {
                try {
                    os(ts.throw(as))
                } catch (cs) {
                    ns(cs)
                }
            },
            os = as => as.done ? is(as.value) : Promise.resolve(as.value).then(rs, ss);
        os((ts = ts.apply(Et, es)).next())
    }),
    m$5 = "br-client";
const d$5 = {};
let n = {};
const L$7 = function () {
    var Et = getCookie(m$5);
    return isReadable(Et) || (Et = uuid(), setCookie(m$5, Et, {
        path: "/",
        expires: "Thu, 01 Jan 2099 00:00:01 GMT;"
    })), Et
};

function C$6() {
    if (isEmpty(n) || !UAParser) try {
        var Et = new UAParser;
        n = Et && Et.getResult() || {}
    } catch (es) {
        log(es)
    }
}

function M$5(Et) {
    if (Et) return /iphone|ipad|ios/i.test(Et) ? 0 : /android/i.test(Et) ? 1 : /windows/i.test(Et) ? 2 : /harmonyOS/i.test(Et) ? 3 : /mac/i.test(Et) ? 4 : 1
}

function getDeviceInfo() {
    try {
        k$3() && C$6(), d$5.di = L$7(), d$5.a = "user", d$5.ot = n && isDefined(n.os) ? n.os.name && M$5(n.os.name) : "1", d$5.ram = isDefined(navigator.deviceMemory) && 1024 * navigator.deviceMemory || -1, d$5.l = navigator.language || navigator.userLanguage, d$5.ds = window.screen.width + "*" + window.screen.height, d$5.rom = -1, d$5.bn = n && isDefined(n.os) ? n.os.name : "unknown", d$5.omv = n && n.os && n.os.version ? n.os.version : "unknown", d$5.ci = n && isDefined(n.cpu) && n.cpu.architecture && n.cpu.architecture || "unknown", d$5.ctn = n && isDefined(n.browser) ? n.browser.name : "unknown", d$5.ctv = n && n.browser && n.browser.version ? n.browser.version : "unknown", isDefined(n.device) && isDefined(n.device.model) && (d$5.m = n.device.model), setDeviceForLog(d$5.di)
    } catch (Et) {
        return log(Et, !0), {}
    }
    return d$5
}

function k$3() {
    try {
        var Et = ["Firefox/47"],
            es = navigator.userAgent && navigator.userAgent.match(/(firefox|msie|chrome|safari)[/\s]([\d.]+)/gi) || void 0;
        if (es && 0 < es.length) {
            var ts = es[0].split("/");
            for (let is = 0, ns = Et.length - 1; is <= ns; is++) {
                let rs = Et[is];
                if ((rs = rs.split("/"))[0] === ts[0] && Number(ts[1].split(".")[0]) <= Number(rs[1])) return !1
            }
        }
        return !0
    } catch (is) {
        log(is)
    }
    return !1
}
let P$4 = class {
    zero(Et) {
        if (0 < Et) {
            for (var es = "0", ts = 1; ts < Et; ts++) es += es;
            return es
        }
        return ""
    }
    stringToArray(Et) {
        for (var es = [], ts = Et.length, is = 0; is < ts; is++) {
            var ns, rs, ss, os, as, cs = Et.charCodeAt(is);
            19968 < cs && cs < 40869 ? (rs = "1110", os = ss = "10", (as = (ns = cs.toString(2)).length) <= 6 ? (os = os + this.zero(6 - as) + ns, ss += this.zero(6), rs += this.zero(4)) : 6 < as && as <= 12 ? (os += ns.slice(-6), ss = ss + this.zero(12 - as) + ns.substr(0, as - 6), rs += this.zero(4)) : (os += ns.slice(-6), ss += ns.substr(as - 12, 6), rs = rs + this.zero(16 - as) + ns.substr(0, as - 12)), es.push(parseInt(rs, 2), parseInt(ss, 2), parseInt(os, 2))) : es.push(cs)
        }
        return es
    }
    stringToArrayBufferInUtf8(Et) {
        return this.stringToArray(Et)
    }
};
Array.prototype.Bonreefill || Object.defineProperty(Array.prototype, "Bonreefill", {
    value: function (Et) {
        if (this == null) throw new TypeError("this is null or not defined");
        for (var es = Object(this), ts = es.length >>> 0, ns = arguments[1] >> 0, is = ns < 0 ? Math.max(ts + ns, 0) : Math.min(ns, ts), ns = arguments[2], ns = ns === void 0 ? ts : ns >> 0, rs = ns < 0 ? Math.max(ts + ns, 0) : Math.min(ns, ts); is < rs;) es[is] = Et, is++;
        return es
    }
});
var l$2 = 16,
    y$4 = new Uint8Array([214, 144, 233, 254, 204, 225, 61, 183, 22, 182, 20, 194, 40, 251, 44, 5, 43, 103, 154, 118, 42, 190, 4, 195, 170, 68, 19, 38, 73, 134, 6, 153, 156, 66, 80, 244, 145, 239, 152, 122, 51, 84, 11, 67, 237, 207, 172, 98, 228, 179, 28, 169, 201, 8, 232, 149, 128, 223, 148, 250, 117, 143, 63, 166, 71, 7, 167, 252, 243, 115, 23, 186, 131, 89, 60, 25, 230, 133, 79, 168, 104, 107, 129, 178, 113, 100, 218, 139, 248, 235, 15, 75, 112, 86, 157, 53, 30, 36, 14, 94, 99, 88, 209, 162, 37, 34, 124, 59, 1, 33, 120, 135, 212, 0, 70, 87, 159, 211, 39, 82, 76, 54, 2, 231, 160, 196, 200, 158, 234, 191, 138, 210, 64, 199, 56, 181, 163, 247, 242, 206, 249, 97, 21, 161, 224, 174, 93, 164, 155, 52, 26, 85, 173, 147, 50, 48, 245, 140, 177, 227, 29, 246, 226, 46, 130, 102, 202, 96, 192, 41, 35, 171, 13, 83, 78, 111, 213, 219, 55, 69, 222, 253, 142, 47, 3, 255, 106, 114, 109, 108, 91, 81, 141, 27, 175, 146, 187, 221, 188, 127, 17, 217, 92, 65, 31, 16, 90, 216, 10, 193, 49, 136, 165, 205, 123, 189, 45, 116, 208, 18, 184, 229, 180, 176, 137, 105, 151, 74, 12, 150, 119, 126, 101, 185, 241, 9, 197, 110, 198, 132, 24, 240, 125, 236, 58, 220, 77, 32, 121, 238, 95, 62, 215, 203, 57, 72]),
    K$2 = (Uint8Array.prototype.Bonreefill = function () {
        Array.prototype.Bonreefill.apply(this, arguments)
    }, Uint8Array.prototype.Bonreeslice || (Uint8Array.prototype.Bonreeslice = function (Et) {
        return new Uint8Array(this).subarray(Et)
    }), new Uint32Array([462357, 472066609, 943670861, 1415275113, 1886879365, 2358483617, 2830087869, 3301692121, 3773296373, 4228057617, 404694573, 876298825, 1347903077, 1819507329, 2291111581, 2762715833, 3234320085, 3705924337, 4177462797, 337322537, 808926789, 1280531041, 1752135293, 2223739545, 2695343797, 3166948049, 3638552301, 4110090761, 269950501, 741554753, 1213159005, 1684763257])),
    g$5 = new Uint32Array([2746333894, 1453994832, 1736282519, 2993693404]);
let E$4 = class {
    constructor(Et) {
        if (this.Crypt = new P$4, Et = this.Crypt.stringToArrayBufferInUtf8(Et.key), Et.length !== 16) throw new Error("key should be a 16 bytes string");
        this.key = Et, this.mode = "ecb", this.encryptRoundKeys = new Uint32Array(32), this.spawnEncryptRoundKeys(), Uint32Array.prototype.reverse = function () {
            Array.prototype.reverse.apply(this, arguments)
        }, this.decryptRoundKeys = new Uint32Array(this.encryptRoundKeys), this.decryptRoundKeys.reverse()
    }
    doBlockCrypt(Et, es) {
        var ts = new Uint32Array(36);
        ts.set(Et, 0);
        for (var is = 0; is < 32; is++) ts[is + 4] = ts[is] ^ this.tTransform1(ts[is + 1] ^ ts[is + 2] ^ ts[is + 3] ^ es[is]);
        return Et = new Uint32Array(4), Et[0] = ts[35], Et[1] = ts[34], Et[2] = ts[33], Et[3] = ts[32], Et
    }
    spawnEncryptRoundKeys() {
        var Et = new Uint32Array(4),
            es = (Et[0] = this.key[0] << 24 | this.key[1] << 16 | this.key[2] << 8 | this.key[3], Et[1] = this.key[4] << 24 | this.key[5] << 16 | this.key[6] << 8 | this.key[7], Et[2] = this.key[8] << 24 | this.key[9] << 16 | this.key[10] << 8 | this.key[11], Et[3] = this.key[12] << 24 | this.key[13] << 16 | this.key[14] << 8 | this.key[15], new Uint32Array(36));
        es[0] = Et[0] ^ g$5[0], es[1] = Et[1] ^ g$5[1], es[2] = Et[2] ^ g$5[2], es[3] = Et[3] ^ g$5[3];
        for (var ts = 0; ts < 32; ts++) es[ts + 4] = es[ts] ^ this.tTransform2(es[ts + 1] ^ es[ts + 2] ^ es[ts + 3] ^ K$2[ts]), this.encryptRoundKeys[ts] = es[ts + 4]
    }
    rotateLeft(Et, es) {
        return Et << es | Et >>> 32 - es
    }
    linearTransform1(Et) {
        return Et ^ this.rotateLeft(Et, 2) ^ this.rotateLeft(Et, 10) ^ this.rotateLeft(Et, 18) ^ this.rotateLeft(Et, 24)
    }
    linearTransform2(Et) {
        return Et ^ this.rotateLeft(Et, 13) ^ this.rotateLeft(Et, 23)
    }
    tauTransform(Et) {
        return y$4[Et >>> 24 & 255] << 24 | y$4[Et >>> 16 & 255] << 16 | y$4[Et >>> 8 & 255] << 8 | y$4[255 & Et]
    }
    tTransform1(Et) {
        return Et = this.tauTransform(Et), this.linearTransform1(Et)
    }
    tTransform2(Et) {
        return Et = this.tauTransform(Et), this.linearTransform2(Et)
    }
    padding(Et) {
        var es, ts;
        return Et === null ? null : (es = l$2 - Et.length % l$2, (ts = new Uint8Array(Et.length + es)).set(Et, 0), ts.Bonreefill(es, Et.length), ts)
    }
    dePadding(Et) {
        var es;
        return Et === null ? null : (es = Et[Et.length - 1], Et.Bonreeslice(0, Et.length - es))
    }
    uint8ToUint32Block(Et, es) {
        es === void 0 && (es = 0);
        var ts = new Uint32Array(4);
        return ts[0] = Et[es] << 24 | Et[es + 1] << 16 | Et[es + 2] << 8 | Et[es + 3], ts[1] = Et[es + 4] << 24 | Et[es + 5] << 16 | Et[es + 6] << 8 | Et[es + 7], ts[2] = Et[es + 8] << 24 | Et[es + 9] << 16 | Et[es + 10] << 8 | Et[es + 11], ts[3] = Et[es + 12] << 24 | Et[es + 13] << 16 | Et[es + 14] << 8 | Et[es + 15], ts
    }
    encrypt(Et) {
        for (var Et = this.Crypt.stringToArrayBufferInUtf8(Et), es = this.padding(Et), ts = es.length / l$2, is = new Uint8Array(es.length), ns = 0; ns < ts; ns++)
            for (var rs = ns * l$2, ss = this.uint8ToUint32Block(es, rs), os = this.doBlockCrypt(ss, this.encryptRoundKeys), as = 0; as < l$2; as++) is[rs + as] = os[parseInt(as / 4)] >> (3 - as) % 4 * 8 & 255;
        return is
    }
};

function O$6() {
    return p$5(this, null, function* () {
        let Et = !1;
        var es;
        if (window.webkitRequestFileSystem && window.webkitRequestFileSystem(window.TEMPORARY, 1, function () {
                Et = !1
            }, function (ts) {
                Et = !0
            }), typeof InstallTrigger != "undefined" && (es = yield new Promise(function (ts, is) {
                try {
                    const ns = indexedDB.open("test");
                    ns.onerror = function () {
                        return ts(!0)
                    }, ns.onsuccess = function () {
                        return ts(!1)
                    }
                } catch (ns) {
                    return ts(!1)
                }
            }), Et = !!es), -1 < window.navigator.userAgent.indexOf("Edge") || -1 < window.navigator.userAgent.indexOf("Chrome"))
            if ("storage" in navigator && "estimate" in navigator.storage) {
                const {
                    usage: ts,
                    quota: is
                } = yield navigator.storage.estimate();
                Et = is < 12e8
            } else Et = !1;
        return Et
    })
}

function le$2(Et) {
    let es = Et.length;
    for (; 0 <= --es;) Et[es] = 0
}
document && document.addEventListener("readystatechange", Et => p$5(void 0, null, function* () {
    if (Et.target.readyState === "complete" && k$3()) try {
        var es = yield O$6();
        isDefined(window.bonreeRUM) && (bonreeRUM.isPrivate = es)
    } catch (ts) {
        log(ts)
    }
}));
const Bi = 0,
    yt$1 = 1,
    Ki = 2,
    Pi = 3,
    Xi = 258,
    Ye$1 = 29,
    ue$2 = 256,
    we$1 = ue$2 + 1 + Ye$1,
    fe$2 = 30,
    Ge = 19,
    mt$1 = 2 * we$1 + 1,
    Q$2 = 15,
    je$1 = 16,
    Yi = 7,
    We$1 = 256,
    zt$1 = 16,
    St$1 = 17,
    At$1 = 18,
    Ve$1 = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]),
    Ne$1 = new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]),
    Gi = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]),
    Rt$1 = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
    ji = 512,
    K$1 = new Array(2 * (we$1 + 2)),
    be$1 = (le$2(K$1), new Array(2 * fe$2)),
    ge$1 = (le$2(be$1), new Array(ji)),
    pe$3 = (le$2(ge$1), new Array(Xi - Pi + 1)),
    Je$1 = (le$2(pe$3), new Array(Ye$1)),
    Le$1 = (le$2(Je$1), new Array(fe$2));

function Qe$1(Et, es, ts, is, ns) {
    this.static_tree = Et, this.extra_bits = es, this.extra_base = ts, this.elems = is, this.max_length = ns, this.has_stree = Et && Et.length
}
let Tt$1, Dt, Zt$1;

function qe$1(Et, es) {
    this.dyn_tree = Et, this.max_code = 0, this.stat_desc = es
}
le$2(Le$1);
const It$1 = Et => Et < 256 ? ge$1[Et] : ge$1[256 + (Et >>> 7)],
    xe$1 = (Et, es) => {
        Et.pending_buf[Et.pending++] = 255 & es, Et.pending_buf[Et.pending++] = es >>> 8 & 255
    },
    N$3 = (Et, es, ts) => {
        Et.bi_valid > je$1 - ts ? (Et.bi_buf |= es << Et.bi_valid & 65535, xe$1(Et, Et.bi_buf), Et.bi_buf = es >> je$1 - Et.bi_valid, Et.bi_valid += ts - je$1) : (Et.bi_buf |= es << Et.bi_valid & 65535, Et.bi_valid += ts)
    },
    F$3 = (Et, es, ts) => {
        N$3(Et, ts[2 * es], ts[2 * es + 1])
    },
    Ot$1 = (Et, es) => {
        let ts = 0;
        for (; ts |= 1 & Et, Et >>>= 1, ts <<= 1, 0 < --es;);
        return ts >>> 1
    },
    Wi = Et => {
        Et.bi_valid === 16 ? (xe$1(Et, Et.bi_buf), Et.bi_buf = 0, Et.bi_valid = 0) : 8 <= Et.bi_valid && (Et.pending_buf[Et.pending++] = 255 & Et.bi_buf, Et.bi_buf >>= 8, Et.bi_valid -= 8)
    },
    Vi = (Et, es) => {
        var ts = es.dyn_tree,
            is = es.max_code,
            ns = es.stat_desc.static_tree,
            rs = es.stat_desc.has_stree,
            ss = es.stat_desc.extra_bits,
            os = es.stat_desc.extra_base,
            as = es.stat_desc.max_length;
        let cs, ds, fs, us, ls, hs, ms = 0;
        for (us = 0; us <= Q$2; us++) Et.bl_count[us] = 0;
        for (ts[2 * Et.heap[Et.heap_max] + 1] = 0, cs = Et.heap_max + 1; cs < mt$1; cs++) ds = Et.heap[cs], (us = ts[2 * ts[2 * ds + 1] + 1] + 1) > as && (us = as, ms++), ts[2 * ds + 1] = us, ds > is || (Et.bl_count[us]++, ls = 0, ds >= os && (ls = ss[ds - os]), hs = ts[2 * ds], Et.opt_len += hs * (us + ls), !rs) || (Et.static_len += hs * (ns[2 * ds + 1] + ls));
        if (ms !== 0) {
            do
                for (us = as - 1; Et.bl_count[us] === 0;) us--; while (Et.bl_count[us]--, Et.bl_count[us + 1] += 2, Et.bl_count[as]--, 0 < (ms -= 2));
            for (us = as; us !== 0; us--)
                for (ds = Et.bl_count[us]; ds !== 0;) is < (fs = Et.heap[--cs]) || (ts[2 * fs + 1] !== us && (Et.opt_len += (us - ts[2 * fs + 1]) * ts[2 * fs], ts[2 * fs + 1] = us), ds--)
        }
    },
    Nt$1 = (Et, es, ts) => {
        var is = new Array(Q$2 + 1);
        let ns, rs, ss = 0;
        for (ns = 1; ns <= Q$2; ns++) ss = ss + ts[ns - 1] << 1, is[ns] = ss;
        for (rs = 0; rs <= es; rs++) {
            var os = Et[2 * rs + 1];
            os !== 0 && (Et[2 * rs] = Ot$1(is[os]++, os))
        }
    },
    Ji = () => {
        let Et, es, ts, is, ns;
        var rs = new Array(Q$2 + 1);
        for (ts = 0, is = 0; is < Ye$1 - 1; is++)
            for (Je$1[is] = ts, Et = 0; Et < 1 << Ve$1[is]; Et++) pe$3[ts++] = is;
        for (pe$3[ts - 1] = is, ns = 0, is = 0; is < 16; is++)
            for (Le$1[is] = ns, Et = 0; Et < 1 << Ne$1[is]; Et++) ge$1[ns++] = is;
        for (ns >>= 7; is < fe$2; is++)
            for (Le$1[is] = ns << 7, Et = 0; Et < 1 << Ne$1[is] - 7; Et++) ge$1[256 + ns++] = is;
        for (es = 0; es <= Q$2; es++) rs[es] = 0;
        for (Et = 0; Et <= 143;) K$1[2 * Et + 1] = 8, Et++, rs[8]++;
        for (; Et <= 255;) K$1[2 * Et + 1] = 9, Et++, rs[9]++;
        for (; Et <= 279;) K$1[2 * Et + 1] = 7, Et++, rs[7]++;
        for (; Et <= 287;) K$1[2 * Et + 1] = 8, Et++, rs[8]++;
        for (Nt$1(K$1, we$1 + 1, rs), Et = 0; Et < fe$2; Et++) be$1[2 * Et + 1] = 5, be$1[2 * Et] = Ot$1(Et, 5);
        Tt$1 = new Qe$1(K$1, Ve$1, ue$2 + 1, we$1, Q$2), Dt = new Qe$1(be$1, Ne$1, 0, fe$2, Q$2), Zt$1 = new Qe$1(new Array(0), Gi, 0, Ge, Yi)
    },
    Lt = Et => {
        let es;
        for (es = 0; es < we$1; es++) Et.dyn_ltree[2 * es] = 0;
        for (es = 0; es < fe$2; es++) Et.dyn_dtree[2 * es] = 0;
        for (es = 0; es < Ge; es++) Et.bl_tree[2 * es] = 0;
        Et.dyn_ltree[2 * We$1] = 1, Et.opt_len = Et.static_len = 0, Et.sym_next = Et.matches = 0
    },
    Ut$1 = Et => {
        8 < Et.bi_valid ? xe$1(Et, Et.bi_buf) : 0 < Et.bi_valid && (Et.pending_buf[Et.pending++] = Et.bi_buf), Et.bi_buf = 0, Et.bi_valid = 0
    },
    Ct$1 = (Et, es, ts, is) => {
        var ns = 2 * es,
            rs = 2 * ts;
        return Et[ns] < Et[rs] || Et[ns] === Et[rs] && is[es] <= is[ts]
    },
    et$1 = (Et, es, ts) => {
        var is = Et.heap[ts];
        let ns = ts << 1;
        for (; ns <= Et.heap_len && (ns < Et.heap_len && Ct$1(es, Et.heap[ns + 1], Et.heap[ns], Et.depth) && ns++, !Ct$1(es, is, Et.heap[ns], Et.depth));) Et.heap[ts] = Et.heap[ns], ts = ns, ns <<= 1;
        Et.heap[ts] = is
    },
    $t$1 = (Et, es, ts) => {
        let is, ns, rs, ss, os = 0;
        if (Et.sym_next !== 0)
            for (; is = 255 & Et.pending_buf[Et.sym_buf + os++], is += (255 & Et.pending_buf[Et.sym_buf + os++]) << 8, ns = Et.pending_buf[Et.sym_buf + os++], is == 0 ? F$3(Et, ns, es) : (rs = pe$3[ns], F$3(Et, rs + ue$2 + 1, es), (ss = Ve$1[rs]) !== 0 && (ns -= Je$1[rs], N$3(Et, ns, ss)), is--, rs = It$1(is), F$3(Et, rs, ts), (ss = Ne$1[rs]) !== 0 && (is -= Le$1[rs], N$3(Et, is, ss))), os < Et.sym_next;);
        F$3(Et, We$1, es)
    },
    tt$1 = (Et, es) => {
        var ts = es.dyn_tree,
            is = es.stat_desc.static_tree,
            ns = es.stat_desc.has_stree,
            rs = es.stat_desc.elems;
        let ss, os, as, cs = -1;
        for (Et.heap_len = 0, Et.heap_max = mt$1, ss = 0; ss < rs; ss++) ts[2 * ss] !== 0 ? (Et.heap[++Et.heap_len] = cs = ss, Et.depth[ss] = 0) : ts[2 * ss + 1] = 0;
        for (; Et.heap_len < 2;) ts[2 * (as = Et.heap[++Et.heap_len] = cs < 2 ? ++cs : 0)] = 1, Et.depth[as] = 0, Et.opt_len--, ns && (Et.static_len -= is[2 * as + 1]);
        for (es.max_code = cs, ss = Et.heap_len >> 1; 1 <= ss; ss--) et$1(Et, ts, ss);
        for (as = rs; ss = Et.heap[1], Et.heap[1] = Et.heap[Et.heap_len--], et$1(Et, ts, 1), os = Et.heap[1], Et.heap[--Et.heap_max] = ss, Et.heap[--Et.heap_max] = os, ts[2 * as] = ts[2 * ss] + ts[2 * os], Et.depth[as] = (Et.depth[ss] >= Et.depth[os] ? Et.depth[ss] : Et.depth[os]) + 1, ts[2 * ss + 1] = ts[2 * os + 1] = as, Et.heap[1] = as++, et$1(Et, ts, 1), 2 <= Et.heap_len;);
        Et.heap[--Et.heap_max] = Et.heap[1], Vi(Et, es), Nt$1(ts, cs, Et.bl_count)
    },
    Ft$1 = (Et, es, ts) => {
        let is, ns, rs = -1,
            ss = es[1],
            os = 0,
            as = 7,
            cs = 4;
        for (ss === 0 && (as = 138, cs = 3), es[2 * (ts + 1) + 1] = 65535, is = 0; is <= ts; is++) ns = ss, ss = es[2 * (is + 1) + 1], ++os < as && ns === ss || (os < cs ? Et.bl_tree[2 * ns] += os : ns !== 0 ? (ns !== rs && Et.bl_tree[2 * ns]++, Et.bl_tree[2 * zt$1]++) : os <= 10 ? Et.bl_tree[2 * St$1]++ : Et.bl_tree[2 * At$1]++, os = 0, rs = ns, cs = ss === 0 ? (as = 138, 3) : ns === ss ? (as = 6, 3) : (as = 7, 4))
    },
    Mt$1 = (Et, es, ts) => {
        let is, ns, rs = -1,
            ss = es[1],
            os = 0,
            as = 7,
            cs = 4;
        for (ss === 0 && (as = 138, cs = 3), is = 0; is <= ts; is++)
            if (ns = ss, ss = es[2 * (is + 1) + 1], !(++os < as && ns === ss)) {
                if (os < cs)
                    for (; F$3(Et, ns, Et.bl_tree), --os != 0;);
                else ns !== 0 ? (ns !== rs && (F$3(Et, ns, Et.bl_tree), os--), F$3(Et, zt$1, Et.bl_tree), N$3(Et, os - 3, 2)) : os <= 10 ? (F$3(Et, St$1, Et.bl_tree), N$3(Et, os - 3, 3)) : (F$3(Et, At$1, Et.bl_tree), N$3(Et, os - 11, 7));
                os = 0, rs = ns, cs = ss === 0 ? (as = 138, 3) : ns === ss ? (as = 6, 3) : (as = 7, 4)
            }
    },
    Qi = Et => {
        let es;
        for (Ft$1(Et, Et.dyn_ltree, Et.l_desc.max_code), Ft$1(Et, Et.dyn_dtree, Et.d_desc.max_code), tt$1(Et, Et.bl_desc), es = Ge - 1; 3 <= es && Et.bl_tree[2 * Rt$1[es] + 1] === 0; es--);
        return Et.opt_len += 3 * (es + 1) + 5 + 5 + 4, es
    },
    qi = (Et, es, ts, is) => {
        let ns;
        for (N$3(Et, es - 257, 5), N$3(Et, ts - 1, 5), N$3(Et, is - 4, 4), ns = 0; ns < is; ns++) N$3(Et, Et.bl_tree[2 * Rt$1[ns] + 1], 3);
        Mt$1(Et, Et.dyn_ltree, es - 1), Mt$1(Et, Et.dyn_dtree, ts - 1)
    },
    en = Et => {
        let es, ts = 4093624447;
        for (es = 0; es <= 31; es++, ts >>>= 1)
            if (1 & ts && Et.dyn_ltree[2 * es] !== 0) return 0;
        if (Et.dyn_ltree[18] !== 0 || Et.dyn_ltree[20] !== 0 || Et.dyn_ltree[26] !== 0) return 1;
        for (es = 32; es < ue$2; es++)
            if (Et.dyn_ltree[2 * es] !== 0) return 1;
        return 0
    };
let Ht$1 = !1;
const tn = Et => {
        Ht$1 || (Ji(), Ht$1 = !0), Et.l_desc = new qe$1(Et.dyn_ltree, Tt$1), Et.d_desc = new qe$1(Et.dyn_dtree, Dt), Et.bl_desc = new qe$1(Et.bl_tree, Zt$1), Et.bi_buf = 0, Et.bi_valid = 0, Lt(Et)
    },
    Bt = (Et, es, ts, is) => {
        N$3(Et, (Bi << 1) + (is ? 1 : 0), 3), Ut$1(Et), xe$1(Et, ts), xe$1(Et, ~ts), ts && Et.pending_buf.set(Et.window.subarray(es, es + ts), Et.pending), Et.pending += ts
    },
    nn = Et => {
        N$3(Et, yt$1 << 1, 3), F$3(Et, We$1, K$1), Wi(Et)
    },
    an = (Et, es, ts, is) => {
        let ns, rs, ss = 0;
        0 < Et.level ? (Et.strm.data_type === 2 && (Et.strm.data_type = en(Et)), tt$1(Et, Et.l_desc), tt$1(Et, Et.d_desc), ss = Qi(Et), ns = Et.opt_len + 3 + 7 >>> 3, (rs = Et.static_len + 3 + 7 >>> 3) <= ns && (ns = rs)) : ns = rs = ts + 5, ts + 4 <= ns && es !== -1 ? Bt(Et, es, ts, is) : Et.strategy === 4 || rs === ns ? (N$3(Et, (yt$1 << 1) + (is ? 1 : 0), 3), $t$1(Et, K$1, be$1)) : (N$3(Et, (Ki << 1) + (is ? 1 : 0), 3), qi(Et, Et.l_desc.max_code + 1, Et.d_desc.max_code + 1, ss + 1), $t$1(Et, Et.dyn_ltree, Et.dyn_dtree)), Lt(Et), is && Ut$1(Et)
    },
    rn = (Et, es, ts) => (Et.pending_buf[Et.sym_buf + Et.sym_next++] = es, Et.pending_buf[Et.sym_buf + Et.sym_next++] = es >> 8, Et.pending_buf[Et.sym_buf + Et.sym_next++] = ts, es === 0 ? Et.dyn_ltree[2 * ts]++ : (Et.matches++, es--, Et.dyn_ltree[2 * (pe$3[ts] + ue$2 + 1)]++, Et.dyn_dtree[2 * It$1(es)]++), Et.sym_next === Et.sym_end);
var ln = tn,
    fn = Bt,
    on = an,
    _n = rn,
    hn = nn,
    dn = {
        _tr_init: ln,
        _tr_stored_block: fn,
        _tr_flush_block: on,
        _tr_tally: _n,
        _tr_align: hn
    };
const sn = (Et, es, ts, is) => {
    let ns = 65535 & Et | 0,
        rs = Et >>> 16 & 65535 | 0,
        ss = 0;
    for (; ts !== 0;) {
        for (ts -= ss = 2e3 < ts ? 2e3 : ts; ns = ns + es[is++] | 0, rs = rs + ns | 0, --ss;);
        ns %= 65521, rs %= 65521
    }
    return ns | rs << 16 | 0
};
var ve$1 = sn;
const cn = () => {
        let Et, es = [];
        for (var ts = 0; ts < 256; ts++) {
            Et = ts;
            for (var is = 0; is < 8; is++) Et = 1 & Et ? 3988292384 ^ Et >>> 1 : Et >>> 1;
            es[ts] = Et
        }
        return es
    },
    un = new Uint32Array(cn()),
    wn = (Et, es, ts, is) => {
        var ns = un,
            rs = is + ts;
        Et ^= -1;
        for (let ss = is; ss < rs; ss++) Et = Et >>> 8 ^ ns[255 & (Et ^ es[ss])];
        return -1 ^ Et
    };
var Z$1 = wn,
    q$2 = {
        2: "need dictionary",
        1: "stream end",
        0: "",
        "-1": "file error",
        "-2": "stream error",
        "-3": "data error",
        "-4": "insufficient memory",
        "-5": "buffer error",
        "-6": "incompatible version"
    },
    ee = {
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        Z_MEM_ERROR: -4,
        Z_BUF_ERROR: -5,
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,
        Z_BINARY: 0,
        Z_TEXT: 1,
        Z_UNKNOWN: 2,
        Z_DEFLATED: 8
    };
const {
    _tr_init: bn,
    _tr_stored_block: it$1,
    _tr_flush_block: gn,
    _tr_tally: Y,
    _tr_align: pn
} = dn, {
    Z_NO_FLUSH: G$1,
    Z_PARTIAL_FLUSH: xn,
    Z_FULL_FLUSH: vn,
    Z_FINISH: C$5,
    Z_BLOCK: Kt$1,
    Z_OK: I$4,
    Z_STREAM_END: Pt$1,
    Z_STREAM_ERROR: M$4,
    Z_DATA_ERROR: kn,
    Z_BUF_ERROR: nt$1,
    Z_DEFAULT_COMPRESSION: En,
    Z_FILTERED: yn,
    Z_HUFFMAN_ONLY: Ue$1,
    Z_RLE: mn,
    Z_FIXED: zn,
    Z_DEFAULT_STRATEGY: Sn,
    Z_UNKNOWN: An,
    Z_DEFLATED: Ce$1
} = ee, Rn = 9, Tn = 15, Dn = 8, Zn = 29, In = 256, at$1 = In + 1 + Zn, On = 30, Nn = 19, Ln = 2 * at$1 + 1, Un = 15, v$5 = 3, j = 258, H$4 = j + v$5 + 1, Cn = 32, oe$1 = 42, rt$1 = 57, lt$1 = 69, ft$1 = 73, ot$1 = 91, _t$1 = 103, te = 113, ke$1 = 666, O$5 = 1, _e$2 = 2, ie$2 = 3, he$3 = 4, $n = 3, ne = (Et, es) => (Et.msg = q$2[es], es), Xt$1 = Et => 2 * Et - (4 < Et ? 9 : 0), W$3 = Et => {
    let es = Et.length;
    for (; 0 <= --es;) Et[es] = 0
}, Fn = Et => {
    let es, ts, is, ns = Et.w_size;
    for (es = Et.hash_size, is = es; ts = Et.head[--is], Et.head[is] = ts >= ns ? ts - ns : 0, --es;);
    for (es = ns, is = es; ts = Et.prev[--is], Et.prev[is] = ts >= ns ? ts - ns : 0, --es;);
};
let Mn = (Et, es, ts) => (es << Et.hash_shift ^ ts) & Et.hash_mask,
    V$2 = Mn;
const L$6 = Et => {
        var es = Et.state;
        let ts = es.pending;
        (ts = ts > Et.avail_out ? Et.avail_out : ts) !== 0 && (Et.output.set(es.pending_buf.subarray(es.pending_out, es.pending_out + ts), Et.next_out), Et.next_out += ts, es.pending_out += ts, Et.total_out += ts, Et.avail_out -= ts, es.pending -= ts, es.pending === 0) && (es.pending_out = 0)
    },
    U$7 = (Et, es) => {
        gn(Et, 0 <= Et.block_start ? Et.block_start : -1, Et.strstart - Et.block_start, es), Et.block_start = Et.strstart, L$6(Et.strm)
    },
    z = (Et, es) => {
        Et.pending_buf[Et.pending++] = es
    },
    Ee$4 = (Et, es) => {
        Et.pending_buf[Et.pending++] = es >>> 8 & 255, Et.pending_buf[Et.pending++] = 255 & es
    },
    ht$1 = (Et, es, ts, is) => {
        let ns = Et.avail_in;
        return (ns = ns > is ? is : ns) === 0 ? 0 : (Et.avail_in -= ns, es.set(Et.input.subarray(Et.next_in, Et.next_in + ns), ts), Et.state.wrap === 1 ? Et.adler = ve$1(Et.adler, es, ns, ts) : Et.state.wrap === 2 && (Et.adler = Z$1(Et.adler, es, ns, ts)), Et.next_in += ns, Et.total_in += ns, ns)
    },
    Yt$1 = (Et, es) => {
        let ts, is, ns = Et.max_chain_length,
            rs = Et.strstart,
            ss = Et.prev_length,
            os = Et.nice_match;
        var as = Et.strstart > Et.w_size - H$4 ? Et.strstart - (Et.w_size - H$4) : 0,
            cs = Et.window,
            ds = Et.w_mask,
            fs = Et.prev,
            us = Et.strstart + j;
        let ls = cs[rs + ss - 1],
            hs = cs[rs + ss];
        Et.prev_length >= Et.good_match && (ns >>= 2), os > Et.lookahead && (os = Et.lookahead);
        do
            if (cs[(ts = es) + ss] === hs && cs[ts + ss - 1] === ls && cs[ts] === cs[rs] && cs[++ts] === cs[rs + 1]) {
                for (rs += 2, ts++; cs[++rs] === cs[++ts] && cs[++rs] === cs[++ts] && cs[++rs] === cs[++ts] && cs[++rs] === cs[++ts] && cs[++rs] === cs[++ts] && cs[++rs] === cs[++ts] && cs[++rs] === cs[++ts] && cs[++rs] === cs[++ts] && rs < us;);
                if (is = j - (us - rs), rs = us - j, is > ss) {
                    if (Et.match_start = es, (ss = is) >= os) break;
                    ls = cs[rs + ss - 1], hs = cs[rs + ss]
                }
            } while ((es = fs[es & ds]) > as && --ns != 0);
        return ss <= Et.lookahead ? ss : Et.lookahead
    },
    de$2 = Et => {
        var es = Et.w_size;
        let ts, is, ns;
        do {
            if (is = Et.window_size - Et.lookahead - Et.strstart, Et.strstart >= es + (es - H$4) && (Et.window.set(Et.window.subarray(es, es + es - is), 0), Et.match_start -= es, Et.strstart -= es, Et.block_start -= es, Et.insert > Et.strstart && (Et.insert = Et.strstart), Fn(Et), is += es), Et.strm.avail_in === 0) break;
            if (ts = ht$1(Et.strm, Et.window, Et.strstart + Et.lookahead, is), Et.lookahead += ts, Et.lookahead + Et.insert >= v$5)
                for (ns = Et.strstart - Et.insert, Et.ins_h = Et.window[ns], Et.ins_h = V$2(Et, Et.ins_h, Et.window[ns + 1]); Et.insert && (Et.ins_h = V$2(Et, Et.ins_h, Et.window[ns + v$5 - 1]), Et.prev[ns & Et.w_mask] = Et.head[Et.ins_h], Et.head[Et.ins_h] = ns, ns++, Et.insert--, !(Et.lookahead + Et.insert < v$5)););
        } while (Et.lookahead < H$4 && Et.strm.avail_in !== 0)
    },
    Gt$1 = (Et, es) => {
        let ts, is, ns, rs = Et.pending_buf_size - 5 > Et.w_size ? Et.w_size : Et.pending_buf_size - 5,
            ss = 0,
            os = Et.strm.avail_in;
        for (; ts = 65535, ns = Et.bi_valid + 42 >> 3, !(Et.strm.avail_out < ns || (ns = Et.strm.avail_out - ns, is = Et.strstart - Et.block_start, (ts = (ts = ts > is + Et.strm.avail_in ? is + Et.strm.avail_in : ts) > ns ? ns : ts) < rs && (ts === 0 && es !== C$5 || es === G$1 || ts !== is + Et.strm.avail_in))) && (ss = es === C$5 && ts === is + Et.strm.avail_in ? 1 : 0, it$1(Et, 0, 0, ss), Et.pending_buf[Et.pending - 4] = ts, Et.pending_buf[Et.pending - 3] = ts >> 8, Et.pending_buf[Et.pending - 2] = ~ts, Et.pending_buf[Et.pending - 1] = ~ts >> 8, L$6(Et.strm), is && (is > ts && (is = ts), Et.strm.output.set(Et.window.subarray(Et.block_start, Et.block_start + is), Et.strm.next_out), Et.strm.next_out += is, Et.strm.avail_out -= is, Et.strm.total_out += is, Et.block_start += is, ts -= is), ts && (ht$1(Et.strm, Et.strm.output, Et.strm.next_out, ts), Et.strm.next_out += ts, Et.strm.avail_out -= ts, Et.strm.total_out += ts), ss === 0););
        return (os -= Et.strm.avail_in) && (os >= Et.w_size ? (Et.matches = 2, Et.window.set(Et.strm.input.subarray(Et.strm.next_in - Et.w_size, Et.strm.next_in), 0), Et.strstart = Et.w_size, Et.insert = Et.strstart) : (Et.window_size - Et.strstart <= os && (Et.strstart -= Et.w_size, Et.window.set(Et.window.subarray(Et.w_size, Et.w_size + Et.strstart), 0), Et.matches < 2 && Et.matches++, Et.insert > Et.strstart) && (Et.insert = Et.strstart), Et.window.set(Et.strm.input.subarray(Et.strm.next_in - os, Et.strm.next_in), Et.strstart), Et.strstart += os, Et.insert += os > Et.w_size - Et.insert ? Et.w_size - Et.insert : os), Et.block_start = Et.strstart), Et.high_water < Et.strstart && (Et.high_water = Et.strstart), ss ? he$3 : es !== G$1 && es !== C$5 && Et.strm.avail_in === 0 && Et.strstart === Et.block_start ? _e$2 : (ns = Et.window_size - Et.strstart, Et.strm.avail_in > ns && Et.block_start >= Et.w_size && (Et.block_start -= Et.w_size, Et.strstart -= Et.w_size, Et.window.set(Et.window.subarray(Et.w_size, Et.w_size + Et.strstart), 0), Et.matches < 2 && Et.matches++, ns += Et.w_size, Et.insert > Et.strstart) && (Et.insert = Et.strstart), (ns = ns > Et.strm.avail_in ? Et.strm.avail_in : ns) && (ht$1(Et.strm, Et.window, Et.strstart, ns), Et.strstart += ns, Et.insert += ns > Et.w_size - Et.insert ? Et.w_size - Et.insert : ns), Et.high_water < Et.strstart && (Et.high_water = Et.strstart), ns = Et.bi_valid + 42 >> 3, ns = 65535 < Et.pending_buf_size - ns ? 65535 : Et.pending_buf_size - ns, rs = ns > Et.w_size ? Et.w_size : ns, ((is = Et.strstart - Et.block_start) >= rs || (is || es === C$5) && es !== G$1 && Et.strm.avail_in === 0 && is <= ns) && (ts = is > ns ? ns : is, ss = es === C$5 && Et.strm.avail_in === 0 && ts === is ? 1 : 0, it$1(Et, Et.block_start, ts, ss), Et.block_start += ts, L$6(Et.strm)), ss ? ie$2 : O$5)
    },
    dt$1 = (Et, es) => {
        let ts, is;
        for (;;) {
            if (Et.lookahead < H$4) {
                if (de$2(Et), Et.lookahead < H$4 && es === G$1) return O$5;
                if (Et.lookahead === 0) break
            }
            if (ts = 0, Et.lookahead >= v$5 && (Et.ins_h = V$2(Et, Et.ins_h, Et.window[Et.strstart + v$5 - 1]), ts = Et.prev[Et.strstart & Et.w_mask] = Et.head[Et.ins_h], Et.head[Et.ins_h] = Et.strstart), ts !== 0 && Et.strstart - ts <= Et.w_size - H$4 && (Et.match_length = Yt$1(Et, ts)), Et.match_length >= v$5)
                if (is = Y(Et, Et.strstart - Et.match_start, Et.match_length - v$5), Et.lookahead -= Et.match_length, Et.match_length <= Et.max_lazy_match && Et.lookahead >= v$5) {
                    for (Et.match_length--; Et.strstart++, Et.ins_h = V$2(Et, Et.ins_h, Et.window[Et.strstart + v$5 - 1]), ts = Et.prev[Et.strstart & Et.w_mask] = Et.head[Et.ins_h], Et.head[Et.ins_h] = Et.strstart, --Et.match_length != 0;);
                    Et.strstart++
                } else Et.strstart += Et.match_length, Et.match_length = 0, Et.ins_h = Et.window[Et.strstart], Et.ins_h = V$2(Et, Et.ins_h, Et.window[Et.strstart + 1]);
            else is = Y(Et, 0, Et.window[Et.strstart]), Et.lookahead--, Et.strstart++;
            if (is && (U$7(Et, !1), Et.strm.avail_out === 0)) return O$5
        }
        return Et.insert = Et.strstart < v$5 - 1 ? Et.strstart : v$5 - 1, es === C$5 ? (U$7(Et, !0), Et.strm.avail_out === 0 ? ie$2 : he$3) : Et.sym_next && (U$7(Et, !1), Et.strm.avail_out === 0) ? O$5 : _e$2
    },
    se$2 = (Et, es) => {
        let ts, is, ns;
        for (;;) {
            if (Et.lookahead < H$4) {
                if (de$2(Et), Et.lookahead < H$4 && es === G$1) return O$5;
                if (Et.lookahead === 0) break
            }
            if (ts = 0, Et.lookahead >= v$5 && (Et.ins_h = V$2(Et, Et.ins_h, Et.window[Et.strstart + v$5 - 1]), ts = Et.prev[Et.strstart & Et.w_mask] = Et.head[Et.ins_h], Et.head[Et.ins_h] = Et.strstart), Et.prev_length = Et.match_length, Et.prev_match = Et.match_start, Et.match_length = v$5 - 1, ts !== 0 && Et.prev_length < Et.max_lazy_match && Et.strstart - ts <= Et.w_size - H$4 && (Et.match_length = Yt$1(Et, ts), Et.match_length <= 5) && (Et.strategy === yn || Et.match_length === v$5 && 4096 < Et.strstart - Et.match_start) && (Et.match_length = v$5 - 1), Et.prev_length >= v$5 && Et.match_length <= Et.prev_length) {
                for (ns = Et.strstart + Et.lookahead - v$5, is = Y(Et, Et.strstart - 1 - Et.prev_match, Et.prev_length - v$5), Et.lookahead -= Et.prev_length - 1, Et.prev_length -= 2; ++Et.strstart <= ns && (Et.ins_h = V$2(Et, Et.ins_h, Et.window[Et.strstart + v$5 - 1]), ts = Et.prev[Et.strstart & Et.w_mask] = Et.head[Et.ins_h], Et.head[Et.ins_h] = Et.strstart), --Et.prev_length != 0;);
                if (Et.match_available = 0, Et.match_length = v$5 - 1, Et.strstart++, is && (U$7(Et, !1), Et.strm.avail_out === 0)) return O$5
            } else if (Et.match_available) {
                if ((is = Y(Et, 0, Et.window[Et.strstart - 1])) && U$7(Et, !1), Et.strstart++, Et.lookahead--, Et.strm.avail_out === 0) return O$5
            } else Et.match_available = 1, Et.strstart++, Et.lookahead--
        }
        return Et.match_available && (is = Y(Et, 0, Et.window[Et.strstart - 1]), Et.match_available = 0), Et.insert = Et.strstart < v$5 - 1 ? Et.strstart : v$5 - 1, es === C$5 ? (U$7(Et, !0), Et.strm.avail_out === 0 ? ie$2 : he$3) : Et.sym_next && (U$7(Et, !1), Et.strm.avail_out === 0) ? O$5 : _e$2
    },
    Hn = (Et, es) => {
        let ts, is, ns, rs;
        for (var ss = Et.window;;) {
            if (Et.lookahead <= j) {
                if (de$2(Et), Et.lookahead <= j && es === G$1) return O$5;
                if (Et.lookahead === 0) break
            }
            if (Et.match_length = 0, Et.lookahead >= v$5 && 0 < Et.strstart && (ns = Et.strstart - 1, (is = ss[ns]) === ss[++ns]) && is === ss[++ns] && is === ss[++ns]) {
                for (rs = Et.strstart + j; is === ss[++ns] && is === ss[++ns] && is === ss[++ns] && is === ss[++ns] && is === ss[++ns] && is === ss[++ns] && is === ss[++ns] && is === ss[++ns] && ns < rs;);
                Et.match_length = j - (rs - ns), Et.match_length > Et.lookahead && (Et.match_length = Et.lookahead)
            }
            if (Et.match_length >= v$5 ? (ts = Y(Et, 1, Et.match_length - v$5), Et.lookahead -= Et.match_length, Et.strstart += Et.match_length, Et.match_length = 0) : (ts = Y(Et, 0, Et.window[Et.strstart]), Et.lookahead--, Et.strstart++), ts && (U$7(Et, !1), Et.strm.avail_out === 0)) return O$5
        }
        return Et.insert = 0, es === C$5 ? (U$7(Et, !0), Et.strm.avail_out === 0 ? ie$2 : he$3) : Et.sym_next && (U$7(Et, !1), Et.strm.avail_out === 0) ? O$5 : _e$2
    },
    Bn = (Et, es) => {
        for (var ts;;) {
            if (Et.lookahead === 0 && (de$2(Et), Et.lookahead === 0)) {
                if (es === G$1) return O$5;
                break
            }
            if (Et.match_length = 0, ts = Y(Et, 0, Et.window[Et.strstart]), Et.lookahead--, Et.strstart++, ts && (U$7(Et, !1), Et.strm.avail_out === 0)) return O$5
        }
        return Et.insert = 0, es === C$5 ? (U$7(Et, !0), Et.strm.avail_out === 0 ? ie$2 : he$3) : Et.sym_next && (U$7(Et, !1), Et.strm.avail_out === 0) ? O$5 : _e$2
    };

function B$2(Et, es, ts, is, ns) {
    this.good_length = Et, this.max_lazy = es, this.nice_length = ts, this.max_chain = is, this.func = ns
}
const ye$1 = [new B$2(0, 0, 0, 0, Gt$1), new B$2(4, 4, 8, 4, dt$1), new B$2(4, 5, 16, 8, dt$1), new B$2(4, 6, 32, 32, dt$1), new B$2(4, 4, 16, 16, se$2), new B$2(8, 16, 32, 32, se$2), new B$2(8, 16, 128, 128, se$2), new B$2(8, 32, 128, 256, se$2), new B$2(32, 128, 258, 1024, se$2), new B$2(32, 258, 258, 4096, se$2)],
    Kn = Et => {
        Et.window_size = 2 * Et.w_size, W$3(Et.head), Et.max_lazy_match = ye$1[Et.level].max_lazy, Et.good_match = ye$1[Et.level].good_length, Et.nice_match = ye$1[Et.level].nice_length, Et.max_chain_length = ye$1[Et.level].max_chain, Et.strstart = 0, Et.block_start = 0, Et.lookahead = 0, Et.insert = 0, Et.match_length = Et.prev_length = v$5 - 1, Et.match_available = 0, Et.ins_h = 0
    };

function Pn() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Ce$1, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(2 * Ln), this.dyn_dtree = new Uint16Array(2 * (2 * On + 1)), this.bl_tree = new Uint16Array(2 * (2 * Nn + 1)), W$3(this.dyn_ltree), W$3(this.dyn_dtree), W$3(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(Un + 1), this.heap = new Uint16Array(2 * at$1 + 1), W$3(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * at$1 + 1), W$3(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0
}
const me$1 = Et => {
        var es;
        return !Et || !(es = Et.state) || es.strm !== Et || es.status !== oe$1 && es.status !== rt$1 && es.status !== lt$1 && es.status !== ft$1 && es.status !== ot$1 && es.status !== _t$1 && es.status !== te && es.status !== ke$1 ? 1 : 0
    },
    jt$1 = Et => {
        if (me$1(Et)) return ne(Et, M$4);
        Et.total_in = Et.total_out = 0, Et.data_type = An;
        var es = Et.state;
        return es.pending = 0, es.pending_out = 0, es.wrap < 0 && (es.wrap = -es.wrap), es.status = es.wrap === 2 ? rt$1 : es.wrap ? oe$1 : te, Et.adler = es.wrap === 2 ? 0 : 1, es.last_flush = -2, bn(es), I$4
    },
    Wt = Et => {
        var es = jt$1(Et);
        return es === I$4 && Kn(Et.state), es
    },
    Xn = (Et, es) => me$1(Et) || Et.state.wrap !== 2 ? M$4 : (Et.state.gzhead = es, I$4),
    Vt$1 = (Et, es, ts, is, ns, rs) => {
        if (!Et) return M$4;
        let ss = 1;
        if (es === En && (es = 6), is < 0 ? (ss = 0, is = -is) : 15 < is && (ss = 2, is -= 16), ns < 1 || ns > Rn || ts !== Ce$1 || is < 8 || 15 < is || es < 0 || 9 < es || rs < 0 || rs > zn || is === 8 && ss !== 1) return ne(Et, M$4);
        is === 8 && (is = 9);
        var os = new Pn;
        return (Et.state = os).strm = Et, os.status = oe$1, os.wrap = ss, os.gzhead = null, os.w_bits = is, os.w_size = 1 << os.w_bits, os.w_mask = os.w_size - 1, os.hash_bits = ns + 7, os.hash_size = 1 << os.hash_bits, os.hash_mask = os.hash_size - 1, os.hash_shift = ~~((os.hash_bits + v$5 - 1) / v$5), os.window = new Uint8Array(2 * os.w_size), os.head = new Uint16Array(os.hash_size), os.prev = new Uint16Array(os.w_size), os.lit_bufsize = 1 << ns + 6, os.pending_buf_size = 4 * os.lit_bufsize, os.pending_buf = new Uint8Array(os.pending_buf_size), os.sym_buf = os.lit_bufsize, os.sym_end = 3 * (os.lit_bufsize - 1), os.level = es, os.strategy = rs, os.method = ts, Wt(Et)
    },
    Yn = (Et, es) => Vt$1(Et, es, Ce$1, Tn, Dn, Sn),
    Gn = (Et, es) => {
        if (me$1(Et) || es > Kt$1 || es < 0) return Et ? ne(Et, M$4) : M$4;
        var ts = Et.state;
        if (!Et.output || Et.avail_in !== 0 && !Et.input || ts.status === ke$1 && es !== C$5) return ne(Et, Et.avail_out === 0 ? nt$1 : M$4);
        var is = ts.last_flush;
        if (ts.last_flush = es, ts.pending !== 0) {
            if (L$6(Et), Et.avail_out === 0) return ts.last_flush = -1, I$4
        } else if (Et.avail_in === 0 && Xt$1(es) <= Xt$1(is) && es !== C$5) return ne(Et, nt$1);
        if (ts.status === ke$1 && Et.avail_in !== 0) return ne(Et, nt$1);
        if (ts.status === oe$1 && ts.wrap === 0 && (ts.status = te), ts.status === oe$1) {
            let rs = Ce$1 + (ts.w_bits - 8 << 4) << 8,
                ss;
            if (ss = ts.strategy >= Ue$1 || ts.level < 2 ? 0 : ts.level < 6 ? 1 : ts.level === 6 ? 2 : 3, rs |= ss << 6, ts.strstart !== 0 && (rs |= Cn), rs += 31 - rs % 31, Ee$4(ts, rs), ts.strstart !== 0 && (Ee$4(ts, Et.adler >>> 16), Ee$4(ts, 65535 & Et.adler)), Et.adler = 1, ts.status = te, L$6(Et), ts.pending !== 0) return ts.last_flush = -1, I$4
        }
        if (ts.status === rt$1) {
            if (Et.adler = 0, z(ts, 31), z(ts, 139), z(ts, 8), ts.gzhead) z(ts, (ts.gzhead.text ? 1 : 0) + (ts.gzhead.hcrc ? 2 : 0) + (ts.gzhead.extra ? 4 : 0) + (ts.gzhead.name ? 8 : 0) + (ts.gzhead.comment ? 16 : 0)), z(ts, 255 & ts.gzhead.time), z(ts, ts.gzhead.time >> 8 & 255), z(ts, ts.gzhead.time >> 16 & 255), z(ts, ts.gzhead.time >> 24 & 255), z(ts, ts.level === 9 ? 2 : ts.strategy >= Ue$1 || ts.level < 2 ? 4 : 0), z(ts, 255 & ts.gzhead.os), ts.gzhead.extra && ts.gzhead.extra.length && (z(ts, 255 & ts.gzhead.extra.length), z(ts, ts.gzhead.extra.length >> 8 & 255)), ts.gzhead.hcrc && (Et.adler = Z$1(Et.adler, ts.pending_buf, ts.pending, 0)), ts.gzindex = 0, ts.status = lt$1;
            else if (z(ts, 0), z(ts, 0), z(ts, 0), z(ts, 0), z(ts, 0), z(ts, ts.level === 9 ? 2 : ts.strategy >= Ue$1 || ts.level < 2 ? 4 : 0), z(ts, $n), ts.status = te, L$6(Et), ts.pending !== 0) return ts.last_flush = -1, I$4
        }
        if (ts.status === lt$1) {
            if (ts.gzhead.extra) {
                let rs = ts.pending,
                    ss = (65535 & ts.gzhead.extra.length) - ts.gzindex;
                for (; ts.pending + ss > ts.pending_buf_size;) {
                    var ns = ts.pending_buf_size - ts.pending;
                    if (ts.pending_buf.set(ts.gzhead.extra.subarray(ts.gzindex, ts.gzindex + ns), ts.pending), ts.pending = ts.pending_buf_size, ts.gzhead.hcrc && ts.pending > rs && (Et.adler = Z$1(Et.adler, ts.pending_buf, ts.pending - rs, rs)), ts.gzindex += ns, L$6(Et), ts.pending !== 0) return ts.last_flush = -1, I$4;
                    rs = 0, ss -= ns
                }
                is = new Uint8Array(ts.gzhead.extra), ts.pending_buf.set(is.subarray(ts.gzindex, ts.gzindex + ss), ts.pending), ts.pending += ss, ts.gzhead.hcrc && ts.pending > rs && (Et.adler = Z$1(Et.adler, ts.pending_buf, ts.pending - rs, rs)), ts.gzindex = 0
            }
            ts.status = ft$1
        }
        if (ts.status === ft$1) {
            if (ts.gzhead.name) {
                let rs, ss = ts.pending;
                do
                    if (ts.pending === ts.pending_buf_size) {
                        if (ts.gzhead.hcrc && ts.pending > ss && (Et.adler = Z$1(Et.adler, ts.pending_buf, ts.pending - ss, ss)), L$6(Et), ts.pending !== 0) return ts.last_flush = -1, I$4;
                        ss = 0
                    } while (rs = ts.gzindex < ts.gzhead.name.length ? 255 & ts.gzhead.name.charCodeAt(ts.gzindex++) : 0, z(ts, rs), rs != 0);
                ts.gzhead.hcrc && ts.pending > ss && (Et.adler = Z$1(Et.adler, ts.pending_buf, ts.pending - ss, ss)), ts.gzindex = 0
            }
            ts.status = ot$1
        }
        if (ts.status === ot$1) {
            if (ts.gzhead.comment) {
                let rs, ss = ts.pending;
                do
                    if (ts.pending === ts.pending_buf_size) {
                        if (ts.gzhead.hcrc && ts.pending > ss && (Et.adler = Z$1(Et.adler, ts.pending_buf, ts.pending - ss, ss)), L$6(Et), ts.pending !== 0) return ts.last_flush = -1, I$4;
                        ss = 0
                    } while (rs = ts.gzindex < ts.gzhead.comment.length ? 255 & ts.gzhead.comment.charCodeAt(ts.gzindex++) : 0, z(ts, rs), rs != 0);
                ts.gzhead.hcrc && ts.pending > ss && (Et.adler = Z$1(Et.adler, ts.pending_buf, ts.pending - ss, ss))
            }
            ts.status = _t$1
        }
        if (ts.status === _t$1) {
            if (ts.gzhead.hcrc) {
                if (ts.pending + 2 > ts.pending_buf_size && (L$6(Et), ts.pending !== 0)) return ts.last_flush = -1, I$4;
                z(ts, 255 & Et.adler), z(ts, Et.adler >> 8 & 255), Et.adler = 0
            }
            if (ts.status = te, L$6(Et), ts.pending !== 0) return ts.last_flush = -1, I$4
        }
        if (Et.avail_in !== 0 || ts.lookahead !== 0 || es !== G$1 && ts.status !== ke$1) {
            if (is = ts.level === 0 ? Gt$1(ts, es) : ts.strategy === Ue$1 ? Bn(ts, es) : ts.strategy === mn ? Hn(ts, es) : ye$1[ts.level].func(ts, es), is !== ie$2 && is !== he$3 || (ts.status = ke$1), is === O$5 || is === ie$2) return Et.avail_out === 0 && (ts.last_flush = -1), I$4;
            if (is === _e$2 && (es === xn ? pn(ts) : es !== Kt$1 && (it$1(ts, 0, 0, !1), es === vn) && (W$3(ts.head), ts.lookahead === 0) && (ts.strstart = 0, ts.block_start = 0, ts.insert = 0), L$6(Et), Et.avail_out === 0)) return ts.last_flush = -1, I$4
        }
        return es !== C$5 || !(ts.wrap <= 0) && (ts.wrap === 2 ? (z(ts, 255 & Et.adler), z(ts, Et.adler >> 8 & 255), z(ts, Et.adler >> 16 & 255), z(ts, Et.adler >> 24 & 255), z(ts, 255 & Et.total_in), z(ts, Et.total_in >> 8 & 255), z(ts, Et.total_in >> 16 & 255), z(ts, Et.total_in >> 24 & 255)) : (Ee$4(ts, Et.adler >>> 16), Ee$4(ts, 65535 & Et.adler)), L$6(Et), 0 < ts.wrap && (ts.wrap = -ts.wrap), ts.pending !== 0) ? I$4 : Pt$1
    },
    jn = Et => {
        var es;
        return me$1(Et) ? M$4 : (es = Et.state.status, Et.state = null, es === te ? ne(Et, kn) : I$4)
    },
    Wn = (Et, es) => {
        let ts = es.length;
        if (me$1(Et)) return M$4;
        var is = Et.state,
            ns = is.wrap;
        if (ns === 2 || ns === 1 && is.status !== oe$1 || is.lookahead) return M$4;
        ns === 1 && (Et.adler = ve$1(Et.adler, es, ts, 0)), is.wrap = 0, ts >= is.w_size && (ns === 0 && (W$3(is.head), is.strstart = 0, is.block_start = 0, is.insert = 0), (rs = new Uint8Array(is.w_size)).set(es.subarray(ts - is.w_size, ts), 0), es = rs, ts = is.w_size);
        var rs = Et.avail_in,
            ss = Et.next_in,
            os = Et.input;
        for (Et.avail_in = ts, Et.next_in = 0, Et.input = es, de$2(is); is.lookahead >= v$5;) {
            let as = is.strstart,
                cs = is.lookahead - (v$5 - 1);
            for (; is.ins_h = V$2(is, is.ins_h, is.window[as + v$5 - 1]), is.prev[as & is.w_mask] = is.head[is.ins_h], is.head[is.ins_h] = as, as++, --cs;);
            is.strstart = as, is.lookahead = v$5 - 1, de$2(is)
        }
        return is.strstart += is.lookahead, is.block_start = is.strstart, is.insert = is.lookahead, is.lookahead = 0, is.match_length = is.prev_length = v$5 - 1, is.match_available = 0, Et.next_in = ss, Et.input = os, Et.avail_in = rs, is.wrap = ns, I$4
    };
var Vn = Yn,
    Jn = Vt$1,
    Qn = Wt,
    qn = jt$1,
    ea = Xn,
    ta = Gn,
    ia = jn,
    na = Wn,
    aa = "pako deflate (from Nodeca project)",
    ze$1 = {
        deflateInit: Vn,
        deflateInit2: Jn,
        deflateReset: Qn,
        deflateResetKeep: qn,
        deflateSetHeader: ea,
        deflate: ta,
        deflateEnd: ia,
        deflateSetDictionary: na,
        deflateInfo: aa
    };
const ra = (Et, es) => Object.prototype.hasOwnProperty.call(Et, es);
var la = function (Et) {
        const es = Array.prototype.slice.call(arguments, 1);
        for (; es.length;) {
            var ts = es.shift();
            if (ts) {
                if (typeof ts != "object") throw new TypeError(ts + "must be non-object");
                for (const is in ts) ra(ts, is) && (Et[is] = ts[is])
            }
        }
        return Et
    },
    fa = Et => {
        let es = 0;
        for (let ns = 0, rs = Et.length; ns < rs; ns++) es += Et[ns].length;
        var ts = new Uint8Array(es);
        for (let ns = 0, rs = 0, ss = Et.length; ns < ss; ns++) {
            var is = Et[ns];
            ts.set(is, rs), rs += is.length
        }
        return ts
    },
    $e$1 = {
        assign: la,
        flattenChunks: fa
    };
let Jt$1 = !0;
try {
    String.fromCharCode.apply(null, new Uint8Array(1))
} catch (Et) {
    Jt$1 = !1
}
const Se$1 = new Uint8Array(256);
for (let Et = 0; Et < 256; Et++) Se$1[Et] = 252 <= Et ? 6 : 248 <= Et ? 5 : 240 <= Et ? 4 : 224 <= Et ? 3 : 192 <= Et ? 2 : 1;
Se$1[254] = Se$1[254] = 1;
var oa = Et => {
    if (typeof TextEncoder == "function" && TextEncoder.prototype.encode) return new TextEncoder().encode(Et);
    let es, ts, is, ns, rs, ss = Et.length,
        os = 0;
    for (ns = 0; ns < ss; ns++)(64512 & (ts = Et.charCodeAt(ns))) == 55296 && ns + 1 < ss && (64512 & (is = Et.charCodeAt(ns + 1))) == 56320 && (ts = 65536 + (ts - 55296 << 10) + (is - 56320), ns++), os += ts < 128 ? 1 : ts < 2048 ? 2 : ts < 65536 ? 3 : 4;
    for (es = new Uint8Array(os), rs = 0, ns = 0; rs < os; ns++)(64512 & (ts = Et.charCodeAt(ns))) == 55296 && ns + 1 < ss && (64512 & (is = Et.charCodeAt(ns + 1))) == 56320 && (ts = 65536 + (ts - 55296 << 10) + (is - 56320), ns++), ts < 128 ? es[rs++] = ts : (ts < 2048 ? es[rs++] = 192 | ts >>> 6 : (ts < 65536 ? es[rs++] = 224 | ts >>> 12 : (es[rs++] = 240 | ts >>> 18, es[rs++] = 128 | ts >>> 12 & 63), es[rs++] = 128 | ts >>> 6 & 63), es[rs++] = 128 | 63 & ts);
    return es
};
const _a = (Et, es) => {
    if (es < 65534 && Et.subarray && Jt$1) return String.fromCharCode.apply(null, Et.length === es ? Et : Et.subarray(0, es));
    let ts = "";
    for (let is = 0; is < es; is++) ts += String.fromCharCode(Et[is]);
    return ts
};
var ha = (Et, es) => {
        var ts = es || Et.length;
        if (typeof TextDecoder == "function" && TextDecoder.prototype.decode) return new TextDecoder().decode(Et.subarray(0, es));
        let is, ns;
        var rs = new Array(2 * ts);
        for (ns = 0, is = 0; is < ts;) {
            let ss = Et[is++];
            if (ss < 128) rs[ns++] = ss;
            else {
                let os = Se$1[ss];
                if (4 < os) rs[ns++] = 65533, is += os - 1;
                else {
                    for (ss &= os === 2 ? 31 : os === 3 ? 15 : 7; 1 < os && is < ts;) ss = ss << 6 | 63 & Et[is++], os--;
                    1 < os ? rs[ns++] = 65533 : ss < 65536 ? rs[ns++] = ss : (ss -= 65536, rs[ns++] = 55296 | ss >> 10 & 1023, rs[ns++] = 56320 | 1023 & ss)
                }
            }
        }
        return _a(rs, ns)
    },
    da = (Et, es) => {
        let ts = (es = (es = es || Et.length) > Et.length ? Et.length : es) - 1;
        for (; 0 <= ts && (192 & Et[ts]) == 128;) ts--;
        return !(ts < 0 || ts === 0) && ts + Se$1[Et[ts]] > es ? ts : es
    },
    Ae$1 = {
        string2buf: oa,
        buf2string: ha,
        utf8border: da
    };

function sa() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0
}
var Qt$1 = sa;
const qt$1 = Object.prototype.toString,
    {
        Z_NO_FLUSH: ca,
        Z_SYNC_FLUSH: ua,
        Z_FULL_FLUSH: wa,
        Z_FINISH: ba,
        Z_OK: Fe$1,
        Z_STREAM_END: ga,
        Z_DEFAULT_COMPRESSION: pa,
        Z_DEFAULT_STRATEGY: xa,
        Z_DEFLATED: va
    } = ee;

function Re$2(Et) {
    if (this.options = $e$1.assign({
            level: pa,
            method: va,
            chunkSize: 16384,
            windowBits: 15,
            memLevel: 8,
            strategy: xa
        }, Et || {}), Et = this.options, Et.raw && 0 < Et.windowBits ? Et.windowBits = -Et.windowBits : Et.gzip && 0 < Et.windowBits && Et.windowBits < 16 && (Et.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Qt$1, this.strm.avail_out = 0, (es = ze$1.deflateInit2(this.strm, Et.level, Et.method, Et.windowBits, Et.memLevel, Et.strategy)) !== Fe$1) throw new Error(q$2[es]);
    if (Et.header && ze$1.deflateSetHeader(this.strm, Et.header), Et.dictionary) {
        var es, Et = typeof Et.dictionary == "string" ? Ae$1.string2buf(Et.dictionary) : qt$1.call(Et.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(Et.dictionary) : Et.dictionary;
        if ((es = ze$1.deflateSetDictionary(this.strm, Et)) !== Fe$1) throw new Error(q$2[es]);
        this._dict_set = !0
    }
}

function st$1(Et, es) {
    if (es = new Re$2(es), es.push(Et, !0), es.err) throw es.msg || q$2[es.err];
    return es.result
}

function ka(Et, es) {
    return (es = es || {}).raw = !0, st$1(Et, es)
}

function Ea(Et, es) {
    return (es = es || {}).gzip = !0, st$1(Et, es)
}
Re$2.prototype.push = function (Et, es) {
    var ts, is, ns = this.strm,
        rs = this.options.chunkSize;
    if (this.ended) return !1;
    for (is = es === ~~es ? es : es === !0 ? ba : ca, typeof Et == "string" ? ns.input = Ae$1.string2buf(Et) : qt$1.call(Et) === "[object ArrayBuffer]" ? ns.input = new Uint8Array(Et) : ns.input = Et, ns.next_in = 0, ns.avail_in = ns.input.length;;)
        if (ns.avail_out === 0 && (ns.output = new Uint8Array(rs), ns.next_out = 0, ns.avail_out = rs), (is === ua || is === wa) && ns.avail_out <= 6) this.onData(ns.output.subarray(0, ns.next_out)), ns.avail_out = 0;
        else {
            if (ze$1.deflate(ns, is) === ga) return 0 < ns.next_out && this.onData(ns.output.subarray(0, ns.next_out)), ts = ze$1.deflateEnd(this.strm), this.onEnd(ts), this.ended = !0, ts === Fe$1;
            if (ns.avail_out !== 0) {
                if (0 < is && 0 < ns.next_out) this.onData(ns.output.subarray(0, ns.next_out)), ns.avail_out = 0;
                else if (ns.avail_in === 0) break
            } else this.onData(ns.output)
        } return !0
}, Re$2.prototype.onData = function (Et) {
    this.chunks.push(Et)
}, Re$2.prototype.onEnd = function (Et) {
    Et === Fe$1 && (this.result = $e$1.flattenChunks(this.chunks)), this.chunks = [], this.err = Et, this.msg = this.strm.msg
};
var ya = Re$2,
    ma = st$1,
    za = ka,
    Sa = Ea,
    Aa = ee,
    Ra = {
        Deflate: ya,
        deflate: ma,
        deflateRaw: za,
        gzip: Sa,
        constants: Aa
    };
const Me$1 = 16209,
    Ta = 16191;
var Da = function (Et, es) {
    let ts, is, ns, rs, ss, os, as, cs, ds, fs, us, ls, hs, ms, ps, gs, ws, $s, bs, Es, Ts, Ss, Cs, vs;
    var ys = Et.state;
    ts = Et.next_in, Cs = Et.input, is = ts + (Et.avail_in - 5), ns = Et.next_out, vs = Et.output, rs = ns - (es - Et.avail_out), ss = ns + (Et.avail_out - 257), os = ys.dmax, as = ys.wsize, cs = ys.whave, ds = ys.wnext, fs = ys.window, us = ys.hold, ls = ys.bits, hs = ys.lencode, ms = ys.distcode, ps = (1 << ys.lenbits) - 1, gs = (1 << ys.distbits) - 1;
    e: do
            for (ls < 15 && (us += Cs[ts++] << ls, ls += 8, us += Cs[ts++] << ls, ls += 8), ws = hs[us & ps];;) {
                if ($s = ws >>> 24, us >>>= $s, ls -= $s, ($s = ws >>> 16 & 255) === 0) vs[ns++] = 65535 & ws;
                else {
                    if (!(16 & $s)) {
                        if (64 & $s) {
                            if (32 & $s) {
                                ys.mode = Ta;
                                break e
                            }
                            Et.msg = "invalid literal/length code", ys.mode = Me$1;
                            break e
                        }
                        ws = hs[(65535 & ws) + (us & (1 << $s) - 1)];
                        continue
                    }
                    for (bs = 65535 & ws, ($s &= 15) && (ls < $s && (us += Cs[ts++] << ls, ls += 8), bs += us & (1 << $s) - 1, us >>>= $s, ls -= $s), ls < 15 && (us += Cs[ts++] << ls, ls += 8, us += Cs[ts++] << ls, ls += 8), ws = ms[us & gs];;) {
                        if ($s = ws >>> 24, us >>>= $s, ls -= $s, 16 & ($s = ws >>> 16 & 255)) {
                            if (Es = 65535 & ws, $s &= 15, ls < $s && (us += Cs[ts++] << ls, (ls += 8) < $s) && (us += Cs[ts++] << ls, ls += 8), os < (Es += us & (1 << $s) - 1)) {
                                Et.msg = "invalid distance too far back", ys.mode = Me$1;
                                break e
                            }
                            if (us >>>= $s, ls -= $s, Es > ($s = ns - rs)) {
                                if (($s = Es - $s) > cs && ys.sane) {
                                    Et.msg = "invalid distance too far back", ys.mode = Me$1;
                                    break e
                                }
                                if (Ts = 0, Ss = fs, ds === 0) {
                                    if (Ts += as - $s, $s < bs) {
                                        for (bs -= $s; vs[ns++] = fs[Ts++], --$s;);
                                        Ts = ns - Es, Ss = vs
                                    }
                                } else if (ds < $s) {
                                    if (Ts += as + ds - $s, ($s -= ds) < bs) {
                                        for (bs -= $s; vs[ns++] = fs[Ts++], --$s;);
                                        if (Ts = 0, ds < bs) {
                                            for ($s = ds, bs -= $s; vs[ns++] = fs[Ts++], --$s;);
                                            Ts = ns - Es, Ss = vs
                                        }
                                    }
                                } else if (Ts += ds - $s, $s < bs) {
                                    for (bs -= $s; vs[ns++] = fs[Ts++], --$s;);
                                    Ts = ns - Es, Ss = vs
                                }
                                for (; 2 < bs;) vs[ns++] = Ss[Ts++], vs[ns++] = Ss[Ts++], vs[ns++] = Ss[Ts++], bs -= 3;
                                bs && (vs[ns++] = Ss[Ts++], 1 < bs) && (vs[ns++] = Ss[Ts++])
                            } else {
                                for (Ts = ns - Es; vs[ns++] = vs[Ts++], vs[ns++] = vs[Ts++], vs[ns++] = vs[Ts++], 2 < (bs -= 3););
                                bs && (vs[ns++] = vs[Ts++], 1 < bs) && (vs[ns++] = vs[Ts++])
                            }
                            break
                        }
                        if (64 & $s) {
                            Et.msg = "invalid distance code", ys.mode = Me$1;
                            break e
                        }
                        ws = ms[(65535 & ws) + (us & (1 << $s) - 1)]
                    }
                }
                break
            }
        while (ts < is && ns < ss);
        bs = ls >> 3, ts -= bs, ls -= bs << 3, us &= (1 << ls) - 1, Et.next_in = ts, Et.next_out = ns, Et.avail_in = ts < is ? is - ts + 5 : 5 - (ts - is), Et.avail_out = ns < ss ? ss - ns + 257 : 257 - (ns - ss), ys.hold = us, ys.bits = ls
};
const ce$1 = 15,
    ei = 852,
    ti = 592,
    ii = 0,
    ct$1 = 1,
    ni = 2,
    Za = new Uint16Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]),
    Ia = new Uint8Array([16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78]),
    Oa = new Uint16Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]),
    Na = new Uint8Array([16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64]),
    La = (Et, es, ts, is, ns, rs, ss, os) => {
        var as = os.bits;
        let cs, ds, fs, us, ls, hs, ms = 0,
            ps = 0,
            gs = 0,
            ws = 0,
            $s = 0,
            bs = 0,
            Es = 0,
            Ts = 0,
            Ss = 0,
            Cs = 0,
            vs = null;
        var ys = new Uint16Array(ce$1 + 1),
            As = new Uint16Array(ce$1 + 1);
        let ks, xs, Gs, Ns = null;
        for (ms = 0; ms <= ce$1; ms++) ys[ms] = 0;
        for (ps = 0; ps < is; ps++) ys[es[ts + ps]]++;
        for ($s = as, ws = ce$1; 1 <= ws && ys[ws] === 0; ws--);
        if ($s > ws && ($s = ws), ws === 0) ns[rs++] = 20971520, ns[rs++] = 20971520, os.bits = 1;
        else {
            for (gs = 1; gs < ws && ys[gs] === 0; gs++);
            for ($s < gs && ($s = gs), Ts = 1, ms = 1; ms <= ce$1; ms++)
                if ((Ts = (Ts <<= 1) - ys[ms]) < 0) return -1;
            if (0 < Ts && (Et === ii || ws !== 1)) return -1;
            for (As[1] = 0, ms = 1; ms < ce$1; ms++) As[ms + 1] = As[ms] + ys[ms];
            for (ps = 0; ps < is; ps++) es[ts + ps] !== 0 && (ss[As[es[ts + ps]]++] = ps);
            if (hs = Et === ii ? (vs = Ns = ss, 20) : Et === ct$1 ? (vs = Za, Ns = Ia, 257) : (vs = Oa, Ns = Na, 0), Cs = 0, ps = 0, ms = gs, ls = rs, bs = $s, Es = 0, fs = -1, us = (Ss = 1 << $s) - 1, Et === ct$1 && Ss > ei || Et === ni && Ss > ti) return 1;
            for (;;) {
                for (ks = ms - Es, Gs = ss[ps] + 1 < hs ? (xs = 0, ss[ps]) : ss[ps] >= hs ? (xs = Ns[ss[ps] - hs], vs[ss[ps] - hs]) : (xs = 96, 0), cs = 1 << ms - Es, ds = 1 << bs, gs = ds; ds -= cs, ns[ls + (Cs >> Es) + ds] = ks << 24 | xs << 16 | Gs | 0, ds !== 0;);
                for (cs = 1 << ms - 1; Cs & cs;) cs >>= 1;
                if (cs !== 0 ? Cs = (Cs &= cs - 1) + cs : Cs = 0, ps++, --ys[ms] == 0) {
                    if (ms === ws) break;
                    ms = es[ts + ss[ps]]
                }
                if (ms > $s && (Cs & us) !== fs) {
                    for (Es === 0 && (Es = $s), ls += gs, bs = ms - Es, Ts = 1 << bs; bs + Es < ws && !((Ts -= ys[bs + Es]) <= 0);) bs++, Ts <<= 1;
                    if (Ss += 1 << bs, Et === ct$1 && Ss > ei || Et === ni && Ss > ti) return 1;
                    ns[fs = Cs & us] = $s << 24 | bs << 16 | ls - rs | 0
                }
            }
            Cs !== 0 && (ns[ls + Cs] = ms - Es << 24 | 64 << 16 | 0), os.bits = $s
        }
        return 0
    };
var Te$2 = La;
const Ua = 0,
    ai = 1,
    ri = 2,
    {
        Z_FINISH: li,
        Z_BLOCK: Ca,
        Z_TREES: He$1,
        Z_OK: ae$1,
        Z_STREAM_END: $a,
        Z_NEED_DICT: Fa,
        Z_STREAM_ERROR: $$3,
        Z_DATA_ERROR: fi,
        Z_MEM_ERROR: oi,
        Z_BUF_ERROR: Ma,
        Z_DEFLATED: _i
    } = ee,
    Be = 16180,
    hi = 16181,
    di = 16182,
    si = 16183,
    ci = 16184,
    ui = 16185,
    wi = 16186,
    bi = 16187,
    gi = 16188,
    pi = 16189,
    Ke$1 = 16190,
    P$3 = 16191,
    ut$1 = 16192,
    xi = 16193,
    wt$1 = 16194,
    vi = 16195,
    ki = 16196,
    Ei = 16197,
    yi = 16198,
    Pe$1 = 16199,
    Xe$1 = 16200,
    mi = 16201,
    zi = 16202,
    Si = 16203,
    Ai = 16204,
    Ri = 16205,
    bt$1 = 16206,
    Ti = 16207,
    Di = 16208,
    R$2 = 16209,
    Zi = 16210,
    Ii = 16211,
    Ha = 852,
    Ba = 592,
    Ka = 15,
    Pa = Ka,
    Oi = Et => (Et >>> 24 & 255) + (Et >>> 8 & 65280) + ((65280 & Et) << 8) + ((255 & Et) << 24);

function Xa() {
    this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0
}
const re$1 = Et => {
        var es;
        return !Et || !(es = Et.state) || es.strm !== Et || es.mode < Be || es.mode > Ii ? 1 : 0
    },
    Ni = Et => {
        var es;
        return re$1(Et) ? $$3 : (es = Et.state, Et.total_in = Et.total_out = es.total = 0, Et.msg = "", es.wrap && (Et.adler = 1 & es.wrap), es.mode = Be, es.last = 0, es.havedict = 0, es.flags = -1, es.dmax = 32768, es.head = null, es.hold = 0, es.bits = 0, es.lencode = es.lendyn = new Int32Array(Ha), es.distcode = es.distdyn = new Int32Array(Ba), es.sane = 1, es.back = -1, ae$1)
    },
    Li = Et => {
        var es;
        return re$1(Et) ? $$3 : ((es = Et.state).wsize = 0, es.whave = 0, es.wnext = 0, Ni(Et))
    },
    Ui = (Et, es) => {
        let ts;
        var is;
        return re$1(Et) || (is = Et.state, es < 0 ? (ts = 0, es = -es) : (ts = 5 + (es >> 4), es < 48 && (es &= 15)), es && (es < 8 || 15 < es)) ? $$3 : (is.window !== null && is.wbits !== es && (is.window = null), is.wrap = ts, is.wbits = es, Li(Et))
    },
    Ci = (Et, es) => {
        var ts;
        return Et ? (ts = new Xa, (Et.state = ts).strm = Et, ts.window = null, ts.mode = Be, (ts = Ui(Et, es)) !== ae$1 && (Et.state = null), ts) : $$3
    },
    Ya = Et => Ci(Et, Pa);
let $i = !0,
    gt$1, pt$1;
const Ga = Et => {
        if ($i) {
            gt$1 = new Int32Array(512), pt$1 = new Int32Array(32);
            let es = 0;
            for (; es < 144;) Et.lens[es++] = 8;
            for (; es < 256;) Et.lens[es++] = 9;
            for (; es < 280;) Et.lens[es++] = 7;
            for (; es < 288;) Et.lens[es++] = 8;
            for (Te$2(ai, Et.lens, 0, 288, gt$1, 0, Et.work, {
                    bits: 9
                }), es = 0; es < 32;) Et.lens[es++] = 5;
            Te$2(ri, Et.lens, 0, 32, pt$1, 0, Et.work, {
                bits: 5
            }), $i = !1
        }
        Et.lencode = gt$1, Et.lenbits = 9, Et.distcode = pt$1, Et.distbits = 5
    },
    Fi = (Et, es, ts, is) => {
        let ns;
        return Et = Et.state, Et.window === null && (Et.wsize = 1 << Et.wbits, Et.wnext = 0, Et.whave = 0, Et.window = new Uint8Array(Et.wsize)), is >= Et.wsize ? (Et.window.set(es.subarray(ts - Et.wsize, ts), 0), Et.wnext = 0, Et.whave = Et.wsize) : ((ns = Et.wsize - Et.wnext) > is && (ns = is), Et.window.set(es.subarray(ts - is, ts - is + ns), Et.wnext), (is -= ns) ? (Et.window.set(es.subarray(ts - is, ts), 0), Et.wnext = is, Et.whave = Et.wsize) : (Et.wnext += ns, Et.wnext === Et.wsize && (Et.wnext = 0), Et.whave < Et.wsize && (Et.whave += ns))), 0
    },
    ja = (Et, es) => {
        let ts, is, ns, rs, ss, os, as, cs, ds, fs, us, ls, hs, ms, ps, gs, ws, $s, bs, Es, Ts, Ss, Cs = 0;
        var vs = new Uint8Array(4);
        let ys, As;
        var ks = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
        if (re$1(Et) || !Et.output || !Et.input && Et.avail_in !== 0) return $$3;
        (ts = Et.state).mode === P$3 && (ts.mode = ut$1), ss = Et.next_out, ns = Et.output, as = Et.avail_out, rs = Et.next_in, is = Et.input, os = Et.avail_in, cs = ts.hold, ds = ts.bits, fs = os, us = as, Ss = ae$1;
        e: for (;;) switch (ts.mode) {
            case Be:
                if (ts.wrap === 0) ts.mode = ut$1;
                else {
                    for (; ds < 16;) {
                        if (os === 0) break e;
                        os--, cs += is[rs++] << ds, ds += 8
                    }
                    2 & ts.wrap && cs === 35615 ? (ts.wbits === 0 && (ts.wbits = 15), vs[ts.check = 0] = 255 & cs, vs[1] = cs >>> 8 & 255, ts.check = Z$1(ts.check, vs, 2, 0), cs = 0, ds = 0, ts.mode = hi) : (ts.head && (ts.head.done = !1), !(1 & ts.wrap) || (((255 & cs) << 8) + (cs >> 8)) % 31 ? (Et.msg = "incorrect header check", ts.mode = R$2) : (15 & cs) !== _i ? (Et.msg = "unknown compression method", ts.mode = R$2) : (cs >>>= 4, ds -= 4, Ts = 8 + (15 & cs), ts.wbits === 0 && (ts.wbits = Ts), 15 < Ts || Ts > ts.wbits ? (Et.msg = "invalid window size", ts.mode = R$2) : (ts.dmax = 1 << ts.wbits, ts.flags = 0, Et.adler = ts.check = 1, ts.mode = 512 & cs ? pi : P$3, cs = 0, ds = 0)))
                }
                break;
            case hi:
                for (; ds < 16;) {
                    if (os === 0) break e;
                    os--, cs += is[rs++] << ds, ds += 8
                }
                if (ts.flags = cs, (255 & ts.flags) !== _i) {
                    Et.msg = "unknown compression method", ts.mode = R$2;
                    break
                }
                if (57344 & ts.flags) {
                    Et.msg = "unknown header flags set", ts.mode = R$2;
                    break
                }
                ts.head && (ts.head.text = cs >> 8 & 1), 512 & ts.flags && 4 & ts.wrap && (vs[0] = 255 & cs, vs[1] = cs >>> 8 & 255, ts.check = Z$1(ts.check, vs, 2, 0)), cs = 0, ds = 0, ts.mode = di;
            case di:
                for (; ds < 32;) {
                    if (os === 0) break e;
                    os--, cs += is[rs++] << ds, ds += 8
                }
                ts.head && (ts.head.time = cs), 512 & ts.flags && 4 & ts.wrap && (vs[0] = 255 & cs, vs[1] = cs >>> 8 & 255, vs[2] = cs >>> 16 & 255, vs[3] = cs >>> 24 & 255, ts.check = Z$1(ts.check, vs, 4, 0)), cs = 0, ds = 0, ts.mode = si;
            case si:
                for (; ds < 16;) {
                    if (os === 0) break e;
                    os--, cs += is[rs++] << ds, ds += 8
                }
                ts.head && (ts.head.xflags = 255 & cs, ts.head.os = cs >> 8), 512 & ts.flags && 4 & ts.wrap && (vs[0] = 255 & cs, vs[1] = cs >>> 8 & 255, ts.check = Z$1(ts.check, vs, 2, 0)), cs = 0, ds = 0, ts.mode = ci;
            case ci:
                if (1024 & ts.flags) {
                    for (; ds < 16;) {
                        if (os === 0) break e;
                        os--, cs += is[rs++] << ds, ds += 8
                    }
                    ts.length = cs, ts.head && (ts.head.extra_len = cs), 512 & ts.flags && 4 & ts.wrap && (vs[0] = 255 & cs, vs[1] = cs >>> 8 & 255, ts.check = Z$1(ts.check, vs, 2, 0)), cs = 0, ds = 0
                } else ts.head && (ts.head.extra = null);
                ts.mode = ui;
            case ui:
                if (1024 & ts.flags && ((ls = (ls = ts.length) > os ? os : ls) && (ts.head && (Ts = ts.head.extra_len - ts.length, ts.head.extra || (ts.head.extra = new Uint8Array(ts.head.extra_len)), ts.head.extra.set(is.subarray(rs, rs + ls), Ts)), 512 & ts.flags && 4 & ts.wrap && (ts.check = Z$1(ts.check, is, ls, rs)), os -= ls, rs += ls, ts.length -= ls), ts.length)) break e;
                ts.length = 0, ts.mode = wi;
            case wi:
                if (2048 & ts.flags) {
                    if (os === 0) break e;
                    for (ls = 0; Ts = is[rs + ls++], ts.head && Ts && ts.length < 65536 && (ts.head.name += String.fromCharCode(Ts)), Ts && ls < os;);
                    if (512 & ts.flags && 4 & ts.wrap && (ts.check = Z$1(ts.check, is, ls, rs)), os -= ls, rs += ls, Ts) break e
                } else ts.head && (ts.head.name = null);
                ts.length = 0, ts.mode = bi;
            case bi:
                if (4096 & ts.flags) {
                    if (os === 0) break e;
                    for (ls = 0; Ts = is[rs + ls++], ts.head && Ts && ts.length < 65536 && (ts.head.comment += String.fromCharCode(Ts)), Ts && ls < os;);
                    if (512 & ts.flags && 4 & ts.wrap && (ts.check = Z$1(ts.check, is, ls, rs)), os -= ls, rs += ls, Ts) break e
                } else ts.head && (ts.head.comment = null);
                ts.mode = gi;
            case gi:
                if (512 & ts.flags) {
                    for (; ds < 16;) {
                        if (os === 0) break e;
                        os--, cs += is[rs++] << ds, ds += 8
                    }
                    if (4 & ts.wrap && cs !== (65535 & ts.check)) {
                        Et.msg = "header crc mismatch", ts.mode = R$2;
                        break
                    }
                    cs = 0, ds = 0
                }
                ts.head && (ts.head.hcrc = ts.flags >> 9 & 1, ts.head.done = !0), Et.adler = ts.check = 0, ts.mode = P$3;
                break;
            case pi:
                for (; ds < 32;) {
                    if (os === 0) break e;
                    os--, cs += is[rs++] << ds, ds += 8
                }
                Et.adler = ts.check = Oi(cs), cs = 0, ds = 0, ts.mode = Ke$1;
            case Ke$1:
                if (ts.havedict === 0) return Et.next_out = ss, Et.avail_out = as, Et.next_in = rs, Et.avail_in = os, ts.hold = cs, ts.bits = ds, Fa;
                Et.adler = ts.check = 1, ts.mode = P$3;
            case P$3:
                if (es === Ca || es === He$1) break e;
            case ut$1:
                if (ts.last) cs >>>= 7 & ds, ds -= 7 & ds, ts.mode = bt$1;
                else {
                    for (; ds < 3;) {
                        if (os === 0) break e;
                        os--, cs += is[rs++] << ds, ds += 8
                    }
                    switch (ts.last = 1 & cs, cs >>>= 1, --ds, 3 & cs) {
                        case 0:
                            ts.mode = xi;
                            break;
                        case 1:
                            if (Ga(ts), ts.mode = Pe$1, es !== He$1) break;
                            cs >>>= 2, ds -= 2;
                            break e;
                        case 2:
                            ts.mode = ki;
                            break;
                        case 3:
                            Et.msg = "invalid block type", ts.mode = R$2
                    }
                    cs >>>= 2, ds -= 2
                }
                break;
            case xi:
                for (cs >>>= 7 & ds, ds -= 7 & ds; ds < 32;) {
                    if (os === 0) break e;
                    os--, cs += is[rs++] << ds, ds += 8
                }
                if ((65535 & cs) != (cs >>> 16 ^ 65535)) {
                    Et.msg = "invalid stored block lengths", ts.mode = R$2;
                    break
                }
                if (ts.length = 65535 & cs, cs = 0, ds = 0, ts.mode = wt$1, es === He$1) break e;
            case wt$1:
                ts.mode = vi;
            case vi:
                if (ls = ts.length) {
                    if ((ls = (ls = ls > os ? os : ls) > as ? as : ls) === 0) break e;
                    ns.set(is.subarray(rs, rs + ls), ss), os -= ls, rs += ls, as -= ls, ss += ls, ts.length -= ls
                } else ts.mode = P$3;
                break;
            case ki:
                for (; ds < 14;) {
                    if (os === 0) break e;
                    os--, cs += is[rs++] << ds, ds += 8
                }
                if (ts.nlen = 257 + (31 & cs), cs >>>= 5, ds -= 5, ts.ndist = 1 + (31 & cs), cs >>>= 5, ds -= 5, ts.ncode = 4 + (15 & cs), cs >>>= 4, ds -= 4, 286 < ts.nlen || 30 < ts.ndist) {
                    Et.msg = "too many length or distance symbols", ts.mode = R$2;
                    break
                }
                ts.have = 0, ts.mode = Ei;
            case Ei:
                for (; ts.have < ts.ncode;) {
                    for (; ds < 3;) {
                        if (os === 0) break e;
                        os--, cs += is[rs++] << ds, ds += 8
                    }
                    ts.lens[ks[ts.have++]] = 7 & cs, cs >>>= 3, ds -= 3
                }
                for (; ts.have < 19;) ts.lens[ks[ts.have++]] = 0;
                if (ts.lencode = ts.lendyn, ts.lenbits = 7, ys = {
                        bits: ts.lenbits
                    }, Ss = Te$2(Ua, ts.lens, 0, 19, ts.lencode, 0, ts.work, ys), ts.lenbits = ys.bits, Ss) {
                    Et.msg = "invalid code lengths set", ts.mode = R$2;
                    break
                }
                ts.have = 0, ts.mode = yi;
            case yi:
                for (; ts.have < ts.nlen + ts.ndist;) {
                    for (; Cs = ts.lencode[cs & (1 << ts.lenbits) - 1], ps = Cs >>> 24, gs = Cs >>> 16 & 255, ws = 65535 & Cs, !(ps <= ds);) {
                        if (os === 0) break e;
                        os--, cs += is[rs++] << ds, ds += 8
                    }
                    if (ws < 16) cs >>>= ps, ds -= ps, ts.lens[ts.have++] = ws;
                    else {
                        if (ws === 16) {
                            for (As = ps + 2; ds < As;) {
                                if (os === 0) break e;
                                os--, cs += is[rs++] << ds, ds += 8
                            }
                            if (cs >>>= ps, ds -= ps, ts.have === 0) {
                                Et.msg = "invalid bit length repeat", ts.mode = R$2;
                                break
                            }
                            Ts = ts.lens[ts.have - 1], ls = 3 + (3 & cs), cs >>>= 2, ds -= 2
                        } else if (ws === 17) {
                            for (As = ps + 3; ds < As;) {
                                if (os === 0) break e;
                                os--, cs += is[rs++] << ds, ds += 8
                            }
                            cs >>>= ps, ds -= ps, Ts = 0, ls = 3 + (7 & cs), cs >>>= 3, ds -= 3
                        } else {
                            for (As = ps + 7; ds < As;) {
                                if (os === 0) break e;
                                os--, cs += is[rs++] << ds, ds += 8
                            }
                            cs >>>= ps, ds -= ps, Ts = 0, ls = 11 + (127 & cs), cs >>>= 7, ds -= 7
                        }
                        if (ts.have + ls > ts.nlen + ts.ndist) {
                            Et.msg = "invalid bit length repeat", ts.mode = R$2;
                            break
                        }
                        for (; ls--;) ts.lens[ts.have++] = Ts
                    }
                }
                if (ts.mode === R$2) break;
                if (ts.lens[256] === 0) {
                    Et.msg = "invalid code -- missing end-of-block", ts.mode = R$2;
                    break
                }
                if (ts.lenbits = 9, ys = {
                        bits: ts.lenbits
                    }, Ss = Te$2(ai, ts.lens, 0, ts.nlen, ts.lencode, 0, ts.work, ys), ts.lenbits = ys.bits, Ss) {
                    Et.msg = "invalid literal/lengths set", ts.mode = R$2;
                    break
                }
                if (ts.distbits = 6, ts.distcode = ts.distdyn, ys = {
                        bits: ts.distbits
                    }, Ss = Te$2(ri, ts.lens, ts.nlen, ts.ndist, ts.distcode, 0, ts.work, ys), ts.distbits = ys.bits, Ss) {
                    Et.msg = "invalid distances set", ts.mode = R$2;
                    break
                }
                if (ts.mode = Pe$1, es === He$1) break e;
            case Pe$1:
                ts.mode = Xe$1;
            case Xe$1:
                if (6 <= os && 258 <= as) {
                    Et.next_out = ss, Et.avail_out = as, Et.next_in = rs, Et.avail_in = os, ts.hold = cs, ts.bits = ds, Da(Et, us), ss = Et.next_out, ns = Et.output, as = Et.avail_out, rs = Et.next_in, is = Et.input, os = Et.avail_in, cs = ts.hold, ds = ts.bits, ts.mode === P$3 && (ts.back = -1);
                    break
                }
                for (ts.back = 0; Cs = ts.lencode[cs & (1 << ts.lenbits) - 1], ps = Cs >>> 24, gs = Cs >>> 16 & 255, ws = 65535 & Cs, !(ps <= ds);) {
                    if (os === 0) break e;
                    os--, cs += is[rs++] << ds, ds += 8
                }
                if (gs && !(240 & gs)) {
                    for ($s = ps, bs = gs, Es = ws; Cs = ts.lencode[Es + ((cs & (1 << $s + bs) - 1) >> $s)], ps = Cs >>> 24, gs = Cs >>> 16 & 255, ws = 65535 & Cs, !($s + ps <= ds);) {
                        if (os === 0) break e;
                        os--, cs += is[rs++] << ds, ds += 8
                    }
                    cs >>>= $s, ds -= $s, ts.back += $s
                }
                if (cs >>>= ps, ds -= ps, ts.back += ps, ts.length = ws, gs === 0) {
                    ts.mode = Ri;
                    break
                }
                if (32 & gs) {
                    ts.back = -1, ts.mode = P$3;
                    break
                }
                if (64 & gs) {
                    Et.msg = "invalid literal/length code", ts.mode = R$2;
                    break
                }
                ts.extra = 15 & gs, ts.mode = mi;
            case mi:
                if (ts.extra) {
                    for (As = ts.extra; ds < As;) {
                        if (os === 0) break e;
                        os--, cs += is[rs++] << ds, ds += 8
                    }
                    ts.length += cs & (1 << ts.extra) - 1, cs >>>= ts.extra, ds -= ts.extra, ts.back += ts.extra
                }
                ts.was = ts.length, ts.mode = zi;
            case zi:
                for (; Cs = ts.distcode[cs & (1 << ts.distbits) - 1], ps = Cs >>> 24, gs = Cs >>> 16 & 255, ws = 65535 & Cs, !(ps <= ds);) {
                    if (os === 0) break e;
                    os--, cs += is[rs++] << ds, ds += 8
                }
                if (!(240 & gs)) {
                    for ($s = ps, bs = gs, Es = ws; Cs = ts.distcode[Es + ((cs & (1 << $s + bs) - 1) >> $s)], ps = Cs >>> 24, gs = Cs >>> 16 & 255, ws = 65535 & Cs, !($s + ps <= ds);) {
                        if (os === 0) break e;
                        os--, cs += is[rs++] << ds, ds += 8
                    }
                    cs >>>= $s, ds -= $s, ts.back += $s
                }
                if (cs >>>= ps, ds -= ps, ts.back += ps, 64 & gs) {
                    Et.msg = "invalid distance code", ts.mode = R$2;
                    break
                }
                ts.offset = ws, ts.extra = 15 & gs, ts.mode = Si;
            case Si:
                if (ts.extra) {
                    for (As = ts.extra; ds < As;) {
                        if (os === 0) break e;
                        os--, cs += is[rs++] << ds, ds += 8
                    }
                    ts.offset += cs & (1 << ts.extra) - 1, cs >>>= ts.extra, ds -= ts.extra, ts.back += ts.extra
                }
                if (ts.offset > ts.dmax) {
                    Et.msg = "invalid distance too far back", ts.mode = R$2;
                    break
                }
                ts.mode = Ai;
            case Ai:
                if (as === 0) break e;
                if (ls = us - as, ts.offset > ls) {
                    if ((ls = ts.offset - ls) > ts.whave && ts.sane) {
                        Et.msg = "invalid distance too far back", ts.mode = R$2;
                        break
                    }
                    hs = ls > ts.wnext ? (ls -= ts.wnext, ts.wsize - ls) : ts.wnext - ls, ls > ts.length && (ls = ts.length), ms = ts.window
                } else ms = ns, hs = ss - ts.offset, ls = ts.length;
                for (ls > as && (ls = as), as -= ls, ts.length -= ls; ns[ss++] = ms[hs++], --ls;);
                ts.length === 0 && (ts.mode = Xe$1);
                break;
            case Ri:
                if (as === 0) break e;
                ns[ss++] = ts.length, as--, ts.mode = Xe$1;
                break;
            case bt$1:
                if (ts.wrap) {
                    for (; ds < 32;) {
                        if (os === 0) break e;
                        os--, cs |= is[rs++] << ds, ds += 8
                    }
                    if (us -= as, Et.total_out += us, ts.total += us, 4 & ts.wrap && us && (Et.adler = ts.check = (ts.flags ? Z$1 : ve$1)(ts.check, ns, us, ss - us)), us = as, 4 & ts.wrap && (ts.flags ? cs : Oi(cs)) !== ts.check) {
                        Et.msg = "incorrect data check", ts.mode = R$2;
                        break
                    }
                    cs = 0, ds = 0
                }
                ts.mode = Ti;
            case Ti:
                if (ts.wrap && ts.flags) {
                    for (; ds < 32;) {
                        if (os === 0) break e;
                        os--, cs += is[rs++] << ds, ds += 8
                    }
                    if (4 & ts.wrap && cs !== (4294967295 & ts.total)) {
                        Et.msg = "incorrect length check", ts.mode = R$2;
                        break
                    }
                    cs = 0, ds = 0
                }
                ts.mode = Di;
            case Di:
                Ss = $a;
                break e;
            case R$2:
                Ss = fi;
                break e;
            case Zi:
                return oi;
            default:
                return $$3
        }
        return Et.next_out = ss, Et.avail_out = as, Et.next_in = rs, Et.avail_in = os, ts.hold = cs, ts.bits = ds, (ts.wsize || us !== Et.avail_out && ts.mode < R$2 && (ts.mode < bt$1 || es !== li)) && Fi(Et, Et.output, Et.next_out, us - Et.avail_out), fs -= Et.avail_in, us -= Et.avail_out, Et.total_in += fs, Et.total_out += us, ts.total += us, 4 & ts.wrap && us && (Et.adler = ts.check = (ts.flags ? Z$1 : ve$1)(ts.check, ns, us, Et.next_out - us)), Et.data_type = ts.bits + (ts.last ? 64 : 0) + (ts.mode === P$3 ? 128 : 0) + (ts.mode === Pe$1 || ts.mode === wt$1 ? 256 : 0), Ss = (fs == 0 && us === 0 || es === li) && Ss === ae$1 ? Ma : Ss
    },
    Wa = Et => {
        var es;
        return re$1(Et) ? $$3 : ((es = Et.state).window && (es.window = null), Et.state = null, ae$1)
    },
    Va = (Et, es) => !re$1(Et) && 2 & (Et = Et.state).wrap ? ((Et.head = es).done = !1, ae$1) : $$3,
    Ja = (Et, es) => {
        var ts = es.length;
        let is;
        return re$1(Et) || (is = Et.state).wrap !== 0 && is.mode !== Ke$1 ? $$3 : is.mode === Ke$1 && ve$1(1, es, ts, 0) !== is.check ? fi : Fi(Et, es, ts, ts) ? (is.mode = Zi, oi) : (is.havedict = 1, ae$1)
    };
var Qa = Li,
    qa = Ui,
    er$1 = Ni,
    tr$1 = Ya,
    ir$1 = Ci,
    nr$1 = ja,
    ar$1 = Wa,
    rr$1 = Va,
    lr$1 = Ja,
    fr$1 = "pako inflate (from Nodeca project)",
    X$3 = {
        inflateReset: Qa,
        inflateReset2: qa,
        inflateResetKeep: er$1,
        inflateInit: tr$1,
        inflateInit2: ir$1,
        inflate: nr$1,
        inflateEnd: ar$1,
        inflateGetHeader: rr$1,
        inflateSetDictionary: lr$1,
        inflateInfo: fr$1
    };

function or$1() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1
}
var _r$1 = or$1;
const Mi = Object.prototype.toString,
    {
        Z_NO_FLUSH: hr$1,
        Z_FINISH: dr$1,
        Z_OK: De$1,
        Z_STREAM_END: xt,
        Z_NEED_DICT: vt$1,
        Z_STREAM_ERROR: sr$1,
        Z_DATA_ERROR: Hi,
        Z_MEM_ERROR: cr$1
    } = ee;

function Ze$1(Et) {
    this.options = $e$1.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ""
    }, Et || {});
    var es = this.options;
    es.raw && 0 <= es.windowBits && es.windowBits < 16 && (es.windowBits = -es.windowBits, es.windowBits === 0) && (es.windowBits = -15), !(0 <= es.windowBits && es.windowBits < 16) || Et && Et.windowBits || (es.windowBits += 32), 15 < es.windowBits && es.windowBits < 48 && (15 & es.windowBits || (es.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Qt$1, this.strm.avail_out = 0;
    let ts = X$3.inflateInit2(this.strm, es.windowBits);
    if (ts !== De$1) throw new Error(q$2[ts]);
    if (this.header = new _r$1, X$3.inflateGetHeader(this.strm, this.header), es.dictionary && (typeof es.dictionary == "string" ? es.dictionary = Ae$1.string2buf(es.dictionary) : Mi.call(es.dictionary) === "[object ArrayBuffer]" && (es.dictionary = new Uint8Array(es.dictionary)), es.raw) && (ts = X$3.inflateSetDictionary(this.strm, es.dictionary)) !== De$1) throw new Error(q$2[ts])
}

function kt$1(Et, es) {
    if (es = new Ze$1(es), es.push(Et), es.err) throw es.msg || q$2[es.err];
    return es.result
}

function ur$1(Et, es) {
    return (es = es || {}).raw = !0, kt$1(Et, es)
}
Ze$1.prototype.push = function (Et, es) {
    var ts, is, ns, rs = this.strm,
        ss = this.options.chunkSize,
        os = this.options.dictionary;
    let as, cs, ds;
    if (this.ended) return !1;
    for (cs = es === ~~es ? es : es === !0 ? dr$1 : hr$1, Mi.call(Et) === "[object ArrayBuffer]" ? rs.input = new Uint8Array(Et) : rs.input = Et, rs.next_in = 0, rs.avail_in = rs.input.length;;) {
        for (rs.avail_out === 0 && (rs.output = new Uint8Array(ss), rs.next_out = 0, rs.avail_out = ss), (as = X$3.inflate(rs, cs)) === vt$1 && os && ((as = X$3.inflateSetDictionary(rs, os)) === De$1 ? as = X$3.inflate(rs, cs) : as === Hi && (as = vt$1)); 0 < rs.avail_in && as === xt && 0 < rs.state.wrap && Et[rs.next_in] !== 0;) X$3.inflateReset(rs), as = X$3.inflate(rs, cs);
        switch (as) {
            case sr$1:
            case Hi:
            case vt$1:
            case cr$1:
                return this.onEnd(as), !(this.ended = !0)
        }
        if (ds = rs.avail_out, !rs.next_out || rs.avail_out !== 0 && as !== xt || (this.options.to === "string" ? (ts = Ae$1.utf8border(rs.output, rs.next_out), is = rs.next_out - ts, ns = Ae$1.buf2string(rs.output, ts), rs.next_out = is, rs.avail_out = ss - is, is && rs.output.set(rs.output.subarray(ts, ts + is), 0), this.onData(ns)) : this.onData(rs.output.length === rs.next_out ? rs.output : rs.output.subarray(0, rs.next_out))), as !== De$1 || ds !== 0) {
            if (as === xt) return as = X$3.inflateEnd(this.strm), this.onEnd(as), this.ended = !0;
            if (rs.avail_in === 0) break
        }
    }
    return !0
}, Ze$1.prototype.onData = function (Et) {
    this.chunks.push(Et)
}, Ze$1.prototype.onEnd = function (Et) {
    Et === De$1 && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = $e$1.flattenChunks(this.chunks)), this.chunks = [], this.err = Et, this.msg = this.strm.msg
};
var wr$1 = Ze$1,
    br$1 = kt$1,
    gr$1 = ur$1,
    pr$1 = kt$1,
    xr$1 = ee,
    vr$1 = {
        Inflate: wr$1,
        inflate: br$1,
        inflateRaw: gr$1,
        ungzip: pr$1,
        constants: xr$1
    };
const {
    Deflate: kr$1,
    deflate: Er$1,
    deflateRaw: yr$1,
    gzip: mr$1
} = Ra, {
    Inflate: zr$1,
    inflate: Sr$1,
    inflateRaw: Ar$1,
    ungzip: Rr$1
} = vr$1;
var Tr$1 = kr$1,
    Dr$1 = Er$1,
    Zr$1 = yr$1,
    Ir$1 = mr$1,
    Or$1 = zr$1,
    Nr$1 = Sr$1,
    Lr$1 = Ar$1,
    Ur$1 = Rr$1,
    Cr$1 = ee,
    $r = {
        Deflate: Tr$1,
        deflate: Dr$1,
        deflateRaw: Zr$1,
        gzip: Ir$1,
        Inflate: Or$1,
        inflate: Nr$1,
        inflateRaw: Lr$1,
        ungzip: Ur$1,
        constants: Cr$1
    },
    ve = [],
    se$1 = 0,
    be = "",
    E$3;
const Gt = 10485760;
let Ae = !1,
    de$1 = 0,
    he$2 = [];

function _t(Et) {
    return Et.nodeType === Et.ELEMENT_NODE
}

function we(Et) {
    var es = Et == null ? void 0 : Et.host;
    return (es == null ? void 0 : es.shadowRoot) === Et
}

function ke(Et) {
    return Object.prototype.toString.call(Et) === "[object ShadowRoot]"
}

function Ut(Et) {
    return Et = Et.includes(" background-clip: text;") && !Et.includes(" -webkit-background-clip: text;") ? Et.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;") : Et
}

function _e$1(Et) {
    try {
        var es = Et.rules || Et.cssRules;
        return es ? Ut(Array.from(es).map(Je).join("")) : null
    } catch (ts) {
        return null
    }
}

function Je(Et) {
    var es = Et.cssText;
    if (Zt(Et)) try {
        es = _e$1(Et.styleSheet) || es
    } catch (ts) {}
    return es
}

function Zt(Et) {
    return "styleSheet" in Et
}(function (Et) {
    Et[Et.Document = 0] = "Document", Et[Et.DocumentType = 1] = "DocumentType", Et[Et.Element = 2] = "Element", Et[Et.Text = 3] = "Text", Et[Et.CDATA = 4] = "CDATA", Et[Et.Comment = 5] = "Comment"
})(E$3 = E$3 || {});
var Qe = function () {
    function Et() {
        this.idNodeMap = new s$4, this.nodeMetaMap = new WeakMap
    }
    return Et.prototype.getId = function (es) {
        return es && (es = (es = this.getMeta(es)) == null ? void 0 : es.id) != null ? es : -1
    }, Et.prototype.getNode = function (es) {
        return this.idNodeMap.get(es) || null
    }, Et.prototype.getIds = function () {
        return Array.from(this.idNodeMap.keys())
    }, Et.prototype.getMeta = function (es) {
        return this.nodeMetaMap.get(es) || null
    }, Et.prototype.removeNodeFromMap = function (es) {
        var ts = this,
            is = this.getId(es);
        this.idNodeMap.delete(is), es.childNodes && es.childNodes.forEach(function (ns) {
            return ts.removeNodeFromMap(ns)
        })
    }, Et.prototype.has = function (es) {
        return this.idNodeMap.has(es)
    }, Et.prototype.hasNode = function (es) {
        return this.nodeMetaMap.has(es)
    }, Et.prototype.add = function (es, ts) {
        var is = ts.id;
        this.idNodeMap.set(is, es), this.nodeMetaMap.set(es, ts)
    }, Et.prototype.replace = function (es, ts) {
        var is = this.getNode(es);
        is && (is = this.nodeMetaMap.get(is)) && this.nodeMetaMap.set(ts, is), this.idNodeMap.set(es, ts)
    }, Et.prototype.reset = function () {
        this.idNodeMap = new s$4, this.nodeMetaMap = new WeakMap
    }, Et
}();

function Vt() {
    return new Qe
}

function Ue(ns) {
    var es = ns.maskInputOptions,
        ts = ns.tagName,
        is = ns.type,
        rs = ns.value,
        ns = ns.maskInputFn,
        rs = rs || "";
    return rs = es[ts.toLowerCase()] || es[is] ? ns ? ns(rs) : "*".repeat(rs.length) : rs
}
var Pe = "__rrweb_original__";

function Kt(Et) {
    var es = Et.getContext("2d");
    if (es)
        for (var ts = 0; ts < Et.width; ts += 50)
            for (var is = 0; is < Et.height; is += 50) {
                var ns = es.getImageData,
                    ns = Pe in ns ? ns[Pe] : ns;
                if (new Uint32Array(ns.call(es, ts, is, Math.min(50, Et.width - ts), Math.min(50, Et.height - is)).data.buffer).some(function (rs) {
                        return rs !== 0
                    })) return !1
            }
    return !0
}
var zt = 1,
    Yt = new RegExp("[^a-z0-9-_:]"),
    Me = -2;

function Xe() {
    return zt++
}

function Ht(Et) {
    return Et instanceof HTMLFormElement ? "form" : (Et = Et.tagName.toLowerCase().trim(), Yt.test(Et) ? "div" : Et)
}

function Jt(Et) {
    return Et.cssRules ? Array.from(Et.cssRules).map(function (es) {
        return es.cssText || ""
    }).join("") : ""
}

function Qt(Et) {
    return (-1 < Et.indexOf("//") ? Et.split("/").slice(0, 3).join("/") : Et.split("/")[0]).split("?")[0]
}
var fe$1, je, Pt = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm,
    Xt = /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/|#).*/,
    jt = /^(data:)([^,]*),(.*)/i;

function Te$1(Et, es) {
    return (Et || "").replace(Pt, function (ts, is, ns, rs, ss, cs) {
        if (ns = ns || ss || cs, ss = is || rs || "", !ns) return ts;
        if (!Xt.test(ns) || jt.test(ns)) return "url(".concat(ss).concat(ns).concat(ss, ")");
        if (ns[0] === "/") return "url(".concat(ss).concat(Qt(es) + ns).concat(ss, ")");
        var as = es.split("/"),
            cs = ns.split("/");
        as.pop();
        for (var ds = 0, fs = cs; ds < fs.length; ds++) {
            var us = fs[ds];
            us !== "." && (us === ".." ? as.pop() : as.push(us))
        }
        return "url(".concat(ss).concat(as.join("/")).concat(ss, ")")
    })
}
var qt = /^[^ \t\n\r\u000c]+/,
    $t = /^[, \t\n\r\u000c]+/;

function er(Et, es) {
    if (es.trim() === "") return es;
    var ts = 0;

    function is(ds) {
        var ds = ds.exec(es.substring(ts));
        return ds ? (ds = ds[0], ts += ds.length, ds) : ""
    }
    for (var ns = []; is($t), !(ts >= es.length);)
        if ((ss = is(qt)).slice(-1) === ",") ss = pe$2(Et, ss.substring(0, ss.length - 1)), ns.push(ss);
        else
            for (var rs = "", ss = pe$2(Et, ss), os = !1;;) {
                var as = es.charAt(ts);
                if (as === "") {
                    ns.push((ss + rs).trim());
                    break
                }
                if (os) as === ")" && (os = !1);
                else {
                    if (as === ",") {
                        ts += 1, ns.push((ss + rs).trim());
                        break
                    }
                    as === "(" && (os = !0)
                }
                rs += as, ts += 1
            }
    return ns.join(", ")
}

function pe$2(Et, es) {
    return es && es.trim() !== "" ? ((Et = Et.createElement("a")).href = es, Et.href) : es
}

function tr(Et) {
    return !(Et.tagName !== "svg" && !Et.ownerSVGElement)
}

function Ze() {
    var Et = document.createElement("a");
    return Et.href = "", Et.href
}

function qe(Et, es, ts, is) {
    return ts === "src" || ts === "href" && is && (es !== "use" || is[0] !== "#") || ts === "xlink:href" && is && is[0] !== "#" || ts === "background" && is && (es === "table" || es === "td" || es === "th") ? pe$2(Et, is) : ts === "srcset" && is ? er(Et, is) : ts === "style" && is ? Te$1(is, Ze()) : es === "object" && ts === "data" && is ? pe$2(Et, is) : is
}

function rr(Et, es, ts) {
    if (typeof es == "string") {
        if (Et.classList.contains(es)) return !0
    } else
        for (var is = Et.classList.length; is--;) {
            var ns = Et.classList[is];
            if (es.test(ns)) return !0
        }
    return !!ts && Et.matches(ts)
}

function Oe$1(Et, es, ts) {
    if (!Et) return !1;
    if (Et.nodeType === Et.ELEMENT_NODE)
        for (var is = Et.classList.length; is--;) {
            var ns = Et.classList[is];
            if (es.test(ns)) return !0
        }
    return !!ts && Oe$1(Et.parentNode, es, ts)
}

function $e(Et, es, ts) {
    if (Et = Et.nodeType === Et.ELEMENT_NODE ? Et : Et.parentElement, Et === null) return !1;
    if (typeof es == "string") {
        if (Et.classList.contains(es) || Et.closest(".".concat(es))) return !0
    } else if (Oe$1(Et, es, !0)) return !0;
    return !(!ts || !Et.matches(ts) && !Et.closest(ts))
}

function nr(Et, es, ts) {
    var is = Et.contentWindow;
    if (is) {
        var ns, rs, ss = !1;
        try {
            rs = is.document.readyState
        } catch (os) {
            return
        }
        if (rs === "complete") return is.location.href !== (rs = "about:blank") || Et.src === rs || Et.src === "" ? (setTimeout(es, 0), Et.addEventListener("load", es)) : void Et.addEventListener("load", es);
        ns = setTimeout(function () {
            ss || (es(), ss = !0)
        }, ts), Et.addEventListener("load", function () {
            clearTimeout(ns), ss = !0, es()
        })
    }
}

function or(Et, es, ts) {
    var is, ns, rs = !1;
    try {
        is = Et.sheet
    } catch (ss) {
        return
    }
    is || (ns = setTimeout(function () {
        rs || (es(), rs = !0)
    }, ts), Et.addEventListener("load", function () {
        clearTimeout(ns), rs = !0, es()
    }))
}

function ir(Et, es) {
    var ts = es.doc,
        is = es.mirror,
        ns = es.blockClass,
        rs = es.blockSelector,
        ss = es.maskTextClass,
        os = es.maskTextSelector,
        as = es.inlineStylesheet,
        ps = es.maskInputOptions,
        cs = ps === void 0 ? {} : ps,
        ds = es.maskTextFn,
        fs = es.maskInputFn,
        ps = es.dataURLOptions,
        us = ps === void 0 ? {} : ps,
        ls = es.inlineImages,
        hs = es.recordCanvas,
        ms = es.keepIframeSrcFn,
        ps = es.newlyAddedElement,
        gs = ps !== void 0 && ps,
        ws = ar(ts, is);
    switch (Et.nodeType) {
        case Et.DOCUMENT_NODE:
            return Et.compatMode !== "CSS1Compat" ? {
                type: E$3.Document,
                childNodes: [],
                compatMode: Et.compatMode
            } : {
                type: E$3.Document,
                childNodes: []
            };
        case Et.DOCUMENT_TYPE_NODE:
            return {
                type: E$3.DocumentType, name: Et.name, publicId: Et.publicId, systemId: Et.systemId, rootId: ws
            };
        case Et.ELEMENT_NODE:
            return lr(Et, {
                doc: ts,
                blockClass: ns,
                blockSelector: rs,
                inlineStylesheet: as,
                maskInputOptions: cs,
                maskInputFn: fs,
                dataURLOptions: us,
                inlineImages: ls,
                recordCanvas: hs,
                keepIframeSrcFn: ms,
                newlyAddedElement: gs,
                rootId: ws
            });
        case Et.TEXT_NODE:
            return sr(Et, {
                maskTextClass: ss,
                maskTextSelector: os,
                maskTextFn: ds,
                rootId: ws
            });
        case Et.CDATA_SECTION_NODE:
            return {
                type: E$3.CDATA, textContent: "", rootId: ws
            };
        case Et.COMMENT_NODE:
            return {
                type: E$3.Comment, textContent: Et.textContent || "", rootId: ws
            };
        default:
            return !1
    }
}

function ar(Et, es) {
    return !es.hasNode(Et) || (es = es.getId(Et)) === 1 ? void 0 : es
}

function sr(Et, es) {
    var ts, is = es.maskTextClass,
        ns = es.maskTextSelector,
        rs = es.maskTextFn,
        ss = es.rootId,
        cs = Et.parentNode && Et.parentNode.tagName,
        os = Et.textContent,
        as = cs === "STYLE" || void 0,
        cs = cs === "SCRIPT" || void 0;
    if (as && os) {
        try {
            Et.nextSibling || Et.previousSibling || (ts = Et.parentNode.sheet) != null && ts.cssRules && (os = Jt(Et.parentNode.sheet))
        } catch (ds) {
            console.warn("Cannot get CSS styles from text's parentNode. Error: ".concat(ds), Et)
        }
        os = Te$1(os, Ze())
    }
    return cs && (os = "SCRIPT_PLACEHOLDER"), !as && !cs && os && $e(Et, is, ns) && (os = rs ? rs(os) : os.replace(/[\S]/g, "*")), {
        type: E$3.Text,
        textContent: os || "",
        isStyle: as,
        rootId: ss
    }
}

function lr(Et, es) {
    for (var ts, is, ns, rs = es.doc, ms = es.blockClass, ss = es.blockSelector, os = es.inlineStylesheet, as = es.maskInputOptions, as = as === void 0 ? {} : as, cs = es.maskInputFn, fs = es.dataURLOptions, ds = fs === void 0 ? {} : fs, fs = es.inlineImages, us = es.recordCanvas, ls = es.keepIframeSrcFn, hs = es.newlyAddedElement, hs = hs !== void 0 && hs, es = es.rootId, ms = rr(Et, ms, ss), ps = Ht(Et), gs = {}, ws = Et.attributes.length, $s = 0; $s < ws; $s++) {
        var bs = Et.attributes[$s];
        gs[bs.name] = qe(rs, ps, bs.name, bs.value)
    }
    return ps === "link" && os && (ts = null, ts = (ss = Array.from(rs.styleSheets).find(function (Es) {
        return Es.href === Et.href
    })) ? _e$1(ss) : ts) && (delete gs.rel, delete gs.href, gs._cssText = Te$1(ts, ss.href)), ps === "style" && Et.sheet && !(Et.innerText || Et.textContent || "").trim().length && (ts = _e$1(Et.sheet)) && (gs._cssText = Te$1(ts, Ze())), ps !== "input" && ps !== "textarea" && ps !== "select" || (os = Et.value, ss = Et.checked, gs.type !== "radio" && gs.type !== "checkbox" && gs.type !== "submit" && gs.type !== "button" && os ? gs.value = Ue({
        type: gs.type,
        tagName: ps,
        value: os,
        maskInputOptions: as,
        maskInputFn: cs
    }) : ss && (gs.checked = ss)), ps === "option" && (Et.selected && !as.select ? gs.selected = !0 : delete gs.selected), ps === "canvas" && us && (Et.__context === "2d" ? Kt(Et) || (gs.rr_dataURL = Et.toDataURL(ds.type, ds.quality)) : "__context" in Et || (ts = Et.toDataURL(ds.type, ds.quality), (os = document.createElement("canvas")).width = Et.width, os.height = Et.height, ts !== os.toDataURL(ds.type, ds.quality) && (gs.rr_dataURL = ts))), ps === "img" && fs && (fe$1 || (fe$1 = rs.createElement("canvas"), je = fe$1.getContext("2d")), ns = (is = Et).crossOrigin, is.crossOrigin = "anonymous", cs = function () {
        try {
            fe$1.width = is.naturalWidth, fe$1.height = is.naturalHeight, je.drawImage(is, 0, 0), gs.rr_dataURL = fe$1.toDataURL(ds.type, ds.quality)
        } catch (Es) {
            console.warn("Cannot inline img src=".concat(is.currentSrc, "! Error: ").concat(Es))
        }
        ns ? gs.crossOrigin = ns : is.removeAttribute("crossorigin")
    }, is.complete && is.naturalWidth !== 0 ? cs() : is.onload = cs), ps !== "audio" && ps !== "video" || (gs.rr_mediaState = Et.paused ? "paused" : "played", gs.rr_mediaCurrentTime = Et.currentTime), hs || (Et.scrollLeft && (gs.rr_scrollLeft = Et.scrollLeft), Et.scrollTop && (gs.rr_scrollTop = Et.scrollTop)), ms && (as = (ss = Et.getBoundingClientRect()).width, us = ss.height, gs = {
        class: gs.class,
        rr_width: "".concat(as, "px"),
        rr_height: "".concat(us, "px")
    }), ps !== "iframe" || ls(gs.src) || (Et.contentDocument || (gs.rr_src = gs.src), delete gs.src), {
        type: E$3.Element,
        tagName: ps,
        attributes: gs,
        childNodes: [],
        isSVG: tr(Et) || void 0,
        needBlock: ms,
        rootId: es
    }
}

function M$3(Et) {
    return Et === void 0 ? "" : Et.toLowerCase()
}

function dr(Et, es) {
    return !!(es.comment && Et.type === E$3.Comment || Et.type === E$3.Element && (es.script && (Et.tagName === "script" || Et.tagName === "link" && Et.attributes.rel === "preload" && Et.attributes.as === "script" || Et.tagName === "link" && Et.attributes.rel === "prefetch" && typeof Et.attributes.href == "string" && Et.attributes.href.endsWith(".js")) || es.headFavicon && (Et.tagName === "link" && Et.attributes.rel === "shortcut icon" || Et.tagName === "meta" && (M$3(Et.attributes.name).match(/^msapplication-tile(image|color)$/) || M$3(Et.attributes.name) === "application-name" || M$3(Et.attributes.rel) === "icon" || M$3(Et.attributes.rel) === "apple-touch-icon" || M$3(Et.attributes.rel) === "shortcut icon")) || Et.tagName === "meta" && (es.headMetaDescKeywords && M$3(Et.attributes.name).match(/^description|keywords$/) || es.headMetaSocial && (M$3(Et.attributes.property).match(/^(og|twitter|fb):/) || M$3(Et.attributes.name).match(/^(og|twitter):/) || M$3(Et.attributes.name) === "pinterest") || es.headMetaRobots && (M$3(Et.attributes.name) === "robots" || M$3(Et.attributes.name) === "googlebot" || M$3(Et.attributes.name) === "bingbot") || es.headMetaHttpEquiv && Et.attributes["http-equiv"] !== void 0 || es.headMetaAuthorship && (M$3(Et.attributes.name) === "author" || M$3(Et.attributes.name) === "generator" || M$3(Et.attributes.name) === "framework" || M$3(Et.attributes.name) === "publisher" || M$3(Et.attributes.name) === "progid" || M$3(Et.attributes.property).match(/^article:/) || M$3(Et.attributes.property).match(/^product:/)) || es.headMetaVerification && (M$3(Et.attributes.name) === "google-site-verification" || M$3(Et.attributes.name) === "yandex-verification" || M$3(Et.attributes.name) === "csrf-token" || M$3(Et.attributes.name) === "p:domain_verify" || M$3(Et.attributes.name) === "verify-v1" || M$3(Et.attributes.name) === "verification" || M$3(Et.attributes.name) === "shopify-checkout-api-token"))))
}

function ge(Et, Cs) {
    var ts = Cs.doc,
        is = Cs.mirror,
        ns = Cs.blockClass,
        rs = Cs.blockSelector,
        ss = Cs.maskTextClass,
        os = Cs.maskTextSelector,
        as = Cs.skipChild,
        as = as !== void 0 && as,
        vs = Cs.inlineStylesheet,
        cs = vs === void 0 || vs,
        vs = Cs.maskInputOptions,
        ds = vs === void 0 ? {} : vs,
        fs = Cs.maskTextFn,
        us = Cs.maskInputFn,
        ls = Cs.slimDOMOptions,
        vs = Cs.dataURLOptions,
        hs = vs === void 0 ? {} : vs,
        vs = Cs.inlineImages,
        ms = vs !== void 0 && vs,
        vs = Cs.recordCanvas,
        ps = vs !== void 0 && vs,
        gs = Cs.onSerialize,
        ws = Cs.onIframeLoad,
        vs = Cs.iframeLoadTimeout,
        $s = vs === void 0 ? 5e3 : vs,
        bs = Cs.onStylesheetLoad,
        vs = Cs.stylesheetLoadTimeout,
        Es = vs === void 0 ? 5e3 : vs,
        vs = Cs.keepIframeSrcFn,
        Ts = vs === void 0 ? function () {
            return !1
        } : vs,
        vs = Cs.newlyAddedElement,
        Cs = Cs.preserveWhiteSpace,
        Ss = Cs === void 0 || Cs,
        Cs = ir(Et, {
            doc: ts,
            mirror: is,
            blockClass: ns,
            blockSelector: rs,
            maskTextClass: ss,
            maskTextSelector: os,
            inlineStylesheet: cs,
            maskInputOptions: ds,
            maskTextFn: fs,
            maskInputFn: us,
            dataURLOptions: hs,
            inlineImages: ms,
            recordCanvas: ps,
            keepIframeSrcFn: Ts,
            newlyAddedElement: vs !== void 0 && vs
        });
    if (!Cs) return console.warn(Et, "not serialized"), null;
    var vs = is.hasNode(Et) ? is.getId(Et) : dr(Cs, ls) || !Ss && Cs.type === E$3.Text && !Cs.isStyle && !Cs.textContent.replace(/^\s+|\s+$/gm, "").length ? Me : Xe(),
        ys = Object.assign(Cs, {
            id: vs
        });
    if (is.add(Et, ys), vs === Me) return null;
    if (gs && gs(Et), Cs = !as, ys.type === E$3.Element && (Cs = Cs && !ys.needBlock, delete ys.needBlock, vs = Et.shadowRoot) && ke(vs) && (ys.isShadowHost = !0), (ys.type === E$3.Document || ys.type === E$3.Element) && Cs) {
        ls.headWhitespace && ys.type === E$3.Element && ys.tagName === "head" && (Ss = !1);
        for (var As, ks = {
                doc: ts,
                mirror: is,
                blockClass: ns,
                blockSelector: rs,
                maskTextClass: ss,
                maskTextSelector: os,
                skipChild: as,
                inlineStylesheet: cs,
                maskInputOptions: ds,
                maskTextFn: fs,
                maskInputFn: us,
                slimDOMOptions: ls,
                dataURLOptions: hs,
                inlineImages: ms,
                recordCanvas: ps,
                preserveWhiteSpace: Ss,
                onSerialize: gs,
                onIframeLoad: ws,
                iframeLoadTimeout: $s,
                onStylesheetLoad: bs,
                stylesheetLoadTimeout: Es,
                keepIframeSrcFn: Ts
            }, xs = 0, Gs = Array.from(Et.childNodes); xs < Gs.length; xs++)(As = ge(Gs[xs], ks)) && ys.childNodes.push(As);
        if (_t(Et) && Et.shadowRoot)
            for (var Ns = 0, Bs = Array.from(Et.shadowRoot.childNodes); Ns < Bs.length; Ns++)(As = ge(Bs[Ns], ks)) && (ke(Et.shadowRoot) && (As.isShadow = !0), ys.childNodes.push(As))
    }
    return Et.parentNode && we(Et.parentNode) && ke(Et.parentNode) && (ys.isShadow = !0), ys.type === E$3.Element && ys.tagName === "iframe" && nr(Et, function () {
        var Ms = Et.contentDocument;
        Ms && ws && (Ms = ge(Ms, {
            doc: Ms,
            mirror: is,
            blockClass: ns,
            blockSelector: rs,
            maskTextClass: ss,
            maskTextSelector: os,
            skipChild: !1,
            inlineStylesheet: cs,
            maskInputOptions: ds,
            maskTextFn: fs,
            maskInputFn: us,
            slimDOMOptions: ls,
            dataURLOptions: hs,
            inlineImages: ms,
            recordCanvas: ps,
            preserveWhiteSpace: Ss,
            onSerialize: gs,
            onIframeLoad: ws,
            iframeLoadTimeout: $s,
            onStylesheetLoad: bs,
            stylesheetLoadTimeout: Es,
            keepIframeSrcFn: Ts
        })) && ws(Et, Ms)
    }, $s), ys.type === E$3.Element && ys.tagName === "link" && ys.attributes.rel === "stylesheet" && or(Et, function () {
        var Ms;
        bs && (Ms = ge(Et, {
            doc: ts,
            mirror: is,
            blockClass: ns,
            blockSelector: rs,
            maskTextClass: ss,
            maskTextSelector: os,
            skipChild: !1,
            inlineStylesheet: cs,
            maskInputOptions: ds,
            maskTextFn: fs,
            maskInputFn: us,
            slimDOMOptions: ls,
            dataURLOptions: hs,
            inlineImages: ms,
            recordCanvas: ps,
            preserveWhiteSpace: Ss,
            onSerialize: gs,
            onIframeLoad: ws,
            iframeLoadTimeout: $s,
            onStylesheetLoad: bs,
            stylesheetLoadTimeout: Es,
            keepIframeSrcFn: Ts
        })) && bs(Et, Ms)
    }, Es), ys
}

function cr(Et, Es) {
    var Es = Es || {},
        ts = Es.mirror,
        ts = ts === void 0 ? new Qe : ts,
        is = Es.blockClass,
        ns = Es.blockSelector,
        rs = Es.maskTextClass,
        ss = Es.maskTextSelector,
        os = Es.inlineStylesheet,
        as = Es.inlineImages,
        cs = Es.recordCanvas,
        ds = Es.maskAllInputs,
        ds = ds !== void 0 && ds,
        fs = Es.maskTextFn,
        us = Es.maskInputFn,
        ls = Es.slimDOM,
        ls = ls !== void 0 && ls,
        hs = Es.dataURLOptions,
        ms = Es.preserveWhiteSpace,
        ps = Es.onSerialize,
        gs = Es.onIframeLoad,
        ws = Es.iframeLoadTimeout,
        $s = Es.onStylesheetLoad,
        bs = Es.stylesheetLoadTimeout,
        Es = Es.keepIframeSrcFn;
    return ge(Et, {
        doc: Et,
        mirror: ts,
        blockClass: is === void 0 ? "rr-block" : is,
        blockSelector: ns === void 0 ? null : ns,
        maskTextClass: rs === void 0 ? "rr-mask" : rs,
        maskTextSelector: ss === void 0 ? null : ss,
        skipChild: !1,
        inlineStylesheet: os === void 0 || os,
        maskInputOptions: ds === !0 ? {
            color: !0,
            date: !0,
            "datetime-local": !0,
            email: !0,
            month: !0,
            number: !0,
            range: !0,
            search: !0,
            tel: !0,
            text: !0,
            time: !0,
            url: !0,
            week: !0,
            textarea: !0,
            select: !0,
            password: !0
        } : ds === !1 ? {
            password: !0
        } : ds,
        maskTextFn: fs,
        maskInputFn: us,
        slimDOMOptions: ls === !0 || ls === "all" ? {
            script: !0,
            comment: !0,
            headFavicon: !0,
            headWhitespace: !0,
            headMetaDescKeywords: ls === "all",
            headMetaSocial: !0,
            headMetaRobots: !0,
            headMetaHttpEquiv: !0,
            headMetaAuthorship: !0,
            headMetaVerification: !0
        } : ls === !1 ? {} : ls,
        dataURLOptions: hs,
        inlineImages: as !== void 0 && as,
        recordCanvas: cs !== void 0 && cs,
        preserveWhiteSpace: ms,
        onSerialize: ps,
        onIframeLoad: gs,
        iframeLoadTimeout: ws,
        onStylesheetLoad: $s,
        stylesheetLoadTimeout: bs,
        keepIframeSrcFn: Es === void 0 ? function () {
            return !1
        } : Es,
        newlyAddedElement: !1
    })
}

function G(Et, es, ts = document) {
    const is = {
        capture: !0,
        passive: !0
    };
    return ts.addEventListener(Et, es, is), () => ts.removeEventListener(Et, es, is)
}
const me = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let et = {
    map: {},
    getId: () => (console.error(me), -1),
    getNode: () => (console.error(me), null),
    removeNodeFromMap() {
        console.error(me)
    },
    has: () => (console.error(me), !1),
    reset() {
        console.error(me)
    }
};

function Re$1(Et, es, ts = {}) {
    let is = null,
        ns = 0;
    return function (...rs) {
        var ss = Date.now();
        ns || ts.leading !== !1 || (ns = ss);
        const os = es - (ss - ns),
            as = this;
        os <= 0 || es < os ? (is && (clearTimeout(is), is = null), ns = ss, Et.apply(as, rs)) : is || ts.trailing === !1 || (is = setTimeout(() => {
            ns = ts.leading === !1 ? 0 : Date.now(), is = null, Et.apply(as, rs)
        }, os))
    }
}

function Fe(Et, es, ts, is, ns = window) {
    const rs = ns.Object.getOwnPropertyDescriptor(Et, es);
    return ns.Object.defineProperty(Et, es, is ? ts : {
        set(ss) {
            setTimeout(() => {
                ts.set.call(this, ss)
            }, 0), rs && rs.set && rs.set.call(this, ss)
        }
    }), () => Fe(Et, es, rs || {}, !0)
}

function Ie(Et, es, ts) {
    try {
        if (!(es in Et)) return () => {};
        const is = Et[es],
            ns = ts(is);
        return typeof ns == "function" && (ns.prototype = ns.prototype || {}, Object.defineProperties(ns, {
            __rrweb_original__: {
                enumerable: !1,
                value: is
            }
        })), Et[es] = ns, () => {
            Et[es] = is
        }
    } catch (is) {
        return () => {}
    }
}

function tt() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight
}

function rt() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth
}

function _$1(Et, es, ts, is) {
    if (!Et) return !1;
    var ns = Et.nodeType === Et.ELEMENT_NODE ? Et : Et.parentElement;
    if (!ns) return !1;
    if (typeof es == "string") {
        if (ns.classList.contains(es) || is && ns.closest("." + es) !== null) return !0
    } else if (Oe$1(ns, es, is)) return !0;
    return !(!ts || !(Et.matches(ts) || is && ns.closest(ts) !== null))
}

function ur(Et, es) {
    return es.getId(Et) !== -1
}

function Ve(Et, es) {
    return es.getId(Et) === Me
}

function nt(Et, es) {
    var ts;
    return !we(Et) && (ts = es.getId(Et), !es.has(ts) || (!Et.parentNode || Et.parentNode.nodeType !== Et.DOCUMENT_NODE) && (!Et.parentNode || nt(Et.parentNode, es)))
}

function ot(Et) {
    return !!Et.changedTouches
}

function hr(Et = window) {
    "NodeList" in Et && !Et.NodeList.prototype.forEach && (Et.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in Et && !Et.DOMTokenList.prototype.forEach && (Et.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...es) => {
        let ts = es[0];
        if (!(0 in es)) throw new TypeError("1 argument is required");
        do
            if (this === ts) return !0; while (ts = ts && ts.parentNode);
        return !1
    })
}

function it(Et, es) {
    return !(Et.nodeName !== "IFRAME" || !es.getMeta(Et))
}

function at(Et, es) {
    return !(Et.nodeName !== "LINK" || Et.nodeType !== Et.ELEMENT_NODE || !Et.getAttribute || Et.getAttribute("rel") !== "stylesheet" || !es.getMeta(Et))
}

function st(Et) {
    return !(Et == null || !Et.shadowRoot)
}
typeof window != "undefined" && window.Proxy && window.Reflect && (et = new Proxy(et, {
    get: (Et, es, ts) => (es === "map" && console.error(me), Reflect.get(Et, es, ts))
}));
class fr {
    constructor() {
        this.id = 1, this.styleIDMap = new WeakMap, this.idStyleMap = new s$4
    }
    getId(es) {
        return (es = this.styleIDMap.get(es)) != null ? es : -1
    }
    has(es) {
        return this.styleIDMap.has(es)
    }
    add(es, ts) {
        return this.has(es) ? this.getId(es) : (ts = ts === void 0 ? this.id++ : ts, this.styleIDMap.set(es, ts), this.idStyleMap.set(ts, es), ts)
    }
    getStyle(es) {
        return this.idStyleMap.get(es) || null
    }
    reset() {
        this.styleIDMap = new WeakMap, this.idStyleMap = new s$4, this.id = 1
    }
    generateId() {
        return this.id++
    }
}
var b$4 = (Et => (Et[Et.DomContentLoaded = 0] = "DomContentLoaded", Et[Et.Load = 1] = "Load", Et[Et.FullSnapshot = 2] = "FullSnapshot", Et[Et.IncrementalSnapshot = 3] = "IncrementalSnapshot", Et[Et.Meta = 4] = "Meta", Et[Et.Custom = 5] = "Custom", Et[Et.Plugin = 6] = "Plugin", Et))(b$4 || {}),
    v$4 = (Et => (Et[Et.Mutation = 0] = "Mutation", Et[Et.MouseMove = 1] = "MouseMove", Et[Et.MouseInteraction = 2] = "MouseInteraction", Et[Et.Scroll = 3] = "Scroll", Et[Et.ViewportResize = 4] = "ViewportResize", Et[Et.Input = 5] = "Input", Et[Et.TouchMove = 6] = "TouchMove", Et[Et.MediaInteraction = 7] = "MediaInteraction", Et[Et.StyleSheetRule = 8] = "StyleSheetRule", Et[Et.CanvasMutation = 9] = "CanvasMutation", Et[Et.Font = 10] = "Font", Et[Et.Log = 11] = "Log", Et[Et.Drag = 12] = "Drag", Et[Et.StyleDeclaration = 13] = "StyleDeclaration", Et[Et.Selection = 14] = "Selection", Et[Et.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", Et))(v$4 || {}),
    Ke = (Et => (Et[Et.MouseUp = 0] = "MouseUp", Et[Et.MouseDown = 1] = "MouseDown", Et[Et.Click = 2] = "Click", Et[Et.ContextMenu = 3] = "ContextMenu", Et[Et.DblClick = 4] = "DblClick", Et[Et.Focus = 5] = "Focus", Et[Et.Blur = 6] = "Blur", Et[Et.TouchStart = 7] = "TouchStart", Et[Et.TouchMove_Departed = 8] = "TouchMove_Departed", Et[Et.TouchEnd = 9] = "TouchEnd", Et[Et.TouchCancel = 10] = "TouchCancel", Et))(Ke || {}),
    Ce = (Et => (Et[Et["2D"] = 0] = "2D", Et[Et.WebGL = 1] = "WebGL", Et[Et.WebGL2 = 2] = "WebGL2", Et))(Ce || {});

function lt(Et) {
    return "__ln" in Et
}
class pr {
    constructor() {
        this.length = 0, this.head = null
    }
    get(es) {
        if (es >= this.length) throw new Error("Position outside of list range");
        let ts = this.head;
        for (let is = 0; is < es; is++) ts = (ts == null ? void 0 : ts.next) || null;
        return ts
    }
    addNode(es) {
        var ts, is = {
            value: es,
            previous: null,
            next: null
        };
        es.__ln = is, es.previousSibling && lt(es.previousSibling) ? (ts = es.previousSibling.__ln.next, is.next = ts, is.previous = es.previousSibling.__ln, es.previousSibling.__ln.next = is, ts && (ts.previous = is)) : es.nextSibling && lt(es.nextSibling) && es.nextSibling.__ln.previous ? (ts = es.nextSibling.__ln.previous, is.previous = ts, is.next = es.nextSibling.__ln, es.nextSibling.__ln.previous = is, ts && (ts.next = is)) : (this.head && (this.head.previous = is), is.next = this.head, this.head = is), this.length++
    }
    removeNode(es) {
        var ts = es.__ln;
        this.head && (ts.previous ? (ts.previous.next = ts.next, ts.next && (ts.next.previous = ts.previous)) : (this.head = ts.next, this.head && (this.head.previous = null)), es.__ln && delete es.__ln, this.length--)
    }
}
const dt = (Et, es) => Et + "@" + es;
class gr {
    constructor() {
        this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = new Set, this.movedSet = new Set, this.droppedSet = new Set, this.processMutations = es => {
            es.forEach(this.processMutation), this.emit()
        }, this.emit = () => {
            if (!this.frozen && !this.locked) {
                const ts = [],
                    is = new pr,
                    ns = os => {
                        let as = os,
                            cs = Me;
                        for (; cs === Me;) as = as && as.nextSibling, cs = as && this.mirror.getId(as);
                        return cs
                    },
                    rs = os => {
                        var as;
                        let cs = null,
                            ds = cs = ((ls = (ls = os.getRootNode) == null ? void 0 : ls.call(os)) == null ? void 0 : ls.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && os.getRootNode().host ? os.getRootNode().host : cs;
                        for (;
                            ((as = (as = ds == null ? void 0 : ds.getRootNode) == null ? void 0 : as.call(ds)) == null ? void 0 : as.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && ds.getRootNode().host;) ds = ds.getRootNode().host;
                        var fs, us, ls = !(this.doc.contains(os) || ds && this.doc.contains(ds));
                        if (os.parentNode && !ls) return ls = we(os.parentNode) ? this.mirror.getId(cs) : this.mirror.getId(os.parentNode), fs = ns(os), ls === -1 || fs === -1 ? is.addNode(os) : void((us = ge(os, {
                            doc: this.doc,
                            mirror: this.mirror,
                            blockClass: this.blockClass,
                            blockSelector: this.blockSelector,
                            maskTextClass: this.maskTextClass,
                            maskTextSelector: this.maskTextSelector,
                            skipChild: !0,
                            newlyAddedElement: !0,
                            inlineStylesheet: this.inlineStylesheet,
                            maskInputOptions: this.maskInputOptions,
                            maskTextFn: this.maskTextFn,
                            maskInputFn: this.maskInputFn,
                            slimDOMOptions: this.slimDOMOptions,
                            dataURLOptions: this.dataURLOptions,
                            recordCanvas: this.recordCanvas,
                            inlineImages: this.inlineImages,
                            onSerialize: hs => {
                                it(hs, this.mirror) && this.iframeManager.addIframe(hs), at(hs, this.mirror) && this.stylesheetManager.trackLinkElement(hs), st(os) && this.shadowDomManager.addShadowRoot(os.shadowRoot, this.doc)
                            },
                            onIframeLoad: (hs, ms) => {
                                this.iframeManager.attachIframe(hs, ms), this.shadowDomManager.observeAttachShadow(hs)
                            },
                            onStylesheetLoad: (hs, ms) => {
                                this.stylesheetManager.attachLinkElement(hs, ms)
                            }
                        })) && ts.push({
                            parentId: ls,
                            nextId: fs,
                            node: us
                        }))
                    };
                for (; this.mapRemoves.length;) this.mirror.removeNodeFromMap(this.mapRemoves.shift());
                for (const os of Array.from(this.movedSet.values())) ct(this.removes, os, this.mirror) && !this.movedSet.has(os.parentNode) || rs(os);
                for (const os of Array.from(this.addedSet.values())) !ht(this.droppedSet, os) && !ct(this.removes, os, this.mirror) || ht(this.movedSet, os) ? rs(os) : this.droppedSet.add(os);
                let ss = null;
                for (; is.length;) {
                    let os = null;
                    if (ss) {
                        const as = this.mirror.getId(ss.value.parentNode),
                            cs = ns(ss.value);
                        as !== -1 && cs !== -1 && (os = ss)
                    }
                    if (!os)
                        for (let as = is.length - 1; 0 <= as; as--) {
                            const cs = is.get(as);
                            if (cs) {
                                const ds = this.mirror.getId(cs.value.parentNode);
                                if (ns(cs.value) !== -1) {
                                    if (ds !== -1) {
                                        os = cs;
                                        break
                                    } {
                                        const fs = cs.value;
                                        if (fs.parentNode && fs.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                            const us = fs.parentNode.host;
                                            if (this.mirror.getId(us) !== -1) {
                                                os = cs;
                                                break
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    if (!os) {
                        for (; is.head;) is.removeNode(is.head.value);
                        break
                    }
                    ss = os.previous, is.removeNode(os.value), rs(os.value)
                }
                var es = {
                    texts: this.texts.map(os => ({
                        id: this.mirror.getId(os.node),
                        value: os.value
                    })).filter(os => this.mirror.has(os.id)),
                    attributes: this.attributes.map(os => ({
                        id: this.mirror.getId(os.node),
                        attributes: os.attributes
                    })).filter(os => this.mirror.has(os.id)),
                    removes: this.removes,
                    adds: ts
                };
                (es.texts.length || es.attributes.length || es.removes.length || es.adds.length) && (this.texts = [], this.attributes = [], this.removes = [], this.addedSet = new Set, this.movedSet = new Set, this.droppedSet = new Set, this.movedMap = {}, this.mutationCb(es))
            }
        }, this.processMutation = es => {
            if (!Ve(es.target, this.mirror)) switch (es.type) {
                case "characterData":
                    var ts = es.target.textContent;
                    _$1(es.target, this.blockClass, this.blockSelector, !1) || ts === es.oldValue || this.texts.push({
                        value: $e(es.target, this.maskTextClass, this.maskTextSelector) && ts ? this.maskTextFn ? this.maskTextFn(ts) : ts.replace(/[\S]/g, "*") : ts,
                        node: es.target
                    });
                    break;
                case "attributes": {
                    var is = es.target;
                    let as = es.target.getAttribute(es.attributeName);
                    if (es.attributeName === "value" && (as = Ue({
                            maskInputOptions: this.maskInputOptions,
                            tagName: es.target.tagName,
                            type: es.target.getAttribute("type"),
                            value: as,
                            maskInputFn: this.maskInputFn
                        })), _$1(es.target, this.blockClass, this.blockSelector, !1) || as === es.oldValue) return;
                    let cs = this.attributes.find(ds => ds.node === es.target);
                    if (is.tagName === "IFRAME" && es.attributeName === "src" && !this.keepIframeSrcFn(as)) {
                        if (is.contentDocument) return;
                        es.attributeName = "rr_src"
                    }
                    if (cs || (cs = {
                            node: es.target,
                            attributes: {}
                        }, this.attributes.push(cs)), es.attributeName === "style") {
                        var ns = this.doc.createElement("span"),
                            rs = (es.oldValue && ns.setAttribute("style", es.oldValue), cs.attributes.style !== void 0 && cs.attributes.style !== null || (cs.attributes.style = {}), cs.attributes.style);
                        for (const ds of Array.from(is.style)) {
                            var ss = is.style.getPropertyValue(ds),
                                os = is.style.getPropertyPriority(ds);
                            ss === ns.style.getPropertyValue(ds) && os === ns.style.getPropertyPriority(ds) || (rs[ds] = os === "" ? ss : [ss, os])
                        }
                        for (const ds of Array.from(ns.style)) is.style.getPropertyValue(ds) === "" && (rs[ds] = !1)
                    } else cs.attributes[es.attributeName] = qe(this.doc, is.tagName, es.attributeName, as);
                    break
                }
                case "childList":
                    if (_$1(es.target, this.blockClass, this.blockSelector, !0)) return;
                    es.addedNodes.forEach(as => this.genAdds(as, es.target)), es.removedNodes.forEach(as => {
                        var cs = this.mirror.getId(as),
                            ds = we(es.target) ? this.mirror.getId(es.target.host) : this.mirror.getId(es.target);
                        _$1(es.target, this.blockClass, this.blockSelector, !1) || Ve(as, this.mirror) || !ur(as, this.mirror) || (this.addedSet.has(as) ? (ze(this.addedSet, as), this.droppedSet.add(as)) : this.addedSet.has(es.target) && cs === -1 || nt(es.target, this.mirror) || (this.movedSet.has(as) && this.movedMap[dt(cs, ds)] ? ze(this.movedSet, as) : this.removes.push({
                            parentId: ds,
                            id: cs,
                            isShadow: !(!we(es.target) || !ke(es.target)) || void 0
                        })), this.mapRemoves.push(as))
                    })
            }
        }, this.genAdds = (es, ts) => {
            if (this.mirror.hasNode(es)) {
                if (Ve(es, this.mirror)) return;
                this.movedSet.add(es);
                let is = null;
                (is = ts && this.mirror.hasNode(ts) ? this.mirror.getId(ts) : is) && is !== -1 && (this.movedMap[dt(this.mirror.getId(es), is)] = !0)
            } else this.addedSet.add(es), this.droppedSet.delete(es);
            _$1(es, this.blockClass, this.blockSelector, !1) || es.childNodes.forEach(is => this.genAdds(is))
        }
    }
    init(es) {
        ["mutationCb", "blockClass", "blockSelector", "maskTextClass", "maskTextSelector", "inlineStylesheet", "maskInputOptions", "maskTextFn", "maskInputFn", "keepIframeSrcFn", "recordCanvas", "inlineImages", "slimDOMOptions", "dataURLOptions", "doc", "mirror", "iframeManager", "stylesheetManager", "shadowDomManager", "canvasManager"].forEach(ts => {
            this[ts] = es[ts]
        })
    }
    freeze() {
        this.frozen = !0, this.canvasManager.freeze()
    }
    unfreeze() {
        this.frozen = !1, this.canvasManager.unfreeze(), this.emit()
    }
    isFrozen() {
        return this.frozen
    }
    lock() {
        this.locked = !0, this.canvasManager.lock()
    }
    unlock() {
        this.locked = !1, this.canvasManager.unlock(), this.emit()
    }
    reset() {
        this.shadowDomManager.reset(), this.canvasManager.reset()
    }
}

function ze(Et, es) {
    Et.delete(es), es.childNodes.forEach(ts => ze(Et, ts))
}

function ct(Et, es, ts) {
    return Et.length !== 0 && ut(Et, es, ts)
}

function ut(Et, es, ts) {
    if (es = es.parentNode, !es) return !1;
    const is = ts.getId(es);
    return !!Et.some(ns => ns.id === is) || ut(Et, es, ts)
}

function ht(Et, es) {
    return Et.size !== 0 && ft(Et, es)
}

function ft(Et, es) {
    return es = es.parentNode, !!es && (!!Et.has(es) || ft(Et, es))
}
const ce = [],
    pt = typeof CSSGroupingRule != "undefined",
    gt = typeof CSSMediaRule != "undefined",
    mt = typeof CSSSupportsRule != "undefined",
    It = typeof CSSConditionRule != "undefined";

function Ne(Et) {
    try {
        if ("composedPath" in Et) {
            var es = Et.composedPath();
            if (es.length) return es[0]
        } else if ("path" in Et && Et.path.length) return Et.path[0];
        return Et.target
    } catch (ts) {
        return Et.target
    }
}

function Ct(rs, es) {
    var ts = new gr;
    ce.push(ts), ts.init(rs);
    let is = window.MutationObserver || window.__rrMutationObserver;
    var ns = (ns = (rs = window == null ? void 0 : window.Zone) == null ? void 0 : rs.__symbol__) == null ? void 0 : ns.call(rs, "MutationObserver"),
        rs = new(is = ns && window[ns] ? window[ns] : is)(ts.processMutations.bind(ts));
    return rs.observe(es, {
        attributes: !0,
        attributeOldValue: !0,
        characterData: !0,
        characterDataOldValue: !0,
        childList: !0,
        subtree: !0
    }), rs
}

function mr({
    mousemoveCb: Et,
    sampling: rs,
    doc: ts,
    mirror: is
}) {
    if (rs.mousemove === !1) return () => {};
    var ns = typeof rs.mousemove == "number" ? rs.mousemove : 50,
        rs = typeof rs.mousemoveCallback == "number" ? rs.mousemoveCallback : 500;
    let ss, os = [];
    const as = Re$1(fs => {
            const us = Date.now() - ss;
            Et(os.map(ls => (ls.timeOffset -= us, ls)), fs), os = [], ss = null
        }, rs),
        cs = Re$1(fs => {
            var us = Ne(fs),
                {
                    clientX: ls,
                    clientY: hs
                } = ot(fs) ? fs.changedTouches[0] : fs;
            ss = ss || Date.now(), os.push({
                x: ls,
                y: hs,
                id: is.getId(us),
                timeOffset: Date.now() - ss
            }), as(typeof DragEvent != "undefined" && fs instanceof DragEvent ? v$4.Drag : fs instanceof MouseEvent ? v$4.MouseMove : v$4.TouchMove)
        }, ns, {
            trailing: !1
        }),
        ds = [G("mousemove", cs, ts), G("touchmove", cs, ts), G("drag", cs, ts)];
    return () => {
        ds.forEach(fs => fs())
    }
}

function Ir({
    mouseInteractionCb: Et,
    doc: es,
    mirror: ts,
    blockClass: is,
    blockSelector: ns,
    sampling: rs
}) {
    if (rs.mouseInteraction === !1) return () => {};
    const ss = rs.mouseInteraction === !0 || rs.mouseInteraction === void 0 ? {} : rs.mouseInteraction,
        os = [];
    return Object.keys(Ke).filter(as => Number.isNaN(Number(as)) && !as.endsWith("_Departed") && ss[as] !== !1).forEach(fs => {
        var cs, ds = fs.toLowerCase(),
            fs = (cs = fs, us => {
                var ls, hs = Ne(us);
                _$1(hs, is, ns, !0) || (us = ot(us) ? us.changedTouches[0] : us) && (hs = ts.getId(hs), {
                    clientX: us,
                    clientY: ls
                } = us, Et({
                    type: Ke[cs],
                    id: hs,
                    x: us,
                    y: ls
                }))
            });
        os.push(G(ds, fs, es))
    }), () => {
        os.forEach(as => as())
    }
}

function yt({
    scrollCb: Et,
    doc: es,
    mirror: ts,
    blockClass: is,
    blockSelector: ns,
    sampling: rs
}) {
    return G("scroll", Re$1(ss => {
        if (ss = Ne(ss), ss && !_$1(ss, is, ns, !0)) {
            var os = ts.getId(ss);
            if (ss === es) {
                const as = es.scrollingElement || es.documentElement;
                Et({
                    id: os,
                    x: as.scrollLeft,
                    y: as.scrollTop
                })
            } else Et({
                id: os,
                x: ss.scrollLeft,
                y: ss.scrollTop
            })
        }
    }, rs.scroll || 100), es)
}

function Cr({
    viewportResizeCb: Et
}) {
    let es = -1,
        ts = -1;
    return G("resize", Re$1(() => {
        var is = tt(),
            ns = rt();
        es === is && ts === ns || (Et({
            width: Number(ns),
            height: Number(is)
        }), es = is, ts = ns)
    }, 200), window)
}

function St(Et, es) {
    return Et = Object.assign({}, Et), es || delete Et.userTriggered, Et
}
const yr = ["INPUT", "TEXTAREA", "SELECT"],
    vt = new WeakMap;

function Sr({
    inputCb: Et,
    doc: es,
    mirror: ts,
    blockClass: is,
    blockSelector: ns,
    ignoreClass: rs,
    maskInputOptions: ss,
    maskInputFn: os,
    sampling: as,
    userTriggeredOnInput: cs
}) {
    function ds(ms) {
        let ps = Ne(ms);
        if (ms = ms.isTrusted, (ps = ps && ps.tagName === "OPTION" ? ps.parentElement : ps) && ps.tagName && !(yr.indexOf(ps.tagName) < 0) && !_$1(ps, is, ns, !0)) {
            var gs = ps.type;
            if (!ps.classList.contains(rs)) {
                let ws = ps.value,
                    $s = !1;
                gs === "radio" || gs === "checkbox" ? $s = ps.checked : (ss[ps.tagName.toLowerCase()] || ss[gs]) && (ws = Ue({
                    maskInputOptions: ss,
                    tagName: ps.tagName,
                    type: gs,
                    value: ws,
                    maskInputFn: os
                })), fs(ps, St({
                    text: ws,
                    isChecked: $s,
                    userTriggered: ms
                }, cs)), ms = ps.name, gs === "radio" && ms && $s && es.querySelectorAll(`input[type="radio"][name="${ms}"]`).forEach(bs => {
                    bs !== ps && fs(bs, St({
                        text: bs.value,
                        isChecked: !$s,
                        userTriggered: !1
                    }, cs))
                })
            }
        }
    }

    function fs(ms, ps) {
        const gs = vt.get(ms);
        if (!gs || gs.text !== ps.text || gs.isChecked !== ps.isChecked) {
            vt.set(ms, ps);
            const ws = ts.getId(ms);
            Et(Object.assign(Object.assign({}, ps), {
                id: ws
            }))
        }
    }
    const us = (as.input === "last" ? ["change"] : ["input", "change"]).map(ms => G(ms, ds, es)),
        ls = es.defaultView;
    var hs;
    return ls ? (as = ls.Object.getOwnPropertyDescriptor(ls.HTMLInputElement.prototype, "value"), hs = [
        [ls.HTMLInputElement.prototype, "value"],
        [ls.HTMLInputElement.prototype, "checked"],
        [ls.HTMLSelectElement.prototype, "value"],
        [ls.HTMLTextAreaElement.prototype, "value"],
        [ls.HTMLSelectElement.prototype, "selectedIndex"],
        [ls.HTMLOptionElement.prototype, "selected"]
    ], as && as.set && us.push(...hs.map(ms => Fe(ms[0], ms[1], {
        set() {
            ds({
                target: this
            })
        }
    }, !1, ls))), () => {
        us.forEach(ms => ms())
    }) : () => {
        us.forEach(ms => ms())
    }
}

function Ee$3(Et) {
    return Et = Et, es = [], pt && Et.parentRule instanceof CSSGroupingRule || gt && Et.parentRule instanceof CSSMediaRule || mt && Et.parentRule instanceof CSSSupportsRule || It && Et.parentRule instanceof CSSConditionRule ? (ts = Array.from(Et.parentRule.cssRules).indexOf(Et), es.unshift(ts)) : Et.parentStyleSheet && (ts = Array.from(Et.parentStyleSheet.cssRules).indexOf(Et), es.unshift(ts)), es;
    var es, ts
}

function le$1(Et, es, ts) {
    let is, ns;
    return Et ? (Et.ownerNode ? is = es.getId(Et.ownerNode) : ns = ts.getId(Et), {
        styleId: ns,
        id: is
    }) : {}
}

function vr({
    styleSheetRuleCb: Et,
    mirror: es,
    stylesheetManager: ts
}, {
    win: is
}) {
    const ns = is.CSSStyleSheet.prototype.insertRule,
        rs = (is.CSSStyleSheet.prototype.insertRule = function (ds, fs) {
            var {
                id: us,
                styleId: ls
            } = le$1(this, es, ts.styleMirror);
            return (us && us !== -1 || ls && ls !== -1) && Et({
                id: us,
                styleId: ls,
                adds: [{
                    rule: ds,
                    index: fs
                }]
            }), ns.apply(this, [ds, fs])
        }, is.CSSStyleSheet.prototype.deleteRule);
    let ss, os;
    is.CSSStyleSheet.prototype.deleteRule = function (ds) {
        var {
            id: fs,
            styleId: us
        } = le$1(this, es, ts.styleMirror);
        return (fs && fs !== -1 || us && us !== -1) && Et({
            id: fs,
            styleId: us,
            removes: [{
                index: ds
            }]
        }), rs.apply(this, [ds])
    }, is.CSSStyleSheet.prototype.replace && (ss = is.CSSStyleSheet.prototype.replace, is.CSSStyleSheet.prototype.replace = function (ds) {
        var {
            id: fs,
            styleId: us
        } = le$1(this, es, ts.styleMirror);
        return (fs && fs !== -1 || us && us !== -1) && Et({
            id: fs,
            styleId: us,
            replace: ds
        }), ss.apply(this, [ds])
    }), is.CSSStyleSheet.prototype.replaceSync && (os = is.CSSStyleSheet.prototype.replaceSync, is.CSSStyleSheet.prototype.replaceSync = function (ds) {
        var {
            id: fs,
            styleId: us
        } = le$1(this, es, ts.styleMirror);
        return (fs && fs !== -1 || us && us !== -1) && Et({
            id: fs,
            styleId: us,
            replaceSync: ds
        }), os.apply(this, [ds])
    });
    const as = {},
        cs = (pt ? as.CSSGroupingRule = is.CSSGroupingRule : (gt && (as.CSSMediaRule = is.CSSMediaRule), It && (as.CSSConditionRule = is.CSSConditionRule), mt && (as.CSSSupportsRule = is.CSSSupportsRule)), {});
    return Object.entries(as).forEach(([ds, fs]) => {
        cs[ds] = {
            insertRule: fs.prototype.insertRule,
            deleteRule: fs.prototype.deleteRule
        }, fs.prototype.insertRule = function (us, ls) {
            var {
                id: hs,
                styleId: ms
            } = le$1(this.parentStyleSheet, es, ts.styleMirror);
            return (hs && hs !== -1 || ms && ms !== -1) && Et({
                id: hs,
                styleId: ms,
                adds: [{
                    rule: us,
                    index: [...Ee$3(this), ls || 0]
                }]
            }), cs[ds].insertRule.apply(this, [us, ls])
        }, fs.prototype.deleteRule = function (us) {
            var {
                id: ls,
                styleId: hs
            } = le$1(this.parentStyleSheet, es, ts.styleMirror);
            return (ls && ls !== -1 || hs && hs !== -1) && Et({
                id: ls,
                styleId: hs,
                removes: [{
                    index: [...Ee$3(this), us]
                }]
            }), cs[ds].deleteRule.apply(this, [us])
        }
    }), () => {
        is.CSSStyleSheet.prototype.insertRule = ns, is.CSSStyleSheet.prototype.deleteRule = rs, ss && (is.CSSStyleSheet.prototype.replace = ss), os && (is.CSSStyleSheet.prototype.replaceSync = os), Object.entries(as).forEach(([ds, fs]) => {
            fs.prototype.insertRule = cs[ds].insertRule, fs.prototype.deleteRule = cs[ds].deleteRule
        })
    }
}

function bt({
    mirror: Et,
    stylesheetManager: es
}, ts) {
    let is;
    is = ts.nodeName === "#document" ? Et.getId(ts) : Et.getId(ts.host);
    const ns = ts.nodeName === "#document" ? (Et = ts.defaultView) == null ? void 0 : Et.Document : (Et = (Et = ts.ownerDocument) == null ? void 0 : Et.defaultView) == null ? void 0 : Et.ShadowRoot,
        rs = Object.getOwnPropertyDescriptor(ns == null ? void 0 : ns.prototype, "adoptedStyleSheets");
    return is !== null && is !== -1 && ns && rs ? (Object.defineProperty(ts, "adoptedStyleSheets", {
        configurable: rs.configurable,
        enumerable: rs.enumerable,
        get() {
            var ss;
            return (ss = rs.get) == null ? void 0 : ss.call(this)
        },
        set(ss) {
            var os = (os = rs.set) == null ? void 0 : os.call(this, ss);
            if (is !== null && is !== -1) try {
                es.adoptStyleSheets(ss, is)
            } catch (as) {}
            return os
        }
    }), () => {
        Object.defineProperty(ts, "adoptedStyleSheets", {
            configurable: rs.configurable,
            enumerable: rs.enumerable,
            get: rs.get,
            set: rs.set
        })
    }) : () => {}
}

function br({
    styleDeclarationCb: Et,
    mirror: es,
    ignoreCSSAttributes: ts,
    stylesheetManager: is
}, {
    win: ns
}) {
    const rs = ns.CSSStyleDeclaration.prototype.setProperty,
        ss = (ns.CSSStyleDeclaration.prototype.setProperty = function (os, as, cs) {
            var ds, fs;
            return !ts.has(os) && ({
                id: ds,
                styleId: fs
            } = le$1((ds = this.parentRule) == null ? void 0 : ds.parentStyleSheet, es, is.styleMirror), ds && ds !== -1 || fs && fs !== -1) && Et({
                id: ds,
                styleId: fs,
                set: {
                    property: os,
                    value: as,
                    priority: cs
                },
                index: Ee$3(this.parentRule)
            }), rs.apply(this, [os, as, cs])
        }, ns.CSSStyleDeclaration.prototype.removeProperty);
    return ns.CSSStyleDeclaration.prototype.removeProperty = function (os) {
        var as, cs;
        return !ts.has(os) && ({
            id: as,
            styleId: cs
        } = le$1((as = this.parentRule) == null ? void 0 : as.parentStyleSheet, es, is.styleMirror), as && as !== -1 || cs && cs !== -1) && Et({
            id: as,
            styleId: cs,
            remove: {
                property: os
            },
            index: Ee$3(this.parentRule)
        }), ss.apply(this, [os])
    }, () => {
        ns.CSSStyleDeclaration.prototype.setProperty = rs, ns.CSSStyleDeclaration.prototype.removeProperty = ss
    }
}

function Ar({
    mediaInteractionCb: Et,
    blockClass: es,
    blockSelector: ts,
    mirror: is,
    sampling: ns
}) {
    const rs = os => Re$1(ls => {
            var cs, ds, fs, us, ls = Ne(ls);
            ls && !_$1(ls, es, ts, !0) && ({
                currentTime: cs,
                volume: ds,
                muted: fs,
                playbackRate: us
            } = ls, Et({
                type: os,
                id: is.getId(ls),
                currentTime: cs,
                volume: ds,
                muted: fs,
                playbackRate: us
            }))
        }, ns.media || 500),
        ss = [G("play", rs(0)), G("pause", rs(1)), G("seeked", rs(2)), G("volumechange", rs(3)), G("ratechange", rs(4))];
    return () => {
        ss.forEach(os => os())
    }
}

function wr({
    fontCb: Et,
    doc: es
}) {
    const ts = es.defaultView;
    if (!ts) return () => {};
    const is = [],
        ns = new WeakMap,
        rs = ts.FontFace;
    return ts.FontFace = function (ss, os, as) {
        var cs = new rs(ss, os, as);
        return ns.set(cs, {
            family: ss,
            buffer: typeof os != "string",
            descriptors: as,
            fontSource: typeof os == "string" ? os : JSON.stringify(Array.from(new Uint8Array(os)))
        }), cs
    }, es = Ie(es.fonts, "add", function (ss) {
        return function (os) {
            return setTimeout(() => {
                var as = ns.get(os);
                as && (Et(as), ns.delete(os))
            }, 0), ss.apply(this, [os])
        }
    }), is.push(() => {
        ts.FontFace = rs
    }), is.push(es), () => {
        is.forEach(ss => ss())
    }
}

function kr(Et) {
    const {
        doc: es,
        mirror: ts,
        blockClass: is,
        blockSelector: ns,
        selectionCb: rs
    } = Et;
    let ss = !0;
    return Et = () => {
        var os = es.getSelection();
        if (!(!os || ss && os != null && os.isCollapsed)) {
            ss = os.isCollapsed || !1;
            const as = [],
                cs = os.rangeCount || 0;
            for (let ds = 0; ds < cs; ds++) {
                const fs = os.getRangeAt(ds),
                    {
                        startContainer: us,
                        startOffset: ls,
                        endContainer: hs,
                        endOffset: ms
                    } = fs;
                _$1(us, is, ns, !0) || _$1(hs, is, ns, !0) || as.push({
                    start: ts.getId(us),
                    startOffset: ls,
                    end: ts.getId(hs),
                    endOffset: ms
                })
            }
            rs({
                ranges: as
            })
        }
    }, Et(), G("selectionchange", Et)
}

function Mr(Et, es) {
    const {
        mutationCb: ts,
        mousemoveCb: is,
        mouseInteractionCb: ns,
        scrollCb: rs,
        viewportResizeCb: ss,
        inputCb: os,
        mediaInteractionCb: as,
        styleSheetRuleCb: cs,
        styleDeclarationCb: ds,
        canvasMutationCb: fs,
        fontCb: us,
        selectionCb: ls
    } = Et;
    Et.mutationCb = (...hs) => {
        es.mutation && es.mutation(...hs), ts(...hs)
    }, Et.mousemoveCb = (...hs) => {
        es.mousemove && es.mousemove(...hs), is(...hs)
    }, Et.mouseInteractionCb = (...hs) => {
        es.mouseInteraction && es.mouseInteraction(...hs), ns(...hs)
    }, Et.scrollCb = (...hs) => {
        es.scroll && es.scroll(...hs), rs(...hs)
    }, Et.viewportResizeCb = (...hs) => {
        es.viewportResize && es.viewportResize(...hs), ss(...hs)
    }, Et.inputCb = (...hs) => {
        es.input && es.input(...hs), os(...hs)
    }, Et.mediaInteractionCb = (...hs) => {
        es.mediaInteaction && es.mediaInteaction(...hs), as(...hs)
    }, Et.styleSheetRuleCb = (...hs) => {
        es.styleSheetRule && es.styleSheetRule(...hs), cs(...hs)
    }, Et.styleDeclarationCb = (...hs) => {
        es.styleDeclaration && es.styleDeclaration(...hs), ds(...hs)
    }, Et.canvasMutationCb = (...hs) => {
        es.canvasMutation && es.canvasMutation(...hs), fs(...hs)
    }, Et.fontCb = (...hs) => {
        es.font && es.font(...hs), us(...hs)
    }, Et.selectionCb = (...hs) => {
        es.selection && es.selection(...hs), ls(...hs)
    }
}

function Rr(Et, es = {}) {
    var ts = Et.doc.defaultView;
    if (!ts) return () => {};
    Mr(Et, es);
    const is = Ct(Et, Et.doc),
        ns = mr(Et),
        rs = Ir(Et),
        ss = yt(Et),
        os = Cr(Et),
        as = Sr(Et),
        cs = Ar(Et),
        ds = vr(Et, {
            win: ts
        }),
        fs = bt(Et, Et.doc),
        us = br(Et, {
            win: ts
        }),
        ls = Et.collectFonts ? wr(Et) : () => {},
        hs = kr(Et),
        ms = [];
    for (const ps of Et.plugins) ms.push(ps.observer(ps.callback, ts, ps.options));
    return () => {
        ce.forEach(ps => ps.reset()), is.disconnect(), ns(), rs(), ss(), os(), as(), cs(), ds(), fs(), us(), ls(), hs(), ms.forEach(ps => ps())
    }
}
class At {
    constructor(es) {
        this.generateIdFn = es, this.iframeIdToRemoteIdMap = new WeakMap, this.iframeRemoteIdToIdMap = new WeakMap
    }
    getId(es, ts, is, ns) {
        is = is || this.getIdToRemoteIdMap(es), ns = ns || this.getRemoteIdToIdMap(es);
        let rs = is.get(ts);
        return rs || (rs = this.generateIdFn(), is.set(ts, rs), ns.set(rs, ts)), rs
    }
    getIds(es, ts) {
        const is = this.getIdToRemoteIdMap(es),
            ns = this.getRemoteIdToIdMap(es);
        return ts.map(rs => this.getId(es, rs, is, ns))
    }
    getRemoteId(es, ts, is) {
        return is = is || this.getRemoteIdToIdMap(es), typeof ts != "number" ? ts : is.get(ts) || -1
    }
    getRemoteIds(es, ts) {
        const is = this.getRemoteIdToIdMap(es);
        return ts.map(ns => this.getRemoteId(es, ns, is))
    }
    reset(es) {
        es ? (this.iframeIdToRemoteIdMap.delete(es), this.iframeRemoteIdToIdMap.delete(es)) : (this.iframeIdToRemoteIdMap = new WeakMap, this.iframeRemoteIdToIdMap = new WeakMap)
    }
    getIdToRemoteIdMap(es) {
        let ts = this.iframeIdToRemoteIdMap.get(es);
        return ts || (ts = new s$4, this.iframeIdToRemoteIdMap.set(es, ts)), ts
    }
    getRemoteIdToIdMap(es) {
        let ts = this.iframeRemoteIdToIdMap.get(es);
        return ts || (ts = new s$4, this.iframeRemoteIdToIdMap.set(es, ts)), ts
    }
}
class Nr {
    constructor(es) {
        this.iframes = new WeakMap, this.crossOriginIframeMap = new WeakMap, this.crossOriginIframeMirror = new At(Xe), this.mutationCb = es.mutationCb, this.wrappedEmit = es.wrappedEmit, this.stylesheetManager = es.stylesheetManager, this.recordCrossOriginIframes = es.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new At(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror)), this.mirror = es.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this))
    }
    addIframe(es) {
        this.iframes.set(es, !0), es.contentWindow && this.crossOriginIframeMap.set(es.contentWindow, es)
    }
    addLoadListener(es) {
        this.loadListener = es
    }
    attachIframe(es, ts) {
        this.mutationCb({
            adds: [{
                parentId: this.mirror.getId(es),
                nextId: null,
                node: ts
            }],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
        }), (ts = this.loadListener) != null && ts.call(this, es), es.contentDocument && es.contentDocument.adoptedStyleSheets && 0 < es.contentDocument.adoptedStyleSheets.length && this.stylesheetManager.adoptStyleSheets(es.contentDocument.adoptedStyleSheets, this.mirror.getId(es.contentDocument))
    }
    handleMessage(es) {
        var ts;
        es.data.type === "rrweb" && es.source && (ts = this.crossOriginIframeMap.get(es.source)) && (ts = this.transformCrossOriginEvent(ts, es.data.event)) && this.wrappedEmit(ts, es.data.isCheckout)
    }
    transformCrossOriginEvent(es, ts) {
        var is;
        switch (ts.type) {
            case b$4.FullSnapshot:
                return this.crossOriginIframeMirror.reset(es), this.crossOriginIframeStyleMirror.reset(es), this.replaceIdOnNode(ts.data.node, es), {
                    timestamp: ts.timestamp,
                    type: b$4.IncrementalSnapshot,
                    data: {
                        source: v$4.Mutation,
                        adds: [{
                            parentId: this.mirror.getId(es),
                            nextId: null,
                            node: ts.data.node
                        }],
                        removes: [],
                        texts: [],
                        attributes: [],
                        isAttachIframe: !0
                    }
                };
            case b$4.Meta:
            case b$4.Load:
            case b$4.DomContentLoaded:
                return !1;
            case b$4.Plugin:
                return ts;
            case b$4.Custom:
                return this.replaceIds(ts.data.payload, es, ["id", "parentId", "previousId", "nextId"]), ts;
            case b$4.IncrementalSnapshot:
                switch (ts.data.source) {
                    case v$4.Mutation:
                        return ts.data.adds.forEach(ns => {
                            this.replaceIds(ns, es, ["parentId", "nextId", "previousId"]), this.replaceIdOnNode(ns.node, es)
                        }), ts.data.removes.forEach(ns => {
                            this.replaceIds(ns, es, ["parentId", "id"])
                        }), ts.data.attributes.forEach(ns => {
                            this.replaceIds(ns, es, ["id"])
                        }), ts.data.texts.forEach(ns => {
                            this.replaceIds(ns, es, ["id"])
                        }), ts;
                    case v$4.Drag:
                    case v$4.TouchMove:
                    case v$4.MouseMove:
                        return ts.data.positions.forEach(ns => {
                            this.replaceIds(ns, es, ["id"])
                        }), ts;
                    case v$4.ViewportResize:
                        return !1;
                    case v$4.MediaInteraction:
                    case v$4.MouseInteraction:
                    case v$4.Scroll:
                    case v$4.CanvasMutation:
                    case v$4.Input:
                        return this.replaceIds(ts.data, es, ["id"]), ts;
                    case v$4.StyleSheetRule:
                    case v$4.StyleDeclaration:
                        return this.replaceIds(ts.data, es, ["id"]), this.replaceStyleIds(ts.data, es, ["styleId"]), ts;
                    case v$4.Font:
                        return ts;
                    case v$4.Selection:
                        return ts.data.ranges.forEach(ns => {
                            this.replaceIds(ns, es, ["start", "end"])
                        }), ts;
                    case v$4.AdoptedStyleSheet:
                        return this.replaceIds(ts.data, es, ["id"]), this.replaceStyleIds(ts.data, es, ["styleIds"]), (is = ts.data.styles) != null && is.forEach(ns => {
                            this.replaceStyleIds(ns, es, ["styleId"])
                        }), ts
                }
        }
    }
    replace(es, ts, is, ns) {
        for (const rs of ns) !Array.isArray(ts[rs]) && typeof ts[rs] != "number" || (Array.isArray(ts[rs]) ? ts[rs] = es.getIds(is, ts[rs]) : ts[rs] = es.getId(is, ts[rs]));
        return ts
    }
    replaceIds(es, ts, is) {
        return this.replace(this.crossOriginIframeMirror, es, ts, is)
    }
    replaceStyleIds(es, ts, is) {
        return this.replace(this.crossOriginIframeStyleMirror, es, ts, is)
    }
    replaceIdOnNode(es, ts) {
        this.replaceIds(es, ts, ["id"]), "childNodes" in es && es.childNodes.forEach(is => {
            this.replaceIdOnNode(is, ts)
        })
    }
}
class Tr {
    constructor(es) {
        this.shadowDoms = new WeakSet, this.restorePatches = [], this.mutationCb = es.mutationCb, this.scrollCb = es.scrollCb, this.bypassOptions = es.bypassOptions, this.mirror = es.mirror;
        const ts = this;
        this.restorePatches.push(Ie(Element.prototype, "attachShadow", function (is) {
            return function (ns) {
                return ns = is.call(this, ns), this.shadowRoot && ts.addShadowRoot(this.shadowRoot, this.ownerDocument), ns
            }
        }))
    }
    addShadowRoot(es, ts) {
        !ke(es) || this.shadowDoms.has(es) || (this.shadowDoms.add(es), Ct(Object.assign(Object.assign({}, this.bypassOptions), {
            doc: ts,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), es), yt(Object.assign(Object.assign({}, this.bypassOptions), {
            scrollCb: this.scrollCb,
            doc: es,
            mirror: this.mirror
        })), setTimeout(() => {
            es.adoptedStyleSheets && 0 < es.adoptedStyleSheets.length && this.bypassOptions.stylesheetManager.adoptStyleSheets(es.adoptedStyleSheets, this.mirror.getId(es.host)), bt({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, es)
        }, 0))
    }
    observeAttachShadow(es) {
        if (es.contentWindow) {
            const ts = this;
            this.restorePatches.push(Ie(es.contentWindow.HTMLElement.prototype, "attachShadow", function (is) {
                return function (ns) {
                    return ns = is.call(this, ns), this.shadowRoot && ts.addShadowRoot(this.shadowRoot, es.contentDocument), ns
                }
            }))
        }
    }
    reset() {
        this.restorePatches.forEach(es => es()), this.shadowDoms = new WeakSet
    }
}

function Or(Et, es) {
    var ts = {};
    for (ns in Et) Object.prototype.hasOwnProperty.call(Et, ns) && es.indexOf(ns) < 0 && (ts[ns] = Et[ns]);
    if (Et != null && typeof Object.getOwnPropertySymbols == "function")
        for (var is = 0, ns = Object.getOwnPropertySymbols(Et); is < ns.length; is++) es.indexOf(ns[is]) < 0 && Object.prototype.propertyIsEnumerable.call(Et, ns[is]) && (ts[ns[is]] = Et[ns[is]]);
    return ts
}

function Fr(Et, es, ts, is) {
    return new(ts = ts || Promise)(function (ns, rs) {
        function ss(cs) {
            try {
                as(is.next(cs))
            } catch (ds) {
                rs(ds)
            }
        }

        function os(cs) {
            try {
                as(is.throw(cs))
            } catch (ds) {
                rs(ds)
            }
        }

        function as(cs) {
            var ds;
            cs.done ? ns(cs.value) : ((ds = cs.value) instanceof ts ? ds : new ts(function (fs) {
                fs(ds)
            })).then(ss, os)
        }
        as((is = is.apply(Et, [])).next())
    })
}
for (var ye = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Er = typeof Uint8Array == "undefined" ? [] : new Uint8Array(256), Le = 0; Le < ye.length; Le++) Er[ye.charCodeAt(Le)] = Le;
var Lr = function (Et) {
    for (var es = new Uint8Array(Et), ts = es.length, is = "", ns = 0; ns < ts; ns += 3) is = (is = (is = (is += ye[es[ns] >> 2]) + ye[(3 & es[ns]) << 4 | es[ns + 1] >> 4]) + ye[(15 & es[ns + 1]) << 2 | es[ns + 2] >> 6]) + ye[63 & es[ns + 2]];
    return ts % 3 == 2 ? is = is.substring(0, is.length - 1) + "=" : ts % 3 == 1 && (is = is.substring(0, is.length - 2) + "=="), is
};
const wt = new s$4;

function Dr(Et, es) {
    let ts = wt.get(Et);
    return ts || (ts = new s$4, wt.set(Et, ts)), ts.has(es) || ts.set(es, []), ts.get(es)
}
const kt = (Et, es, ts) => {
    if (Et && (Rt(Et, es) || typeof Et == "object")) {
        es = Dr(ts, Et.constructor.name);
        let is = es.indexOf(Et);
        return is === -1 && (is = es.length, es.push(Et)), is
    }
};

function De(Et, es, ts) {
    if (Et instanceof Array) return Et.map(is => De(is, es, ts));
    if (Et === null) return Et;
    if (Et instanceof Float32Array || Et instanceof Float64Array || Et instanceof Int32Array || Et instanceof Uint32Array || Et instanceof Uint8Array || Et instanceof Uint16Array || Et instanceof Int16Array || Et instanceof Int8Array || Et instanceof Uint8ClampedArray) return {
        rr_type: Et.constructor.name,
        args: [Object.values(Et)]
    };
    if (Et instanceof ArrayBuffer) return {
        rr_type: Et.constructor.name,
        base64: Lr(Et)
    };
    if (Et instanceof DataView) return {
        rr_type: Et.constructor.name,
        args: [De(Et.buffer, es, ts), Et.byteOffset, Et.byteLength]
    };
    if (Et instanceof HTMLImageElement) {
        const is = Et.constructor.name,
            ns = Et.src;
        return {
            rr_type: is,
            src: ns
        }
    }
    return Et instanceof HTMLCanvasElement ? {
        rr_type: "HTMLImageElement",
        src: Et.toDataURL()
    } : Et instanceof ImageData ? {
        rr_type: Et.constructor.name,
        args: [De(Et.data, es, ts), Et.width, Et.height]
    } : Rt(Et, es) || typeof Et == "object" ? {
        rr_type: Et.constructor.name,
        index: kt(Et, es, ts)
    } : Et
}
const Mt = (Et, es, ts) => [...Et].map(is => De(is, es, ts)),
    Rt = (Et, es) => !!["WebGLActiveInfo", "WebGLBuffer", "WebGLFramebuffer", "WebGLProgram", "WebGLRenderbuffer", "WebGLShader", "WebGLShaderPrecisionFormat", "WebGLTexture", "WebGLUniformLocation", "WebGLVertexArrayObject", "WebGLVertexArrayObjectOES"].filter(ts => typeof es[ts] == "function").find(ts => Et instanceof es[ts]);

function xr(Et, es, ts, is) {
    const ns = [],
        rs = Object.getOwnPropertyNames(es.CanvasRenderingContext2D.prototype);
    for (const ss of rs) try {
        if (typeof es.CanvasRenderingContext2D.prototype[ss] != "function") continue;
        const os = Ie(es.CanvasRenderingContext2D.prototype, ss, function (as) {
            return function (...cs) {
                return _$1(this.canvas, ts, is, !0) || setTimeout(() => {
                    var ds = Mt([...cs], es, this);
                    Et(this.canvas, {
                        type: Ce["2D"],
                        property: ss,
                        args: ds
                    })
                }, 0), as.apply(this, cs)
            }
        });
        ns.push(os)
    } catch (os) {
        const as = Fe(es.CanvasRenderingContext2D.prototype, ss, {
            set(cs) {
                Et(this.canvas, {
                    type: Ce["2D"],
                    property: ss,
                    args: [cs],
                    setter: !0
                })
            }
        });
        ns.push(as)
    }
    return () => {
        ns.forEach(ss => ss())
    }
}

function Nt(Et, es, ts) {
    const is = [];
    try {
        var ns = Ie(Et.HTMLCanvasElement.prototype, "getContext", function (rs) {
            return function (ss, ...os) {
                return _$1(this, es, ts, !0) || "__context" in this || (this.__context = ss), rs.apply(this, [ss, ...os])
            }
        });
        is.push(ns)
    } catch (rs) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext")
    }
    return () => {
        is.forEach(rs => rs())
    }
}

function Tt(Et, es, ts, is, ns, rs, ss) {
    const os = [],
        as = Object.getOwnPropertyNames(Et);
    for (const cs of as)
        if (!["isContextLost", "canvas", "drawingBufferWidth", "drawingBufferHeight"].includes(cs)) try {
            if (typeof Et[cs] != "function") continue;
            const ds = Ie(Et, cs, function (fs) {
                return function (...us) {
                    var ls = fs.apply(this, us);
                    if (kt(ls, ss, this), !_$1(this.canvas, is, ns, !0)) {
                        const hs = Mt([...us], ss, this),
                            ms = {
                                type: es,
                                property: cs,
                                args: hs
                            };
                        ts(this.canvas, ms)
                    }
                    return ls
                }
            });
            os.push(ds)
        } catch (ds) {
            const fs = Fe(Et, cs, {
                set(us) {
                    ts(this.canvas, {
                        type: es,
                        property: cs,
                        args: [us],
                        setter: !0
                    })
                }
            });
            os.push(fs)
        }
    return os
}

function Wr(Et, es, ts, is, ns) {
    const rs = [];
    return rs.push(...Tt(es.WebGLRenderingContext.prototype, Ce.WebGL, Et, ts, is, ns, es)), es.WebGL2RenderingContext !== void 0 && rs.push(...Tt(es.WebGL2RenderingContext.prototype, Ce.WebGL2, Et, ts, is, ns, es)), () => {
        rs.forEach(ss => ss())
    }
}
var Ot = null;
try {
    var Br = typeof module != "undefined" && typeof module.require == "function" && module.require("worker_threads") || typeof __non_webpack_require__ == "function" && __non_webpack_require__("worker_threads") || typeof require == "function" && require("worker_threads"),
        Ot = Br.Worker
} catch (Et) {}

function Gr(Et, es) {
    return Buffer.from(Et, "base64").toString("utf8")
}

function _r(is, es, ts) {
    var is = Gr(is),
        ns = is.indexOf(`
`, 10) + 1,
        rs = is.substring(ns) + "";
    return function (ss) {
        return new Ot(rs, Object.assign({}, ss, {
            eval: !0
        }))
    }
}

function Ur(Et, es) {
    return atob(Et)
}

function Zr(is, es, ts) {
    var is = Ur(is),
        ns = is.indexOf(`
`, 10) + 1,
        is = is.substring(ns) + "",
        ns = new Blob([is], {
            type: "application/javascript"
        });
    return URL.createObjectURL(ns)
}

function Vr(Et, es, ts) {
    var is;
    return function (ns) {
        return is = is || Zr(Et), new Worker(is, ns)
    }
}
var Kr = Object.prototype.toString.call(typeof process != "undefined" ? process : 0) === "[object process]";

function zr() {
    return Kr
}

function Yr(Et, es, ts) {
    return (zr() ? _r : Vr)(Et)
}
var Hr = Yr("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");
class Jr {
    constructor(es) {
        this.pendingCanvasMutations = new s$4, this.rafStamps = {
            latestId: 0,
            invokeId: null
        }, this.frozen = !1, this.locked = !1, this.processMutation = (as, cs) => {
            (this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId || !this.rafStamps.invokeId) && (this.rafStamps.invokeId = this.rafStamps.latestId), this.pendingCanvasMutations.has(as) || this.pendingCanvasMutations.set(as, []), this.pendingCanvasMutations.get(as).push(cs)
        };
        var {
            sampling: ts = "all",
            win: is,
            blockClass: ns,
            blockSelector: rs,
            recordCanvas: ss,
            dataURLOptions: os
        } = es;
        this.mutationCb = es.mutationCb, this.mirror = es.mirror, ss && ts === "all" && this.initCanvasMutationObserver(is, ns, rs), ss && typeof ts == "number" && this.initCanvasFPSObserver(ts, is, ns, rs, {
            dataURLOptions: os
        })
    }
    reset() {
        this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers()
    }
    freeze() {
        this.frozen = !0
    }
    unfreeze() {
        this.frozen = !1
    }
    lock() {
        this.locked = !0
    }
    unlock() {
        this.locked = !1
    }
    initCanvasFPSObserver(es, ts, is, ns, rs) {
        const ss = Nt(ts, is, ns),
            os = new s$4,
            as = new Hr,
            cs = (as.onmessage = ls => {
                var hs, ms, ps, gs = ls.data.id;
                os.set(gs, !1), "base64" in ls.data && ({
                    base64: ls,
                    type: hs,
                    width: ms,
                    height: ps
                } = ls.data, this.mutationCb({
                    id: gs,
                    type: Ce["2D"],
                    commands: [{
                        property: "clearRect",
                        args: [0, 0, ms, ps]
                    }, {
                        property: "drawImage",
                        args: [{
                            rr_type: "ImageBitmap",
                            args: [{
                                rr_type: "Blob",
                                data: [{
                                    rr_type: "ArrayBuffer",
                                    base64: ls
                                }],
                                type: hs
                            }]
                        }, 0, 0]
                    }]
                }))
            }, 1e3 / es);
        let ds, fs = 0;
        const us = ls => {
            fs && ls - fs < cs || (fs = ls, (() => {
                const hs = [];
                return ts.document.querySelectorAll("canvas").forEach(ms => {
                    _$1(ms, is, ns, !0) || hs.push(ms)
                }), hs
            })().forEach(hs => Fr(this, void 0, void 0, function* () {
                const ms = this.mirror.getId(hs);
                if (!os.get(ms)) {
                    if (os.set(ms, !0), ["webgl", "webgl2"].includes(hs.__context)) {
                        const gs = hs.getContext(hs.__context);
                        ((ps = gs == null ? void 0 : gs.getContextAttributes()) == null ? void 0 : ps.preserveDrawingBuffer) !== !1 || gs != null && gs.clear(gs.COLOR_BUFFER_BIT)
                    }
                    var ps = yield createImageBitmap(hs);
                    as.postMessage({
                        id: ms,
                        bitmap: ps,
                        width: hs.width,
                        height: hs.height,
                        dataURLOptions: rs.dataURLOptions
                    }, [ps])
                }
            }))), ds = requestAnimationFrame(us)
        };
        ds = requestAnimationFrame(us), this.resetObservers = () => {
            ss(), cancelAnimationFrame(ds)
        }
    }
    initCanvasMutationObserver(es, ts, is) {
        this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
        const ns = Nt(es, ts, is),
            rs = xr(this.processMutation.bind(this), es, ts, is),
            ss = Wr(this.processMutation.bind(this), es, ts, is, this.mirror);
        this.resetObservers = () => {
            ns(), rs(), ss()
        }
    }
    startPendingCanvasMutationFlusher() {
        requestAnimationFrame(() => this.flushPendingCanvasMutations())
    }
    startRAFTimestamping() {
        const es = ts => {
            this.rafStamps.latestId = ts, requestAnimationFrame(es)
        };
        requestAnimationFrame(es)
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((es, ts) => {
            var is = this.mirror.getId(ts);
            this.flushPendingCanvasMutationFor(ts, is)
        }), requestAnimationFrame(() => this.flushPendingCanvasMutations())
    }
    flushPendingCanvasMutationFor(es, ts) {
        var is, ns;
        this.frozen || this.locked || (ns = this.pendingCanvasMutations.get(es)) && ts !== -1 && (is = ns.map(rs => Or(rs, ["type"])), ns = ns[0].type, this.mutationCb({
            id: ts,
            type: ns,
            commands: is
        }), this.pendingCanvasMutations.delete(es))
    }
}
class Qr {
    constructor(es) {
        this.trackedLinkElements = new WeakSet, this.styleMirror = new fr, this.mutationCb = es.mutationCb, this.adoptedStyleSheetCb = es.adoptedStyleSheetCb
    }
    attachLinkElement(es, ts) {
        "_cssText" in ts.attributes && this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [{
                id: ts.id,
                attributes: ts.attributes
            }]
        }), this.trackLinkElement(es)
    }
    trackLinkElement(es) {
        this.trackedLinkElements.has(es) || (this.trackedLinkElements.add(es), this.trackStylesheetInLinkElement(es))
    }
    adoptStyleSheets(es, ts) {
        if (es.length !== 0) {
            const is = {
                    id: ts,
                    styleIds: []
                },
                ns = [];
            for (const rs of es) {
                let ss;
                if (this.styleMirror.has(rs)) ss = this.styleMirror.getId(rs);
                else {
                    ss = this.styleMirror.add(rs);
                    const os = Array.from(rs.rules || CSSRule);
                    ns.push({
                        styleId: ss,
                        rules: os.map((as, cs) => ({
                            rule: Je(as),
                            index: cs
                        }))
                    })
                }
                is.styleIds.push(ss)
            }
            0 < ns.length && (is.styles = ns), this.adoptedStyleSheetCb(is)
        }
    }
    reset() {
        this.styleMirror.reset(), this.trackedLinkElements = new WeakSet
    }
    trackStylesheetInLinkElement(es) {}
}

function F$2(Et) {
    return Object.assign(Object.assign({}, Et), {
        timestamp: Date.now()
    })
}
let N$2, xe, Ye, We = !1;
const $$2 = Vt();

function ie$1(Et = {}) {
    const {
        emit: es,
        checkoutEveryNms: ts,
        checkoutEveryNth: is,
        blockClass: ns = "rr-block",
        blockSelector: rs = null,
        ignoreClass: ss = "rr-ignore",
        maskTextClass: os = "rr-mask",
        maskTextSelector: as = null,
        inlineStylesheet: cs = !0,
        maskAllInputs: ds,
        maskInputOptions: fs,
        slimDOMOptions: us,
        maskInputFn: ls,
        maskTextFn: hs,
        hooks: ms,
        packFn: ps,
        sampling: gs = {},
        dataURLOptions: ws = {},
        mousemoveWait: $s,
        recordCanvas: bs = !1,
        recordCrossOriginIframes: Es = !1,
        userTriggeredOnInput: Ts = !1,
        collectFonts: Ss = !1,
        inlineImages: Cs = !1,
        plugins: vs,
        keepIframeSrcFn: ys = () => !1,
        ignoreCSSAttributes: As = new Set([])
    } = Et, ks = !Es || window.parent === window;
    let xs = !1;
    if (!ks) try {
        window.parent.document, xs = !1
    } catch (_s) {
        xs = !0
    }
    if (ks && !es) throw new Error("emit function is required");
    $s !== void 0 && gs.mousemove === void 0 && (gs.mousemove = $s), $$2.reset();
    const Gs = ds === !0 ? {
            color: !0,
            date: !0,
            "datetime-local": !0,
            email: !0,
            month: !0,
            number: !0,
            range: !0,
            search: !0,
            tel: !0,
            text: !0,
            time: !0,
            url: !0,
            week: !0,
            textarea: !0,
            select: !0,
            password: !0
        } : fs !== void 0 ? fs : {
            password: !0
        },
        Ns = us === !0 || us === "all" ? {
            script: !0,
            comment: !0,
            headFavicon: !0,
            headWhitespace: !0,
            headMetaSocial: !0,
            headMetaRobots: !0,
            headMetaHttpEquiv: !0,
            headMetaVerification: !0,
            headMetaAuthorship: us === "all",
            headMetaDescKeywords: us === "all"
        } : us || {};
    hr();
    let Bs, Ms = 0;
    const zs = _s => {
            for (const Ds of vs || []) Ds.eventProcessor && (_s = Ds.eventProcessor(_s));
            return _s = ps ? ps(_s) : _s
        },
        Fs = (N$2 = (_s, Ds) => {
            var Rs;
            if ((Rs = ce[0]) == null || !Rs.isFrozen() || _s.type === b$4.FullSnapshot || _s.type === b$4.IncrementalSnapshot && _s.data.source === v$4.Mutation || ce.forEach(Os => Os.unfreeze()), ks) es != null && es(zs(_s), Ds);
            else if (xs) {
                const Os = {
                    type: "rrweb",
                    event: zs(_s),
                    isCheckout: Ds
                };
                window.parent.postMessage(Os, "*")
            }
            if (_s.type === b$4.FullSnapshot) Bs = _s, Ms = 0;
            else if (_s.type === b$4.IncrementalSnapshot && (_s.data.source !== v$4.Mutation || !_s.data.isAttachIframe)) {
                Ms++;
                const Os = is && Ms >= is,
                    Is = ts && _s.timestamp - Bs.timestamp > ts;
                (Os || Is) && xe(!0)
            }
        }, _s => {
            N$2(F$2({
                type: b$4.IncrementalSnapshot,
                data: Object.assign({
                    source: v$4.Mutation
                }, _s)
            }))
        }),
        qs = _s => N$2(F$2({
            type: b$4.IncrementalSnapshot,
            data: Object.assign({
                source: v$4.Scroll
            }, _s)
        })),
        Ws = _s => N$2(F$2({
            type: b$4.IncrementalSnapshot,
            data: Object.assign({
                source: v$4.CanvasMutation
            }, _s)
        })),
        Ls = new Qr({
            mutationCb: Fs,
            adoptedStyleSheetCb: _s => N$2(F$2({
                type: b$4.IncrementalSnapshot,
                data: Object.assign({
                    source: v$4.AdoptedStyleSheet
                }, _s)
            }))
        }),
        Us = new Nr({
            mirror: $$2,
            mutationCb: Fs,
            stylesheetManager: Ls,
            recordCrossOriginIframes: Es,
            wrappedEmit: N$2
        });
    for (const _s of vs || []) _s.getMirror && _s.getMirror({
        nodeMirror: $$2,
        crossOriginIframeMirror: Us.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: Us.crossOriginIframeStyleMirror
    });
    Ye = new Jr({
        recordCanvas: bs,
        mutationCb: Ws,
        win: window,
        blockClass: ns,
        blockSelector: rs,
        mirror: $$2,
        sampling: gs.canvas,
        dataURLOptions: ws
    });
    const Ps = new Tr({
        mutationCb: Fs,
        scrollCb: qs,
        bypassOptions: {
            blockClass: ns,
            blockSelector: rs,
            maskTextClass: os,
            maskTextSelector: as,
            inlineStylesheet: cs,
            maskInputOptions: Gs,
            dataURLOptions: ws,
            maskTextFn: hs,
            maskInputFn: ls,
            recordCanvas: bs,
            inlineImages: Cs,
            sampling: gs,
            slimDOMOptions: Ns,
            iframeManager: Us,
            stylesheetManager: Ls,
            canvasManager: Ye,
            keepIframeSrcFn: ys
        },
        mirror: $$2
    });
    xe = (Ds = !1) => {
        N$2(F$2({
            type: b$4.Meta,
            data: {
                href: window.location.href,
                width: rt(),
                height: tt()
            }
        }), Ds), Ls.reset(), ce.forEach(Rs => Rs.lock());
        var Ds = cr(document, {
            mirror: $$2,
            blockClass: ns,
            blockSelector: rs,
            maskTextClass: os,
            maskTextSelector: as,
            inlineStylesheet: cs,
            maskAllInputs: Gs,
            maskTextFn: hs,
            slimDOM: Ns,
            dataURLOptions: ws,
            recordCanvas: bs,
            inlineImages: Cs,
            onSerialize: Rs => {
                it(Rs, $$2) && Us.addIframe(Rs), at(Rs, $$2) && Ls.trackLinkElement(Rs), st(Rs) && Ps.addShadowRoot(Rs.shadowRoot, document)
            },
            onIframeLoad: (Rs, Os) => {
                Us.attachIframe(Rs, Os), Ps.observeAttachShadow(Rs)
            },
            onStylesheetLoad: (Rs, Os) => {
                Ls.attachLinkElement(Rs, Os)
            },
            keepIframeSrcFn: ys
        });
        if (!Ds) return console.warn("Failed to snapshot the document");
        N$2(F$2({
            type: b$4.FullSnapshot,
            data: {
                node: Ds,
                initialOffset: {
                    left: window.pageXOffset !== void 0 ? window.pageXOffset : (document == null ? void 0 : document.documentElement.scrollLeft) || ((Ds = (Ds = document == null ? void 0 : document.body) == null ? void 0 : Ds.parentElement) == null ? void 0 : Ds.scrollLeft) || ((Ds = document == null ? void 0 : document.body) == null ? void 0 : Ds.scrollLeft) || 0,
                    top: window.pageYOffset !== void 0 ? window.pageYOffset : (document == null ? void 0 : document.documentElement.scrollTop) || ((Ds = (Ds = document == null ? void 0 : document.body) == null ? void 0 : Ds.parentElement) == null ? void 0 : Ds.scrollTop) || ((Ds = document == null ? void 0 : document.body) == null ? void 0 : Ds.scrollTop) || 0
                }
            }
        })), ce.forEach(Rs => Rs.unlock()), document.adoptedStyleSheets && 0 < document.adoptedStyleSheets.length && Ls.adoptStyleSheets(document.adoptedStyleSheets, $$2.getId(document))
    };
    try {
        const _s = [],
            Ds = (_s.push(G("DOMContentLoaded", () => {
                N$2(F$2({
                    type: b$4.DomContentLoaded,
                    data: {}
                }))
            })), Os => Rr({
                mutationCb: Fs,
                mousemoveCb: (Is, Hs) => N$2(F$2({
                    type: b$4.IncrementalSnapshot,
                    data: {
                        source: Hs,
                        positions: Is
                    }
                })),
                mouseInteractionCb: Is => N$2(F$2({
                    type: b$4.IncrementalSnapshot,
                    data: Object.assign({
                        source: v$4.MouseInteraction
                    }, Is)
                })),
                scrollCb: qs,
                viewportResizeCb: Is => N$2(F$2({
                    type: b$4.IncrementalSnapshot,
                    data: Object.assign({
                        source: v$4.ViewportResize
                    }, Is)
                })),
                inputCb: Is => N$2(F$2({
                    type: b$4.IncrementalSnapshot,
                    data: Object.assign({
                        source: v$4.Input
                    }, Is)
                })),
                mediaInteractionCb: Is => N$2(F$2({
                    type: b$4.IncrementalSnapshot,
                    data: Object.assign({
                        source: v$4.MediaInteraction
                    }, Is)
                })),
                styleSheetRuleCb: Is => N$2(F$2({
                    type: b$4.IncrementalSnapshot,
                    data: Object.assign({
                        source: v$4.StyleSheetRule
                    }, Is)
                })),
                styleDeclarationCb: Is => N$2(F$2({
                    type: b$4.IncrementalSnapshot,
                    data: Object.assign({
                        source: v$4.StyleDeclaration
                    }, Is)
                })),
                canvasMutationCb: Ws,
                fontCb: Is => N$2(F$2({
                    type: b$4.IncrementalSnapshot,
                    data: Object.assign({
                        source: v$4.Font
                    }, Is)
                })),
                selectionCb: Is => {
                    N$2(F$2({
                        type: b$4.IncrementalSnapshot,
                        data: Object.assign({
                            source: v$4.Selection
                        }, Is)
                    }))
                },
                blockClass: ns,
                ignoreClass: ss,
                maskTextClass: os,
                maskTextSelector: as,
                maskInputOptions: Gs,
                inlineStylesheet: cs,
                sampling: gs,
                recordCanvas: bs,
                inlineImages: Cs,
                userTriggeredOnInput: Ts,
                collectFonts: Ss,
                doc: Os,
                maskInputFn: ls,
                maskTextFn: hs,
                keepIframeSrcFn: ys,
                blockSelector: rs,
                slimDOMOptions: Ns,
                dataURLOptions: ws,
                mirror: $$2,
                iframeManager: Us,
                stylesheetManager: Ls,
                shadowDomManager: Ps,
                canvasManager: Ye,
                ignoreCSSAttributes: As,
                plugins: ((Os = vs == null ? void 0 : vs.filter(Is => Is.observer)) == null ? void 0 : Os.map(Is => ({
                    observer: Is.observer,
                    options: Is.options,
                    callback: Hs => N$2(F$2({
                        type: b$4.Plugin,
                        data: {
                            plugin: Is.name,
                            payload: Hs
                        }
                    }))
                }))) || []
            }, ms)),
            Rs = (Us.addLoadListener(Os => {
                _s.push(Ds(Os.contentDocument))
            }), () => {
                xe(), _s.push(Ds(document)), We = !0
            });
        return document.readyState === "interactive" || document.readyState === "complete" ? Rs() : _s.push(G("load", () => {
            N$2(F$2({
                type: b$4.Load,
                data: {}
            })), Rs()
        }, window)), () => {
            _s.forEach(Os => Os()), We = !1
        }
    } catch (_s) {
        console.warn(_s)
    }
}

function Pr(Et) {
    return Et = JSON.stringify(Et), Et = $r.gzip(Et, {
        level: 9
    }), btoa(new Uint8Array(Et).reduce(function (es, ts) {
        return es + String.fromCharCode(ts)
    }, ""))
}
ie$1.addCustomEvent = (Et, es) => {
    if (!We) throw new Error("please add custom event after start recording");
    N$2(F$2({
        type: b$4.Custom,
        data: {
            tag: Et,
            payload: es
        }
    }))
}, ie$1.freezePage = () => {
    ce.forEach(Et => Et.freeze())
}, ie$1.takeFullSnapshot = Et => {
    if (!We) throw new Error("please take full snapshot after start recording");
    xe(Et)
}, ie$1.mirror = $$2;
let He = !1;

function Ft(Et, ts) {
    var {
        data: ts,
        url: is,
        sectionInfo: ns
    } = jr(Et, be, ts);
    ns && ns.isRestSID === void 0 || ns && ns.isRestSID === !1 ? (console.log("\u8FD9\u662F\u771F\u6B63\u8981\u4E0A\u62A5\u7684\u6570\u636E", Et), He = !1, fetch(is, {
        method: "POST",
        body: ts
    }).then(rs => {
        rs.ok ? he$2 = [] : de$1++, Ae = !1, de$1 = 0
    }).catch(rs => {
        Ae = !1, de$1++
    })) : (console.log("\u4F1A\u8BDDid\u66F4\u65B0\u4E86,\u8FD9\u6B21\u6570\u636E\u4E0D\u4E0A\u62A5"), Ae = !1, de$1 = 0, He = !0)
}

function Xr(Et) {
    return new Blob([Et]).size
}

function jr(Et, es, ts) {
    if (He === !0) {
        const ss = Et.findIndex(os => os.type === 4 && os.data && os.data.href === window.location.href); - 1 < ss && Et.splice(0, ss)
    }
    se$1 === 0 && (se$1 = 1e3 * Et[0].timestamp);
    var is, ns = new FormData,
        rs = bonreeRUM.getSession();
    if (ns.append("s", rs.sessionID), ns.append("v", bonreeRUM && bonreeRUM.version || "1.0.0"), ns.append("mt", String(now())), ns.append("cmt", String(ts.initTime)), ns.append("di", JSON.stringify(getDeviceInfo())), ns.append("ai", JSON.stringify({
            ai: ts.appId,
            av: ts.appVersion || "unknown",
            an: ts.appName || "unknown",
            at: 4
        })), ts.dataFusionInfo == "net" && ns.append("dfi", JSON.stringify({
            net: "net"
        })), se$1 === 0 && (se$1 = 1e3 * Et[0].timestamp), ns.append("st", se$1), isDefined(window.bonreeRUM) || !isDefined(window.bonreeRUM.getUserInfo)) return Object.getOwnPropertyNames(bonreeRUM.getUserInfo()).length !== 0 && ns.append("ui", JSON.stringify(Object.entries(bonreeRUM.getUserInfo())[0][1])), is = 1e3 * Et[Et.length - 1].timestamp - se$1, ns.append("ud", is), se$1 = 1e3 * Et[Et.length - 1].timestamp, ns.append("wev", "2.0.0-alpha.8"), is = new Blob([JSON.stringify({
        wsd: Pr(Et)
    })], {
        type: "application/json"
    }), ns.append("event", is), {
        data: ns,
        url: es + "?a=" + ts.appId + "&brkey=" + uuid() + "&d=" + getDeviceInfo().di + "&v=2024083001",
        sectionInfo: rs
    };
    log("C154")
}

function qr(Et) {
    if (window.fetch && !Ae && !isDefined(window.stopBonreeRecordUpload) && ve.length !== 0) {
        Ae = !0;
        let is = 0;
        for (3 <= de$1 && (he$2 = [], de$1 = 0); 0 < ve.length && de$1 === 0;) {
            var es = ve.shift(),
                ts = Xr(JSON.stringify(es));
            is + ts > Gt && (Ft(he$2, Et), is = 0), he$2.push(es), is += ts
        }
        0 < he$2.length && Ft(he$2, Et)
    }
}

function BonreeRecord(Et) {
    u$1.BonreeRecordState = !0, (ts = Et.RecordConfiguration || Et.mc) instanceof Array && ts.forEach(function (ns) {
        ns.n === "sessionreplay" && (es = ns)
    });
    var es, ts = es || ts;
    if (isDefined(ts)) {
        let ns = function (rs) {
            return !(rs < Math.floor(100 * Math.random()))
        };
        var is;
        if (isDefined(ts) && isDefined(ts.Rate) && ns(ts.Rate) || isDefined(ts) && isDefined(ts.c) && ns(ts.c)) return be = window.location.protocol === "https:" ? ts.UploadHttps || ts.src && ts.src.uas : ts.UploadHttp || ts.src && ts.src.ua, isDefined(window.$bonreeReplayUrl = be) && window === window.top && setInterval(qr, 1e3 * (ts.UploadCycle || ts.src && ts.src.uc), Et), Et = {
            emit: function (rs) {
                window === window.top && ve.push(rs)
            },
            maskAllInputs: !0,
            recordCanvas: !0,
            sampling: {
                canvas: 5
            },
            dataURLOptions: {
                type: "image/webp",
                quality: .3
            },
            recordCrossOriginIframes: !0,
            maskTextSelector: "body",
            maskTextFn: function (rs) {
                var ss;
                return rs.indexOf(`
`) === -1 ? "*".repeat(rs.length) : (ss = rs.trim(), rs.replace(ss, "*".repeat(ss.length)))
            }
        }, is = {
            emit: function (rs) {
                window === window.top && ve.push(rs)
            },
            maskAllInputs: !0,
            recordCanvas: !0,
            recordCrossOriginIframes: !0,
            sampling: {
                canvas: 5
            },
            dataURLOptions: {
                type: "image/webp",
                quality: .3
            }
        }, ts.src && ts.src.sl !== void 0 ? ts.src.sl === 1 ? ie$1(Et) : ie$1(is) : ts.Sensitivity !== void 0 ? ts.Sensitivity === 1 ? ie$1(Et) : ie$1(is) : void 0
    }
}
BonreeRecord.takeFullSnapshot = ie$1.takeFullSnapshot;
let D$4 = class {
        constructor() {
            this.firstDayEnd = 0, this.isFirstDay = !1
        }
        getTodayEnd() {
            var ts = new Date,
                Et = ts.getFullYear(),
                es = ts.getMonth(),
                ts = ts.getDate();
            return +new Date(Et, es, ts + 1)
        }
        unserialize(Et) {
            try {
                return JSON.parse(Et)
            } catch (es) {
                return Et
            }
        }
        updateFirstDay(Et) {
            var es = this.unserialize(getLocaStore(GC.FIRST_DAY));
            return es && isRightTimestamp(es) ? (this.firstDayEnd = es, this.isFirstDay = Et <= this.firstDayEnd) : (this.firstDayEnd = this.getTodayEnd(), this.isFirstDay = !0, setLocalStore(GC.FIRST_DAY, this.firstDayEnd)), this.isFirstDay
        }
        getIsFirstDay(Et) {
            return this.updateFirstDay(Et)
        }
    },
    y$3 = new D$4;

function p$4() {
    function Et() {
        for (var rs = 0; rs < is.length; rs++) is[rs]()
    }
    var es = !(!window.attachEvent || window.opera),
        ts = /webkit\/(\d+)/i.test(navigator.userAgent) && RegExp.$1 < 525,
        is = [],
        ns = document;
    ns.ready = function (rs) {
        if (!es && !ts && ns.addEventListener) return ns.addEventListener("DOMContentLoaded", rs, !1);
        var ss;
        1 < is.push(rs) || (es ? function () {
            try {
                ns.documentElement.doScroll("left"), Et()
            } catch (os) {
                setTimeout(arguments.callee, 0)
            }
        }() : ts && (ss = setInterval(function () {
            /^(loaded|complete)$/.test(ns.readyState) && (clearInterval(ss), Et())
        }, 0)))
    }
}

function b$3() {
    return !/BonreeRUM=0/.test(window.location.search) || (f$1.checkProbability(0), !1)
}

function D$3() {
    v$8([GC.PAGE_READY, GC.PAGE_LOAD], Et => {
        Et.t === GC.PAGE_READY ? u$1.changeState(1) : u$1.changeState(2)
    })
}

function h$9() {
    document && (u$1.setData(GC.TITLE, document.title), u$1.setEviData("n", document.URL), document.title != "" && u$1.setEviData("vt", document.title), document.referrer) && u$1.setEviData("ru", document.referrer)
}

function l$1() {
    function Et(es) {
        es = es.data, isDefined(es.bonreeID) && w$5(es.bonreeID)
    }
    try {
        if (window.addEventListener ? window.addEventListener("message", Et, !1) : window.attachEvent("onmessage", Et), window.parent) {
            let es = window.parent.document.querySelectorAll("iframe"),
                ts = !1;
            forEach(es, function (is) {
                !ts && isDefined(is.getAttribute("bonreeid")) && (w$5(is.getAttribute("bonreeid")), ts = !0)
            })
        }
    } catch (es) {}
}

function I$3() {
    if (l$1(), !b$3()) return log("C106", !0), !1;
    p$4(), D$3(), document && document.ready(h$9), isDefined(window) && (window.setJsBridge = function (ts) {
        window.bonreePrivateInterface = ts
    });
    try {
        var Et = document.querySelector("#BonreeAgent");
        if (!isDefined(Et)) return !1;
        var es = Et.getAttribute("data");
        if (!isJSON(es = window.decodeURIComponent && window.decodeURIComponent(es))) return log("C102", !0), !1;
        if (isDefined((es = JSON.parse(es)).appId) || log("C101", !0), isDefined(window.getIsRunWithNetClient) && (es.dataFusionInfo = "net"), isDefined(window.bonreeRUM) ? window.bonreeRUM.config(es, !1, 1) : f$1.setConfig(es), f$1.sett.initTime = now(), f$1.sett.probability) return !0;
        log("C103", !0)
    } catch (ts) {
        return log("C102", !0), !1
    }
    return !0
}
class Protocol {
    constructor() {
        this.json = {
            v: bonreeRUM && bonreeRUM.version || "1.0.0",
            e: []
        }
    }
}
Protocol.prototype.setMonitorTime = function (Et) {
    return this.json.mt = Et, this
}, Protocol.prototype.setConfigTime = function (Et) {
    return this.json.cmt = Et, this
}, Protocol.prototype.setSessionId = function (Et) {
    return this.json.s = Et, this
}, Protocol.prototype.setDeviceInfo = function (Et) {
    return this.json.di = Et, this
}, Protocol.prototype.setAppInfo = function (Et) {
    return this.json.ai = Et, this
}, Protocol.prototype.setFirstUserInfoIndex = function () {
    var Et = u$1.firstUserInfoSetMapKey;
    return Et !== "" && (this.json.fui = Et, u$1.updateFirstUserInfoSetMapKey("")), this
}, Protocol.prototype.setUserInfo = function (Et) {
    return this.json.ui = Et, this
}, Protocol.prototype.setEventViewInfo = function (Et) {
    return this.json.evi = Et, this
}, Protocol.prototype.setIfd = function (Et) {
    return this.json.ifd = Et, this
}, Protocol.prototype.setEei = function (Et) {
    return isEmpty(Et) || (this.json.eei = Et), this
}, Protocol.prototype.setSessionDuration = function (Et) {
    return this.json.usd = Et, this
}, Protocol.prototype.pushEventData = function (Et) {
    var es = {
        k: Et.type,
        ent: Et.ent,
        sin: Et.sin,
        v: Et.data
    };
    return isDefined(Et.eei) && !isEmpty(Et.eei) && (es.eei = Et.eei), isDefined(Et.revts) && (es.revts = Et.revts), this.json.e.push(es), this
}, Protocol.prototype.build = function (Et) {
    return this.json
}, Protocol.prototype.setDataFusionInfo = function (Et) {
    return this.json.dfi = {
        net: Et
    }, this
}, Protocol.prototype.setSessionStartTime = function (Et) {
    return this.json.sst = Et, this
};
const c$1 = 3e4,
    a$3 = [];
let p$3 = !0;

function A$4() {
    return f$1.sett.isFirstUpload ? (extend(f$1.sett, {
        isFirstUpload: 0
    }), 1) : 0
}

function S$3(Et, es) {
    let ts = "";
    return window.location.protocol === "https:" ? (isDefined(f$1.sett.uploadAddrHttps) && (ts = f$1.sett.uploadAddrHttps), isDefined(f$1.secondSett.uploadAddrHttps) && (ts = f$1.secondSett.uploadAddrHttps)) : (isDefined(f$1.sett.uploadAddrHttp) && (ts = f$1.sett.uploadAddrHttp), isDefined(f$1.secondSett.uploadAddrHttp) && (ts = f$1.secondSett.uploadAddrHttp)), ts = (ts = (ts = (ts = (ts = (ts = (ts += "?v=2024083001") + ("&a=" + Et.ai.ai)) + ("&d=" + Et.di.di)) + ("&mt=" + Et.mt)) + ("&cmt=" + Et.cmt)) + ("&s=" + Et.s) + ("&brkey=" + es)) + ("&if=" + A$4()), f$1.sett.sm4Config !== void 0 && /^[A-Za-z0-9_-]{1,256}$/.test(f$1.sett.sm4Config.identify || f$1.sett.sm4Config.identifier) && (ts += "&BR-Encryption-Method=sm4:" + (f$1.sett.sm4Config.identify || f$1.sett.sm4Config.identifier)), isDefined(window.bonreeRUM) && window.bonreeRUM.isPrivate ? ts += "&isp=1" : ts += "&isp=0", ts
}

function C$4(Et, es, ts, is, ns) {
    var rs;
    if (window.XDomainRequest)(rs = new window.XDomainRequest).open("POST", Et), rs.timeout = c$1, rs.onload = function () {
        ts && ts(!0)
    }, rs.onerror = rs.ontimeout = function () {
        ts && ts(!1)
    }, delay(function () {
        rs.send(es)
    });
    else {
        if (!window.XMLHttpRequest) return !1;
        rs = new window.XMLHttpRequest;
        try {
            rs.$$inner = !0, rs.overrideMimeType("text/plain"), rs.open("POST", Et, !0), rs.setRequestHeader("brkey", ns), rs.timeout = c$1, rs.onreadystatechange = function () {
                rs.readyState === 4 && (ts && ts(rs.status === 200), h$8(rs))
            }
        } catch (ss) {}
        rs.send(es)
    }
    return !0
}

function H$3() {
    return /\bQQ\b/i.test(navigator.userAgent)
}

function h$8(Et) {
    p$3 = !0, w$4()
}

function y$2() {
    var Et;
    p$3 === !0 && 0 < a$3.length && (Et = a$3.shift(), p$3 = !1, C$4(Et.url, Et.data, onEnd, !0, Et.uid))
}

function w$4(Et, es, ts, is, ns) {
    Et && es && a$3.length < 100 && a$3.push({
        data: es,
        uid: ns,
        url: Et
    }), y$2()
}

function sendUpload(Et, es, ts) {
    var is = uuid(),
        ns = S$3(Et, is);
    if (!startWith(ns, "http")) return !1;
    var rs, ss = f$1.sett.useXHR || f$1.secondSett.useXHR || !1;
    if (window.navigator && navigator.sendBeacon && !H$3() && ss === !1) {
        if (f$1.sett.sm4Config !== void 0 && /^[A-Za-z0-9_-]{1,256}$/.test(f$1.sett.sm4Config.identify || f$1.sett.sm4Config.identifier)) {
            try {
                isDefined(window.BonreeRecord) && window.BonreeRecord.Sm4 && (rs = new window.BonreeRecord.Sm4(f$1.sett.sm4Config)), isDefined(window.BonreeAgent) && window.BonreeAgent.Sm4 && (rs = new window.BonreeAgent.Sm4(f$1.sett.sm4Config))
            } catch (os) {
                return log("C156"), ss = f$1.sett.sm4Config.identify || f$1.sett.sm4Config.identifier, ts(navigator.sendBeacon(ns.replace("&BR-Encryption-Method=sm4:" + ss, ""), stringify(Et)))
            }
            return ts(navigator.sendBeacon(ns, rs.encrypt(stringify(Et))))
        }
        return ts(navigator.sendBeacon(ns, stringify(Et)))
    }
    if (f$1.sett.sm4Config !== void 0) {
        if (isDefined(window.BonreeRecord) && window.BonreeRecord.Sm4) return w$4(ns, (rs = new window.BonreeRecord.Sm4(f$1.sett.sm4Config)).encrypt(stringify(Et)), ts, es, is);
        if (isDefined(window.BonreeAgent) && window.BonreeAgent.Sm4) return w$4(ns, (rs = new window.BonreeAgent.Sm4(f$1.sett.sm4Config)).encrypt(stringify(Et)), ts, es, is)
    }
    return w$4(ns, stringify(Et), ts, es, is)
}
let S$2 = 0,
    d$4 = [];
const ALL_DATAS = [];
let a$2 = {
    WORKER: null,
    IDLE: 0,
    CAPACITY: 0,
    RETRY: 3
};
const O$4 = "br-session-cache";

function V$1() {
    var Et;
    0 < a$2.IDLE || (Et = Number(f$1.sett.cycleTime) || Number(f$1.secondSett.cycleTime) || 10, a$2.IDLE = Et && 0 < Et && Et <= 60 ? 1e3 * Et : 1e4)
}

function getMaxSize() {
    var Et;
    0 < a$2.CAPACITY || (Et = Number(f$1.sett.maxSize) || Number(f$1.secondSett.maxSize) || 20, a$2.CAPACITY = Et && 0 < Et && Et <= 60 ? 1024 * Et : 20480)
}

function U$6(Et) {
    var es = 0;
    if (Et.length !== 0) return forEach(Et, function (ts) {
        (es === 0 || es > ts.data.ent) && (es = ts.data.ent)
    }), es
}

function W$2() {
    v$8(GC.FLUSH_DATA, function (Et) {
        var es;
        V$1(), f$1.sett.osType !== 1 || isDefined(a$2.WORKER) || (es = setInterval(C$3, a$2.IDLE), a$2.changeData(es)), 1 < u$1.state && !isDefined(a$2.WORKER) && (es = setInterval(C$3, a$2.IDLE), a$2.changeData(es)), C$3(Et.p)
    }), v$8(GC.INIT_SESSION_START, function (Et) {
        S$2 = 0;
        var es = U$6(d$4);
        f$1.sett.initTime = es || now()
    })
}

function b$2(Et, es, ts) {
    const is = new Protocol;
    var ns = {
            ai: f$1.sett.appId || f$1.secondSett.appId,
            av: f$1.sett.appVersion || f$1.secondSett.appVersion || "unknown",
            an: f$1.sett.appName || f$1.secondSett.appName || "unknown",
            at: 4
        },
        rs = (isDefined(f$1.sett.channelId) && (ns.ci = f$1.sett.channelId), w$7.getSession().sessionID);
    is.setMonitorTime(now()).setConfigTime(f$1.sett.initTime).setSessionId(rs).setAppInfo(ns).setUserInfo(u$1.getUserInfo()).setEventViewInfo(u$1.getEviData()).setEei(u$1.getEeiData()).setIfd(y$3.getIsFirstDay(+new Date)).setFirstUserInfoIndex(), isDefined(window.BonreeAgent) && isDefined(window.BonreeAgent.getDeviceInfo) ? is.setDeviceInfo(window.BonreeAgent.getDeviceInfo()) : log("C153"), isDefined(window.BonreeRecord) && isDefined(window.BonreeRecord.getDeviceInfo) ? is.setDeviceInfo(window.BonreeRecord.getDeviceInfo()) : log("C153"), isDefined(f$1.sett.dataFusionInfo) && f$1.sett.dataFusionInfo == "net" && is.setDataFusionInfo("net"), S$2 === 0 ? (S$2 = U$6(d$4), is.setSessionStartTime(S$2), f$1.sett.initTime = S$2, is.setConfigTime(f$1.sett.initTime)) : is.setSessionStartTime(S$2);
    let ss = 0,
        os = 0;
    forEach(Et, function (as) {
        var cs = as.ent;
        if ((cs < ss || ss === 0) && (ss = cs), (cs > os || os === 0) && (os = cs), isDefined(as.revts))
            for (var ds of as.revts) ds.ent < ss && (ss = ds.ent), ds.ent > os && (os = ds.ent);
        is.pushEventData(as)
    }, function () {
        var as, cs = getCookie(O$4),
            ds = isJSON(cs) && JSON.parse(cs) || [];
        for (as of ds) isDefined(as.startTime) && as.startTime == 0 && (as.startTime = ss, w$7.setSessionCookie(O$4, JSON.stringify(ds)))
    }), rs = E$6.usdTime && os - E$6.usdTime || os - ss, rs = Math.abs(rs), E$6.changUsdTime(os), is.setSessionDuration(rs), sendUpload(is.build(), es, ts)
}

function k$2(Et, es, ts) {
    if (isDefined(Et) && !isEmpty(Et)) {
        try {
            b$2(Et, es, ts), ts && ts(!0)
        } catch (is) {
            log(is), ts && ts(!1)
        }
        return !0
    }
}

function J$1(Et, es) {
    let ts, is = [],
        ns = 0,
        rs = 0;
    if (ns >= a$2.RETRY) return log("C117");

    function ss(os, as) {
        !isEmpty(is) && (getMaxSize(), os || rs > a$2.CAPACITY) && (k$2(is, es, function (cs) {
            cs ? 0 < ns && (ns = 0) : (ns += 1, es || delay(function () {
                var ds = size(Et);
                rs += ds, is.push(Et)
            }, a$2.IDLE / 10))
        }), is = [], rs = 0, ts = os === 1 ? as : null)
    }
    forEach(Et, os => {
        var cs = os.data && os.data.e;
        if (os.data && os.data.eei && delete os.data.eei, !isDefined(cs)) return rs += os.size, is.push(os.data), ss.call(this);
        var as = cs[0],
            cs = cs[1],
            ds = os.data && os.data.p.info;
        ds.userTime = Math.max(0, ds.timestamp - cs), (ts = isDefined(ts) ? ts : as) !== as && ss.call(this, 1, as), rs += os.size, is.push(os.data), ss.call(this)
    }), ss.call(this, 2)
}

function C$3(Et) {
    isEmpty(d$4 = Et && ALL_DATAS.length ? d$4.concat(ALL_DATAS.splice(0)) : d$4) || (g$7.useAPI || (l$1(), g$7.startCatchDataFun()), J$1(d$4, Et), d$4 = [])
}
a$2.changeData = function (Et) {
    this.WORKER = Et
};
var h$7 = {};
let a$1 = class Ks {
        constructor(es, ts, is = !1, ns, rs = -1, ss = !1, os) {
            this.isChild = is, isDefined(ns) && (this.startTime = ns), isDefined(es) && isDefined(ts) && typeof es == "string" && typeof ts == "string" && /^[a-zA-Z0-9:_-\s@./]+$/.test(ts) && ts.trim() !== "" && /^[a-zA-Z0-9:_-\s@./]+$/.test(es) && es.trim() !== "" ? (this.spanEvent = {
                n: es.slice(0, 256),
                t: ts.slice(0, 256),
                da: [],
                tag: [],
                m: [],
                ic: !0,
                st: isDefined(ns) ? 1e3 * new Date().getTime() - ns : 0
            }, this.special = ss) : this.special = !0, is || this.special || (this.spanEvent.timestamp = 1e3 * new Date().getTime(), this.startTime = this.spanEvent.timestamp), is ? (this.identify = os, h$7[this.identify] = h$7[this.identify] + 1) : (this.identify = uuid(), h$7[this.identify] = 0), this.dataSave = [], this.tagSave = [], this.metricSave = [], this.childSave = [], this.hasFinished = !1, this.deep = rs + 1
        }
        startChild(es, ts) {
            return this.hasFinished || !(isDefined(es) && isDefined(ts) && typeof es == "string" && typeof ts == "string" && /^[a-zA-Z0-9:_-\s@./]+$/.test(ts) && ts.trim() !== "" && /^[a-zA-Z0-9:_-\s@./]+$/.test(es) && es.trim() !== "") || this.special || 10 <= this.deep || isDefined(this.childSave) && 50 <= this.childSave.length || isDefined(h$7) && isDefined(h$7[this.identify]) && 200 <= h$7[this.identify] ? new Ks("name", "type", !0, this.startTime, this.deep, !0, this.identify) : isDefined(this.spanEvent) ? (es = new Ks(es, ts, !0, this.startTime, this.deep, !1, this.identify), isDefined(this.spanEvent.sub) ? this.spanEvent.sub.push(es.spanEvent) : this.spanEvent.sub = [es.spanEvent], this.childSave.push(es), es) : void 0
        }
        setData(es, ts) {
            if (!this.special && !this.hasFinished && isDefined(es) && isDefined(ts) && typeof es == "string" && typeof ts == "string" && !(200 < es.length) && /^[a-zA-Z][a-zA-Z._-]{0,199}$/.test(es) && es.trim() !== "" && ts.trim() !== "" && !(isDefined(this.spanEvent.da) && 64 <= this.spanEvent.da.length) && isDefined(this.spanEvent.da))
                if (0 < this.spanEvent.da.length)
                    if (isDefined(this.dataSave) && -1 < this.dataSave.indexOf(es))
                        for (let is = 0; is < this.spanEvent.da.length; is++) isDefined(this.spanEvent.da[is].k) && this.spanEvent.da[is].k === es && (this.spanEvent.da[is].k = es, this.spanEvent.da[is].v = ts.slice(0, 7e3));
                    else this.spanEvent.da.push({
                        k: es,
                        v: ts.slice(0, 7e3)
                    }), this.dataSave.push(es);
            else this.spanEvent.da.push({
                k: es,
                v: ts.slice(0, 7e3)
            }), this.dataSave.push(es)
        }
        removeData(es) {
            if (!this.special && !this.hasFinished && isDefined(es) && typeof es == "string" && !(200 < es.length) && /^[a-zA-Z][a-zA-Z._-]{0,199}$/.test(es) && es.trim() !== "" && isDefined(this.dataSave) && -1 < this.dataSave.indexOf(es))
                for (let is = 0; is < this.spanEvent.da.length; is++) {
                    var ts;
                    isDefined(this.spanEvent.da[is].k) && this.spanEvent.da[is].k === es && (this.spanEvent.da.splice(is, 1), ts = this.dataSave.indexOf(es), this.dataSave.splice(ts, 1))
                }
        }
        setTag(es, ts) {
            if (!this.special && !this.hasFinished && isDefined(es) && isDefined(ts) && typeof es == "string" && typeof ts == "string" && !(200 < es.length) && /^[a-zA-Z][a-zA-Z._-]{0,199}$/.test(es) && es.trim() !== "" && ts.trim() !== "" && !(isDefined(this.spanEvent.tag) && 64 <= this.spanEvent.tag.length) && isDefined(this.spanEvent.tag))
                if (0 < this.spanEvent.tag.length)
                    if (isDefined(this.tagSave) && -1 < this.tagSave.indexOf(es))
                        for (let is = 0; is < this.spanEvent.tag.length; is++) isDefined(this.spanEvent.tag[is].k) && this.spanEvent.tag[is].k === es && (this.spanEvent.tag[is].k = es, this.spanEvent.tag[is].v = ts.slice(0, 7e3));
                    else this.spanEvent.tag.push({
                        k: es,
                        v: ts.slice(0, 7e3)
                    }), this.tagSave.push(es);
            else this.spanEvent.tag.push({
                k: es,
                v: ts.slice(0, 7e3)
            }), this.tagSave.push(es)
        }
        removeTag(es) {
            if (!this.special && !this.hasFinished && isDefined(es) && typeof es == "string" && !(200 < es.length) && /^[a-zA-Z][a-zA-Z._-]{0,199}$/.test(es) && es.trim() !== "" && isDefined(this.tagSave) && -1 < this.tagSave.indexOf(es))
                for (let is = 0; is < this.spanEvent.tag.length; is++) {
                    var ts;
                    isDefined(this.spanEvent.tag[is].k) && this.spanEvent.tag[is].k === es && (this.spanEvent.tag.splice(is, 1), ts = this.tagSave.indexOf(es), this.tagSave.splice(ts, 1))
                }
        }
        setMetric(es, ts, is) {
            if (!this.special && !this.hasFinished && isDefined(es) && isDefined(ts) && typeof ts == "number" && typeof es == "string" && !(200 < es.length) && /^[a-zA-Z][a-zA-Z._-]{0,199}$/.test(es) && es.trim() !== "" && !(isDefined(this.spanEvent.m) && 64 <= this.spanEvent.m.length) && isDefined(this.spanEvent.m))
                if (0 < this.spanEvent.m.length)
                    if (isDefined(this.metricSave) && -1 < this.metricSave.indexOf(es))
                        for (let ns = 0; ns < this.spanEvent.m.length; ns++) isDefined(this.spanEvent.m[ns].k) && this.spanEvent.m[ns].k === es && (this.spanEvent.m[ns].k = es, this.spanEvent.m[ns].v = Math.round(ts), isDefined(is) && typeof is == "string" && is.length <= 256 && /^[a-zA-Z0-9:_-\s@./]+$/.test(is) && is.trim() !== "" ? this.spanEvent.m[ns].u = is : delete this.spanEvent.m[ns].u);
                    else isDefined(is) && typeof is == "string" && is.length <= 256 && /^[a-zA-Z0-9:_-\s@./]+$/.test(is) && is.trim() !== "" ? this.spanEvent.m.push({
                        k: es,
                        v: Math.round(ts),
                        u: is
                    }) : this.spanEvent.m.push({
                        k: es,
                        v: Math.round(ts)
                    }), this.metricSave.push(es);
            else isDefined(is) && typeof is == "string" && is.length <= 256 && /^[a-zA-Z0-9:_-\s@./]+$/.test(is) && is.trim() !== "" ? this.spanEvent.m.push({
                k: es,
                v: Math.round(ts),
                u: is
            }) : this.spanEvent.m.push({
                k: es,
                v: Math.round(ts)
            }), this.metricSave.push(es)
        }
        removeMetric(es) {
            if (!this.special && !this.hasFinished && isDefined(es) && typeof es == "string" && !(200 < es.length) && /^[a-zA-Z][a-zA-Z._-]{0,199}$/.test(es) && es.trim() !== "" && isDefined(this.metricSave) && -1 < this.metricSave.indexOf(es))
                for (let is = 0; is < this.spanEvent.m.length; is++) {
                    var ts;
                    isDefined(this.spanEvent.m[is].k) && this.spanEvent.m[is].k === es && (this.spanEvent.m.splice(is, 1), ts = this.metricSave.indexOf(es), this.metricSave.splice(ts, 1))
                }
        }
        setDuration(es) {
            this.special || this.hasFinished || !isDefined(es) || typeof es != "number" || (this.spanEvent.du = Math.round(es))
        }
        setStatus(es) {
            this.special || this.hasFinished || !isDefined(es) || typeof es != "number" || es !== 0 && es !== 1 && es !== 2 || (this.spanEvent.sta = es)
        }
        setStatusCode(es) {
            this.special || this.hasFinished || !isDefined(es) || typeof es != "string" || 7e3 < es.length || es.trim() === "" || (this.spanEvent.stac = es)
        }
        finish(es) {
            if (!this.special && !this.hasFinished && (!isDefined(es) && typeof es != "number" || es !== 0 && es !== 1 && es !== 2 || (this.spanEvent.sta = es), this.hasFinished = !0, isDefined(this.spanEvent.da) && this.spanEvent.da.length === 0 && delete this.spanEvent.da, isDefined(this.spanEvent.tag) && this.spanEvent.tag.length === 0 && delete this.spanEvent.tag, isDefined(this.spanEvent.m) && this.spanEvent.m.length === 0 && delete this.spanEvent.m, isDefined(this.spanEvent.du) || (this.spanEvent.du = 1e3 * new Date().getTime() - this.startTime - this.spanEvent.st), isDefined(this.spanEvent.sta) || (this.spanEvent.sta = 1), isDefined(this.spanEvent.st)) && isDefined(this.spanEvent.n) && isDefined(this.spanEvent.t) && isDefined(this.spanEvent.ic)) {
                if (isDefined(this.childSave) && 0 < this.childSave.length)
                    for (let ts = 0; ts < this.childSave.length; ts++) this.childSave[ts].finish();
                this.isChild || (isDefined(h$7) && isDefined(h$7[this.identify]) && delete h$7[this.identify], c$4({
                    t: GC.SPAN_DATA,
                    p: {
                        info: this.spanEvent
                    }
                }))
            }
        }
    },
    T$4 = class {
        constructor() {
            this.varObj = {}, this.localObj = {}, this.pushData = {}
        }
        objDeal(Et) {
            let es = 0;
            for (const is in Et) {
                var ts;
                es >= GC.LIMIT_64 && delete Et[is], es += 1, Object.hasOwnProperty.call(Et, is) && (ts = Et[is], isString(is) && GC.ATT_REG.test(is) && !(is.length > GC.LIMIT_256) && isDefined(ts) && typeof ts != "object" || (delete Et[is], --es), isDefined(ts)) && typeof ts == "string" && ts.length > GC.LIMIT_512 && (Et[is] = set_length(ts, GC.LIMIT_512))
            }
            return Et
        }
        addWithObj(Et, es) {
            for (const ts in Et) Object.hasOwnProperty.call(Et, ts) && (ts == null || /^\s{0,}$/.test(ts) || typeof ts == "number" || typeof ts == "boolean") && delete Et[ts];
            typeof this.varObj == "object" && 64 <= Object.keys(this.varObj).length || (es ? (es = getLocaStore(GC.BR_ATTRIBUTE) || "{}", this.localObj = Object.assign({}, JSON.parse(es), this.objDeal(Et)), setLocalStore(GC.BR_ATTRIBUTE, JSON.stringify(this.localObj))) : (es = Object.assign({}, this.varObj), this.varObj = Object.assign({}, es, this.objDeal(Et))), this.sendObj())
        }
        addWithKey(Et, es, ts) {
            Et == null || /^\s{0,}$/.test(Et) || typeof Et == "number" || typeof Et == "boolean" || typeof this.varObj == "object" && 64 <= Object.keys(this.varObj).length || !isString(Et) || !GC.ATT_REG.test(Et) || Et.length > GC.LIMIT_256 || !isDefined(es) || typeof es == "object" || (Et = {
                [Et]: es = typeof es != "number" && es.length > GC.LIMIT_512 ? set_length(es, GC.LIMIT_512) : es
            }, ts ? (es = getLocaStore(GC.BR_ATTRIBUTE) || "{}", this.localObj = Object.assign({}, JSON.parse(es), Et), setLocalStore(GC.BR_ATTRIBUTE, JSON.stringify(this.localObj))) : (ts = Object.assign({}, this.varObj), this.varObj = Object.assign({}, ts, Et)), this.sendObj())
        }
        delWithKeys(Et) {
            let es = JSON.parse(getLocaStore(GC.BR_ATTRIBUTE) || "{}"),
                ts = this.varObj;
            isArray(Et) && forEach(Et, function (is) {
                delete es[is], delete ts[is]
            }), this.localObj = Object.assign({}, es), setLocalStore(GC.BR_ATTRIBUTE, JSON.stringify(this.localObj)), this.varObj = Object.assign({}, ts), this.sendObj()
        }
        delAll() {
            c$4({
                t: GC.FLUSH_DATA,
                p: !1
            }), this.localObj = {}, setLocalStore(GC.BR_ATTRIBUTE, JSON.stringify(this.localObj)), this.varObj = {}, this.sendObj()
        }
        sendObj() {
            var Et = getLocaStore(GC.BR_ATTRIBUTE) || "{}",
                es = Object.assign({}, JSON.parse(Et), this.varObj);
            if (64 < Object.keys(es).length) {
                let ts = 0;
                for (const is in es) Object.hasOwnProperty.call(es, is) && (64 <= ts ? delete es[is] : ts += 1)
            }
            this.pushData = es, u$1.setEeiData(this.pushData)
        }
    },
    g$4 = new T$4;
class Metric {
    constructor(es, ts) {
        this.d_type = ts, this.data = es || {}, this.$metric = {}, ts = es && es.info && es.info.timestamp && es.info.timestamp || now(), this.ent = ts
    }
}

function R$1(Et, es) {
    this.$metric[Et] = es
}
Metric.prototype.info = function (Et, es = "", ts, is = !1) {
    var ns = this.data.info;
    if (isDefined(ns)) {
        let rs = ns[Et];
        isDefined(rs) || (rs = es), isDefined(ts) && (Et = ts), is && rs === "" || (this.$metric[Et] = rs)
    }
    return this
}, Metric.prototype.metric = function (Et, es = "", ts) {
    var is = this.data.metric;
    if (isDefined(is)) {
        let ns = is[Et];
        isDefined(ns) || (ns = isDefined(es) ? es : -1), isDefined(ts) && (Et = ts), R$1.call(this, Et, ns)
    }
    return this
}, Metric.prototype.build = function (ss) {
    var es = u$1.getEviData("key"),
        ts = u$1.getEeiData("key"),
        is = u$1.lastUserInfoSetMapKey,
        ss = (ss && ss.ent ? ss : this).ent,
        ns = g$4.pushData,
        rs = u$1.getEviData("value"),
        ss = {
            type: this.d_type,
            ent: ss,
            data: {},
            sin: [is, "", "", ts, es],
            evi: rs
        },
        os = (isEmpty(ns) || (ss.eei = ns), this.$metric);
    if (isDefined(this.data.ext)) switch (this.d_type) {
        case GC.ACTION:
        case GC.NET:
        case GC.ERROR:
        case GC.ROUTE:
            break;
        case GC.PAGE:
        case GC.RESOURCE:
        case GC.WEBVIEWDATA:
        default:
            os.ext = this.data.ext
    }
    return ss.data = os, ss
};
let h$6 = 0;

function pushQueueData(Et, es) {
    if (isDefined(Et) && isDefined(d$4)) {
        const ts = size(Et);
        ALL_DATAS.push({
            data: Et,
            size: ts
        }), getMaxSize(), h$6 + ts > a$2.CAPACITY ? (C$3(!0), h$6 = 0) : (h$6 += ts, d$4.push(ALL_DATAS.shift()))
    }
}

function k$1(Et, is) {
    var ts = is.fullCollect || is.fc,
        is = is.whiteList || is.wl;
    if (!isDefined(ts) || ts) return !0;
    if (isDefined(is)) {
        try {
            var ns = Et,
                rs = "";
            if (ns.indexOf("http") !== 0 && ns.indexOf("file:") !== 0 && ns.indexOf("ws") !== 0) return !1;
            rs = (isDefined(ns.match(/:\/\/\[([^\]]+)\]/)) ? ns.match(/:\/\/\[([^\]]+)\]/) : ns.match(/:\/\/(.[^/:]+)/))[1]
        } catch (cs) {
            return !1
        }
        ts = isDefined(is.hostRule || is.hr) ? (is.hostRule || is.hr).slice(0, 20) : [], is = isDefined(is.pathRule || is.pr) ? (is.pathRule || is.pr).slice(0, 20) : [];
        let ss = function (cs, ds) {
                var fs = ds.split("*");
                return !(2 < fs.length) && (ds.indexOf("*") === -1 ? ds === cs : fs[0] !== "" && fs[1] !== "" ? new RegExp("(" + fs[0] + ").+(" + fs[1] + ")").test(cs) : fs[0] == "" && fs[1] !== "" ? !!endWith(cs, fs[1]) : fs[0] !== "" && fs[1] == "" ? !!startWith(cs, fs[0]) : void 0)
            },
            os = function (cs, ds) {
                return cs = cs.split("?")[0], ss(cs, ds)
            },
            as = function (cs, ds) {
                var fs, us = ds === 1 ? ss : os,
                    ls = ds === 1 ? rs : ns;
                for (fs of cs)
                    if (us(ls, fs)) return !0;
                return !1
            };
        return as(ts, 1) || as(is, 2)
    }
    return !1
}

function O$3(Et) {
    var es = void 0;
    return isDefined(Et.collectionStrategy) ? es = Et.collectionStrategy : isDefined(Et.mc) && Et.mc instanceof Array && Et.mc.forEach(function (ts) {
        ts.n === "network" && isDefined(ts.cs) && (es = ts.cs)
    }), es
}

function A$3(Et, es, ts) {
    {
        var is = Et.mk || Et.maskKeys,
            ns = Et.mt || Et.maskType,
            Et = isDefined(is.qka || is.urlKeys) && (is.qka || is.urlKeys);
        if (is.aqk || is.allQueryKeys) switch (ns) {
            case 1:
                es.p.info.url = es.p.info.url.split("?")[0], isDefined(ts.reqURLKey) && (es.p.info.reqUrlDta = null);
                break;
            case 2:
                es.p.info.url = es.p.info.url.replace(/(\?|&)([^=&]+)=([^&]+)/g, "$1$2=**"), isDefined(ts.reqURLKey) && (es.p.info.reqUrlDta = es.p.info.url.split("?")[1]);
                break;
            default:
                return
        } else if (isDefined(Et) && 0 < Et.length && es.p.info && es.p.info.url && -1 < es.p.info.url.indexOf("?")) {
            var rs = es.p.info.url.split("?")[1].split("&"),
                ss = "";
            for (let gs = 0; gs < rs.length; gs++) {
                var os = rs[gs].split("=");
                switch (ns) {
                    case 1:
                        includes(is.qka || is.urlKeys, os[0]) || (ss += rs[gs] + "&");
                        break;
                    case 2:
                        includes(is.qka || is.urlKeys, os[0]) ? ss += rs[gs].split("=")[0] + "=**&" : ss += rs[gs] + "&"
                }
            }
            isDefined(ts.reqURLKey) && (es.p.info.reqUrlDta = ss.slice(0, -1)), ss.slice(0, -1) !== "" ? es.p.info.url = es.p.info.url.split("?")[0] + "?" + ss.slice(0, -1) : es.p.info.url = es.p.info.url.split("?")[0]
        } let ms = isDefined(is.reqhka || is.requestHeadersKeys) ? is.reqhka || is.requestHeadersKeys : [];
        if (ms = ms.map(function (gs) {
                return gs.toLowerCase()
            }), is.areqh || is.allRequestHeaders) switch (ns) {
            case 1:
                es.p.info[GC.REQUEST_HEADER] = void 0, es.p.info.reqhtData = {};
                break;
            case 2:
                isDefined(es.p.info[GC.REQUEST_HEADER]) && (es.p.info[GC.REQUEST_HEADER] = es.p.info[GC.REQUEST_HEADER].replace(/:(.*?)($|\r\n)/g, ":**$2")), isDefined(ts.reqHeaderTraceKey) && 0 < ts.reqHeaderTraceKey.length && (isEmpty(es.p.info.reqhtData) || forEach(es.p.info.reqhtData, function (gs, ws) {
                    es.p.info.reqhtData[ws] = "**"
                }));
                break;
            default:
                return
        } else switch (ns) {
            case 1:
                if (isDefined(es.p.info[GC.REQUEST_HEADER]) && isDefined(ms) && 0 < ms.length)
                    for (var as of ms) as = new RegExp(as + `:(.*?)(\r
|$)`, "i"), as.test(es.p.info[GC.REQUEST_HEADER]) && (es.p.info[GC.REQUEST_HEADER] = es.p.info[GC.REQUEST_HEADER].replace(as, ""));
                if (isDefined(ts.reqHeaderTraceKey) && 0 < ts.reqHeaderTraceKey.length && !isEmpty(es.p.info.reqhtData)) {
                    for (var cs in es.p.info.reqhtData)
                        if (includes(ms, cs.toLowerCase())) {
                            delete es.p.info.reqhtData[cs];
                            continue
                        }
                }
                break;
            case 2:
                if (isDefined(es.p.info[GC.REQUEST_HEADER]) && isDefined(ms) && 0 < ms.length)
                    for (var ds of ms) ds = new RegExp(ds + `:(.*?)(\r
|$)`, "i"), ds.test(es.p.info[GC.REQUEST_HEADER]) && (es.p.info[GC.REQUEST_HEADER] = es.p.info[GC.REQUEST_HEADER].replace(ds, function (gs, ws) {
                        return gs.replace(ws, "**")
                    }));
                if (isDefined(ts.reqHeaderTraceKey) && 0 < ts.reqHeaderTraceKey.length && !isEmpty(es.p.info.reqhtData)) {
                    for (var fs in es.p.info.reqhtData)
                        if (includes(ms, fs.toLowerCase())) {
                            es.p.info.reqhtData[fs] = "**";
                            continue
                        }
                }
                break;
            default:
                return
        }
        let ps = isDefined(is.reshka || is.responseHeadersKeys) ? is.reshka || is.responseHeadersKeys : [];
        if (ps = ps.map(function (gs) {
                return gs.toLowerCase()
            }), is.aresh || is.allResponseHeaders) switch (ns) {
            case 1:
                isDefined(es.p.info.responseHeader) && delete es.p.info.responseHeader, isEmpty(es.p.info.reshtData) || delete es.p.info.reshtData, isDefined(es.p.info.guid) && delete es.p.info.guid, isDefined(es.p.info.xBrResponse) && delete es.p.info.xBrResponse, isDefined(es.p.info.traceResponse) && delete es.p.info.traceResponse;
                break;
            case 2:
                isDefined(es.p.info.responseHeader) && (es.p.info.responseHeader = es.p.info.responseHeader.replace(/:(.*?)($|\r\n)/g, ":**$2")), isEmpty(es.p.info.reshtData) || forEach(es.p.info.reshtData, function (gs, ws) {
                    es.p.info.reshtData[ws] = "**"
                }), isDefined(es.p.info.guid) && es.p.info.guid !== "" && (es.p.info.guid = "**"), isDefined(es.p.info.xBrResponse) && es.p.info.xBrResponse != "" && (es.p.info.xBrResponse = "**"), isDefined(es.p.info.traceResponse) && es.p.info.traceResponse !== "" && (es.p.info.traceResponse = "**")
        } else switch (ns) {
            case 1:
                if (isDefined(es.p.info.responseHeader))
                    for (var us of ps) us = new RegExp(us + `:(.*?)(\r
|$)`, "i"), us.test(es.p.info.responseHeader) && (es.p.info.responseHeader = es.p.info.responseHeader.replace(us, ""));
                isEmpty(es.p.info.reshtData) || forEach(es.p.info.reshtData, function (gs, ws) {
                    includes(ps, ws.toLowerCase()) && delete es.p.info.reshtData[ws]
                }), isDefined(es.p.info.guid) && includes(ps, "br-resp-key") && delete es.p.info.guid, isDefined(es.p.info.xBrResponse) && includes(ps, "x-br-response") && delete es.p.info.xBrResponse, isDefined(es.p.info.traceResponse) && includes(ps, "traceresponse") && delete es.p.info.traceResponse;
                break;
            case 2:
                if (isDefined(es.p.info.responseHeader))
                    for (var ls of ps) ls = new RegExp(ls + `:(.*?)(\r
|$)`, "i"), ls.test(es.p.info.responseHeader) && (es.p.info.responseHeader = es.p.info.responseHeader.replace(ls, function (gs, ws) {
                        return gs.replace(ws, "**")
                    }));
                isEmpty(es.p.info.reshtData) || forEach(es.p.info.reshtData, function (gs, ws) {
                    includes(ps, ws.toLowerCase()) && (es.p.info.reshtData[ws] = "**")
                }), isDefined(es.p.info.guid) && includes(ps, "br-resp-key") && (es.p.info.guid = "**"), isDefined(es.p.info.xBrResponse) && includes(ps, "x-br-response") && (es.p.info.xBrResponse = "**"), isDefined(es.p.info.traceResponse) && includes(ps, "traceresponse") && (es.p.info.traceResponse = "**")
        }
    }
}

function d$3(Et, es) {
    if (isDefined(es) && (isDefined(es.sensitiveNetworkRule) || isDefined(es.snr))) {
        let ss = function (as) {
                if (as.type === 1 || as.t === 1) {
                    if (!isDefined(as.c || as.content)) return !1;
                    switch (as.r || as.rule) {
                        case 1:
                            if (ts.toLowerCase() === (as.c || as.content).toLowerCase()) return !0;
                            break;
                        case 2:
                            if (-1 < ts.toLowerCase().indexOf((as.c || as.content).toLowerCase())) return !0;
                            break;
                        case 3:
                            if (startWith(ts.toLowerCase(), (as.c || as.content).toLowerCase())) return !0;
                            break;
                        case 4:
                            if (endWith(ts.toLowerCase(), (as.c || as.content).toLowerCase())) return !0;
                        default:
                            return !1
                    }
                }
                if (as.type === 2 || as.t === 2) switch (as.r || as.rule) {
                    case 1:
                        if (is === (as.c || as.content)) return !0;
                        break;
                    case 2:
                        if (-1 < is.indexOf(as.c || as.content)) return !0;
                        break;
                    case 3:
                        if (startWith(is, as.c || as.content)) return !0;
                        break;
                    case 4:
                        if (endWith(is, as.c || as.content)) return !0;
                    default:
                        return !1
                }
                return !1
            },
            os = function (as, cs) {
                switch (cs) {
                    case 1:
                        for (var ds of as)
                            if (ss(ds)) return !0;
                        return !1;
                    case 2:
                        for (var fs of as)
                            if (!ss(fs)) return !1;
                        return !0;
                    default:
                        return !1
                }
            };
        try {
            var ts, is = Et.p.info.url;
            if (is.indexOf("http") !== 0 && is.indexOf("file:") !== 0 && is.indexOf("ws") !== 0) return Et;
            ts = is.match(/:\/\/(.[^/:?]+)/)[1]
        } catch (as) {
            return Et
        }
        var ns, rs = es.sensitiveNetworkRule || es.snr;
        for (ns of rs) ns.t !== 1 && ns.type !== 1 ? ns.t !== 2 && ns.type !== 2 || os(ns.sa || ns.scopes, 2) && A$3(ns, Et, es) : os(ns.sa || ns.scopes, 1) && A$3(ns, Et, es)
    }
    return Et
}

function x$3(Et) {
    let es = 0,
        ts = 0,
        is = 0,
        ns = 0,
        rs = 0,
        ss = 0,
        {
            domainLookupStart: os,
            domainLookupEnd: as,
            connectStart: cs,
            connectEnd: ds,
            responseStart: fs,
            responseEnd: us,
            secureConnectionStart: ls,
            fetchStart: hs,
            requestStart: ms
        } = Et.p.metric;
    isDefined(os) && isDefined(as) && 0 < os && (ps = as - os || -1, es = 0 < ps ? ps : 0), isDefined(cs) && isDefined(ds) && 0 < cs && (ps = ds - cs || -1, ts = 0 < ps ? ps : 0), isDefined(ds) && isDefined(ls) && 0 < ls && (ps = ds - ls || -1, is = 0 < ps ? ps : 0), isDefined(fs) && 0 < fs ? (isDefined(ms) && 0 < ms && (ps = fs - ms || -1, rs = 0 <= ps ? ps : 999), isDefined(ds) && 0 < ds && (ps = ms - ds || -1, ns = 0 <= ps ? ps : 999), isDefined(us) && (ps = us - fs || -1, ss = 0 <= ps ? ps : 999)) : isDefined(hs) && 0 < hs && (ps = us - hs || -1, ss = 0 <= ps ? ps : 999);
    var ps = isDefined(Et.p.metric) ? Et.p.metric : {};
    ps.domianTime = es, ps.connetcTime = ts, ps.sslt = is, ps.rti = rs, ps.dti = ss, ps.rt = ns
}

function g$3(Et, es) {
    if (isDefined(es.reqBodyKey)) {
        let ts = "";
        if (isJSON(Et.p.info.requestBody)) try {
            const is = new Function("", "return " + Et.p.info.requestBody)();
            forEach(es.reqBodyKey, function (ns, rs) {
                isDefined(is[ns]) && (ts += `${ns}=${escape(is[ns])}&`)
            }), Et.p.info[GC.NET_CBBQ] = ts.slice(0, -1)
        } catch (is) {} else if (isString(Et.p.info.requestBody)) try {
            forEach(Et.p.info.requestBody.split("&"), function (is) {
                forEach(es.reqBodyKey, function (ns, rs) {
                    ns && is.indexOf(ns + "=") !== -1 && (ts += is.split("=")[0] + "=" + escape(is.split("=")[1]) + "&")
                })
            }), Et.p.info[GC.NET_CBBQ] = ts.slice(0, -1)
        } catch (is) {}
    }
    if (isDefined(es.reqURLKey) && isString(Et.p.info.reqUrlDta)) try {
        let ts = "";
        forEach(Et.p.info.reqUrlDta.split("&"), function (is) {
            forEach(es.reqURLKey, function (ns, rs) {
                ns && is.split("=")[0] === ns && (ts += is.split("=")[0] + "=" + escape(is.split("=")[1]) + "&")
            })
        }), Et.p.info[GC.NET_CBQ] = ts.slice(0, -1)
    } catch (ts) {} else delete Et.p.info[GC.NET_CBQ];
    if (isDefined(Et.p.metric) && isDefined(Et.p.metric[GC.CALLBACK_END]) && isDefined(Et.p.metric[GC.CALLBACK_START]) && (Et.p.metric[GC.CALLBACK_TIME] = Et.p.metric[GC.CALLBACK_END] - Et.p.metric[GC.CALLBACK_START], Et.p.metric[GC.CALLBACK_TIME] = 0 < Et.p.metric[GC.CALLBACK_TIME] && 1e3 * Et.p.metric[GC.CALLBACK_TIME] || 0), isDefined(es.reqHeaderKey) && isDefined(Et.p.info) && isDefined(Et.p.info[GC.REQUEST_HEADER])) try {
        let ts = "";
        forEach(Et.p.info[GC.REQUEST_HEADER].split(`\r
`), function (is) {
            forEach(es.reqHeaderKey, function (ns) {
                isDefined(ns) && ns != "" && is.split(":")[0].toLowerCase() === ns.toLowerCase() && (ts += is.split(":")[0] + "=" + escape(is.split(":")[1]) + "&")
            })
        }), Et.p.info[GC.NET_CBHQ] = ts.slice(0, -1)
    } catch (ts) {}
    return Et
}

function B$1(Et) {
    var es = Et.data;
    return isDefined(es.tid) && es.tid === "" && delete es.tid, isDefined(es.xbr) && es.xbr === "" && delete es.xbr, isDefined(es.trsp) && es.trsp === "" && delete es.trsp, isDefined(es.tpar) && es.tpar === "" && delete es.tpar, isDefined(es.cbhq) && es.cbhq === "" && delete es.cbhq, isDefined(es.cbbq) && es.cbbq === "" && delete es.cbbq, isDefined(es.cbq) && es.cbq === "" && delete es.cbq, isDefined(es.ti) && es.ti === "" && delete es.ti, isDefined(es.ec) && 200 <= es.ec && es.ec < 400 && (isDefined(es.ep) && delete es.ep, isDefined(es.eop)) && delete es.eop, isDefined(es.ec) && 400 < es.ec && es.ec <= 602 && isDefined(es.eop) && (es.eop = 4), isDefined(es.cbhq) && (es.cbhq = es.cbhq.replace("/", "%2F")), isDefined(es.ec) && es.ec === 602 && isDefined(es.ru) && es.ru.indexOf("file:") === 0 && (es.ec = 200, delete es.eop, delete es.ep, delete es.em), Et
}

function U$5(Et, es) {
    if (isDefined(es.reqHeaderTraceKey) && 0 < es.reqHeaderTraceKey.length) {
        let ts = {};
        isDefined(Et.p.info.reqhtData && Object.getOwnPropertyNames(Et.p.info.reqhtData).length <= 64) ? ts = Et.p.info.reqhtData : Object.getOwnPropertyNames(Et.p.info.reqhtData).slice(0, 64).forEach(function (is) {
            ts[is] = Et.p.info.reqhtData[is]
        }), isEmpty(ts) || (Et.p.info.reqht = ts)
    }
    if (isDefined(es.respHeaderTraceKey) && 0 < es.respHeaderTraceKey.length) {
        let ts = {},
            is = 0;
        for (let ns = 0, rs = es.respHeaderTraceKey.length - 1; ns <= rs; ns++) is < 64 && isDefined(Et.p.info.reshtData) && isDefined(Et.p.info.reshtData[es.respHeaderTraceKey[ns]]) && (is += 1, ts[es.respHeaderTraceKey[ns]] = Et.p.info.reshtData[es.respHeaderTraceKey[ns]]);
        isEmpty(ts) || (Et.p.info.resht = ts)
    }
}

function Q$1(Et, es, ts = !1) {
    var is = {};
    if (Et) {
        var is = JSON.parse(JSON.stringify(Et)),
            ns = O$3(es);
        if (!ts && isDefined(ns) && !k$1(is.p.info.url || "", ns)) return null;
        try {
            if (isDefined(window.$bonreeReplayUrl) && -1 < is.p.info.url.indexOf(window.$bonreeReplayUrl)) return null
        } catch (ss) {}
        return isDefined(is.p.metric) && x$3.call(this, is), isDefined(is.p.metric) && x$3.call(this, is), isDefined(es.sensitiveNetworkRule || es.snr) && d$3.call(this, is, es), g$3.call(this, is, es), U$5.call(this, is, es), ts = is.p.info, ns = es.hcs, es = (isDefined(ns) && (isDefined(ts.requestHeader) || isDefined(ts.responseHeader)) && (ns === 0 || ns === 1 && ts.status < 400 || ns === 1 && ts.code < 400) && (delete is.p.info.requestHeader, delete is.p.info.responseHeader), is && is.p.info.url && -1 < is.p.info.url.indexOf("https") ? 2 : 1), ns = getMineTypeByHeader(is.p.info[GC.RESPONSE_HEADER]) || getMineTypeByHeader(is.p.info[GC.REQUEST_HEADER]) || getMineTypeByUrl(is.p.info[GC.URL]) || "text/html", ts = new Metric(is.p, GC.NET), (isDefined(ts.data.info[GC.NET_EC]) && 400 < ts.data.info[GC.NET_EC] || !isDefined(ts.data.info[GC.NET_EC])) && isDefined(window.BRLog) && window.BRLog.__sendNetInfo(ts.data.info), ts.info("id").info(GC.URL, "", "ru").info(GC.NET_METHOD, "", "m").info(GC.NET_IP, "", "ti").info(GC.NET_PORT, 0, "tp").info(GC.REQUEST_HEADER, "", "rh", !0).info(GC.RESPONSE_HEADER, "", "rhe", !0).info(GC.NET_TID, "", "tid").info(GC.NET_XBR, "", "xbr").info(GC.NET_TRACE, "", "trsp").info("reqht", "", "reqht", !0).info("resht", "", "resht", !0).info(GC.E_TYPE, "http", "ep", !0).info(GC.NET_EOP, "", "eop", !0).info(GC.NET_TYPE, 3, "art").info(GC.PAGE_ID, "", "pvid").info(GC.CUSTOM_IC, !1, "ic").info(GC.NET_CBBQ, "", "cbbq").info(GC.NET_CBHQ, "", "cbhq").info(GC.NET_CBQ, "", "cbq").info("ret", ns, "ret").metric("domianTime", 0, "dt").metric("connetcTime", 0, "ct").metric("sslt", 0, "sslt").metric("rt", 0, "rt").metric("rti", 0, "rti").metric("dti", 0, "dti").metric(GC.DECODED_BODY_SIZE, 0, "ds").metric(GC.UPLOAD_BODY_SIZE, 0, "rds").metric(GC.NET_PT, es, "pt"), is.p && is.p.info.ai && ts.info("ai", "", "ai"), (is.p && is.p.info[GC.NET_EC] == 200 || is.p && is.p[GC.STATUS] == 200) && ts.info(GC.NET_EOP, 0, "eop"), is.p && isDefined(is.p.info[GC.NET_EC]) && ts.info(GC.NET_EC, 200, "ec"), is.p && isDefined(is.p.info[GC.STATUS]) && ts.info(GC.STATUS, 200, "ec"), is.p && is.p.info[GC.E_TYPE] === "XHR" && ts.info(GC.MESSAGE, "", "em", !0), is.p && is.p.info[GC.E_TYPE] === "FETCH" && ts.info(GC.STATUS_TEXT, "", "em", !0), B$1(ts.build())
    }
}

function P$2(Et) {
    var es;
    if (isDefined(Et)) return es = new Metric(Et, GC.NET), Et = getMineTypeByUrl(Et.info[GC.URL]) || "text/html", es.info("id").info("ru").info("m").info("ti").info("tp").info("art").info("pvid", "", "pvid").info("ic").info("ret", Et, "ret").info("dt").info("ct").info("sslt").info("rt").info("rti").info("dti").info("ds", 0, "ds").info("rds", 0, "rds").info("pt").info("ec", 200, "ec"), B$1(es.build())
}
const d$2 = function (Et, es, ts, is, ns, rs) {
        return !(Et === void 0 || (es == null || es === "" ? (v$9.log(ts + " Parameter has a value or key [" + Et + "] that does not exist!"), rs) : is !== null && es.length > is ? (v$9.log(ts + " Parameter has a value or key [" + Et + "] that the value length exceeds " + es.length + "!"), 0) : !ns || !isNaN(es) || (v$9.log(ts + " Parameter has a value or key [" + Et + "] value is not a valid number!"), 0)))
    },
    E$2 = 2083,
    m$4 = 256,
    T$3 = 512,
    W$1 = function (Et) {
        var es = {};
        if (Et !== void 0 && Object.prototype.toString.call(Et) === "[object Object]") {
            if (64 < Object.getOwnPropertyNames(Et).length) {
                var ts, is = Object.getOwnPropertyNames(Et).slice(0, 64);
                for (ts in is) typeof is[ts] != "string" || 256 < is[ts].length || is[ts] === "" || (es[is[ts]] = Et[is[ts]])
            } else
                for (var ns in Et) typeof ns != "string" || 256 < ns.length || ns === "" || (es[ns] = Et[ns]);
            return Object.getOwnPropertyNames(es).length === 0 ? void 0 : es
        }
    };
let O$2 = {},
    x$2 = {},
    M$2 = {},
    U$4 = {},
    A$2 = [],
    L$5 = [],
    X$2 = u$1.getEviData("value");

function v$3(Et, es) {
    !isDefined(f$1.secondSett) || isEmpty(f$1.secondSett) || isEmpty(Et) || (isDefined(Et.data.url) && (Et.data.url = d$3({
        p: {
            info: {
                url: Et.data.url
            }
        }
    }, f$1.secondSett).p.info.url), isDefined(f$1.secondSett.osType) && f$1.secondSett.osType !== GC.BROWSER ? es.call(v$9, stringify({
        ent: Et.ent,
        v: Et.data,
        evi: X$2
    }), f$1.secondSett) : pushQueueData(Et)), !isDefined(f$1.sett) || isEmpty(f$1.sett) || isEmpty(Et) || (isDefined(f$1.sett.osType) && f$1.sett.osType !== GC.BROWSER ? es.call(v$9, stringify({
        ent: Et.ent,
        v: Et.data
    }), f$1.sett) : pushQueueData(Et))
}
const K = {
    returnShadeArea: function () {
        return S$7.checkElement()
    },
    setCustomSpeedTest: function (Et, es) {
        var ts;
        arguments.length < 1 || 2 < arguments.length || Et && 256 < Et.length || (Array.isArray(es) && 0 < es.length && es.length <= 1e3 ? (ts = {}, isDefined(Et) && Et !== "" && (ts.oip = Et, ts.sti = es, (ts = new Metric({
            info: ts
        }, "speedtest")).info("oip").info("sti"), v$3(ts.build(), v$9.customSpeedTestEvent))) : log("C156"))
    },
    setExtraInfo: function (Et) {
        v$9.log("setExtraInfo=>" + Et);
        var es = Et && set_64_keys(Et, 64) || Et;
        try {
            O$8(es), S$5(f$1.sett.osType) || S$5(f$1.secondSett.osType) ? window.webkit.messageHandlers.brsWKSetExtraInfo.postMessage(stringify(es)) : w$6(f$1.sett.osType) || w$6(f$1.secondSett.osType) ? window.bonreePrivateInterface.call(stringify({
                setExtraInfo: es
            })) : window.bonreePrivateInterface.setExtraInfo(stringify(es))
        } catch (ts) {}
    },
    setUserID: function (Et) {
        if (v$9.log("setUserID=>" + Et), !d$2("userId", Et, "setUserID", m$4, !1) && /^[\u4E00-\u9FFFa-zA-Z0-9:_\-@.\s/*#!]+$/.test(Et)) try {
            w$5(Et), S$5(f$1.sett.osType) || S$5(f$1.secondSett.osType) ? window.webkit.messageHandlers.brsWKSetUserId.postMessage(Et) : w$6(f$1.sett.osType) || w$6(f$1.secondSett.osType) ? window.bonreePrivateInterface.call(stringify({
                setUserID: Et
            })) : window.bonreePrivateInterface.setUserID(Et)
        } catch (es) {}
    },
    setCustomEventWithLabel: function (Et, es, ts, is, ns) {
        var rs, ss, os;
        arguments.length < 1 || 5 < arguments.length || d$2("eventId", Et, "setCustomEvent", m$4, !1) || isDefined(ns) && 7e3 < JSON.stringify(ns).length || (rs = {}, os = set_length(es, m$4), ss = set_length(is, 7e3), rs.eventId = isDefined(Et) ? Et : "", rs.eventName = os, rs.eventParam = ss, rs.eventLabel = set_length(ts, 256), rs.info = W$1(ns), (os = new Metric({
            info: rs
        }, GC.CUSTOM_EVENT)).info("eventId", "", "i").info("t", 0).info("d", 0), rs.eventName !== void 0 && rs.eventName !== "" && rs.eventName !== null && os.info("eventName", "", "n"), rs.eventLabel !== void 0 && rs.eventLabel !== "unuse" && rs.eventLabel !== "" && rs.eventLabel !== null && os.info("eventLabel", "", "l"), rs.eventParam !== void 0 && rs.eventParam !== "" && rs.eventParam !== null && os.info("eventParam", "", "p"), rs.info !== void 0 && rs.info instanceof Object && os.info("info", "", "info"), v$3(os.build(), v$9.customEvent))
    },
    setCustomEvent: function (Et, es, ts, is) {
        this.setCustomEventWithLabel(Et, es, "unuse", ts, is)
    },
    setCustomLog: function (Et, es) {
        var ts, is, ns;
        arguments.length < 1 || 2 < arguments.length ? v$9.log("setcustomlog custom log parameter number error") : d$2("logInfo", Et, "setCustomLog", null, !1) || (ts = {}, ns = isDefined(Et) && set_length(Et, 1e4) || "", is = isDefined(es) ? set_length(es, 1e4) : es, ts.logInfo = ns, ts.logParam = is, (ns = new Metric({
            info: ts
        }, GC.CUSTOM_LOG)).info("logInfo", "", "i"), ts.logParam !== void 0 && ns.info("logParam", "", "p"), v$3(ns.build(), v$9.customLogEvent))
    },
    setCustomMetric: function (Et, es, ts) {
        var is;
        arguments.length < 1 || 3 < arguments.length ? v$9.log("setCustomMetric\u81EA\u5B9A\u4E49\u6307\u6807\u53C2\u6570\u4E2A\u6570\u9519\u8BEF") : d$2("metricName", Et, "setCustomMetric", m$4, !1) || d$2("metricValue", es, "setCustomMetric", null, !1) || ((is = {}).metricName = isDefined(Et) ? Et : "", is.metricValue = isDefined(es) ? Math.round(es) : "", isDefined(ts) && (is.metricParam = 1e4 < ts.length ? ts.slice(0, 1e4) : ts), (is = new Metric({
            info: is
        }, GC.CUSTOM_METRIC)).info("metricName", "", "n").info("metricValue", 0, "v"), ts !== void 0 && is.info("metricParam", "", "p"), v$3(is.build(), v$9.customMetricEvent))
    },
    setCustomException: function (Et, es, ts) {
        var is, ns, rs;
        arguments.length < 1 || 3 < arguments.length ? v$9.log("onEvent\u81EA\u5B9A\u4E49\u4E8B\u4EF6\u53C2\u6570\u4E2A\u6570\u9519\u8BEF") : d$2("exceptionType", Et, "setCustomException", m$4, !1) || (is = {}, rs = isDefined(es) && set_length(es, 512) || "", ns = isDefined(ts) && set_length(ts, 1e4) || "", is.exceptionType = isDefined(Et) ? Et : "", is.causedBy = rs, is.errorDump = ns, (rs = new Metric({
            info: is
        }, GC.CRASH)).info("causedBy", "", "cab").info("exceptionType", "", "t").info("errorDump", "", "p").info("ic", !0).info("id", uuid()), v$3(rs.build(), v$9.customExceptionEvent))
    },
    setCustomPageStart: function (Et, es) {
        var ts;
        arguments.length < 1 || 2 < arguments.length || d$2("pageName", Et, "setCustomPageStart", m$4, !1) || includes(A$2, Et) || (A$2.push(Et), O$2[Et] = dateNow(), x$2[Et] = buildViewID(), !Et) || (ts = set_length(es, m$4), (ts = new Metric({
            info: {
                pageName: Et,
                param: ts
            }
        }, GC.VIEW)).info("pageName", "", "n").info("ci", x$2[Et]).info("lt", 0).info("m", 1).info("t", 1).info("ic", !0), es !== void 0 && ts.info("param", "", "p"), v$3(ts.build(), v$9.webviewPageEvent))
    },
    setCustomPageEnd: function (Et, es) {
        if (!(arguments.length < 1 || 2 < arguments.length || d$2("pageName", Et, "setCustomPageEnd", m$4, !1)) && includes(A$2, Et)) {
            let is = 0;
            var ts;
            isDefined(dateNow) && O$2 && isDefined(O$2[Et]) && (is = dateNow() - O$2[Et], is *= 1e3, Et) && (ts = set_length(es, m$4), ts = {
                pageName: Et,
                param: ts
            }, A$2 = filter(A$2, function (ns) {
                return ns !== Et
            }), delete O$2[Et], (ts = new Metric({
                info: ts
            }, GC.VIEW)).info("pageName", "", "n").info("ci", x$2[Et]).info("st", is).info("lt", 0).info("m", 2).info("t", 1).info("ic", !0), es !== void 0 && ts.info("param", "", "p"), v$3(ts.build(), v$9.webviewPageEvent), delete x$2[Et])
        }
    },
    setCustomH5performanceData: function (Et) {
        let es = {};
        try {
            es = JSON.parse(Et)
        } catch (rs) {
            return void v$9.log("setCustomH5performanceData has error! ==>" + rs)
        }
        let ts = !0;
        if (ts && forEach(["url"], function (rs) {
                d$2(rs, es[rs], "setCustomH5performanceData", E$2, !1) && (es[rs] = set_length(es[rs], E$2))
            }), ts && forEach(["imd", "ns", "ues", "uee", "rds", "rde", "fs", "dls", "dle", "cs", "scs", "ce", "reqs", "rsps", "rspe", "dl", "di", "dcles", "dclee", "dc", "les", "lee", "fp", "fcp", "lcp"], function (rs) {
                if (d$2(rs, es[rs], "setCustomH5performanceData", null, !0)) return ts = !1
            }), ts && ((es.pvid === void 0 || es.pvid === null || es.pvid === "" || es.pvid.length > m$4) && (es.pvid = uuid()), es = {
                url: es.url,
                pvid: es.pvid,
                ic: !0,
                wpi: {
                    ns: isDefined(es.ns) && 0 < es.ns ? es.ns : 0,
                    ues: isDefined(es.ues) && 0 < es.ues ? es.ues : -1,
                    uee: isDefined(es.uee) && 0 < es.uee ? es.uee : -1,
                    rds: isDefined(es.rds) && 0 < es.rds ? es.rds : -1,
                    rde: isDefined(es.rde) && 0 < es.rde ? es.rde : -1,
                    fs: isDefined(es.fs) && 0 < es.fs ? es.fs : 0,
                    dls: isDefined(es.dls) && 0 < es.dls ? es.dls : -1,
                    dle: isDefined(es.dle) && 0 < es.dle ? es.dle : -1,
                    cs: isDefined(es.cs) && 0 < es.cs ? es.cs : -1,
                    scs: isDefined(es.scs) && 0 < es.scs ? es.scs : -1,
                    ce: isDefined(es.ce) && 0 < es.ce ? es.ce : -1,
                    reqs: isDefined(es.reqs) && 0 < es.reqs ? es.reqs : 0,
                    rsps: isDefined(es.rsps) && 0 < es.rsps ? es.rsps : 0,
                    rspe: isDefined(es.rspe) && 0 < es.rspe ? es.rspe : 0,
                    dl: isDefined(es.dl) && 0 < es.dl ? es.dl : 0,
                    di: isDefined(es.di) && 0 < es.di ? es.di : 0,
                    dcles: isDefined(es.dcles) && 0 < es.dcles ? es.dcles : 0,
                    dclee: isDefined(es.dclee) && 0 < es.dclee ? es.dclee : 0,
                    dc: isDefined(es.dc) && 0 < es.dc ? es.dc : 0,
                    les: isDefined(es.les) && 0 < es.les ? es.les : 0,
                    lee: isDefined(es.lee) && 0 < es.lee ? es.lee : -1,
                    fp: isDefined(es.fp) && 0 < es.fp ? es.fp : -1,
                    fcp: isDefined(es.fcp) && 0 < es.fcp ? es.fcp : -1,
                    lcp: isDefined(es.lcp) && 0 < es.lcp ? es.lcp : -1
                }
            }, isDefined(es.url)) && es.url.trim("") !== "") {
            if (D$6(f$1.sett.osType) || D$6(f$1.secondSett.osType)) {
                const rs = new Metric({
                    info: es
                }, GC.WEBVIEWDATA);
                rs.info("url", "").info("ic", !0).info("pvid").info("wpi"), pushQueueData(rs.build())
            }
            var ns = u$1.getEviData("value"),
                is = stringify({
                    h5: [{
                        ent: now(),
                        v: es,
                        k: "h5",
                        evi: ns
                    }],
                    imd: es.imd
                }),
                ns = stringify({
                    ent: now(),
                    v: es,
                    evi: ns
                });
            v$9.log("setCustomH5performanceData=> " + ns);
            try {
                S$5(f$1.sett.osType) || S$5(f$1.secondSett.osType) ? window.webkit.messageHandlers.brsWKSetCustomH5performanceData.postMessage(ns) : w$6(f$1.sett.osType) || w$6(f$1.secondSett.osType) ? window.bonreePrivateInterface.call(is) : window.bonreePrivateInterface.webViewEventBus(is, f$1.sett.webviewID || f$1.secondSett.webviewID)
            } catch (rs) {}
        }
    },
    setCustomRouteChangeData: function (Et) {
        let es = {};
        try {
            (es = JSON.parse(Et)).d = 1e3 * Math.round(es.d)
        } catch (ns) {
            return void v$9.log("setCustomRouteChangeData has error! ==>" + ns)
        }
        let ts = !0;
        var is;
        ts && forEach(["tu", "fu", "rt", "pu"], function (ns) {
            (!isDefined(es[ns]) || es[ns] === "" || es[ns].length > E$2) && (ts = !1)
        }), ts && forEach(["pt", "fw"], function (ns) {
            (!isDefined(es[ns]) || es[ns] === "" || es[ns].length > m$4) && (ts = !1)
        }), ts && forEach(["d", "sta"], function (ns) {
            isDefined(es[ns]) && typeof es[ns] == "number" || (ts = !1)
        }), ts && (es.fu === void 0 && es.fu === null ? v$9.log("setCustomRouteChangeData Parameter has a value or key [fu] that does not exist!") : (es.al !== void 0 && es.al !== null && es.al.length > m$4 && (v$9.log("setCustomRouteChangeData Parameter has a value or key [al] that the value length exceeds " + m$4 + "!"), es.al = ""), es.ent = 1e3 * new Date().getTime(), (is = new Metric({
            info: es
        }, GC.ROUTE)).info("tu", "").info("fu", "").info("d", 0).info("sta", 0).info("pt", "").info("rt", "").info("pu", "").info("fw", "").info("ic", !0).info("ctp", 2).info("pvid", isDefined(f$1.sett.pageViewId) ? f$1.sett.pageViewId : ""), isDefined(es.al) && es.al !== "" && is.info("al", ""), isDefined(window.performance) && isDefined(window.performance.timing) && is.info("ns", window.performance.timing.navigationStart), v$3(is.build(), v$9.routeChangeData)))
    },
    setCustomNetworkData: function (Et) {
        let es = {};
        try {
            es = JSON.parse(Et)
        } catch (ns) {
            return void v$9.log("setCustomNetworkData has error! ==>" + ns)
        }
        let ts = !0;
        var is;
        forEach(["tp", "dt", "ct", "sslt", "rt", "rti", "dti", "ds", "pt", "rds"], function (ns) {
            if (d$2(ns, es[ns], "setCustomNetworkData", null, !0) || es[ns] < 0) return ts = !1
        }), d$2("ti", es.ti, "setCustomNetworkData", null, !1) && (ts = !1), isDefined(es.ru) && es.ru !== "" && (d$2("ru", es.ru, "setCustomNetworkData", E$2, !1) && (es.ru = set_length(es.ru, E$2)), d$2("m", es.m, "setCustomNetworkData", E$2, !1) && (es.m = set_length(es.m, E$2)), ts) && (es.ent = 1e3 * new Date().getTime(), (is = new Metric({
            info: es
        }, GC.NET)).info("ru", "").info("m", "").info("ti", "").info("tp", 1e3).info("dt", 1e3).info("ct", 1e3).info("sslt", 1e3).info("rt", 1e3).info("rti", 1e3).info("dti", 1e3).info("ds", 0).info("pt", 0).info("rh", "").info("rhe", "").info("ret", "").info("rds", 0).info("id", uuid()).info("ic", !0).info("art", 0).info("ec", 200), v$3(is.build(), v$9.NetworkEvent))
    },
    setCustomEventStart: function (Et, es, ts, is, ns) {
        var rs, ss, os;
        arguments.length < 1 || 5 < arguments.length || d$2("eventId", Et, "setCustomEventStart", null, !1) || isDefined(ns) && 7e3 < JSON.stringify(ns).length || includes(L$5, Et) || (L$5.push(Et), !Et) || (U$4[Et] = dateNow(), M$2[Et] = buildViewID(), rs = {}, os = set_length(es, m$4), ss = set_length(is, 7e3), rs.eventId = isDefined(Et) ? Et : "", 256 < Et.length || Et.length === 0 || (rs.eventName = os, rs.eventParam = ss, rs.eventLabel = set_length(ts, 256), rs.info = W$1(ns), (os = new Metric({
            info: rs
        }, GC.CUSTOM_EVENT)).info("eventId", "", "i").info("t", 1).info("d", 0).info("ci", M$2[Et]), rs.eventName !== void 0 && rs.eventName !== "" && os.info("eventName", "", "n"), rs.eventLabel !== void 0 && rs.eventLabel !== "" && os.info("eventLabel", "", "l"), rs.eventParam !== void 0 && rs.eventParam !== "" && os.info("eventParam", "", "p"), rs.info !== void 0 && rs.info instanceof Object && os.info("info", "", "info"), v$3(os.build(), v$9.customEvent)))
    },
    setCustomEventEnd: function (Et, es, ts, is, ns) {
        if (!(arguments.length < 1 || 5 < arguments.length) && !d$2("eventId", Et, "setCustomEventEnd", null, !1) && !(isDefined(ns) && 7e3 < JSON.stringify(ns).length) && includes(L$5, Et)) {
            if (Et) {
                let as = 0;
                isDefined(dateNow) && U$4 && isDefined(U$4[Et]) && (as = dateNow() - U$4[Et], as *= 1e3);
                var rs = {},
                    ss = set_length(es, m$4),
                    os = set_length(is, 7e3);
                if (rs.eventId = isDefined(Et) ? Et : "", 256 < Et.length || Et.length === 0) return;
                rs.eventName = ss, rs.eventParam = os, rs.eventLabel = set_length(ts, 256), rs.info = W$1(ns), ss = new Metric({
                    info: rs
                }, GC.CUSTOM_EVENT), ss.info("eventId", "", "i").info("t", 2).info("d", as).info("ci", M$2[Et]), rs.eventName !== void 0 && rs.eventName !== "" && ss.info("eventName", "", "n"), rs.eventLabel !== void 0 && rs.eventLabel !== "" && ss.info("eventLabel", "", "l"), rs.eventParam !== void 0 && rs.eventParam !== "" && ss.info("eventParam", "", "p"), rs.info !== void 0 && rs.info instanceof Object && ss.info("info", "", "info"), v$3(ss.build(), v$9.customEvent)
            }
            L$5 = filter(L$5, function (as) {
                return as !== Et
            }), delete U$4[Et], delete M$2[Et]
        }
    },
    startSpan: function (Et, es) {
        return new a$1(Et, es)
    },
    addUserExtraInfo: function (Et, es) {
        var ts;
        d$2("key", Et, "setUserProperty", m$4, !1, !1) || !/^[:0-9a-zA-Z /@._-]{1,}$/.test(Et) || /^\s{0,}$/.test(Et) || typeof Et == "boolean" || typeof Et == "number" || !isDefined(es) || typeof es == "object" || /^\s{0,}$/.test(es) || (typeof es != "number" && es.length > T$3 && (es = set_length(es, T$3)), (ts = u$1.getUser() || "") != "" && ((ts = {
            ui: ts,
            c: 2,
            i: {}
        }).i[Et] = es, (Et = new Metric({
            info: ts
        }, GC.USERCHANGE)).info("ui", "").info("c").info("i"), v$3(Et.build(), v$9.setUserProperty)))
    },
    setUserExtraInfo: function (Et) {
        if (isObj(Et) && !isEmpty(Et)) {
            for (const is in Et)
                if (Object.hasOwnProperty.call(Et, is)) {
                    const ns = Et[is];
                    let rs = !0;
                    !d$2("key", is, "setUserProperty", m$4, !1, !1) && /^[:0-9a-zA-Z /@._-]{1,}$/.test(is) && !/^\s{0,}$/.test(is) || (delete Et[is], rs = !1), isDefined(ns) && typeof ns != "object" && !/^\s{0,}$/.test(ns) || (delete Et[is], rs = !1), rs && typeof ns != "number" && ns.length > T$3 && (Et[is] = set_length(ns, T$3))
                } let ts = set_64_keys(Et, 64);
            if (!isEmpty(ts)) {
                let is = u$1.getUser() || "";
                var es;
                is != "" && ((es = new Metric({
                    info: {
                        ui: is,
                        c: 1,
                        i: ts
                    }
                }, GC.USERCHANGE)).info("ui", "").info("c").info("i"), v$3(es.build(), v$9.setUserProperty))
            }
        }
    },
    increaseUserExtraInfo: function (Et, es) {
        var ts;
        !d$2("key", Et, "setUserProperty", m$4, !1, !1) && /^[:0-9a-zA-Z /@._-]{1,}$/.test(Et) && !/^\s{0,}$/.test(Et) && typeof Et == "string" && isDefined(es) && typeof es != "object" && typeof es == "number" && (typeof es != "number" && es.length > T$3 && (es = set_length(es, T$3)), (ts = u$1.getUser() || "") != "") && ((ts = {
            ui: ts,
            c: 4,
            i: {}
        }).i[Et] = es, (Et = new Metric({
            info: ts
        }, GC.USERCHANGE)).info("ui", "").info("c").info("i"), v$3(Et.build(), v$9.setUserProperty))
    },
    removeUserExtraInfo: function (Et) {
        var es;
        d$2("key", Et, "setUserProperty", m$4, !1, !1) || !/^[:0-9a-zA-Z /@._-]{1,}$/.test(Et) || typeof Et != "string" || /^\s{0,}$/.test(Et) || (es = u$1.getUser() || "") != "" && (es = {
            ui: es,
            c: 3,
            i: {}
        }, Et && (es.i[Et] = ""), (Et = new Metric({
            info: es
        }, GC.USERCHANGE)).info("ui", "").info("c").info("i"), v$3(Et.build(), v$9.setUserProperty))
    },
    addEventAttributes(Et, es = !1) {
        var ts;
        typeof Et == "object" && (ts = Object.assign({}, Et), g$4.addWithObj(Et, es), Et = {
            local: es,
            attributes: ts
        }, v$9.addAtt(Et))
    },
    addEventAttributeWithKey(Et, es, ts = !1) {
        g$4.addWithKey(Et, es, ts), ts = {
            local: ts,
            attributes: {
                [Et]: es
            }
        }, v$9.addAtt(ts)
    },
    removeEventAttributeWithKeys(Et) {
        g$4.delWithKeys(Et), v$9.delAtt(Et)
    },
    removeAllEventAttributes() {
        g$4.delAll(), v$9.delAttAll()
    }
};
var h$5 = Object.defineProperty,
    o = (Et, es, ts) => es in Et ? h$5(Et, es, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: ts
    }) : Et[es] = ts,
    e$2 = (Et, es, ts) => o(Et, typeof es != "symbol" ? es + "" : es, ts);
class u {
    constructor(es) {
        e$2(this, "funActionModify", function (ts, is) {
            return isDefined(ts) && isDefined(is) && (this[ts] = is), this
        }), e$2(this, "funActionBuild", function () {
            var ts = {
                n: this.n,
                t: this.t,
                to: this.to,
                ice: this.ice,
                st: this.st,
                et: this.et || now(),
                ti: this.ti,
                im: this.im,
                ne: this.ne
            };
            return isEmpty(ts.ne) && delete ts.ne, ts
        }), this.n = es && typeof es == "string" ? es : es.name, this.t = 12, this.to = !1, this.ice = !1, this.st = 1, this.et = 0, this.ti = 1225, this.im = !0, this.ne = {}
    }
}
let e$1 = class {
        constructor() {
            this.lastTarget = null, this.count = 0, this.lastTime = 0
        }
        isClick(Et, es) {
            return es = es && es / 1e3 || +new Date, this.lastTarget === null && this.count === 0 ? (this.lastTarget = Et, this.count += 1, this.lastTime = es, 0) : this.lastTarget !== Et ? (this.lastTarget = Et, this.count = 1, this.lastTime = es, 0) : this.lastTarget == Et && 300 <= es - this.lastTime ? (this.count = 1, this.lastTime = es, 0) : this.lastTarget == Et && this.count < 2 && es - this.lastTime < 300 ? (this.count += 1, this.lastTime = es, 0) : this.lastTarget == Et && 2 <= this.count && es - this.lastTime < 300 ? (this.count += 1, this.lastTime = es, 1) : void 0
        }
    },
    h$4 = new e$1;

function P$1(Et) {
    var es;
    return isDefined(Et) ? (Et.$xpath || (200 < (es = xpath(Et)).length ? Et.$xpath = "[Error: Overflow with more than 200 characters.]" : Et.$xpath = es), Et.$xpath) : ""
}

function R(Et, es = !1) {
    var ts;
    isDefined(Et) && (isDefined(Et.$timeoutTimer) && clearTimeout(Et.$timeoutTimer), d$9(GC.LIFESTYLE_REQUEST_END + Et.identify), d$9(GC.CUSTOM_ACTION_END), d$9(GC.LIFESTYLE_CALLBACK_REQUEST_START + Et.identify), d$9(GC.ROUTE_CHANGE_END + Et.identify), d$9(GC.WEBSOCKET_CONNECTION_END), d$9(GC.SPAN_CALLBACK_DATA), (ts = new u("anonymous")).funActionModify("st", Et.startTime), ts.funActionModify("et", Et.endTime), es && (ts.funActionModify("ice", !0), Et.startEvent.lt = Et.endTime - Et.startTime, Et.startEvent.ice = !0, isDefined(Et.hasEmitStart)) && !Et.hasEmitStart && (c$4({
        t: GC.TRACE_ACTION_DATA,
        p: {
            info: Et.startEvent
        },
        type: 1
    }), isEmpty(f$1.secondSett) || c$4({
        t: GC.TRACE_ACTION_DATA,
        p: {
            info: Et.startEvent
        },
        type: 2
    }), Et.hasEmitStart = !0), (es = extend({}, Et.startEvent)).m = 2, es.me = ts.funActionBuild(), c$4({
        t: GC.TRACE_ACTION_DATA,
        p: {
            info: es
        },
        revts: Et.handledRequestStruct,
        type: 1
    }), isEmpty(f$1.secondSett) || c$4({
        t: GC.TRACE_ACTION_DATA,
        p: {
            info: es
        },
        revts: Et.handledRequestStructSecond,
        type: 2
    }))
}

function W(Et) {
    try {
        d$9(GC.CUSTOM_ACTION_END);
        let cs = now();
        Et.startTime = cs, Et.requestRecord = [], Et.handledRequestStruct = [], Et.handledRequestStructSecond = [], Et.requestCount = 0, Et.routeCount = 0, Et.wsCount = 0, Et.identify = uuid(), Et.handledRouteRequest = [], Et.handledRouteRequestSecond = [], Et.handledSpan = [], v$8(GC.ROUTE_CHANGE_START, function (ds) {
            Et.routeCount = Et.routeCount + 1, Et.relatedRoute = !0, ds.info.id = Et.identify
        }), v$8(GC.ROUTE_CHANGE_END + Et.identify, function (ds) {
            var fs;
            Et.routeCount = Et.routeCount - 1, isDefined(ds.routeData) && Et.relatedRoute && 0 < Et.handledRouteRequest.length && Et.routeCount === 0 ? ((fs = JSON.parse(JSON.stringify(ds.routeData))).revts = Et.handledRouteRequest, Et.handledRequestStruct.push(fs)) : Et.handledRequestStruct.push(ds.routeData), !isEmpty(f$1.secondSett) && checkMoudle("routechange") && (isDefined(ds.routeData) && Et.relatedRoute && 0 < Et.handledRouteRequestSecond.length && Et.routeCount === 0 ? ((fs = JSON.parse(JSON.stringify(ds.routeData))).revts = Et.handledRouteRequestSecond, Et.handledRequestStructSecond.push(fs)) : Et.handledRequestStructSecond.push(ds.routeData)), Et.hasEmitStart && Et.requestCount === 0 && Et.wsCount === 0 && (d$9(GC.LIFESTYLE_REQUEST_END + Et.identify), d$9(GC.LIFESTYLE_CALLBACK_REQUEST_START + Et.identify), d$9(GC.ROUTE_CHANGE_END + Et.identify), d$9(GC.WEBSOCKET_CONNECTION_END), R(Et))
        }), v$8(GC.LIFESTYLE_FETCH_START, function (ds) {
            isDefined(ds.info) && (ds.info.ai = Et.identify), Et.requestRecord.push(now()), Et.requestCount = Et.requestCount + 1
        }), v$8(GC.LIFESTYLE_XHR_START, function (ds) {
            isDefined(ds.info) && (ds.info.ai = Et.identify), Et.requestRecord.push(now()), Et.requestCount = Et.requestCount + 1
        }), v$8(GC.LIFESTYLE_CALLBACK_REQUEST_START + Et.identify, function (ds) {
            Et.requestCount = Et.requestCount + 1
        }), v$8(GC.LIFESTYLE_REQUEST_END + Et.identify, function (ds) {
            Et.requestCount = Et.requestCount - 1;
            var fs, us = u$1.getEviData("value");
            isDefined(ds) && isDefined(ds.requestData) && isDefined(ds.endTime) && !Et.relatedRoute && (fs = Q$1(ds.requestData, f$1.sett, !0), Et.handledRequestStruct.push({
                k: fs.type,
                ent: fs.ent,
                sin: fs.sin,
                v: fs.data,
                evi: us
            }), !isEmpty(f$1.secondSett)) && checkMoudle("network") && (fs = Q$1(ds.requestData, f$1.secondSett, !0), Et.handledRequestStructSecond.push({
                k: fs.type,
                ent: fs.ent,
                sin: fs.sin,
                v: fs.data,
                evi: us
            })), Et.relatedRoute && (fs = Q$1(ds.requestData, f$1.sett, !0), us = u$1.getEviData("value"), Et.handledRouteRequest.push({
                k: fs.type,
                ent: fs.ent,
                sin: fs.sin,
                v: fs.data,
                evi: us
            }), !isEmpty(f$1.secondSett)) && checkMoudle("network") && (fs = Q$1(ds.requestData, f$1.secondSett, !0), Et.handledRouteRequestSecond.push({
                k: fs.type,
                ent: fs.ent,
                sin: fs.sin,
                v: fs.data,
                evi: us
            })), Et.requestCount === 0 && Et.routeCount === 0 && Et.wsCount === 0 && (d$9(GC.LIFESTYLE_REQUEST_END + Et.identify), d$9(GC.LIFESTYLE_CALLBACK_REQUEST_START + Et.identify), d$9(GC.ROUTE_CHANGE_END + Et.identify), d$9(GC.WEBSOCKET_CONNECTION_END), isDefined(Et.loadTime) && R(Et), u$4.turnOffRecord(), u$4.stopPageActivityObserver())
        }), v$8(GC.CUSTOM_ACTION_END, function (ds) {
            Et.endTime = now(), R(Et, !0)
        }), v$8(GC.SPAN_CALLBACK_DATA, function (ds) {
            var fs, us, ls, hs, ms;
            isDefined(ds.websocketData) && ({
                type: fs,
                ent: us,
                sin: ls,
                data: hs,
                evi: ms
            } = ds.websocketData, ds.websocketData.isRelated = !0, Et.handledRequestStruct.push({
                k: fs,
                ent: us,
                sin: ls,
                v: hs,
                evi: ms
            }), checkMoudle("span") && Et.handledRequestStructSecond.push({
                k: fs,
                ent: us,
                sin: ls,
                v: hs,
                evi: ms
            }), Et.handledSpan.push(ds.websocketData))
        }), v$8(GC.WEBSOCKET_CONNECTION_START, function () {
            Et.wsCount = Et.wsCount + 1
        }), v$8(GC.WEBSOCKET_CONNECTION_END, function () {
            Et.wsCount = Et.wsCount - 1, Et.requestCount === 0 && Et.routeCount === 0 && Et.wsCount === 0 && (d$9(GC.LIFESTYLE_REQUEST_END + Et.identify), d$9(GC.LIFESTYLE_CALLBACK_REQUEST_START + Et.identify), d$9(GC.ROUTE_CHANGE_END + Et.identify), d$9(GC.WEBSOCKET_CONNECTION_END), R(Et))
        }), f$1.sett.pageUrl = d$3({
            p: {
                info: {
                    url: isDefined(window.location) ? window.location.href : ""
                }
            }
        }, f$1.sett).p.info.url, isDefined(u$4) && (u$4.startPageActivityObserver(), u$4.turnOnRecord());
        var es, ts, is, ns, rs, ss, os, as = Et.target;
        (isString(as.tagName) || as.name || "") !== "BODY" && (es = P$1(as), ts = "xpath" + unicode("=") + es + ",outerHTML" + unicode("=") + as.outerHTML, is = Et && Et.type === "click" ? 1 : 4, ns = Et && Et.target && Et.target.tagName || "", rs = {
            t: getActionText(as) || as.innerText || "",
            c: String(as.className || ""),
            tag: as.nodeName || as.localName || "",
            id: isDefined(as.id) ? as.id : ""
        }, ss = f$1.sett.pageUrl, os = h$4.isClick(es, cs), Et.startEvent = {
            t: is,
            n: ns,
            sa: 1,
            i: ts,
            vn: ss,
            ic: !1,
            lt: 0,
            is: !1,
            id: Et.identify,
            m: 1,
            ice: !1,
            ci: rs,
            timestamp: cs,
            vci: f$1.sett.pageViewId,
            ir: os
        }, Et.$startTimer = setTimeout(function () {
            isDefined(u$4) && isDefined(checkRecord) && (checkRecord(u$4.mutationRecord, cs) || checkRecord(u$4.performanceRecord, cs) || checkRecord(Et.requestRecord, cs) ? (c$4({
                t: GC.TRACE_ACTION_DATA,
                p: {
                    info: Et.startEvent
                },
                type: 1
            }), isEmpty(f$1.secondSett) || c$4({
                t: GC.TRACE_ACTION_DATA,
                p: {
                    info: Et.startEvent
                },
                type: 2
            }), d$9(GC.LIFESTYLE_REQUEST_END + Et.identify), d$9(GC.LIFESTYLE_FETCH_START), d$9(GC.LIFESTYLE_XHR_START), d$9(GC.CUSTOM_ACTION_END), d$9(GC.LIFESTYLE_CALLBACK_REQUEST_START + Et.identify), d$9(GC.ROUTE_CHANGE_START), d$9(GC.ROUTE_CHANGE_END + Et.identify), d$9(GC.SPAN_CALLBACK_DATA), d$9(GC.WEBSOCKET_CONNECTION_START), d$9(GC.WEBSOCKET_CONNECTION_END), u$4.turnOffRecord(), u$4.stopPageActivityObserver(), Et.hasEmitStart = !0) : (d$9(GC.LIFESTYLE_REQUEST_END + Et.identify), d$9(GC.LIFESTYLE_FETCH_START), d$9(GC.LIFESTYLE_XHR_START), d$9(GC.CUSTOM_ACTION_END), d$9(GC.LIFESTYLE_CALLBACK_REQUEST_START + Et.identify), d$9(GC.ROUTE_CHANGE_START), d$9(GC.ROUTE_CHANGE_END + Et.identify), d$9(GC.SPAN_CALLBACK_DATA), d$9(GC.WEBSOCKET_CONNECTION_START), d$9(GC.WEBSOCKET_CONNECTION_END), u$4.turnOffRecord(), u$4.stopPageActivityObserver()))
        }, 1e3))
    } catch (cs) {
        log("C151")
    }
}

function X$1(Et) {
    try {
        var es = now(),
            ts = (isDefined(Et.$startTimer) && clearTimeout(Et.$startTimer), d$9(GC.LIFESTYLE_FETCH_START), d$9(GC.LIFESTYLE_XHR_START), d$9(GC.ROUTE_CHANGE_START), d$9(GC.WEBSOCKET_CONNECTION_START), es - Et.startTime);
        if (Et.loadTime = ts, Et.endTime = es, isDefined(u$4))
            if (!Et.hasEmitStart && (0 < Et.requestRecord.length || checkRecord(u$4.mutationRecord, Et.startTime) || checkRecord(u$4.performanceRecord, Et.startTime))) Et.startEvent.lt = ts, c$4({
                t: GC.TRACE_ACTION_DATA,
                p: {
                    info: Et.startEvent
                },
                type: 1
            }), isEmpty(f$1.secondSett) || c$4({
                t: GC.TRACE_ACTION_DATA,
                p: {
                    info: Et.startEvent
                },
                type: 2
            }), Et.hasEmitStart = !0, Et.$timeoutTimer = setTimeout(function () {
                R(Et)
            }, 12e4), Et.requestCount === 0 && Et.routeCount === 0 && Et.wsCount === 0 && R(Et), u$4.turnOffRecord(), u$4.stopPageActivityObserver();
            else {
                if (0 < Et.handledSpan.length)
                    for (var is of Et.handledSpan) v$3(is, v$9.spanEvent);
                d$9(GC.LIFESTYLE_REQUEST_END + Et.identify), d$9(GC.CUSTOM_ACTION_END), d$9(GC.LIFESTYLE_CALLBACK_REQUEST_START + Et.identify), d$9(GC.ROUTE_CHANGE_END + Et.identify), d$9(GC.WEBSOCKET_CONNECTION_END), d$9(GC.SPAN_CALLBACK_DATA)
            }
    } catch (ns) {
        log("C152")
    }
}

function J() {
    c$4({
        t: GC.CUSTOM_ACTION_END
    })
}

function V() {
    on$1(window, "click", W, !0), on$1(window, "click", Et => setTimeout(() => X$1(Et), 50), !1)
}

function e(Et, es) {
    this.lastTimer = null, this.lastEvent = null, this.period = es || 1e3, this.compare = function () {
        return !1
    }, this.submit = Et || NIL_FN
}

function p$2(Et) {
    var es = Et.data;
    return isDefined(es.al) && es.al === "" && delete es.al, Et
}

function s$2() {
    try {
        return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? 2 : 1
    } catch (Et) {
        log("C119")
    }
}

function routeService(Et) {
    var es = new Metric(Et.p, GC.ROUTE),
        ts = s$2(),
        ts = (es.info(GC.URL, "", "tu").info(GC.REFERRER, "", "fu").info(GC.DURATION, 0, "d").info(GC.STATUS, 0, "sta").info(GC.ALIAS, "", "al").info(GC.PATH, "", "pt").info(GC.ROOT, "", "rt").info(GC.FULL_URL, "", "pu").info(GC.FRAME_WORK, "", "fw").info(GC.CUSTOM_IC, !1, "ic").info(GC.CLIENT_TYPE, ts, "ctp").info("pvid", "", "pvid").info("ns", 0, "ns"), isDefined(Et.p.info.wri) && es.info("wri", [], "wri"), es.build());
    return isDefined(Et.revts) && 0 < Et.revts.length && (ts.revts = Et.revts), p$2(ts)
}
extend(e.prototype, {
    $schedule: function (Et) {
        isDefined(this.lastTimer) && clearTimeout(this.lastTimer);
        var es = this;
        this.lastEvent = Et, this.lastTimer = delay(function () {
            es.submit(es.lastEvent), es.lastEvent = null
        }, this.period)
    },
    event: function (Et) {
        isDefined(this.lastEvent) && (this.compare(this.lastEvent, Et) ? (Et.info[GC.DURATION] = Et.info[GC.START_TIME] - this.lastEvent.info[GC.START_TIME], Et.info[GC.TIMESTAMP] = this.lastEvent.info[GC.TIMESTAMP], Et.info[GC.START_TIME] = this.lastEvent.info[GC.START_TIME], Et.info.count = this.lastEvent.info.count + 1) : this.submit(this.lastEvent)), this.$schedule(Et)
    },
    flush: function () {
        isDefined(this.lastTimer) && (clearTimeout(this.lastTimer), this.lastTimer = null), isDefined(this.lastEvent) && (this.submit(this.lastEvent), this.lastEvent = null)
    },
    equalsWith: function (Et) {
        "apply" in Et && (this.compare = Et)
    }
});
var m$3 = isDefined(window.location) ? window.location : "";

function getFramework() {
    return window ? window.Vue !== void 0 || window.__VUE__ || window.$nuxt && window.$nuxt._isVue ? "Vue" : window.React ? "React" : window.ng !== void 0 || isDefined(window.Zone) || isDefined(window.angular) ? "Angular" : "Other" : "Other"
}
var h$3 = [],
    r$2 = {};

function P() {
    u$1.setData(GC.TITLE, document.title), u$1.setEviData("n", document.URL), document.title != "" && u$1.setEviData("vt", document.title), document.referrer && u$1.setEviData("ru", document.referrer)
}

function T$2() {
    if (P(), isDefined(m$3) && isDefined(m$3.href) && m$3.href.split("?")[0] !== (isDefined(location) ? location.href : "").split("?")[0]) {
        let rs = {
            id: ""
        };
        c$4({
            t: GC.ROUTE_CHANGE_START,
            info: rs
        }), isDefined(r$2) && 0 < Object.getOwnPropertyNames(r$2).length && Object.keys(r$2).map(ss => {
            typeof r$2[ss] == "function" && (r$2[ss](), delete r$2[ss])
        }), f$1.sett.isSinglePage = !0, f$1.sett.pageViewId = uuid();
        var Et = extend({}, location),
            es = {
                info: {
                    uuid: uuid(),
                    timestamp: now(),
                    url: Et.href,
                    referrer: extend({}, m$3).href,
                    duration: 1e3,
                    status: 0,
                    path: Et.hash === "" ? Et.pathname : Et.hash,
                    root: Et.hash === "" ? Et.origin + Et.pathname : Et.origin + Et.pathname + Et.hash.replace("#/", ""),
                    fullUrl: Et.hash !== "" ? Et.origin + Et.pathname : Et.origin + "/",
                    framework: getFramework(),
                    pvid: f$1.sett.pageViewId,
                    ns: isDefined(performance) && isDefined(performance.timing) ? performance.timing.navigationStart : 0
                }
            },
            ts = (-1 < es.info.url.indexOf("?") && (es.info.url = es.info.url.split("?")[0]), -1 < es.info.referrer.indexOf("?") && (es.info.referrer = es.info.referrer.split("?")[0]), -1 < es.info.path.indexOf("?") && (es.info.path = es.info.path.split("?")[0]), -1 < es.info.root.indexOf("?") && (es.info.root = es.info.root.split("?")[0]), -1 < es.info.fullUrl.indexOf("?") && (es.info.fullUrl = es.info.fullUrl.split("?")[0]), function () {
                var ss, os, as, cs, ds;
                isDefined(r$2) && isDefined(r$2[es.info.uuid]) && (isDefined(r$2) && isDefined(r$2[es.info.uuid]) && delete r$2[es.info.uuid], {
                    type: ss,
                    ent: os,
                    sin: as,
                    data: cs
                } = routeService({
                    p: es
                }), ds = u$1.getEviData("value"), c$4({
                    t: GC.ROUTE_CHANGE_END + rs.id,
                    routeData: {
                        k: ss,
                        ent: os,
                        sin: as,
                        v: cs,
                        evi: ds
                    }
                }))
            }),
            is = (isDefined(r$2) && (r$2[es.info.uuid] = ts), setTimeout(ts, 1e3)),
            ns = new PageActivityManager(function (ss) {
                ss.forEach(os => {
                    var as = {
                        st: getFixedMetric(os, GC.START_TIME),
                        name: d$3({
                            p: {
                                info: {
                                    url: os[GC.NAME]
                                }
                            }
                        }, f$1.sett).p.info.url,
                        dura: isDefined(os[GC.DURATION]) ? getFixedMetric(os, GC.DURATION) : os[GC.RESPONSE_END] - os[GC.START_TIME],
                        rt: getMineTypeByUrl(os[GC.NAME]),
                        fs: getFixedMetric(os, GC.FETCH_START),
                        dls: getFixedMetric(os, GC.DOMAIN_LOOKUP_START),
                        dle: getFixedMetric(os, GC.DOMAIN_LOOKUP_END),
                        cs: getFixedMetric(os, GC.CONNECT_START),
                        ce: getFixedMetric(os, GC.CONNECT_END),
                        scs: getFixedMetric(os, GC.SECURE_CONNECTION_START),
                        reqs: getFixedMetric(os, GC.REQUEST_START),
                        rsps: getFixedMetric(os, GC.RESPONSE_START),
                        rspe: getFixedMetric(os, GC.RESPONSE_END),
                        rs: isDefined(os[GC.RESPONSE_STATUS]) ? os[GC.RESPONSE_STATUS] : -1
                    };
                    isDefined(os[GC.INITIATOR_TYPE]) && (as.it = os[GC.INITIATOR_TYPE]), isDefined(os[GC.DECODED_BODY_SIZE]) ? (as.ts = os[GC.TRANSFER_SIZE], as.ebs = os[GC.ENCODED_BODY_SIZE] >= Math.pow(2, 64) ? Math.pow(2, 60) : os[GC.ENCODED_BODY_SIZE], as.dbs = os[GC.DECODED_BODY_SIZE]) : (as.ts = 0, as.ebs = 0, as.dbs = 0), isDefined(as.it) && (as.it === "xmlhttprequest" || as.it === "fetch") || h$3.push(as)
                }), isDefined(is) && (clearTimeout(is), is = setTimeout(ts, 1e3))
            });
        ns.turnOnRecord(), ns.startPageActivityObserver(), ts = function () {
            var ss, os, as, cs, ds;
            isDefined(r$2) && isDefined(r$2[es.info.uuid]) ? (isDefined(r$2) && isDefined(r$2[es.info.uuid]) && delete r$2[es.info.uuid], 0 < ns.mutationRecord.length ? 0 < ns.performanceRecord.length ? (ss = ns.performanceRecord.pop(), os = ns.mutationRecord.pop(), es.info.duration = 0 < ss - os ? ss - es.info.timestamp : os - es.info.timestamp) : es.info.duration = ns.mutationRecord.pop() - es.info.timestamp : 0 < ns.performanceRecord.length && (es.info.duration = ns.performanceRecord.pop() - es.info.timestamp), ns.turnOffRecord(), ns.stopPageActivityObserver(), isDefined(es) && isDefined(h$3) && 0 < h$3.length && (es.info.wri = h$3), {
                type: ss,
                ent: os,
                sin: as,
                data: cs
            } = routeService({
                p: es
            }), ds = u$1.getEviData("value"), c$4({
                t: GC.ROUTE_CHANGE_END + rs.id,
                routeData: {
                    k: ss,
                    ent: os,
                    sin: as,
                    v: cs,
                    evi: ds
                }
            }), isDefined(h$3) && (h$3 = [])) : (ns.turnOffRecord(), ns.stopPageActivityObserver())
        }, isDefined(r$2) && (r$2[es.info.uuid] = ts), m$3 = Et
    }
}
let H$2 = class {
    constructor(Et) {
        this.currentLocation = extend({}, Et), m$3 = this.currentLocation
    }
    trackHistory() {
        const Et = history.pushState,
            es = history.replaceState;
        isDefined(Et) && !isDefined(Et.$hasHooked) && (history.pushState = function (ts, is, ns) {
            Et.apply(this, [ts, is, ns]), T$2()
        }, history.pushState.$hasHooked = !0), isDefined(es) && !isDefined(history.replaceState.$hasHooked) && (history.replaceState = function (ts, is, ns) {
            es.apply(this, [ts, is, ns]), T$2()
        }, history.replaceState.$hasHooked = !0), window.addEventListener("popstate", T$2)
    }
    trackHashchage() {
        window.addEventListener("hashchange", T$2)
    }
    init() {
        this.trackHistory(), this.trackHashchage()
    }
};

function b$1() {
    var Et = new H$2(isDefined(window.location) ? window.location : "");
    return Et.init(), Et
}

function U$3(Et, es, ts) {
    if (!isReadable(Et.file) && es) {
        try {
            let ls = function (hs) {
                return hs = Number(hs), isNaN(hs) ? 0 : hs
            };
            for (var is, ns = /[@(\s]+?([\S]+):(\d+):(\d+)\)?/, rs = /[@(\s]+?([\S]+):(\d+)\)?/, ss = /([^@(\s)]+):(\d+):(\d+)/, os = /([^@(\s)]+):(\d+)/, as = es.split(`
`), cs = !0, ds = 0; ds < as.length; ds++)
                if (is = as[ds], ns.test(is) || rs.test(is)) {
                    if (!cs || !ts) {
                        var fs = last(is.split(/\s+/)),
                            us = ss.exec(fs) || os.exec(fs);
                        Et.file = us[1].replace(/^\(/, ""), Et.line = ls(us[2]), Et.column = ls(us[3]);
                        break
                    }
                    cs = !1, as[ds] = ""
                } ts && (Et.stack = as.join(`
`).replace(/\n+/g, `
`).replace(/^\n/, ""))
        } catch (ls) {
            log("C146")
        }
        return Et
    }
}

function v$2(Et, es, ts) {
    var is;
    return isDefined(es) && (is = es.name || es.constructor && es.constructor.name, Et.name = is && toString(is) || "", isReadable(Et.message) || (Et.message = (isReadable(is) ? is + ": " : "") + es.message), isReadable(Et.file) || (Et.file = es.fileName), isDefined(Et.line) || (Et.line = es.lineNumber, Et.column = es.columnNumber), Et.stack = es.stack, Et.framework = getFramework(), U$3(Et, Et.stack, ts)), Et
}
var w$3 = new e(function (Et) {
    c$4({
        t: GC.ERROR_DATA,
        p: Et
    })
}, f$1.sett.debounce);

function y$1(Et, es) {
    Et = {
        info: extend(Et, {
            message: withLength(Et.message, 200),
            duration: 0,
            type: isDefined(Et.type) ? Et.type : 0,
            count: 1,
            file: withLength(Et.file, 200) || "<anonymous>",
            stack: withLength(Et.stack, 5e3),
            framework: getFramework()
        })
    }, isDefined(es) && (Et.ext = es), w$3.event(Et)
}

function h$2() {
    window.onerror = hack(window.onerror, function (Et, es, ts, is, ns) {
        Et = extend({
            message: Et,
            line: ts,
            column: is,
            file: es,
            type: 3
        }, getTime()), v$2(Et, ns), y$1(Et)
    })
}

function $$1() {
    h$2(), v$8(GC.PAGE_READY, function () {
        h$2()
    }), addListener(window, "error", function (Et) {
        var es = Et.target || Et.srcElement;
        isDefined(es) && (es instanceof HTMLScriptElement || es instanceof HTMLLinkElement || es instanceof HTMLImageElement) && c$4({
            t: GC.ERROR_DATA,
            p: {
                info: extend({
                    message: xpath(es),
                    duration: 0,
                    type: 1,
                    count: 1,
                    file: withLength(es.src || Et.filename, 200),
                    line: 0,
                    column: 0,
                    stack: "",
                    framework: getFramework()
                }, getTime())
            }
        })
    }, !0), addListener(window, "unhandledrejection", function (Et) {
        var es;
        isDefined(Et) && (isString(Et.reason) ? (es = extend({
            message: Et.reason,
            line: 0,
            column: 0
        }, getTime()), isDefined(Et.type) && (es.type = 2), y$1(es)) : N$1(Et.reason))
    }, !0)
}

function N$1(Et) {
    if (!isDefined(Et)) return log("C122");
    var es, ts = getTime();
    typeof Et == "string" ? (ts.message = Et, v$2(ts, Et = new Error(Et), !0)) : window.ErrorEvent && Et instanceof ErrorEvent ? (extend(ts, {
        message: Et.message,
        line: Et.lineno,
        column: Et.colno,
        file: Et.filename
    }), v$2(ts, Et.error), isReadable(ts.file) || Et.target && (ts.file = Et.target.baseURI)) : (v$2(ts, Et), typeof Et.type == "number" ? ts.type = Et.type : ts.type = 3, es = Et.ext), y$1(ts, es)
}

function g$2() {
    console && console.error && (console.error = h$1(console.error, null, d$1))
}

function h$1(Et, es, ts) {
    var is;
    return Et.$original ? Et : ((is = function () {
        var ns = args(arguments);
        try {
            return isDefined(es) && es.apply(this, ns), ns[0] instanceof Error && N$1(ns[0]), Et.apply(this, ns)
        } catch (rs) {
            throw rs
        } finally {
            ts.apply(this, ns)
        }
    }).$original = Et, is)
}

function d$1() {
    var Et;
    console.$bonree || (Et = {
        lv: "error",
        msg: E$1(args(arguments))
    }, c$4({
        t: GC.CONSOLE_DATA,
        p: {
            info: Et
        }
    }))
}

function E$1(Et) {
    return Et && isArray(Et) ? map(Et, function (es) {
        return S$1(es = es === void 0 ? String(es) : es)
    }).join(" ") : Et
}

function S$1(Et) {
    let es;
    if (isString(Et)) return Et;
    if (Et instanceof Error || Et instanceof Function) return String(Et);
    try {
        es = stringify(Et)
    } catch (ts) {
        es = String(Et)
    }
    return es
}

function Reactive(Et) {
    for (var es in this.data = Et, this.computed = {}, Et) Et.hasOwnProperty(es) && this.defineReactive(es, Et[es])
}
w$3.equalsWith(function (Et, es) {
    function ts(is) {
        return is.message + is.line + is.column
    }
    return ts(Et.info) === ts(es.info)
}), v$8(GC.FLUSH_DATA, function () {
    w$3.flush()
}), Reactive.prototype.defineReactive = function (Et, es) {
    var ts = this;
    Object.defineProperty(this.data, Et, {
        get: function () {
            return es
        },
        set: function (is) {
            es = is, ts.notifyComputed(Et)
        }
    })
}, Reactive.prototype.defineComputed = function (Et, es) {
    var ts = this;
    Object.defineProperty(this.computed, Et, {
        get: function () {
            return es.call(ts)
        }
    })
}, Reactive.prototype.notifyComputed = function (Et) {
    for (var es in this.computed) this.computed.hasOwnProperty(es) && (this.computed[es].value = this.computed[es].get())
};
var C$2 = !1,
    k = [],
    m$2 = [];
let N, c, F$1;
const A$1 = new Reactive({
    FP: null,
    FCP: null,
    LCP: null
});
var w$2 = [],
    I$2 = [],
    Q = !1,
    d = 0;
const B = (Et, es) => {
        try {
            PerformanceObserver.supportedEntryTypes.includes(Et) && new PerformanceObserver(ts => {
                es(ts.getEntries())
            }).observe({
                type: Et,
                buffered: !0
            })
        } catch (ts) {
            console.log("PerformanceObserver")
        }
    },
    Te = Et => {
        forEach(Et, function (es) {
            es.name === "first-paint" && (N = es[GC.START_TIME] && es[GC.START_TIME] || "", A$1.data.FP = es[GC.START_TIME] && es[GC.START_TIME] || "", A$1.computed.allin), es.name === "first-contentful-paint" && (c = es[GC.START_TIME] && es[GC.START_TIME] || "", A$1.data.FCP = es[GC.START_TIME] && es[GC.START_TIME] || "", A$1.computed.allin)
        })
    },
    Ee$2 = Et => {
        let es = 0,
            ts = 0;
        for (var is of Et) is.size > es && (es = is.size, ts = is.startTime);
        F$1 = ts, A$1.data.LCP = ts || 0, A$1.computed.allin
    },
    re = Et => {
        k = Et
    };

function oe() {
    B("largest-contentful-paint", Ee$2), B("longtask", re)
}

function ie() {
    B("paint", Te)
}

function ae(Et) {
    var es, ts;
    return u$1.state ? (isDefined(N) && isDefined(c) || !window.performance.getEntriesByType || forEach(window.performance.getEntriesByType("paint"), function (is) {
        is.name === "first-paint" && (N = is[GC.START_TIME] && is[GC.START_TIME] || 0), is.name === "first-contentful-paint" && (c = is[GC.START_TIME] && is[GC.START_TIME] || 0)
    }), isDefined(N) || (es = (ts = window.performance.timing)[GC.NAVIGATION_START], ts.msFirstPaint && (log("C111"), N = ts.msFirstPaint - es), window.chrome && window.chrome.loadTimes && (ts = window.chrome.loadTimes()) && ts.firstPaintTime && (log("C112"), N = ts.firstPaintTime - es)), {
        fp: N ? Math.round(N) : 0,
        fcp: c ? Math.round(c) : 0,
        lcp: F$1 ? Math.round(F$1) : 0
    }) : log("C110")
}

function _(Et, es) {
    return 0 < Et ? Et - es : 0
}

function _e() {
    var Et = window.performance || window.msPerformance || window.webkitPerformance,
        es = Et.getEntriesByType("resource") || [];
    return es.length === 0 ? isDefined(Et.timing) ? 0 < Et.timing[GC.LOAD_EVENT_END] - Et.timing[GC.NAVIGATION_START] ? Et.timing[GC.LOAD_EVENT_END] - Et.timing[GC.NAVIGATION_START] : 0 : 10 : (Et = map(es, function (ts) {
        return ts.responseEnd
    }).sort((ts, is) => is - ts), Math.round(Et[0]))
}

function X() {
    let Et = d$3({
        p: {
            info: {
                url: f$1.sett.pageUrl
            }
        }
    }, f$1.sett).p.info.url;
    if (f$1.setData("pageUrl", Et), c$4({
            t: GC.PAGE_LOAD
        }), ie(), window === window.top) {
        const es = PerformanceObserver.supportedEntryTypes;
        es && es.includes("largest-contentful-paint") ? A$1.defineComputed("allin", function () {
            return this.data.FP !== null && this.data.FCP !== null && this.data.LCP !== null && L$4(), this.data.FP !== null && this.data.FCP !== null && this.data.LCP !== null
        }) : L$4(), parentReceiveMsg(), isDefined(f$1.sett.RecordConfiguration || f$1.sett.mc) && (isDefined(window.BonreeRecord) && isDefined(window.BonreeRecord.BonreeRecord) ? window.BonreeRecord.BonreeRecord(f$1.sett) : isDefined(window.BonreeAgent) && isDefined(window.BonreeAgent.BonreeRecord) && window.BonreeAgent.BonreeRecord(f$1.sett))
    } else sunLoaded(L$4), sunReceiveMsg(L$4)
}

function L$4(Et) {
    C$2 || (C$2 = !0, c$4({
        t: GC.RESOURCE_DATA,
        p: Oe(),
        type: 1
    }), c$4({
        t: GC.RESOURCE_DATA,
        p: Re(),
        type: 2,
        special: Q
    }), d === 0 && (d$9(GC.LIFESTYLE_XHR_START), d$9(GC.LIFESTYLE_FETCH_START), d$9(GC.LIFESTYLE_REQUEST_END + "H5"), c$4({
        t: GC.RESOURCE_DATA,
        p: {},
        type: 3,
        revts: w$2
    }), isEmpty(f$1.secondSett) || c$4({
        t: GC.RESOURCE_DATA,
        p: {},
        type: 4,
        revts: I$2
    }))), c$4({
        t: GC.FLUSH_DATA,
        p: !!Et
    })
}

function Re() {
    var Et;
    return window.performance && window.performance.getEntriesByType ? (Et = m$2.concat(window.performance.getEntriesByType("resource")), m$2 = [], map(Et, function (es) {
        var ts, is, ns = es[GC.INITIATOR_TYPE],
            rs = es.entryType,
            ss = getMineTypeByUrl(es.name);
        if (isDefined(es.name) && es.name.indexOf(f$1.sett.uploadAddrHttps) === -1 || isDefined(es.name) && es.name.indexOf(f$1.sett.uploadAddrHttp) === -1) return is = {}, (ts = {}).name = d$3({
            p: {
                info: {
                    url: es.name
                }
            }
        }, f$1.sett).p.info.url, ts[GC.START_TIME] = getFixedMetric(es, GC.START_TIME), ts[GC.INITIATOR_TYPE] = ns, ts.entryType = rs, ts.ret = ss, is[GC.WORKER_START] = getFixedMetric(es, GC.WORKER_START), is[GC.REDIRECT_START] = getFixedMetric(es, GC.REDIRECT_START), is[GC.REDIRECT_END] = getFixedMetric(es, GC.REDIRECT_END), is[GC.FETCH_START] = getFixedMetric(es, GC.FETCH_START), is[GC.DOMAIN_LOOKUP_START] = getFixedMetric(es, GC.DOMAIN_LOOKUP_START), is[GC.DOMAIN_LOOKUP_END] = getFixedMetric(es, GC.DOMAIN_LOOKUP_END), is[GC.CONNECT_START] = getFixedMetric(es, GC.CONNECT_START), is[GC.CONNECT_END] = getFixedMetric(es, GC.CONNECT_END), is[GC.SECURE_CONNECTION_START] = getFixedMetric(es, GC.SECURE_CONNECTION_START), is[GC.REQUEST_START] = getFixedMetric(es, GC.REQUEST_START), is[GC.RESPONSE_START] = getFixedMetric(es, GC.RESPONSE_START), is[GC.RESPONSE_END] = getFixedMetric(es, GC.RESPONSE_END), is[GC.RESPONSE_STATUS] = es[GC.RESPONSE_STATUS], ts[GC.DURATION] = isDefined(es[GC.DURATION]) ? getFixedMetric(es, GC.DURATION) : is[GC.RESPONSE_END] - is[GC.START_TIME], isDefined(es[GC.DECODED_BODY_SIZE]) && (ts[GC.NEXT_HOP_PROTOCOL] = es[GC.NEXT_HOP_PROTOCOL], is[GC.TRANSFER_SIZE] = es[GC.TRANSFER_SIZE], is[GC.ENCODED_BODY_SIZE] = es[GC.ENCODED_BODY_SIZE] >= Math.pow(2, 64) ? Math.pow(2, 60) : es[GC.ENCODED_BODY_SIZE], is[GC.DECODED_BODY_SIZE] = es[GC.DECODED_BODY_SIZE]), {
            info: ts,
            metric: is
        }
    })) : (log("C116"), [])
}

function fe(Et, es) {
    var ts = performance.timing.domContentLoadedEventEnd - performance.timing.domContentLoadedEventStart; {
        var is = Et,
            ns = es,
            rs = performance.getEntriesByType("resource"),
            ss = ts;
        let as, cs = is;
        for (; is + 5e3 <= 5e4;) {
            cs = is;
            var os = ns.filter(ds => ds.startTime < is + 5e3 && ds.startTime + ds.duration > is);
            if (os.length) {
                const ds = os[os.length - 1];
                is = ds.startTime + ds.duration
            } else {
                if (!(2 < (as = rs.filter(ds => !(ds.startTime >= is + 5e3 || ds.startTime + ds.duration <= is))).length)) return Math.max(cs, ss); {
                    const ds = as[0];
                    is = ds.startTime + ds.duration
                }
            }
        }
        return Math.max(cs, ss)
    }
}

function Oe() {
    var Et, es, ts = window.screen || {},
        ts = {
            timestamp: now(0),
            title: u$1.title,
            referrer: document.referrer,
            charset: document.characterSet || document.charset || "",
            embed: window.top && window.self && window.top !== window.self ? 1 : 0,
            width: ts.width || 0,
            height: ts.height || 0,
            completed: u$1.state,
            param: location && location.search || ""
        },
        is = window.performance && window.performance.timing;
    return ts.supported = isDefined(is) ? 1 : 0, is ? (is = {}, Et = (es = window.performance.timing)[GC.NAVIGATION_START] || es[GC.FETCH_START], is[GC.NAVIGATION_START] = Et || "", is[GC.UNLOAD_EVENT_START] = _(es[GC.UNLOAD_EVENT_START], Et), is[GC.UNLOAD_EVENT_END] = _(es[GC.UNLOAD_EVENT_END], Et), is[GC.REDIRECT_START] = _(es[GC.REDIRECT_START], Et), is[GC.REDIRECT_END] = _(es[GC.REDIRECT_END], Et), is[GC.FETCH_START] = _(es[GC.FETCH_START], Et), is[GC.DOMAIN_LOOKUP_START] = _(es[GC.DOMAIN_LOOKUP_START], Et), is[GC.DOMAIN_LOOKUP_END] = _(es[GC.DOMAIN_LOOKUP_END], Et), is[GC.CONNECT_START] = _(es[GC.CONNECT_START], Et), is[GC.CONNECT_END] = _(es[GC.CONNECT_END], Et), is[GC.SECURE_CONNECTION_START] = _(es[GC.SECURE_CONNECTION_START], Et), is[GC.REQUEST_START] = _(es[GC.REQUEST_START], Et), is[GC.RESPONSE_START] = _(es[GC.RESPONSE_START], Et), is[GC.RESPONSE_END] = _(es[GC.RESPONSE_END], Et), is[GC.DOM_LOADING] = _(es[GC.DOM_LOADING], Et), is[GC.DOM_INTERACTIVE] = _(es[GC.DOM_INTERACTIVE], Et), is[GC.DOM_CONTENT_LOADED_EVENT_START] = _(es[GC.DOM_CONTENT_LOADED_EVENT_START], Et), is[GC.DOM_CONTENT_LOADED_EVENT_END] = _(es[GC.DOM_CONTENT_LOADED_EVENT_END], Et), is[GC.DOM_COMPLETE] = _(es[GC.DOM_COMPLETE], Et), is[GC.LOAD_EVENT_START] = _(es[GC.LOAD_EVENT_START], Et), is[GC.LOAD_EVENT_END] = _(es[GC.LOAD_EVENT_END], Et), is[GC.FULL_RESOURCE_LOAD_TIME] = _e(), ts[GC.DURATION] = u$1.state ? Math.max(0, is[GC.LOAD_EVENT_END], is[GC.LOAD_EVENT_START]) : Math.round(tillNow() / 1e3), window.performance.getEntriesByType && isDefined(es = last(window.performance.getEntriesByType("navigation"))) && (ts.type = es.type, ts[GC.NEXT_HOP_PROTOCOL] = es[GC.NEXT_HOP_PROTOCOL], is[GC.REDIRECT_COUNT] = es[GC.REDIRECT_COUNT], is[GC.TRANSFER_SIZE] = es[GC.TRANSFER_SIZE], is[GC.ENCODED_BODY_SIZE] = es[GC.ENCODED_BODY_SIZE], is[GC.DECODED_BODY_SIZE] = es[GC.DECODED_BODY_SIZE], is[GC.RESPONSE_STATUS] = es[GC.RESPONSE_STATUS]), extend(is, Et = ae()), Et && Et.fcp && (es = fe(Et.fcp, k) || 0, extend(is, {
        tti: Math.round(es)
    })), {
        info: ts,
        metric: is
    }) : (log("C109"), ts[GC.DURATION] = tillNow(), {
        info: ts
    })
}

function Se() {
    var Et;
    window.performance && window.performance.getEntriesByType && (Et = function (es) {
        return function () {
            log("Dump when resource buffer is full");
            var ts = window.performance.getEntriesByType("resource"),
                ts = (c$4({
                    t: GC.RESOURCE_DUMP,
                    p: ts
                }), C$2 || (m$2 = m$2.concat(ts)), es + "learResourceTimings");
            ts in window.performance && window.performance[ts]()
        }
    }, addListener(window.performance, "resourcetimingbufferfull", Et("c"), !1), addListener(window.performance, "webkitresourcetimingbufferfull", Et("webkitC"), !1))
}

function se() {
    v$8(GC.LIFESTYLE_XHR_START, function (Et) {
        isDefined(Et.info) && (Et.info.isRelatedH5 = !0), d += 1
    }), v$8(GC.LIFESTYLE_FETCH_START, function (Et) {
        isDefined(Et.info) && (Et.info.isRelatedH5 = !0), d += 1
    }), v$8(GC.LIFESTYLE_REQUEST_END + "H5", function (Et) {
        --d;
        var es = Q$1(JSON.parse(JSON.stringify(Et.requestData)), f$1.sett, !0),
            ts = u$1.getEviData("value");
        w$2.push({
            k: es.type,
            ent: es.ent,
            sin: es.sin,
            v: es.data,
            evi: ts
        }), !isEmpty(f$1.secondSett) && checkMoudle("network") && (es = Q$1(JSON.parse(JSON.stringify(Et.requestData)), f$1.secondSett, !0), I$2.push({
            k: es.type,
            ent: es.ent,
            sin: es.sin,
            v: es.data,
            evi: ts
        })), d === 0 && (d$9(GC.LIFESTYLE_XHR_START), d$9(GC.LIFESTYLE_FETCH_START), d$9(GC.LIFESTYLE_REQUEST_END + "H5"), c$4({
            t: GC.RESOURCE_DATA,
            p: {},
            type: 3,
            revts: w$2
        }), isEmpty(f$1.secondSett) || c$4({
            t: GC.RESOURCE_DATA,
            p: {},
            type: 4,
            revts: I$2
        }))
    }), addListener(document, "DOMContentLoaded", function () {
        c$4({
            t: GC.PAGE_READY
        })
    }), document.readyState !== "complete" || C$2 ? on$1(window, "load", X) : startWith(document.location.href, "about:") && startWith(document.URL, "about:") || (X.call(), Q = !0), on$1(window, "pagehide", function () {
        C$3(!0)
    }, !1), oe(), Se()
}
var O$1 = [],
    A, D$2 = [],
    I$1 = [GC.XML_HTTP_REQUEST, GC.FETCH],
    b = function (Et, es) {
        return Et[GC.START_TIME] - es[GC.START_TIME]
    };

function getCookieUserID() {
    var Et = g$7.cookieArr,
        es = g$7.configeManage;
    if (0 < Et.length)
        for (let is = 0, ns = Et.length - 1; is <= ns; is++) {
            var ts = getCookie(Et[is].rule);
            if (isDefined(ts) && u$3(ts) && Et[is].index <= g$7.isStopGetValue) return es[Et[is].index].value = "" + ts, void g$7.checkValueRight()
        }
}

function H$1(rs) {
    var es, ts = rs.url,
        is = rs[GC.TIMESTAMP],
        ns = I$1[rs.type],
        rs = map(D$2, function (os) {
            if (os.url === ts && I$1[os.type] === ns) return os
        }),
        ss = (rs.sort(b), -1);
    if (forEach(rs, function (os, as) {
            if (os[GC.TIMESTAMP] === is) return ss = as, !1
        }), !(ss < 0)) return rs = map(O$1, function (os, as) {
        if (v$1(os, ts, ns)) return os
    }), ss >= rs.length ? (log("C131"), es = [], window.performance.getEntriesByType && (es = map(window.performance.getEntriesByType("resource"), function (os) {
        if (v$1(os, ts, ns)) return os
    })), rs = rs.concat(es)) : log("C132"), rs.sort(b), rs.length < 1 || ss >= rs.length ? void log("C133") : rs[ss];
    log("C130")
}

function m$1(Et) {
    return (Et.initiatorType === GC.XML_HTTP_REQUEST || Et.initiatorType === GC.FETCH) && Et[GC.START_TIME] > A
}

function v$1(Et, es, ts) {
    return m$1(Et) && endWith(Et.name, es) && Et.initiatorType === ts
}

function L$3(Et) {
    return 0 < Et && Et < 600
}
var extendMetrics = function (Et) {
        var es, ts, is;
        return window.performance && window.performance.now ? L$3((es = Et.info).status || es.code) ? isDefined(ts = H$1(es)) ? (is = Et.metric, es[GC.START_TIME] = 1e3 * getFixedMetric(ts, GC.START_TIME), es[GC.TIMESTAMP] = 1e3 * (es[GC.START_TIME] / 1e3 + window.performance.timing.navigationStart), es[GC.DURATION] = 1e3 * getFixedMetric(ts, GC.DURATION), is[GC.REDIRECT_START] = 1e3 * getFixedMetric(ts, GC.REDIRECT_START), is[GC.REDIRECT_END] = 1e3 * getFixedMetric(ts, GC.REDIRECT_END), is[GC.FETCH_START] = 1e3 * getFixedMetric(ts, GC.FETCH_START), is[GC.DOMAIN_LOOKUP_START] = 1e3 * getFixedMetric(ts, GC.DOMAIN_LOOKUP_START), is[GC.DOMAIN_LOOKUP_END] = 1e3 * getFixedMetric(ts, GC.DOMAIN_LOOKUP_END), is[GC.CONNECT_START] = 1e3 * getFixedMetric(ts, GC.CONNECT_START), is[GC.CONNECT_END] = 1e3 * getFixedMetric(ts, GC.CONNECT_END), is[GC.SECURE_CONNECTION_START] = 1e3 * getFixedMetric(ts, GC.SECURE_CONNECTION_START), is[GC.RESPONSE_START] = 1e3 * getFixedMetric(ts, GC.RESPONSE_START), is[GC.REQUEST_START] = 1e3 * getFixedMetric(ts, GC.REQUEST_START), is[GC.RESPONSE_END] = 1e3 * getFixedMetric(ts, GC.RESPONSE_END), isDefined(ts[GC.DECODED_BODY_SIZE]) && (es[GC.NEXT_HOP_PROTOCOL] = ts[GC.NEXT_HOP_PROTOCOL], is[GC.WORKER_START] = 1e3 * getFixedMetric(ts, GC.WORKER_START), is[GC.TRANSFER_SIZE] = getFixedMetric(ts, GC.TRANSFER_SIZE), is[GC.ENCODED_BODY_SIZE] = getFixedMetric(ts, GC.ENCODED_BODY_SIZE), is[GC.DECODED_BODY_SIZE] = getFixedMetric(ts, GC.DECODED_BODY_SIZE))) : log("C137") : log("C135") : log("C134"), Et
    },
    polyfillMetric = function (Et) {
        var es = Et.info,
            ts = Et.metric;
        return isDefined(es[GC.DURATION]) || (es[GC.DURATION] = ts[GC.RESPONSE_END] - es[GC.START_TIME]), isDefined(es.callbackError) || (es.callbackError = 0), Et
    },
    queueRequest = function (Et) {
        var es = Et.info;
        L$3(es.status || es.code) && D$2.push(Et.info)
    };

function F() {
    A = tillNow() / 1e3 || 0, v$8(GC.RESOURCE_DUMP, function (Et) {
        Et = map(Et.p, function (es) {
            if (m$1(es)) return es
        }), O$1 = O$1.concat(Et)
    })
}
class Z {
    constructor() {
        this.list = {}, this.isOpen = !1, this.blackKey = []
    }
    checkIsOpen() {
        isDefined(f$1.sett.brss) && !f$1.sett.brss || isDefined(f$1.secondSett.brss) && !f$1.secondSett.brss ? this.isOpen = !1 : this.isOpen = !0
    }
    getItem(es, ts, is) {
        var ns = es + "+" + ts;
        return isDefined(es) && this.list[ns] ? this.list[ns] : this.setItem(es, ts, is)
    }
    setItem(es, ts, is) {
        let {
            urlTotalList: ns,
            urlWhiteList: rs,
            urlBlackList: ss
        } = isDefined(f$1.sett.traceConfig) ? f$1.sett.traceConfig : {
            urlTotalList: [],
            urlBlackList: [],
            urlWhiteList: []
        }, os = (isDefined(f$1.secondSett.traceConfig) && (isDefined(f$1.secondSett.traceConfig.urlTotalList) && (ns = isDefined(ns) ? ns.concat(f$1.secondSett.traceConfig.urlTotalList) : f$1.secondSett.traceConfig.urlTotalList), isDefined(f$1.secondSett.traceConfig.urlWhiteList) && (rs = isDefined(rs) ? rs.concat(f$1.secondSett.traceConfig.urlWhiteList) : f$1.secondSett.traceConfig.urlWhiteList), isDefined(f$1.secondSett.traceConfig.urlBlackList)) && (ss = isDefined(ss) ? ss.concat(f$1.secondSett.traceConfig.urlBlackList) : f$1.secondSett.traceConfig.urlBlackList), {});
        if (isDefined(ns) && 0 < ns.length)
            for (let as = 0, cs = (ns = 200 < ns.length ? ns.slice(0, 200) : ns).length - 1; as <= cs; as++) extend(os, this.totalHead(ns[as], es, ts, is));
        if (isDefined(rs) && 0 < rs.length)
            for (let as = 0, cs = (rs = 200 < rs.length ? rs.slice(0, 200) : rs).length - 1; as <= cs; as++) this.whiteCheck(es, rs[as]) && extend(os, this.whiteHead(rs[as], es, ts, is));
        if (isDefined(ss) && 0 < ss.length)
            for (let as = 0, cs = (ss = 200 < ss.length ? ss.slice(0, 200) : ss).length - 1; as <= cs; as++) this.black(es, ss[as]) ? extend(os, this.blackHead(ss[as], es, ts, is)) : this.getBlackKey(ss[as]);
        return 200 < Object.keys(os).length && (os = getElementForNum(os, 200)), os = this.delBlackKey(os), this.list[es + "+" + ts] = os
    }
    delBlackKey(es) {
        if (0 < this.blackKey.length)
            for (let ts = 0, is = this.blackKey.length - 1; ts <= is; ts++) isDefined(es[this.blackKey[ts]]) && delete es[this.blackKey[ts]];
        return this.blackKey = [], es
    }
    getBlackKey(es) {
        var ts = es && es.reqHeaderRules;
        if (isDefined(ts) && 0 < ts.length && this.blackKey)
            for (let is = 0, ns = ts.length - 1; is <= ns; is++) ts[is] && ts[is].key && this.blackKey.push(ts[is].key)
    }
    totalHead(es, ts, is, ns) {
        var rs = {};
        return extend(rs, this.constructData(es, ts, is, ns)), rs
    }
    whiteCheck(es, ts) {
        if (ts.reqHeaderRules && 0 < ts.reqHeaderRules.length) {
            if (includes([0, 1, 2, 3, 4], ts.type) === !1) return !1;
            switch (ts.type) {
                case 0:
                    if (es == ts.rule) return !0;
                    break;
                case 1:
                    if (startWith(es, ts.rule)) return !0;
                    break;
                case 2:
                    if (endWith(es, ts.rule)) return !0;
                    break;
                case 3:
                    var is = new RegExp(ts.rule);
                    if (is instanceof RegExp && is.test(es)) return !0;
                    break;
                case 4:
                    if (-1 < es.indexOf(ts.rule)) return !0;
                    break;
                default:
                    return !1
            }
        }
        return !1
    }
    whiteHead(es, ts, is, ns) {
        var rs = es.reqHeaderRules,
            ss = {};
        if (isDefined(rs) && 0 < rs.length)
            for (let os = 0, as = rs.length - 1; os <= as; os++) extend(ss, this.constructData(rs[os], ts, is, ns));
        return ss
    }
    black(es, ts) {
        if (ts.reqHeaderRules && 0 < ts.reqHeaderRules.length) {
            if (includes([0, 1, 2, 3, 4], ts.type) === !1) return !1;
            switch (ts.type) {
                case 0:
                    if (es == ts.rule) return !1;
                    break;
                case 1:
                    if (startWith(es, ts.rule)) return !1;
                    break;
                case 2:
                    if (endWith(es, ts.rule)) return !1;
                    break;
                case 3:
                    var is = new RegExp(ts.rule);
                    if (is instanceof RegExp && is.test(es)) return !1;
                    break;
                case 4:
                    if (-1 < es.indexOf(ts.rule)) return !1;
                    break;
                default:
                    return !0
            }
        }
        return !0
    }
    blackHead(es, ts, is, ns) {
        var rs = es.reqHeaderRules,
            ss = {};
        if (isDefined(rs) && 0 < rs.length)
            for (let os = 0, as = rs.length - 1; os <= as; os++) extend(ss, this.constructData(rs[os], ts, is, ns));
        return ss
    }
    checkKey(es, ts, is) {
        return !(!is || is === 1) || !(!isDefined(es) || es.length > ts) && (ts === 256 ? !!/^[0-9a-zA-Z_-]{1,256}$/.test(es) : trim(es) != "")
    }
    constructData(es, ts, is, ns) {
        var rs = {},
            ss = getUserAgent(),
            os = ss && ss.osName + "/" + ss.osVersion || f$1.sett.osType && f$1.sett.typeArr[f$1.sett.osType] || f$1.sett.typeArr[1],
            as = es.rhsr;
        if (isDefined(es) && isDefined(es.type) && this.checkKey(es.key, 256)) {
            if (isDefined(es.value) && this.checkKey(es.value, 512) === !1) return;
            switch (es.type) {
                case 1:
                    isDefined(es.value) && (rs[es.key] = es.value);
                    break;
                case 2:
                    rs[es.key] = {
                        fun: uuidWithLength,
                        len: 16
                    };
                    break;
                case 3:
                    rs[es.key] = {
                        fun: uuidWithLength,
                        len: 32
                    };
                    break;
                case 4:
                    rs[es.key] = {
                        fun: skyData,
                        len: 32,
                        sky: !0,
                        url: ts,
                        pathname: is,
                        rhsr: as
                    };
                    break;
                case 5:
                    rs[es.key] = {
                        fun: traceId,
                        len: 32,
                        sky: !1,
                        rhsr: as
                    };
                    break;
                case 6:
                    rs[es.key] = "bnro=" + os + "_js/" + f$1.sett.agentVersion
            }
        }
        return rs
    }
}
let BWexample = new Z;

function checkBlackAndWhite(Et, es) {
    if (isDefined(Et.url) && (Et = (Et = Et.url).indexOf("http") === 0 ? (ts = Et.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/)) && {
            href: Et,
            protocol: ts[1],
            host: ts[2],
            hostname: ts[3],
            port: ts[4],
            pathname: ts[5],
            search: ts[6],
            hash: ts[7]
        } : (ts = Et.match(/^(file?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/)) && {
            href: Et,
            protocol: ts[1],
            host: ts[2],
            hostname: ts[3],
            port: ts[4],
            pathname: ts[5],
            search: ts[6],
            hash: ts[7]
        }, isDefined(Et))) return ts = isDefined(Et.hostname) ? Et.hostname : "", Et = isDefined(Et.pathname) ? Et.pathname : "", isDefined(ts) ? BWexample.getItem(ts, Et, es) : void 0;
    var ts
}

function skyData(as, os, ts) {
    var is = String(enBase64(skyUuid())),
        ns = String(enBase64(skyUuid())),
        rs = String(enBase64(f$1.sett.appName)),
        ss = String(enBase64(f$1.sett.appVersion)),
        os = os && String(enBase64(os)) || String(enBase64("/")),
        as = String(enBase64(as));
    return !(0 <= ts && ts <= 100) || t(ts) ? `1-${is}-${ns}-0-${rs}-${ss}-${os}-` + as : `0-${is}-${ns}-0-${rs}-${ss}-${os}-` + as
}
var p$1 = {
    isPeriod: !1,
    actionID: "",
    networkID: ""
};

function H(Et, es, ts) {
    !Et.$metric || isDefined((Et = Et.$metric.metric)[es]) && !ts || (Et[es] = tillNow())
}

function he$1(Et, es, ts) {
    Et.$metric && (Et.$metric.info[es] = ts)
}

function safetySetErrorInfo(Et, es, ts, is, ns) {
    Et.$metric && ((Et = Et.$metric.info)[es] = ts, Et[GC.MESSAGE] = ns, Et[GC.E_TYPE] = is)
}

function v(Et, es) {
    let ts = es;
    es = getIP(ts = getUrl(ts = typeof es != "string" ? es.href || "" : ts)), this.$$inner || (this.$metric = {
        info: {
            id: uuid(),
            url: ts.slice(0, 4096),
            ip: es[0] || "",
            port: es[1] || "",
            method: toUpper(Et),
            type: 0,
            protocalType: -1 < ts.indexOf("https") ? 2 : 1,
            reqUrlDta: isDefined(f$1.sett.reqURLKey || f$1.secondSett.reqURLKey) && getParams(ts) || "",
            reqhtData: {},
            reshtData: {}
        }
    }, isDefined(f$1.sett) && isDefined(f$1.sett.pageViewId) && (this.$metric.info.pageViewId = f$1.sett.pageViewId))
}

function getParams(Et) {
    return isDefined(Et) ? String.prototype.split.call(Et, "?")[1] : ""
}

function ue$1(Et) {
    if (this.$metric && !this.$$done) {
        this.$$done = !0;
        var es, ts = this.$metric,
            is = ts.info,
            ns = ts.metric;
        extendMetrics(ts), polyfillMetric(ts);
        try {
            if ((!isDefined(ns[GC.DECODED_BODY_SIZE]) || ns[GC.DECODED_BODY_SIZE] <= 0) && (es = this.responseType === "" || this.responseType === "text" ? getContentSize(this.responseText) : getContentSize(this.response), ns[GC.DECODED_BODY_SIZE] = es), this.getAllResponseHeaders) {
                var rs = this.getAllResponseHeaders(),
                    ss = rs,
                    os = toLower(ss),
                    as = ss.trim().split(/[\r\n]+/),
                    cs = {},
                    ds = (as.forEach(function (ls) {
                        var ls = ls.split(": "),
                            us = ls.shift(),
                            ls = ls.join(": ");
                        cs[us] = ls
                    }), is.guid = isDefined(cs[GC.GUID_KEY]) && cs[GC.GUID_KEY].split(",")[0] || "", is.xBrResponse = isDefined(cs[GC.X_BR_RESPONSE]) && cs[GC.X_BR_RESPONSE].split(",")[0] || "", is.traceResponse = isDefined(cs[GC.TRACE_RESPONSE]) && cs[GC.TRACE_RESPONSE].split(",")[0] || "", is[GC.RESPONSE_HEADER] = withLength(ss, 2e3), []);
                if (isDefined(f$1.sett.respHeaderTraceKey) && 0 < f$1.sett.respHeaderTraceKey.length || isDefined(f$1.secondSett.respHeaderTraceKey) && 0 < f$1.secondSett.respHeaderTraceKey.length) {
                    isDefined(f$1.secondSett.respHeaderTraceKey) && 0 < f$1.secondSett.respHeaderTraceKey.length ? ds = isDefined(f$1.sett.respHeaderTraceKey) ? f$1.sett.respHeaderTraceKey.concat(f$1.secondSett.respHeaderTraceKey) : f$1.secondSett.respHeaderTraceKey : isDefined(f$1.sett.respHeaderTraceKey) && (ds = f$1.sett.respHeaderTraceKey);
                    for (let fs = 0, us = ds.length - 1; fs <= us; fs++) - 1 < os.indexOf(toLower(ds[fs])) && (is.reshtData[ds[fs]] = this.getResponseHeader(ds[fs]))
                }
                getResponseHead(rs)
            }
        } catch (fs) {
            log("C123")
        }
        c$4({
            t: GC.REQUEST_DATA,
            p: ts,
            isRelatedH5: !!isDefined(ts.info.isRelatedH5)
        }), setTimeout(function () {
            getCookieUserID()
        }, 50)
    }
}

function getResponseHead(Et) {
    if (0 < (Et = Et.trim()).length) {
        let ns = Et.split(/[\r\n]+/),
            rs = {};
        ns.forEach(function (as) {
            var as = as.split(": "),
                os = as.shift(),
                as = as.join(": ");
            rs[os] = as
        });
        var es = g$7.responseArr,
            ts = g$7.configeManage;
        if (0 < es.length)
            for (let ss = 0, os = es.length - 1; ss <= os; ss++) {
                var is = es[ss].rule.toLowerCase();
                if (rs.hasOwnProperty(is) && es[ss].index <= g$7.isStopGetValue && u$3(rs[is])) return ts[es[ss].index].value = "" + rs[is], void g$7.checkValueRight()
            }
    }
}

function U$2(Et) {
    return isFunction(prop(Et.onreadystatechange, "$$original"))
}

function $(Et) {
    return Et.readyState === 0 || Et.readyState === 4
}

function pe$1() {
    D$1.call(this), U$2(this) || ($(this) ? T$1.call(this) : this.onreadystatechange = hack(this.onreadystatechange, D$1, T$1, q$1))
}

function D$1() {
    isDefined(this) && (isDefined(this.$metric) && isDefined(this.$metric.info) && isDefined(this.$metric.info.ai) && !p$1.isPeriod && p$1.networkID !== this.$metric.info.id && (p$1.isPeriod = !0, p$1.actionID = this.$metric.info.ai, p$1.networkID = this.$metric.info.id, c$4({
        t: GC.XHR_CALLBACK_IDENTIFY,
        info: p$1
    })), this.readyState === 2 && H(this, GC.RESPONSE_START), $(this)) && (H(this, GC.RESPONSE_START), H(this, GC.RESPONSE_END), H(this, GC.CALLBACK_START))
}

function T$1() {
    if ($(this)) {
        p$1.isPeriod = !1, c$4({
            t: GC.XHR_CALLBACK_IDENTIFY,
            info: p$1
        });
        let ts = now();
        H(this, GC.CALLBACK_END);
        var Et = this;
        if (this.$metric) {
            var es = 0;
            try {
                es = this.status, this.$metric.info[GC.E_TYPE] = "http"
            } catch (is) {
                log("C124")
            }
            es === 0 && (this.$metric.info[GC.E_TYPE] = "XHR", this.$metric.info[GC.MESSAGE] = "XHR internal services not available or Cross domain request"), this.$metric.info.code = es, queueRequest(this.$metric), delay(function () {
                log("C125"), ue$1.call(Et, ts)
            })
        }
    }
}

function q$1() {
    log("C126"), N$1(last(args(arguments))), he$1(this, "callbackError", 1)
}

function L$2(Et, es, ts) {
    var is;
    (isDefined(f$1.sett.reqHeaderTraceKey) || isDefined(f$1.secondSett.reqHeaderTraceKey)) && (is = [], isDefined(f$1.secondSett.reqHeaderTraceKey) && 0 < f$1.secondSett.reqHeaderTraceKey.length ? is = isDefined(f$1.sett.reqHeaderTraceKey) ? f$1.sett.reqHeaderTraceKey.concat(f$1.secondSett.reqHeaderTraceKey) : f$1.secondSett.reqHeaderTraceKey : isDefined(f$1.sett.reqHeaderTraceKey) && (is = f$1.sett.reqHeaderTraceKey), isDefined(is)) && includes(is.map(function (ns) {
        return ns.toLowerCase()
    }), Et.toLowerCase()) && (ts.info.reqhtData[Et] = es)
}

function x$1(Et) {
    if (!this.$$inner && isDefined(this.$metric)) {
        p$1.isPeriod && (this.$metric.info.ai = p$1.actionID, this.$metric.info.parentNetworkID = p$1.networkID, c$4({
            t: GC.LIFESTYLE_CALLBACK_REQUEST_START + this.$metric.info.ai
        })), c$4({
            t: GC.LIFESTYLE_XHR_START,
            info: isDefined(this.$metric.info) ? this.$metric.info : null
        });
        var es, ts, is = this,
            ns = (BWexample.checkIsOpen(), isDefined(this.$metric.info) && BWexample.isOpen && (this.$metric.info.timestamp = now(), isDefined(ns = checkBlackAndWhite(this.$metric.info, "_xhr"))) && isObj(ns) && forEachOwn(ns, function (ss, os) {
                var as;
                isObj(ss) ? (as = (as = ss).sky ? ss.fun(ss.url, ss.pathname, ss.rhsr) : ss.sky === !1 ? ss.fun(ss.rhsr) : ss.fun(ss.len), is.setRequestHeader(os, as), L$2(os, as, is.$metric)) : (startWith(ss, "bnro=") && (ss += "_xhr_XMLHttpRequest"), L$2(os, ss, is.$metric), is.setRequestHeader(os, ss))
            }), isFunction(this.addEventListener) ? (forEach(["abort", "timeout", "error"], function (ss, os) {
                var as = ["User terminates XHR request", "XHR request timeout", "XHR request exception"];
                addListener(is, ss, function () {
                    safetySetErrorInfo(is, "code", 600 + Number(os), "XHR", as[os])
                }, !1)
            }), addListener(this, "readystatechange", pe$1, !1)) : (es = 3, (ts = function () {
                delay(function () {
                    if ($(is) && !U$2(is)) return T$1.call(is);
                    $(is) || (is.onreadystatechange = hack(is.onreadystatechange, D$1, T$1, q$1), 0 <= --es && ts())
                })
            })()), this.onreadystatechange = hack(this.onreadystatechange, D$1, T$1, q$1), this.$metric.info),
            rs = (extend(ns, getTime()), this.$metric.metric = {});
        try {
            ns[GC.REQUEST_BODY] = getRequestParam(Et), rs[GC.UPLOAD_BODY_SIZE] = getContentSize(Et)
        } catch (ss) {
            log("C127")
        }
    }
}

function de(Et, es) {
    if (u$3(es)) {
        var ts = g$7.requestArr,
            is = g$7.configeManage;
        if (0 < ts.length) {
            for (let ns = 0, rs = ts.length - 1; ns <= rs; ns++)
                if (ts[ns].rule == Et && ts[ns].index <= g$7.isStopGetValue) return is[ts[ns].index].value = "" + es, void g$7.checkValueRight()
        }
    }
}

function M$1(Et, es) {
    var ts;
    de(Et, es), isDefined(this.$metric) && (L$2(Et, es, this.$metric), isDefined((ts = this.$metric.info)[GC.REQUEST_HEADER]) || (ts[GC.REQUEST_HEADER] = ""), ts[GC.REQUEST_HEADER] = ts[GC.REQUEST_HEADER] && ts[GC.REQUEST_HEADER] + GC.BREAK_LINE + Et + ":" + es || Et + ":" + es)
}

function Ee$1() {
    if (!window.XMLHttpRequest) return log("C128");
    var Et;
    XMLHttpRequest.prototype ? (XMLHttpRequest.prototype.open = hack(XMLHttpRequest.prototype.open, v), XMLHttpRequest.prototype.send = hack(XMLHttpRequest.prototype.send, x$1), XMLHttpRequest.prototype.setRequestHeader = hack(XMLHttpRequest.prototype.setRequestHeader, M$1)) : (log("C129"), Et = window.XMLHttpRequest, window.XMLHttpRequest = function () {
        var es = new Et;
        return es.open = hack(es.open, v), es.send = hack(es.send, x$1), es.setRequestHeader = hack(es.setRequestHeader, M$1), es
    })
}
var C$1 = {
    isPeriod: !1,
    actionID: "",
    networkID: ""
};

function le(Et) {
    return getRequestParam(Et)
}

function ue(Et) {
    return getContentSize(Et)
}

function U$1(Et) {
    if (!isDefined(Et)) return "";
    var es = "";
    try {
        var ts, es = (window.Headers && Et instanceof Headers ? map(iterate(Et.entries()), function (ns) {
            return ns.join(":")
        }) : (ts = [], forEachOwn(Et, function (ns, rs) {
            ts.push(rs + ":" + ns)
        }), ts)).join(GC.BREAK_LINE)
    } catch (is) {
        es = "", log("C150")
    }
    return es
}

function D(Et) {
    return isDefined(Et) && typeof Et != "string"
}

function q(Et, es, ts) {
    return ts === "headers" && es ? D(Et) && Et[ts] ? extend(es[ts], Et[ts]) : es[ts] : D(Et) ? Et[ts] : es ? es[ts] : null
}

function pe(Et, es) {
    return {
        requestBody: le(q(Et, es, "body")),
        requestHeader: U$1(q(Et, es, "headers"))
    }
}

function he(is, ns) {
    var ts = getUrl(ts = D(is) ? is.url : is),
        is = toUpper(q(is, ns, "method")) || "GET",
        ns = getIP(ts);
    return {
        id: uuid(),
        url: ts.slice(0, 4096),
        method: is,
        ip: ns[0] || "",
        port: ns[1] || "",
        protocalType: -1 < ts.indexOf("https") ? 2 : 1,
        reqUrlDta: isDefined(f$1.sett.reqURLKey || f$1.secondSett.reqURLKey) && getParams(ts) || "",
        requestType: 4
    }
}

function O(Et, es) {
    var ts, is;
    Et && (extendMetrics(Et), polyfillMetric(Et), (!isDefined((ts = Et.metric)[GC.DECODED_BODY_SIZE]) || ts[GC.DECODED_BODY_SIZE] <= 0) && (is = Et.ext || {}, ts[GC.DECODED_BODY_SIZE] = is.originalResponseSize || 0), c$4({
        t: GC.REQUEST_DATA,
        p: Et,
        isRelatedH5: !!isDefined(Et.info.isRelatedH5)
    }), setTimeout(function () {
        getCookieUserID()
    }, 50))
}

function Ee() {
    var Et = window.fetch;
    window.fetch = function (os, ts) {
        let is = os;
        !os instanceof Request && typeof os != "string" && os && (os.href || os.url) && (is = os.href || os.url || "");
        var os = isDefined(window.$bonreeReplayUrl) ? window.$bonreeReplayUrl : null,
            ns = he(is, ts);
        if ((!D(is) && is.indexOf(os) === -1 || D(is)) && c$4({
                t: GC.LIFESTYLE_FETCH_START,
                info: ns
            }), C$1.isPeriod && (ns.ai = C$1.actionID, ns.parentNetworkID = C$1.networkID, c$4({
                t: GC.LIFESTYLE_CALLBACK_REQUEST_START + ns.ai
            })), (ns = extend(ns, {
                reqhtData: {},
                reshtData: {}
            })).timestamp = now(), isDefined(f$1.sett) && isDefined(f$1.sett.pageViewId) && (ns.pageViewId = f$1.sett.pageViewId), BWexample.checkIsOpen(), BWexample.isOpen && (extend(ns, {
                reqhtData: {},
                reshtData: {}
            }), isDefined(os = checkBlackAndWhite(ns, "_fetch"))) && isObj(os) && forEachOwn(os, function (ds, fs) {
                let us = ds;
                if (isObj(ds) && (us = ds.sky ? ds.fun(ds.url, ds.pathname, ds.rhsr) : ds.sky === !1 ? ds.fun(ds.rhsr) : ds.fun(ds.len)), startWith(ds, "bnro=") && (us += "_fetch_fetch"), isDefined(ts))
                    if (isDefined(ts.headers)) {
                        if (ts.headers instanceof Headers) {
                            var ls, hs = {};
                            for (ls of ts.headers.entries()) hs[ls[0]] = ls[1];
                            ts.headers = hs
                        }
                        extend(ts.headers, {
                            [fs]: us
                        })
                    } else extend(ts, {
                        headers: {
                            [fs]: us
                        }
                    });
                else ts = {
                    headers: {
                        [fs]: us
                    }
                }
            }), ts && ts.headers) {
            if (ts.headers instanceof Headers) {
                var rs, ss = {};
                for (rs of ts.headers.entries()) ss[rs[0]] = rs[1];
                ts.headers = ss
            }
            x(ts.headers, ns)
        }
        ns.type = 1, extend(ns, getTime());
        var os = Et(is, ts),
            as = (extend(ns, pe(is, ts)), {
                info: ns
            }),
            cs = as.metric = {};
        return cs[GC.UPLOAD_BODY_SIZE] = ue(q(is, ts, "body")), os.then(function (ds) {
            ns.status = ds.status, ns.statusText = ds.statusText;
            var fs = cs[GC.RESPONSE_END] = tillNow(),
                fs = (cs[GC.RESPONSE_START] = cs[GC.CALLBACK_START] = fs, queueRequest(as), U$1(ds.headers)),
                us = fs,
                ls = toLower(us),
                hs = us.trim().split(/[\r\n]+/),
                ms = {};
            hs.forEach(function ($s) {
                var $s = $s.split(":"),
                    ws = $s.shift(),
                    $s = $s.join(": ");
                ms[ws] = $s
            }), ns.guid = isDefined(ms[GC.GUID_KEY]) && ms[GC.GUID_KEY].split(",")[0] || "", ns.xBrResponse = isDefined(ms[GC.X_BR_RESPONSE]) && ms[GC.X_BR_RESPONSE].split(",")[0] || "", ns.traceResponse = isDefined(ms[GC.TRACE_RESPONSE]) && ms[GC.TRACE_RESPONSE].split(",")[0] || "", ns[GC.RESPONSE_HEADER] = withLength(us, 2e3);
            try {
                var ps = [];
                if (isDefined(f$1.sett.respHeaderTraceKey) && 0 < f$1.sett.respHeaderTraceKey.length || isDefined(f$1.secondSett.respHeaderTraceKey) && 0 < f$1.secondSett.respHeaderTraceKey.length) {
                    isDefined(f$1.secondSett.respHeaderTraceKey) && 0 < f$1.secondSett.respHeaderTraceKey.length ? ps = isDefined(f$1.sett.respHeaderTraceKey) ? f$1.sett.respHeaderTraceKey.concat(f$1.secondSett.respHeaderTraceKey) : f$1.secondSett.respHeaderTraceKey : isDefined(f$1.sett.respHeaderTraceKey) && (ps = f$1.sett.respHeaderTraceKey);
                    for (let gs = 0, ws = ps.length - 1; gs <= ws; gs++) - 1 < ls.indexOf(toLower(ps[gs])) && (ns.reshtData[ps[gs]] = ds.headers.get(ps[gs]))
                }
            } catch (gs) {
                log("C148")
            }
            if (getResponseHead(fs), ds.$metric = as, cs[GC.CALLBACK_END] = tillNow(), hs = tryToClone(ds), hs) try {
                const gs = {
                    bytesLimit: Number.POSITIVE_INFINITY,
                    collectStreamBody: !0
                };
                readBytesFromStream(hs.body, gs, function (ws) {
                    as.ext = {
                        originalResponseSize: ws
                    }, O(as, ds)
                })
            } catch (gs) {
                log("C149")
            } else O(as);
            return ds
        }, function (ds) {
            var fs = cs[GC.RESPONSE_END] = tillNow();
            throw cs[GC.RESPONSE_START] = cs[GC.CALLBACK_START] = cs[GC.CALLBACK_END] = fs, ns.status = window.TypeError && ds instanceof TypeError ? 602 : 600, ns.eType = "FETCH", ns[GC.STATUS_TEXT] = ns.status == 602 ? "FETCH request exception" : "User terminates FETCH request", O(as), ds
        }).catch(ds => {
            throw ds.type = 2, ds
        })
    }
}

function x(Et, es) {
    if (isDefined(Et)) {
        var ts, is = g$7.requestArr,
            ns = g$7.configeManage;
        if (0 < is.length) {
            for (let rs = 0, ss = is.length - 1; rs <= ss; rs++)
                if (Et.hasOwnProperty(is[rs].rule) && is[rs].index <= g$7.isStopGetValue && u$3(Et[is[rs].rule])) return ns[is[rs].index].value = "" + Et[is[rs].rule], void g$7.checkValueRight()
        }(isDefined(f$1.sett.reqHeaderTraceKey) && 0 < f$1.sett.reqHeaderTraceKey.length || isDefined(f$1.secondSett.reqHeaderTraceKey) && 0 < f$1.secondSett.reqHeaderTraceKey.length) && (ts = [], isDefined(f$1.secondSett.reqHeaderTraceKey) && 0 < f$1.secondSett.reqHeaderTraceKey.length ? ts = isDefined(f$1.sett.reqHeaderTraceKey) ? f$1.sett.reqHeaderTraceKey.concat(f$1.secondSett.reqHeaderTraceKey) : f$1.secondSett.reqHeaderTraceKey : isDefined(f$1.sett.reqHeaderTraceKey) && (ts = f$1.sett.reqHeaderTraceKey), Object.keys(Et).map(function (rs) {
            includes(ts.map(function (ss) {
                return ss.toLowerCase()
            }), rs.toLowerCase()) && (es.reqhtData[rs] = Et[rs])
        }))
    }
}

function i$1() {
    if (!isFunction(window.fetch)) return log("C147");
    v$8(GC.XHR_CALLBACK_IDENTIFY, function (Et) {
        C$1 = Et.info
    }), Ee()
}

function r$1() {
    Ee$1(), i$1(), window.performance && window.performance.now && F()
}
var w$1 = 0;

function E(Et) {
    w$1 = 1e3 * new Date().getTime()
}

function g$1(Et) {
    if (isDefined(Et)) try {
        -1 < Et.constructor.toString().indexOf("String") && (es = (isDefined(window.TextEncoder) ? new TextEncoder().encode(Et) : Et).length), -1 < Et.constructor.toString().indexOf("ArrayBuffer") && (es = Et.byteLength), -1 < Et.constructor.toString().indexOf("Blob") && (es = Et.size), -1 < Et.constructor.toString().indexOf("Array") && (es = Et.byteLength), -1 < Et.constructor.toString().indexOf("Uint8Array") && (es = Et.toString().length || 0);
        var es, ts, is, ns = isDefined(this.name) ? this.name : this.url.split("?")[0];
        /^[a-zA-Z0-9:_-\s@./]+$/.test(ns) !== !1 && ((ts = new a$1(ns, "websocket")).setStatus(1), isDefined(ts.spanEvent) && isDefined(ts.spanEvent.ic) && (ts.spanEvent.ic = !1), ts.setTag("process", "send"), ts.setTag("connectID", isDefined(this.identify) ? this.identify : uuid()), ts.setData("url", isDefined(this.handledUrl) ? this.handledUrl : this.url), (is = 1e3 * new Date().getTime() - w$1) === 0 && (is = 999), !isDefined(this.readyState) || this.readyState !== 2 && this.readyState !== 3 || (ts.setStatus(2), ts.setStatusCode("WebSocket is already in CLOSING or CLOSED state.")), ts.setMetric("send", is, "us"), ts.setDuration(is), ts.setMetric("size", es, "byte"), ts.finish())
    } catch (rs) {}
}

function y() {
    var Et = window.WebSocket;
    window.WebSocket.prototype.send = hack(window.WebSocket.prototype.send, E, g$1), window.WebSocket = function () {
        c$4({
            t: GC.WEBSOCKET_CONNECTION_START
        });
        let es = 1e3 * new Date().getTime();
        var ts = arguments[1] === void 0 ? new Et(arguments[0]) : new Et(arguments[0], arguments[1]),
            is = ts && ts.url && -1 < ts.url.indexOf("?") ? ts.url.split("?")[0] : ts.url,
            ns = d$3({
                p: {
                    info: {
                        url: ts.url
                    }
                }
            }, f$1.sett).p.info.url;
        return ts.handledUrl = isDefined(ns) ? ns : "", ts.identify = uuid(), ts.name = isDefined(is) ? is : "", ts.hasHandleConnect = !1, ts.addEventListener("open", function () {
            var rs;
            /^[a-zA-Z0-9:_-\s@./]+$/.test(is) !== !1 && ((rs = new a$1(is, "websocket")).spanEvent.st = 0, rs.spanEvent.timestamp = es, rs.setStatus(1), isDefined(rs.spanEvent) && isDefined(rs.spanEvent.ic) && (rs.spanEvent.ic = !1), rs.setTag("process", "connect"), rs.setTag("connectID", isDefined(ts.identify) ? ts.identify : uuid()), rs.setData("url", ts.handledUrl), rs.setDuration(1e3 * new Date().getTime() - es), rs.finish(), ts.hasHandleConnect = !0, c$4({
                t: GC.WEBSOCKET_CONNECTION_END
            }))
        }), ts.addEventListener("error", function (rs) {
            var ss;
            ts.hasHandleConnect || /^[a-zA-Z0-9:_-\s@./]+$/.test(is) !== !1 && ((ss = new a$1(is, "websocket")).spanEvent.st = 0, ss.spanEvent.timestamp = es, ss.setStatus(2), isDefined(ss.spanEvent) && isDefined(ss.spanEvent.ic) && (ss.spanEvent.ic = !1), ss.setTag("process", "connect"), ss.setTag("connectID", isDefined(ts.identify) ? ts.identify : uuid()), ss.setData("url", ts.handledUrl), ss.setDuration(1e3 * new Date().getTime() - es), ss.setStatusCode("Websocket connection failed"), ss.finish(), ts.hasHandleConnect = !0, c$4({
                t: GC.WEBSOCKET_CONNECTION_END
            }))
        }), ts
    }, window.WebSocket = extend(window.WebSocket, Et), window.WebSocket.prototype = Et.prototype
}

function T() {
    f$1.sett.enableWebsocket !== !1 && (window.WebSocket === void 0 ? log("C157") : window.WebSocket.prototype === void 0 ? log("C158") : y())
}
var p = {
    config: NIL_FN,
    error: NIL_FN,
    recordCustomActionEnd: NIL_FN,
    setUserProperties: NIL_FN,
    incUserProperty: NIL_FN,
    removeUserProperty: NIL_FN
};

function S() {
    if (typeof document == "undefined" || !f$1.sett.probability || window.bonreeRUM) return log("C105"), window.bonreeRUM || p;
    b$1(), $$1(), se(), r$1(), g$2(), V(), T();
    var Et = overwrite(p, {
        config: function (es, ts = !0, is = 0) {
            isDefined(es.osType) && es.osType === GC.ANDROID && f$1.sett.osType === GC.ANDROID || (f$1.setConfig.call(f$1, es, ts, is), isDefined(es.appId) && w$7.setAppid(es))
        },
        error: N$1,
        recordCustomActionEnd: J
    });
    isDefined(window) && (window.bonreeRUM = Et), window.bonreeRUM.version = version, window.bonreeRUM.startSpan = function (es, ts) {
        return new a$1(es, ts)
    }, window.bonreeRUM.getSession = function () {
        return w$7.getSession()
    }, window.bonreeRUM.getUserInfo = function () {
        return u$1.getUserInfo()
    }, window.bonreeRUM.updateConfig = function (es) {
        isDefined(window.stopBonreeRecord) && (window.stopBonreeRecord(), window.stopBonreeRecordUpload = !0), C$3(), w$7.setAppid(es)
    }, window.bonreeJsBridge = K, window.bonreeRUM = extend(window.bonreeRUM, K)
}

function r(Et) {
    var es = new Metric(Et.p, GC.ACTION),
        es = (es.info("t").info("n").info("sa").info("i").info("vn").info("ic").info("p", "", "p", !0).info("lt").info("is").info("id").info("m").info("ice").info("ci").info("vt", 1, "vt").info("vci", "", "vci").info("ir"), isDefined(Et.p.info.me) && es.info("me"), es.build());
    return isDefined(Et.revts) && 0 < Et.revts.length && (es.revts = Et.revts), es
}

function i(Et) {
    return Et = new Metric(Et.p, GC.CONSOLE), Et.info("lv").info("msg", "", "msg", !0), Et.build()
}

function a(Et) {
    var es = typeof window != "undefined" && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : "",
        ts = new Metric(Et.p, GC.ERROR),
        is = isDefined(window.performance) && isDefined(window.performance.timing) && performance.timing.navigationStart || now();
    return isDefined(window.BRLog) && window.BRLog.__sendErrorInfo(ts.data.info), ts.info(GC.PAGE_ID, "", "pvid").info(GC.PAGE_URL, "", "url").info(GC.ERROR_FILE, "", "n").info(GC.MESSAGE, "", "m").info(GC.ERROR_LINE, 0, "l").info(GC.ERROR_COLUMN, 0, "col").info(GC.PAGE_CREATE_TIME, 1e3 * is, "pct").info(GC.PAGE_TITLE, document.title || "", "t").info("type", 3, "ect").info("ua", es, "ua").info(GC.FRAME_WORK, "", "fw"), isDefined(Et.p.info[GC.NAME] && Et.p.info[GC.NAME] !== "") && ts.info(GC.NAME, "", "et"), isDefined(Et.p.info[GC.ERROR_STACK]) && Et.p.info[GC.ERROR_STACK] !== "" ? ts.info(GC.ERROR_STACK, "", "sta") : isDefined(ts.data.info.file) && (ts.data.info[GC.ERROR_STACK] = "undefined at @" + ts.data.info.file, ts.info(GC.ERROR_STACK, "at undefined @ " + ts.data.info.file, "sta")), isDefined(f$1.sett.isSinglePage) ? ts.info("pt", 2, "pt") : ts.info("pt", 1, "pt"), ts.build()
}
let m = {
    pvid: "",
    url: "",
    wpi: {},
    wri: [],
    ic: !1,
    timestamp: isDefined(performance.timing) && performance.timing.navigationStart ? 1e3 * performance.timing.navigationStart : now()
};

function h(Et) {
    isDefined(Et.p.info[GC.PAGE_ID]) && (m.pvid = Et.p.info[GC.PAGE_ID]), isDefined(Et.p.info[GC.PAGE_URL]) && (m.url = Et.p.info[GC.PAGE_URL]), isDefined(Et.p.info[GC.TITLE]) && Et.p.info[GC.TITLE] != "" && (m.vt = Et.p.info[GC.TITLE]);
    const es = new Metric(Et.p, GC.WEBVIEWDATA);
    es.metric(GC.NAVIGATION_START, "", "ns").metric(GC.UNLOAD_EVENT_START, 0, "ues").metric(GC.FULL_RESOURCE_LOAD_TIME, 0, "frlt").metric(GC.UNLOAD_EVENT_END, 0, "uee").metric(GC.REDIRECT_START, 0, "rds").metric(GC.REDIRECT_END, 0, "rde").metric(GC.FETCH_START, 0, "fs").metric(GC.DOMAIN_LOOKUP_START, 0, "dls").metric(GC.DOMAIN_LOOKUP_END, 0, "dle").metric(GC.CONNECT_START, 0, "cs").metric(GC.SECURE_CONNECTION_START, 0, "scs").metric(GC.CONNECT_END, 0, "ce").metric(GC.REQUEST_START, 0, "reqs").metric(GC.RESPONSE_START, 0, "rsps").metric(GC.RESPONSE_END, 0, "rspe").metric(GC.DOM_LOADING, 0, "dl").metric(GC.DOM_INTERACTIVE, 0, "di").metric(GC.DOM_CONTENT_LOADED_EVENT_START, 0, "dcles").metric(GC.DOM_CONTENT_LOADED_EVENT_END, 0, "dclee").metric(GC.DOM_COMPLETE, 0, "dc").metric(GC.LOAD_EVENT_START, 0, "les").metric(GC.LOAD_EVENT_END, 0, "lee").metric(GC.FIRST_PAINT, 0, "fp").metric(GC.FIRST_CONTENTFUL_PAINT, 0, "fcp").metric(GC.LARGEST_CONTENTFUL_PAINT, 0, "lcp").metric(GC.TRANSFER_SIZE, 0, "ts").metric(GC.ENCODED_BODY_SIZE, 0, "ebs").metric(GC.DECODED_BODY_SIZE, 0, "dbs").metric("tti", 0, "tti").metric(GC.RESPONSE_STATUS, -1, "rs"), m.wpi = es.build().data;
    try {
        const {
            type: is,
            ent: ns,
            sin: rs,
            data: ss
        } = P$2(M(m.wpi, m.url, m.pvid));
        var ts = u$1.getEviData("value");
        w$2.push(JSON.parse(JSON.stringify({
            k: is,
            ent: ns,
            sin: rs,
            v: ss,
            evi: ts
        }))), ss.ru = d$3({
            p: {
                info: {
                    url: ss.ru
                }
            }
        }, f$1.secondSett).p.info.url, I$2.push({
            k: is,
            ent: ns,
            sin: rs,
            v: ss,
            evi: ts
        })
    } catch (is) {
        log("C99-WebviewPerformanceInfoHandle" + is)
    }
}

function L$1(Et) {
    forEach(Et.p || [], function (es) {
        const ts = new Metric(es, GC.RESOURCE);
        ts.info(GC.START_TIME, 0, "st").info(GC.NAME, "", "name").info(GC.DURATION, 0, "dura").info("ret", "", "rt").metric(GC.FETCH_START, 0, "fs").metric(GC.DOMAIN_LOOKUP_START, 0, "dls").metric(GC.DOMAIN_LOOKUP_END, 0, "dle").metric(GC.CONNECT_START, 0, "cs").metric(GC.CONNECT_END, 0, "ce").metric(GC.SECURE_CONNECTION_START, 0, "scs").metric(GC.REQUEST_START, 0, "reqs").metric(GC.RESPONSE_START, 0, "rsps").metric(GC.RESPONSE_END, 0, "rspe").metric(GC.TRANSFER_SIZE, 0, "ts").metric(GC.ENCODED_BODY_SIZE, 0, "ebs").metric(GC.DECODED_BODY_SIZE, 0, "dbs").metric(GC.RESPONSE_STATUS, -1, "rs"), isDefined(es.info) && isDefined(es.info[GC.INITIATOR_TYPE]) && ts.info(GC.INITIATOR_TYPE, "", "it");
        var is = ts.build().data,
            ns = u$1.getEviData("value");
        if (ns && (is.evi = ns), isDefined(is.it) && !Et.special) {
            if (is.it !== "xmlhttprequest" && is.it !== "fetch") {
                m.wri.push(is);
                const {
                    type: rs,
                    ent: ss,
                    sin: os,
                    data: as
                } = P$2(C(is));
                w$2.push(JSON.parse(JSON.stringify({
                    k: rs,
                    ent: ss,
                    sin: os,
                    v: as,
                    evi: ns
                }))), as.ru = d$3({
                    p: {
                        info: {
                            url: as.ru
                        }
                    }
                }, f$1.secondSett).p.info.url, I$2.push({
                    k: rs,
                    ent: ss,
                    sin: os,
                    v: as,
                    evi: ns
                })
            }
        } else m.wri.push(is)
    })
}

function U(Et) {
    var es, ts;
    return isEmpty(m.wpi) ? null : (ts = u$1.getEviData("value"), (es = new Metric({
        info: m
    }, GC.WEBVIEWDATA)).info("pvid", "", "pvid").info("url", "", "url").info("wpi", {}, "wpi").info("ic", !1, "ic").info("vt", "", "vt", !0).info("evi", ts), 0 < m.wri.length && es.info("wri", [], "wri"), isDefined(Et.revts) && 0 < Et.revts.length ? ((ts = es.build()).revts = Et.revts, ts) : es.build())
}

function M(Et, es, ts) {
    if (es !== "about:blank") {
        let is = Et,
            ns = getIP(es),
            rs = getMineTypeByUrl(es) || "text/html",
            ss = 1e3 * (is.dle - is.dls),
            os = (ss < 0 && (ss = 0), 1e3 * (is.ce - is.scs) || -1),
            as = ((os < 0 || is.scs === 0) && (os = 0), 1e3 * (is.reqs - is.ce) || -1),
            cs = (as < -1 ? as = 999 : as === -1 && (as = 0), 1e3 * (is.rsps - is.reqs) || -1),
            ds = (cs < -1 ? cs = 999 : cs === -1 && (cs = 0), 0);
        return (ds = is.rsps === 0 ? 1e3 * (is.rspe - is.fs) || -1 : 1e3 * (is.rspe - is.rsps) || -1) < -1 ? ds = 999 : ds === -1 && (ds = 0), Et = {
            info: {
                id: uuid(),
                ru: es,
                m: "GET",
                ti: ns[0] || "",
                tp: ns[1] || "",
                dt: ss,
                sslt: os,
                rt: as,
                rti: cs,
                dti: ds,
                ds: 0,
                rds: 0,
                pt: -1 < es.indexOf("https") ? 2 : 1,
                ec: 200,
                art: 1,
                ret: rs,
                pvid: ts,
                ic: !1
            }
        }, Et.info.ct = 0 < is.ce - is.cs ? 1e3 * (is.ce - is.cs) : 0, Et.info.ti.length < 1 && delete Et.info.ti, Et
    }
}

function C(fs) {
    let es = fs,
        ts = es.name.slice(0, 4096),
        is = 3;
    if (isDefined(es.it)) switch (es.it) {
        case "xmlhttprequest":
            is = 3;
            break;
        case "beacon":
            is = 5;
            break;
        case "fetch":
            is = 4;
            break;
        default:
            is = 2
    }
    let ns = getIP(ts),
        rs = getMineTypeByUrl(ts) || "text/html",
        ss = 1e3 * (es.dle - es.dls),
        os = ((ss < 0 || es.dura <= 10) && (ss = 0), 1e3 * (es.ce - es.scs) || -1),
        as = ((os < 0 || es.dura <= 10 || es.scs === 0) && (os = 0), 1e3 * (es.reqs - es.ce) || -1),
        cs = (as < -1 || es.dura <= 10 ? as = 999 : as === -1 && (as = 0), 1e3 * (es.rsps - es.reqs) || -1),
        ds = (cs < -1 || es.dura <= 10 ? cs = 999 : cs === -1 && (cs = 0), 0);
    (ds = es.rsps === 0 ? 1e3 * (es.rspe - es.fs) || -1 : 1e3 * (es.rspe - es.rsps) || -1) < -1 || es.dura <= 10 ? ds = 999 : ds === -1 && (ds = 0);
    var fs = {
            info: {
                timestamp: isDefined(es.st) && isDefined(window.performance) && isDefined(window.performance.timing) ? 1e3 * (window.performance.timing.navigationStart + es.st) : now(),
                id: uuid(),
                ru: ts,
                m: "GET",
                ti: ns[0] || "",
                tp: ns[1] || "",
                dt: ss,
                sslt: os,
                rt: as,
                rti: cs,
                dti: ds,
                ds: 0,
                rds: 0,
                pt: -1 < ts.indexOf("https") ? 2 : 1,
                ec: 200,
                art: is,
                ret: rs,
                ic: !1,
                pvid: isDefined(f$1.sett.pageViewId) ? f$1.sett.pageViewId : ""
            }
        },
        us = 1e3 * (es.ce - es.cs);
    return fs.info.ct = 0 < us ? us : 0, fs
}

function s$1(Et) {
    var es = new Metric(Et.p, GC.SPAN);
    return es.info("st").info("n", "", "n", !0).info("t", "", "t").info("du", 0, "du").info("sta", 0, "sta").info("ic", !1, "ic"), isDefined(Et.p.info) && isDefined(Et.p.info.da) && es.info("da", [], "da"), isDefined(Et.p.info) && isDefined(Et.p.info.m) && es.info("m", [], "m"), isDefined(Et.p.info) && isDefined(Et.p.info.tag) && es.info("tag", [], "tag"), isDefined(Et.p.info) && isDefined(Et.p.info.stac) && es.info("stac", "", "stac"), isDefined(Et.p.info) && isDefined(Et.p.info.sub) && es.info("sub", {}, "sub"), es.build()
}

function L(Et) {
    v$8(Et, function (es) {
        if (!isDefined(es.p)) return log("C144");
        var ts = es.t;
        isDefined(es.p) && isDefined(es.p.info) && !isDefined(es.p.info[GC.PAGE_ID]) && (es.p.info[GC.PAGE_ID] = f$1.sett.pageViewId, es.p.info[GC.PAGE_URL] = d$3({
            p: {
                info: {
                    url: isDefined(window.location) ? window.location.href : ""
                }
            }
        }, f$1.sett).p.info.url);
        let is = u$1.getEviData("value"),
            ns = {};
        switch (ts) {
            case GC.ERROR_DATA:
                v$3(ns = a(es), v$9.webviewJSErrorEvent);
                break;
            case GC.CONSOLE_DATA:
                v$3(ns = i(es), v$9.consoleEvent);
                break;
            case GC.REQUEST_DATA:
                isDefined(es) && isDefined(es.p) && isDefined(es.p.info.ai) || isDefined(es.isRelatedH5) && es.isRelatedH5 || (isEmpty(f$1.secondSett) || isEmpty(ns = Q$1(JSON.parse(stringify(es)), f$1.secondSett)) || (isDefined(f$1.secondSett.osType) && f$1.secondSett.osType !== GC.BROWSER ? v$9.NetworkEvent(stringify({
                    ent: ns.ent,
                    v: ns.data,
                    evi: is
                }), f$1.secondSett) : pushQueueData(ns)), isEmpty(ns = Q$1(JSON.parse(stringify(es)), f$1.sett))) || (isDefined(f$1.sett.osType) && f$1.sett.osType !== GC.BROWSER ? v$9.NetworkEvent(stringify({
                    ent: ns.ent,
                    v: ns.data,
                    evi: is
                }), f$1.sett) : pushQueueData(ns)), isDefined(es) && isDefined(es.p.info) && isDefined(es.p.info.ai) && c$4({
                    t: GC.LIFESTYLE_REQUEST_END + es.p.info.ai,
                    requestData: JSON.parse(stringify(es)),
                    endTime: now()
                }), isDefined(es.isRelatedH5) && es.isRelatedH5 && c$4({
                    t: GC.LIFESTYLE_REQUEST_END + "H5",
                    requestData: JSON.parse(stringify(es)),
                    endTime: now()
                }), c$4({
                    t: GC.LIFESTYLE_REQUEST_END,
                    requestData: JSON.parse(stringify(es)),
                    endTime: now()
                });
                break;
            case GC.SPAN_DATA:
                isDefined((ns = s$1(es)).data) && c$4({
                    t: GC.SPAN_CALLBACK_DATA,
                    websocketData: ns
                }), ns.isRelated || v$3(ns, v$9.spanEvent);
                break;
            case GC.RESOURCE_DATA:
                if (es.type === 1 && h(es), es.type === 2 && L$1(es), es.type === 3 && isDefined(ns = U(es)))
                    if (isDefined(f$1.sett.osType) && f$1.sett.osType !== GC.BROWSER) {
                        let ss = window.top && window.self && window.top === window.self ? 1 : 0;
                        ns.imd = ss;
                        var rs = {
                            ent: ns.ent,
                            v: ns.data,
                            evi: ns.evi
                        };
                        isDefined(ns.revts) && 0 < ns.revts.length && (ns.revts.map(function (os) {
                            return os.v.ru.split("?")[0] == window.location.href.split("?")[0] && (os.v.imd = ss), ns.evi && (os.evi = ns.evi), os
                        }), rs.revts = ns.revts), checkMoudle("network") || delete rs.revts, v$9.webviewPerformanceTimingEvent(stringify(rs), f$1.sett, ss)
                    } else pushQueueData(ns);
                if (es.type === 4 && isDefined(ns = U(es)))
                    if (isDefined(f$1.secondSett.osType) && f$1.secondSett.osType !== GC.BROWSER) {
                        let ss = window.top && window.self && window.top === window.self ? 1 : 0;
                        ns.imd = ss, ns.data.url = d$3({
                            p: {
                                info: {
                                    url: ns.data.url
                                }
                            }
                        }, f$1.secondSett).p.info.url;
                        var rs = {
                            ent: ns.ent,
                            v: ns.data,
                            evi: ns.evi
                        };
                        isDefined(ns.revts) && 0 < ns.revts.length && (ns.revts.map(function (as) {
                            return as.v.ru.split("?")[0] == window.location.href.split("?")[0] && (as.v.imd = ss), ns.evi && (as.evi = ns.evi), as
                        }), rs.revts = ns.revts), checkMoudle("network") || delete rs.revts, v$9.webviewPerformanceTimingEvent(stringify(rs), f$1.secondSett, ss)
                    } else pushQueueData(ns);
                break;
            case GC.TRACE_ACTION_DATA:
                ns = r(es), isDefined(es.type) && es.type === 1 && (isDefined(f$1.sett.osType) && f$1.sett.osType !== GC.BROWSER ? (rs = {
                    ent: ns.ent,
                    v: ns.data,
                    evi: is
                }, isDefined(ns.revts) && 0 < ns.revts.length && (rs.revts = ns.revts), v$9.webviewActionEvent(stringify(rs), f$1.sett)) : pushQueueData(ns)), isDefined(es.type) && es.type === 2 && (isDefined(f$1.secondSett.osType) && f$1.secondSett.osType !== GC.BROWSER ? (ns.data.vn = d$3({
                    p: {
                        info: {
                            url: ns.data.vn
                        }
                    }
                }, f$1.secondSett).p.info.url, rs = {
                    ent: ns.ent,
                    v: ns.data,
                    evi: is
                }, isDefined(ns.revts) && 0 < ns.revts.length && (rs.revts = ns.revts), v$9.webviewActionEvent(stringify(rs), f$1.secondSett)) : pushQueueData(ns));
                break;
            default:
                log("C118")
        }
    })
}

function I() {
    L([GC.ROUTE_DATA, GC.ERROR_DATA, GC.CONSOLE_DATA, GC.REQUEST_DATA, GC.TRACE_ACTION_DATA, GC.SPAN_DATA, GC.RESOURCE_DATA, GC.PAGE_DATA])
}
let g = I$3();

function w() {
    window.bonreeRUM ? log("C104") : (window.BonreeRecord = {
        BonreeRecord
    }, S(), I(), W$2())
}

function s(Et) {
    if (isDefined(window.getIsRunWithNetClient) && (Et.dataFusionInfo = "net"), isDefined(window.bonreeRUM)) {
        if (isDefined(window.bonreeRUM.config)) return void window.bonreeRUM.config(Et, !1, 1)
    } else f$1.setConfig(Et);
    f$1.sett.initTime = now(), w()
}
g && w();
const l = {
    BonreeRecord,
    BonreeStart: s,
    Sm4: E$4,
    getDeviceInfo,
    setExtraInfo: O$8,
    setUserID: w$5
};
window.BonreeAgent = l;
export {
    BonreeRecord,
    s as BonreeStart,
    E$4 as Sm4,
    getDeviceInfo,
    O$8 as setExtraInfo,
    w$5 as setUserID
};